/* eslint-disable */
export const strings = {
    "hy": {
        of: (count: number, total: number) => <>{count}-ը {total}-ից</>,
        phoneWrong: "Մուտքագրեք հեռախոսահամարը հետևյալ ֆորմատով +7 (999) 999 99 99",
        extraDigits: "Ստուգեք հեռախոսահամարը. դրանում ավելորդ թվեր կան",
        missingDigits: "Ստուգեք հեռախոսահամարը. դրանում պակասող թվեր կան",
        emailWrong: "Սա email չէ: Ստուգեք՝ արդյոք նրանում չկան վրիպակներ",
        lessThanMinDate: "Ամսաթիվը պետք է լինի նվազագույնը {{minDate}}",
        notValidDepartmentCode: "Ստորաբաժանման կոդը պետք է լինի 000-000 ֆորմատով",
        onlyNumbers: "Կարելի է մուտքագրել միայն թվեր",
        choosePackageType: "Անհրաժեշտ է ընտրել փաթեթավորման տեսակը",
        notValidTrackNumber: "Թրեք-համարը պետք է պարունակի միայն թվեր, լատինատառեր, նշաններ . և - ",
        notValidUrl: "Սխալ URL հասցե",
        emptyCoordinates: "Ընտրեք հասցեն ցուցակից կամ նշեք քարտեզի վրա",
        invalidDateString: "Սխալ ամսաթիվ",
        invalidTimeString: "Սխալ ժամանակ",
        wrongRangeEnd: "Սխալ միջակայք",
        wrongCheckSum: "Սխալ հսկիչ գումար",
        symbols: {
            many: "նիշ",
            few: "նիշ",
            one: "նիշ"
        },
        numbers: {
            many: "թվանշան ",
            few: "թվանշան ",
            one: "թվանշան ",
        },
        numberFromTo: "Մուտքագրեք թիվ {{from}} և {{to}} միջև",
        symbolsRange: "Մուտքագրեք {{from}}-ից մինչև {{to}} նիշ",
        enterPositiveNumber: "Մուտքագրեք դրական թիվ",
        numberLessThen: "Նշանակությունը չպետք է գերազանցի",
        korrSchetParams: "20 թիվ՝ սկսած 301-ից և վերջացրած ԲԻԿ-ի վերջին 3 թվերով ",
        OKPOLength: "8 կամ 10 թիվ",
        OKPOCheckNumber: "Սխալ հսկիչ համար",
        twentySymbolsNoSpaces: "20 թիվ առանց բացատների",
        enterValue: "Այս դաշտը չպետք է դատարկ մնա",
        selectValue: "Ընտրեք նշանակությունը",
        requiredDigits: "Անհրաժեշտ է մուտքագրել {{number}} թիվ",
        fifteenDigits: "15 թիվ",
        thirteenDigits: "13 թիվ",
        datesNotInThePast: "Չի կարելի ընտրել ամսաթվեր անցյալում",
        dateInTheFuture: "Չի կարելի ընտրել ամսաթիվ անցյալում",
        dateInThePast: "Չի կարելի ընտրել ամսաթիվ ապագայում",
        isInvalidDate: "Անթույլատրելի ամսաթիվ",
        invalidDateFormat: "Մուտքագրեք ամսաթիվը ՕՕ.ԱԱ.ՏՏՏՏ ֆորմատով",
        wrongPhoneNumber: "Անթույլատրելի հեռախոսահամար",
        region: "Մուտքագրեք տարածաշրջանը",
        carNumber: "Մուտքագրեք համարը",
        lengthMessage: "նիշեր",
        maxLengthMessage: "Առավելագույնը {{max}} նիշ",
        upToEightSymbols: "Մինչև 8 նիշ",
        sixSevenSymbols: "6-7 նիշ",
        sixDigits: "Վեց թիվ",
        fourDigits: "Չորս թիվ",
        notAfterCurrent: "Տարին չպետք է ավելի շատ լինի {{currentYear}}",
        notBeforeMinYear: "Տարին չպետք է ավելի քիչ լինի {{currentYear}}",
        registrationNumber: "Գրանցման համար",
        egrpou: "ՈւՁԿՊՄԳ",
        unp: "ՀՎՀՀ (Բելառուս)",
        inn: "ՀՎՀՀ",
        bin: "ԲՆՀ",
        iin: "ԱՆՀ",
        // strings: {
        //     rateNds: "ԱԱՀ-ով",
        //     rateWithoutNds: "առանց ԱԱՀ",
        //     direct: "ուղիղ պայմ.",
        //     torg: "սակ.",
        //     payDays: "{0} բ/օրից",
        //     inFuel: "վառ.",
        //     prepayAlone: "կանխ.",
        //     prepay: "կանխ. {0}%",
        //     onLoad: "բեռնաթափ. ",
        //     onlyToSepCar: "առանձին մեքենա",
        //     dogruzPossible: "հնարավոր հավել. բեռ",
        //     dogruz: "հավել. բեռ",
        //     sborgruz: "հավաք. բեռ"
        // },
        duplicate_contractor_error: "Չի կարելի ավելացնել կոնտրագենտ: Այն արդեն ավելացվել է ձեր տեղեկատուում:",
        unknown_error: "Անհայտ սխալ",
        json_validation_error: "json վավերացման սխալ",
        partial_execution_error: "Կապ հաստատելու ընթացքում տեղի է ունեցել սխալ, ՏՄ պահպանված են",
        failed_save_trucks: "Որոշ ՏՄ չի հաջողվել պահպանել",
        failed_save_truck: "Չի հաջողվել պահպանել ՏՄ",
        customColumns: {
            historyBtn: "Բեռի պատմություն",
            copyBtn: "Կրկնօրինակել",
            addCommentBtn: "Գրել մեկնաբանություն",
            map: "Քարտեզ",
            orderStatus: "Կարգավիճակ",
            completion: "Ավարտ",
            date: "Ամսաթիվ",
            carrierContactPhone: "Փոխադրողի կոնտակտի համարը",
            carrierContact: "Փոխադրողի կոնտակտը",
            carrier: "Փոխադրող",
            cashRate: "Դրույքաչափ կանխիկ",
            rateWithoutVAT: "Դրույքաչափ առանց ԱԱՀ",
            rateWithVAT: "Դրույքաչափ ԱԱՀ-ով",
            offers: "Առաջ.",
            contact: "Կոնտակտ",
            contactWithDate: "Կոնտակտ, ավելացված է/փոխ.",
            driver: "Վարորդ",
            car: "ՏՄ",
            separateCar: "Առանձին մեքենա",
            loadingUnloadingCar: "ՏՄ բեռն./բեռնաթափ.",
            bodyType: "Թափքի տեսակը",
            loadParams: "Բեռի չափանիշները",
            unloading: "Բեռնաթափում",
            loading: "Բեռնում",
            routeAddress: "Երթուղու հասցե",
            route: "Երթուղի",
            loadNumber: "Բեռի համարը"
        },
        byDefault: "Լռելյայն ",
        columns: "Սյունակներ",
        informer: "Այժմ դուք կարող եք\nկարգավորել տվյալների արտատպումը\nկոմպակտ քարտերի վրա",
        verify: "Ստուգել",
        toTime: "մինչև",
        fromTime: "-ից",
        dateInputPlaceHolder: "ընտրեք ամսաթիվը",
        timeInputPlaceholder: '09:00',
        rate: "Դրույքաչափ",
        unloading: "Բեռնաթափում",
        loading: "Բեռնում",
        loadParams: {
            __html: "Քաշ, տ/ծավալ, մ<sup>3</sup>, բեռ"
        },
        transport: "Տրանսպորտ",
        direction: "Ուղղ.",
        roundTheClock: "շուրջօրյա",
        workdays: "աշխ. օրերին",
        everyday: "ամեն օր",
        loadReady: "պատրաստ է",
        alwaysReady: "միշտ",
        ExpandingSection: {
            showFullInfo: "Ցուցադրել ամբողջությամբ"
        },
        "as-ui-kit/src/controls/DocumentBlock/strings": {
            "js/ru/previousVersion": "նախորդ խմբագրումը",
            "js/ru/forContragent": "Փոխվել է կոնտրագենտի կողմից: Մինչ ձեր հաստատումը վավեր է",
            "js/ru/forChanger": "Մինչ կոնտրագենտի կողմից փոփոխությունների հաստատումը, գործում է",
            "js/ru/transportationOrder": "Փոխադրման հայտ",
            "js/ru/sentToCounterparty": "Ուղարկվել է կոնտրագենտին",
            "js/ru/sentThroughAtiDocs": "Ուղարկվել է ԱՏԻ-Դոկերի միջոցով",
            "js/ru/documentApprovedByTrucker": "Փաստաթուղթը հաստատված է փոխադրողի կողմից",
            "js/ru/documentApprovedByYou": "Փաստաթուղթը հաստատված է ձեր կողմից",
            "js/ru/documentSignedByTrucker": "Փաստաթուղթը ստորագրված է փոխադրողի կողմից",
            "js/ru/documentSignedByYou": "Փաստաթուղթը ստորագրված է ձեր կողմից",
            "js/ru/documentCreated": "Փաստաթուղթը ձևակերպված է ",
            "js/ru/awaitsReview": "Սպասում է ուսումնասիրման"
        },
        DealUpdateTime: {
            at: "-ին"
        },
        ConsultantsInfo: {
            workHours: "09:00-18:00 Մոսկվայի ժամանակով",
            autoparkConsultants: "Կօգնենք լցնել ձեր ավտոպարկը",
            dealsConsultants: "Կպատասխանենք Պատվերների վերաբերյալ հարցերին"
        },
        CancelButton: {
            moveToArchive: "Պահոց"
        },
        "as-ui-kit/src/controls/AtiSelect/AtiSelect": {
            "jsx/strings/clearValue": "Մաքրել"
        },
        AtiCarNumberInput: {
            otherCountries: "Այլ երկրներ",
            russia: "Ռուսաստան"
        },
        "as-ui-kit/src/controls/AtiCarNumberInput/AtiCarNumberInput": {
            "jsx/carPlaceholder": "М 123 ММ 78"
        },
        "as-ui-kit/src/controls/AddressCoordinatesInput/strings": {
            "js/ru/pickOnMap": "Ընտրել քարտեզի վրա",
            "js/ru/clearAddress": "Մաքրել",
            "js/ru/addressNotFound": "Հասցեն չի գտնվել, փորձեք",
            "js/ru/pointOnMap": "Ցույց տալ քարտեզի վրա",
            "en": {
                "js/DEFAULT_EXPORT/pickOnMap": "Ընտրել քարտեզի վրա"
            }
        },
        "as-ui-kit/src/const/unilateralOrder": {
            "js/paymentTypesOptions/paymentTypes": {
                "cash/name": "Կանխիկ",
                "cashlessWithNds/name": "ԱԱՀ-ով, անկանխ.",
                "cashlessWithoutNds/name": "Առանց ԱԱՀ, անկանխ."
            }
        },
        weekDaysLowerShortList: [
            "կիր",
            "երկ",
            "եր",
            "չոր",
            "հինգ",
            "ուրբ",
            "շբթ",
        ],
        weekDaysShortList: [
            "Կիր",
            "Երկ",
            "Եր",
            "Չոր",
            "Հինգ",
            "Ուրբ",
            "Շբթ",
        ],
        timeStrings: {
            months: [
                "հունվարի",
                "փետրվարի",
                "մարտի",
                "ապրիլի",
                "մայիսի",
                "հունիսի",
                "հուլիսի",
                "օգոստոսի",
                "սեպտեմբերի",
                "հոկտեմբերի",
                "նոյեմբերի",
                "դեկտեմբերի",
            ],
            shortMonths: [
                "հունվ",
                "փետ",
                "մարտ",
                "ապր",
                "մայ",
                "հուն",
                "հուլ",
                "օգ",
                "սեպ",
                "հոկ",
                "նոյ",
                "դեկ",
            ],
            year: "տ.",
            h: "ժ",
            d: "օր",
            min: "րոպե",
            sec: "վրկ",
            tomorrow: "վաղը",
            yesterday: "երեկ",
            today: "այսօր",
            at: "-ին",
        },
        MonthList: [
            "Հունվար",
            "Փետրվար",
            "Մարտ",
            "Ապրիլ",
            "Մայիս",
            "Հունիս",
            "Հուլիս",
            "Օգոստոս",
            "Սեպտեմբեր",
            "Հոկտեմբեր",
            "Նոյեմբեր",
            "Դեկտեմբեր",
        ],
        "as-ui-kit/src/const/sensors": {
            "js/errors/ru/errorCodes": {
                "AuthLimitError": "Մուտքի հասանելիությունը մերժվել է: Փորձեք կրկնել ավելի ուշ",
                "BLError": "Տեղի է ունեցել սխալ: Փորձեք կրկնել ավելի ուշ"
            },
            "js/providers/scout/name": "Սքաութ",
            "js/providers/wialon/name": "Վիալոն"
        },
        "as-ui-kit/src/const/scans": {
            "js/scanTypeNames/ru/scanTypes": {
                "marriage": "Ամուսնության վկայական",
                "rentContract": "Վարձակալության պայմանագիր",
                "carPhoto": "Լուսանկար",
                "plasticTechPassport": "ՏՄՀՎ",
                "techPassport": "ՏՄՏԱ",
                "passport": "Անձնագիր",
                "driverLicense": "ՎԻ"
            }
        },
        "as-ui-kit/src/const/requisites": {
            "js/defaultAddress/officeType": "գրաս.",
            "js/defaultAddress/partType": "մասն.",
            "js/defaultAddress/houseType": "շ.",
            "js/dictionaries/officeTypes/2/label": "սենյակ",
            "js/dictionaries/officeTypes/2/value": "սեն.",
            "js/dictionaries/officeTypes/1/label": "բնակարան",
            "js/dictionaries/officeTypes/1/value": "բն.",
            "js/dictionaries/officeTypes/0/label": "գրասենյակ",
            "js/dictionaries/officeTypes/0/value": "գր.",
            "js/dictionaries/partTypes/1/label": "շինություն",
            "js/dictionaries/partTypes/1/value": "շին.",
            "js/dictionaries/partTypes/0/label": "մասնաշենք",
            "js/dictionaries/partTypes/0/value": "մասն.",
            "js/dictionaries/houseTypes/1/label": "շինություն",
            "js/dictionaries/houseTypes/1/value": "շին.",
            "js/dictionaries/houseTypes/0/label": "շենք",
            "js/dictionaries/houseTypes/0/value": "շ.",
            "js/dictionaries/streetTypes/13/label": "փ/ա",
            "js/dictionaries/streetTypes/12/label": "գիծ",
            "js/dictionaries/streetTypes/11/label": "տրակտ",
            "js/dictionaries/streetTypes/10/label": "ալիք",
            "js/dictionaries/streetTypes/9/label": "անցում",
            "js/dictionaries/streetTypes/8/label": "զբոսայգի",
            "js/dictionaries/streetTypes/7/label": "ծառուղի",
            "js/dictionaries/streetTypes/6/label": "հրապարակ",
            "js/dictionaries/streetTypes/5/label": "ափամերձ պողոտա",
            "js/dictionaries/streetTypes/4/label": "նրբանցք",
            "js/dictionaries/streetTypes/3/label": "մայրուղի",
            "js/dictionaries/streetTypes/2/label": "պողոտա",
            "js/dictionaries/streetTypes/1/label": "փողոց",
            "js/dictionaries/streetTypes/0/label": "(այլ)",
            "js/dictionaries/residences/ru/4/label": "Այլ",
            "js/dictionaries/residences/ru/3/label": "Ղազախստան",
            "js/dictionaries/residences/ru/2/label": "Բելառուս",
            "js/dictionaries/residences/ru/1/label": "Ուկրաինա",
            "js/dictionaries/residences/ru/0/label": "Ռուսաստան"
        },
        "as-ui-kit/src/const/payDocs": {
            "js/mappedTransportCompanyNames/ru/1": "այլ",
            "js/payDocsLabels/ru/ClosingDocuments": "Փակող",
            "js/payDocsLabels/ru/Payment": "Վճարված է ",
            "js/payDocsLabels/ru/DocumentsOriginalTrack": "Թրեք-համար",
            "js/payDocsLabels/ru/DocumentsOriginal": "Բնօրինակները",
            "js/payDocsLabels/ru/DocumentsCopies": "Կրկնօրինակները",
            "js/payDocsName/ru/carrier/ClosingDocuments/name": "Փակող փաստաթղթերը ստացվել են",
            "js/payDocsName/ru/carrier/Payment/name": "Վճարումը ստացվել է",
            "js/payDocsName/ru/carrier/DocumentsOriginal/name": "Բնօրինակները ուղարկվել են",
            "js/payDocsName/ru/carrier/DocumentsCopies/name": "Փաստաթղթերի կրկնօրինակները ուղարկվել են",
            "js/payDocsName/ru/cargoOwner/Payment/name": "Վճարված է",
            "js/payDocsName/ru/cargoOwner/DocumentsOriginal/name": "Բնօրինակները ստացվել են",
            "js/payDocsName/ru/cargoOwner/DocumentsCopies/name": "Փաստաթղթերի կրկնօրինակները ստացվել են"
        },
        "as-ui-kit/src/const/index": {
            "js/undefinedError": "Անհայտ սխալ"
        },
        "as-ui-kit/src/const/files": {
            "js/fileSourceTypeNames/ru/dealFileSourceFileTypes": {
                "freeUse": "Անհատույց օգտագործման պայմանագիր",
                "truckPhoto": "Լուսանկար",
                "truckPlasticTechPassport": "Պլաստիկ",
                "truckTechPassport": "ՏՄՏԱ",
                "driverPassport": "Անձնագիր",
                "driverLicense": "ՎԻ"
            },
            "js/fileSourceNames/ru/dealFileSourceTypes": {
                "tractor": "քարշակի",
                "semiTrailer": "կիսակցորդի",
                "trailer": "կցորդի",
                "truck": "բեռնատարի",
                "driver": "վարորդի"
            }
        },
        documentTypes: {
            poa: "լիազորագիր",
            uniliteralDissolution: "ծանուցում կատարումից հրաժարվելու մասին",
            invoice: "հաշիվ",
            act: "ակտ",
            commission: "հանձնարարական էքսպեդիտորին",
            tableRequest: "պայմանագրի հայտ (աղյուսակի տեսքով)",
            request: "հայտ (պայմանագրի համար)",
            order: "պատվեր",
            tableOrder: "պատվեր (աղյուսակի տեսքով)",
            contract: "պատվեր (պայմանագիր-հայտ)"
        },
        displayedDocumentTypes: {
            commission: "Հանձնարարական էքսպեդիտորին",
            request: "Հայտ՝ փաստաթղթի ձևով",
            tableRequest: "հայտ՝ աղյուսակի ձևով",
            order: "Պատվեր՝ փաստաթղթի տեսքով",
            tableOrder: "Պատվեր՝ աղյուսակի տեսքով",
        },
        docTypesGroups: [
            "Առաջին անգամ եք աշխատում կոնտրագենտի հետ",
            "Առկա է պայմանագիր",
            "Աշխատում եք տրանսպորտային էքսպեդիտորական պայմանագրով",
        ],
        additionalDocuments: {
            cancelDeal: "Ծանուցում կատարումից հրաժարվելու մասին",
            poa: "Լիազորագիր",
            invoice: "Հաշիվն՝ ըստ հայտի",
            act: "Ակտ (երկկողմ)",
        },
        cancelDocuments: {
            refusalOfFulfilment: "Ծանուցում կատարումից հրաժարվելու մասին",
        },
        "as-ui-kit/src/const/documents": {
            "js/docTypeTemplates/contract": "պայմանագիր",
        },
        auctionPaymentTypes: {
            25: "առանց ԱԱՀ",
            24: "ԱԱՀ-ով",
            23: "քարտին",
            1: "կանխ",
            0: "ցանկացած"
        },
        ton: "տ",
        weight: "Քաշ",
        to: "մինչև",
        from: "սկսած",
        meter: "մ",
        volume: "Ծավալ",
        TruckIcon: {
            carInGratuitousUseVerifiedTooltip: "Հաստատված ՏՄ՝ անհատույց օգտագործման",
            carInGratuitousUseTooltip: "ՏՄ՝ անհատույց օգտագործման",
            carInSousesJointOwnershipVerifiedTooltip: "Հաստատված ՏՄ՝ որպես ամուսինների համատեղ սեփականություն",
            carInSousesJointOwnershipTooltip: "ՏՄ՝ որպես ամուսինների համատեղ սեփականություն",
            carExternalTooltip: "Ներգրավված ՏՄ",
            carOwnVerifiedTooltip: "Հաստատված սեփական ՏՄ",
            carOwnTooltip: "Սեփական ՏՄ",
            carInLeasingVerifiedTooltip: "Հաստատված ՏՄ լիզինգով",
            carInLeasingTooltip: "ՏՄ լիզինգով",
            carInRentVerifiedTooltip: "Հաստատված ՏՄ՝ վարձակալությամբ",
            carInRentTooltip: "Վարձակալությամբ ՏՄ"
        },
        TrackerStatus: {
            promoAction: "Ինչպես է դա աշխատում",
            promoHeader: "Այժմ բեռը կարելի է հետևել քարտեզի վրա՝ վարորդի համար նախատեսված հավելվածի միջոցով"
        },
        LastActive: {
            exclusivePopoverLinkText: "բացառիկ մուտքի հասանելիություն:",
            ago: "հետ",
            activity: "ակտիվություն",
            exclusiveAccess: "Այլ ընկերության բացառիկ մուտքի հասանելիություն",
            installed: "սահմանված է",
            hasTracker: "ԱՏԻ Վարորդ"
        },
        Invite: {
            car: {
                cantInviteTooltip: 'Приглашение можно выслать только на мобильный номер телефона. У водителя указан не мобильный. Телефон можно изменить в вашем Справочнике Водителей',
                tooManyRequests: "Հրավերն ուղարկելու փորձերը չափազանց շատ են: Փորձեք ավելի ուշ",
                toApp: "սահմանել",
                invited: "Հրավերն ուղարկված է",
                invite: "Ուղարկել հրավեր",
                undefinedError: "Անհայտ սխալ",
                cantInvite: "Այս պատվերի վարորդին չի կարելի հրավիրել",
                alreadyInvited: "Դուք արդեն ուղարկել եք հրավեր այս վարորդին: Փորձեք ավելի ուշ",
                resend: "Կրկին հրավիրել",
                atiTrucker: "ԱՏԻ Վարորդ"
            },
            driver: {
                                cantInviteTooltip: 'Приглашение можно выслать только на мобильный номер телефона. У водителя указан не мобильный. Телефон можно изменить в вашем Справочнике Водителей',

                tooManyRequests: "Վարորդին հրավիրելու փորձերը չափազանց շատ են: Փորձեք ավելի ուշ",
                toApp: "սահմանել",
                invited: "Վարորդը հրավիրված է",
                sent: "ուղարկվել է",
                invite: "Հրավեր",
                inviteDriver: "Հրավիրել վարորդ",
                undefinedError: "Անհայտ սխալ",
                cantInvite: "Այս պատվերի վարորդին չի կարելի հրավիրել",
                alreadyInvited: "Դուք արդեն ուղարկել եք հրավեր այս վարորդին: Փորձեք ավելի ուշ",
                resend: "Կրկին հրավիրել",
                atiTrucker: "ԱՏԻ Վարորդ"
            }
        },
        InvitePopover: {
            car: {
                exclusiveDescription:
                    'Только вы сможете отправлять\n' +
                    'заказы водителю, получать\n' +
                    'актуальные статусы перевозки,\n' +
                    'отслеживать местоположение\n' +
                    'груза на карте.',
                smsIsSent: "Հեռախոսահամարին հաղորդագրություն է ուղարկվել",
                caption: "Հեռախոսահամարին հաղորդագրություն կուղարկվի՝ հավելվածի ներբեռնման հղումով",
                invite: "Ուղարկել հրավեր",
                exclusiveAccess: "Բացառիկ մուտքի հասանելիություն նրա ԱՏԻ Վարորդին",
                onlyAndroid: "Հավելվածը գործում է միայն Android-ի վրա",
                sendSms: "Ուղարկել SMS",
                atiDriver: "ԱՏԻ Վարորդ"
            },
            driver: {
                exclusiveDescription:
                    'Только вы сможете отправлять\n' +
                    'заказы водителю, получать\n' +
                    'актуальные статусы перевозки,\n' +
                    'отслеживать местоположение\n' +
                    'груза на карте.',
                smsIsSent: "Վարորդին ուղարկվել է սմս",
                caption: "Վարորդին կուղարկվի հաղորդագրություն հավելվածի ներբեռնման հղումով",
                invite: "Հրավիրել վարորդ",
                exclusiveAccess: "Բացառիկ մուտքի հասանելիություն նրա ԱՏԻ Վարորդին",
                onlyAndroid: "Հավելվածը գործում է միայն Android-ի վրա",
                sendSms: "Ուղարկել SMS",
                atiDriver: "ԱՏԻ Վարորդ"
            }
        },
        "as-ui-kit/src/components/TrackerLink/strings": {
            "js/ru/atiTrucker": "ԱՏԻ Վարորդ"
        },
        "as-ui-kit/src/components/TrackerIcon/strings": {
            "js/ru/howToUseTracker": "ԱՏԻ Վարորդ. ինչպես ներբեռնել և օգտագործել"
        },
        "as-ui-kit/src/components/TrackerAppInfoPopover/strings": {
            "js/ru/trackerFeatures": "ԱՏԻ Վարորդի հնարավորությունները",
            "js/ru/atiTracker": "ԱՏԻ Վարորդ"
        },
        "as-ui-kit/src/components/Signee/Signee": {
            "jsx/strings/useByDefault": "Գործածում լռելյայն",
            "jsx/strings/signee": "Ստորագրող",
            "jsx/strings/remove": "ջնջել",
            "jsx/strings/positionInGenitive": "Պաշտոնը՝ սեռական հոլովով",
            "jsx/strings/fullNameInGenitive": "ԱԱՀ-ն՝ սեռական հոլովով",
            "jsx/strings/actUponWhatText": "Ինչի հիման վրա է գործում: Օրինակ, «Կանոնադրության ...», « №...Լիազորագրի» "
        },
        ShortFirmInfo: {
            recommend: "Խորհուրդ տալ"
        },
        "as-ui-kit/src/components/SensorActivateLink/strings": {
            "js/ru/reauthorizationRequired": "Պահանջվում է կրկնակի նույնականացում",
            "js/ru/inactive": "Ակտիվ չէ"
        },
        "as-ui-kit/src/components/SearchLoad/strings": {
            "js/ru/unloading": "Բեռնաթափում",
            "js/ru/loading": "Բեռնում",
            "js/ru/loadParams/__html": "Քաշ, տ/ծավալ, մ<sup>3</sup>, բեռ",
            "js/ru/transport": "Տրանսպորտ",
            "js/ru/direction": "Ուղղ."
        },
        "as-ui-kit/src/components/SearchLoad/SearchLoadParams/strings": {
            "js/ru/widthShort": "Լ",
            "js/ru/sborgruz": "հավաք. բեռ",
            "js/ru/onlyToSepCar": "առանձին մեքենա",
            "js/ru/meters": "մ",
            "js/ru/load": "Բեռ",
            "js/ru/lengthShort": "Ե",
            "js/ru/items": "հատ",
            "js/ru/heightShort": "Բ",
            "js/ru/dogruzPossible": "հնար. հավելյալ բեռ",
            "js/ru/dogruz": "հավելյալ բեռ"
        },
        "as-ui-kit/src/components/SearchLoad/LoadUnloading/RouteThrough/strings": {
            "js/ru/through": "գնալ."
        },
        "as-ui-kit/src/components/SearchLoad/LoadUnloading/CustomsOnRoute/strings": {
            "js/ru/custom": "մաքսատուն."
        },
        "as-ui-kit/src/components/SearchLoad/LoadTransport/strings": {
            "js/ru/capacity": "բ/տ {{number}} տ,",
            "js/ru/onlyToSepCar": "առանձին մեքենա.",
            "js/ru/dogruzPossible": "հնար. հավելյալ բեռ",
            "js/ru/dogruz": "հավելյալ բեռ",
            "js/ru/beltOther": "գոտի",
            "js/ru/beltMany": "գոտի",
            "js/ru/beltFew": "գոտի",
            "js/ru/beltOne": "գոտի",
            "js/ru/sanPassport": "բժշկական գրքույկ",
            "js/ru/loadUnload": "բեռնում/բեռնաթ",
            "js/ru/unload": "բեռնաթ",
            "js/ru/load": "բեռն.",
            "js/ru/pnevmohod": "պնևմո",
            "js/ru/stsepka": "քարշակ",
            "js/ru/koniki": "կոնիկներ",
            "js/ru/cars": "մեք."
        },
        "as-ui-kit/src/components/SearchLoad/LoadRate/strings": {
            "js/ru/allTermsInATIDocs": "բոլոր պայմանները ԱՏԻ-Դոկերի հայտում",
            "js/ru/cashlessAll": "անկանխիկ ԱԱՀ-ով, առանց ԱԱՀ",
            "js/ru/cashlessWithoutVat": "անկանխիկ առանց ԱԱՀ",
            "js/ru/cashlessWithVat": "անկանխիկ ԱԱՀ-ով",
            "js/ru/cash": "կանխիկ",
            "js/ru/bargainOff": "առանց սակարկության",
            "js/ru/undefined": "ԱԱՀ-ով",
            "js/ru/direct": "ուղիղ պայմ.",
            "js/ru/bargainOn": "սակ.",
            "js/ru/payDays": "{0} աշ./օրից",
            "js/ru/prepayAlone": "կանխավճ.",
            "js/ru/inFuel": "վառ.",
            "js/ru/prepay": "կանխ. {0}%",
            "js/ru/onLoad": "բեռնաթափման",
            "js/ru/inquireLoad": "դրույքաչափի հարցում",
            "js/ru/noLoad": "բեռ չկա, դրույքաչափի հարցում"
        },
        "as-ui-kit/src/components/SearchLoad/LoadDirection/strings": {
            "js/ru/km": "կմ",
            "js/ru/seePath": "տեսնել երթուղին",
            "js/ru/krugoreis": "շրջանաձև երթուղի"
        },
        cardsCompact: "Քարտերի կոմպակտ տեսք",
        cards: "Քարտերի սովորական տեսք",
        appearance: "Տեսք",
        RejectOrder: {
            restoreLot: "Լոտը կրկին կհրապարակվի միևնույն հարթակներում:",
            restoreLoad: "վերականգնել բեռը",
            toArchive: "Պահոց",
            move: "տեղափոխել",
            cancelDeals: ", Սակարկությունները չեղարկել",
            inArchive: "Պահոցում",
            leftLoad: "թողնել բեռը",
            publicLoadWithoutDeal: "տեղադրել բեռն առանց Սակարկությունների",
            restartDeal: "վերսկսել Սակարկությունները",
            rubles: "ռուբլի",
            withRate: "դրույքաչափով",
            chooseWinner: "ընտրել հաղթող",
            noReasonWarning: "Նշեք չեղարկման պատճառը",
            reasonRejectionOffer: "Նշեք առաջարկի չեղարկման պատճառը",
            whatHappenedWithLoads: "Ինչ անել բեռը",
            popoverWarning: "Պատվերը կտեղափոխվի պահոց և կնշվի որպես չեղարկված"
        },
        "as-ui-kit/src/components/PopupWarning/strings": {
            "js/ru/notToSave": "Չպահպանել",
            "js/ru/save": "Պահպանել",
            "js/ru/edit": "Խմբագրել",
            "js/ru/p2": "Փոփոխությունները կարող են կորել:",
            "js/ru/p1": "Դուք չեք պահպանել փոփոխությունները և փորձում եք փակել պատուհանը:",
            "js/ru/header": "Ի՞նչ անել փոփոխությունները:"
        },
        Selected: {
            showAll: "Ցուցադրել ամբողջությամբ"
        },
        "as-ui-kit/src/components/PhoneForm/strings": {
            "js/ru/phoneInCar": "Բջջային սարքավորում՝ տեղադրված տրանսպորտային միջոցի մեջ",
            "js/ru/exclusiveAccess": "Բացառիկ մուտքի հասանելիություն նրա ԱՏԻ Վարորդին",
            "js/ru/phone": "Հեռախոս"
        },
        "as-ui-kit/src/components/PhoneForm/TrackerInfo/strings": {
            "js/ru/promo": "Նշեք բջջային հեռախոսը, որպեսզի  հղումը ուղարկեք հավելվածին ",
            "js/ru/invitedHint": "Կուղարկվի հաղորդագրություն՝ հղումով",
            "js/ru/atiTrucker": "ԱՏԻ Վարորդ"
        },
        "as-ui-kit/src/components/PhoneForm/TrackerInfo/BindOwn/strings": {
            "js/ru/bindingTypes": {
                "driver": "դեպի Վարորդը",
                "car": "դեպի ՏՄ"
            },
            "js/ru/goToAutopark": "Անցնել Ավտոպարկ",
            "js/ru/goToCatalog": "Անցնել Տեղեկատու",
            "js/ru/alreadyAttached": "Այս համարն արդեն կցված է հավելվածում"
        },
        "as-ui-kit/src/components/PhoneForm/TrackerInfo/BindOther/strings": {
            "js/ru/carFromAnother": "Դուք չեք կարող ՏՄ-ն կցել [[AppLink]][[Break]] հավելվածին, քանի որ այն կցված է ընկերությանը",
            "js/ru/employedToAnotherFirm": "Դուք չեք կարող այս վարորդին պատվերներ ուղարկել [[Break]][[AppLink]]-ի միջոցով, քանի որ նա հանդիսանում է ընկերության աշխատակիցը",
            "js/ru/atiTrucker": "ԱՏԻ Վարորդ"
        },
        "as-ui-kit/src/components/PhoneForm/BindingStatus/strings": {
            "js/ru/resend": "Կրկին ուղարկել",
            "js/ru/driverRejected": "Հարցումը մերժված է",
            "js/ru/cancel": "Չեղարկել",
            "js/ru/sent": "Հարցումն ուղարկված է",
            "js/ru/sendRequest": "Ուղարկել հարցում"
        },
        PayDocsStatus: {
            infoTextForCargoOwner:
                'Перевозчик может добавить трек-номер \nотправленных документов прямо к Заказу.\n' +
                'Вы получите уведомление, добавится статус \nв разделе «Документооборот и оплата», после чего \nвы сможете отслеживать посылку на сайте Службы \nдоставки.',
            trackNotExist: "Թրեք-համարը նշված չէ",
            learnMore: "Իմանալ ավելին",
            carrierTrack: "Առաքանու թրեք-համարը փոխադրողից",
            addTrackNumber: "Ավելացնել թրեք-համարը (հետևելու համարը) ուղարկման համար",
            choosePaymentStatus: "Ընտրեք ՓՇ և վճարման կարգավիճակը",
            tooltipText: "Այն բանից հետո, երբ դուք ավելացնեք թրեք-համարը, Պատվիրատուն կստանա ծանուցում և կկարողանա հետևել ուղարկմանը առաքման ծառայության կայքում:",
            availableToCustomer: "(հասանելի է Պատվիրատուին)",
            trackNumber: "թրեք-համար",
            status: "կարգավիճակ",
            paymentStatusHint: "(տեսանելի է միայն ձեզ)",
            paymentStatus: "Փաստթղթաշրջանառություն և վճարում"
        },
        "as-ui-kit/src/components/PayDocsStatus/StatusLabel/strings": {
            "js/ru/changeTrackNumber": "Փոխել թրեք-համարը (հետևելու համարը) ուղարկման համար",
            "js/ru/cancelDelete": "Չհեռացնել",
            "js/ru/delete": "Հեռացնել",
            "js/ru/deleteTrackNumber": "Հեռացնե՞լ թրեք-համարը անվերադարձ:",
            "js/ru/defaultCompanyName": "առաքման ծառայություններ",
            "js/ru/ofCompany": "ընկերություններ",
            "js/ru/trackInWebsite": "Հետևել կայքում",
            "js/ru/trackNumberCopied": "Թրեք-համարը կրկնօրինակված է",
            "js/ru/header": "Թրեք-համար",
            "js/ru/trackNumber": "թրեք-համար"
        },
        "as-ui-kit/src/components/PayDocsStatus/PayDocTrackPopover/strings": {
            "js/ru/trackNotExist": "Թրեք-համարը նշված չէ",
            "js/ru/learnMore": "Իմանալ ավելին",
            "js/ru/carrierTrack": "Առաքանիի թրեք-համարը Փոխադրողից",
            "js/ru/trackNumberForShipment": "թրեք-համարը (հետևելու համարը) ուղարկման համար",
            "js/ru/trackNumber": "թրեք-համար",
            "js/ru/change": "Փոխել",
            "js/ru/add": "Ավելացնել"
        },
        "as-ui-kit/src/components/PayDocsStatus/ChooseStatusForm/StatusFormRow/strings": {
            "js/ru/availableToCustomer": "(հասանելի է Պատվիրատուին)",
            "js/ru/tooltipText": "Այն բանից հետո, երբ դուք ավելացնեք թրեք-համարը, Պատվիրատուն կստանա ծանուցում և կկարողանա հետևել ուղարկմանը առաքման ծառայության կայքում:",
            "js/ru/trackNumber": "թրեք-համար",
            "js/ru/addTrackNumber": "Ավելացնել թրեք-համարը",
            "js/ru/chooseDate": "ընտրեք ամսաթիվը"
        },
        cancel: "Չեղարկում",
        "as-ui-kit/src/components/PayDocsStatus/ChooseStatusForm/StatusFormFooter/strings": {
            "js/ru/finishOfferRequestError": "Փոխադրման ավարտի ժամանակ տեղի է ունեցել սխալ:",
            "js/ru/saveAndArchive": "Պահոց",
            "js/ru/save": "Պահպանել"
        },
        "as-ui-kit/src/components/PayDocsStatus/ChangeTrackForm/TrackFormRow/strings": {
            "js/ru/chooseDate": "Ընտրեք ամսաթիվը",
            "js/ru/sendDate": "Ուղարկման ամսաթիվը",
            "js/ru/inputError": "Թրեք-համարը պետք է պարունակի միայն թվեր և լատինատառեր",
            "js/ru/trackNumber": "Թրեք-համար",
            "js/ru/trackUrl": "Առաքման ծառայության կայքի հղումը",
            "js/ru/chooseTransportCompany": "Ընտրեք առաքման ծառայություն",
            "js/ru/transportCompany": "Առաքման ծառայություն",
            "js/ru/body": "Այն բանից հետո, երբ դուք ավելացնեք թրեք-համարը, Պատվիրատուն կստանա ծանուցում և կկարողանա հետևել ուղարկմանը առաքման ծառայության կայքում:"
        },
        "as-ui-kit/src/components/PayDocsStatus/ChangeTrackForm/TrackFormFooter/strings": {
            "js/ru/cantSaveForm": "Դուք չեք կարողանա պահպանել թրեք-համարը, քանի դեռ բոլոր պարտադիր դաշտերը լրացված չեն",
            "js/ru/delete": "Հեռացնել թրեք-համարը",
            "js/ru/save": "Պահպանել",
            "js/ru/cancel": "Չավելացնել",
            "js/ru/add": "Ավելացնել թրեք-համարը"
        },
        "as-ui-kit/src/components/PayDocsStatus/ChangeTrackForm/TrackFormFooter/ConfirmDeletePopover/strings": {
            "js/ru/dontDelete": "Չհեռացնել",
            "js/ru/delete": "Հեռացնել",
            "js/ru/confirmDelete": "Հեռացնե՞լ թրեք-համարն անվերադարձ:"
        },
        ParticipantsPopup: {
            noPermissionsText: "Բեռի հետ աշխատանքն իրականցավում է միայն բեռի ստորաբաժանմանը հասանելիություն ունեցող աշխատակիցների կողմից",
            anotherPtWinner: "Հաղթել է միջանցիկ Սակարկությունների այլ մասնակից",
            update: "Թարմացնել",
            noWinners2: "Չեղարկեք Սակարկությունները և կրկին վերսկսեք",
            noWinners1: "Հաղթողներ չկան:",
            winnerRemovedFromBoard2: "Ընրեք այլ",
            winnerRemovedFromBoard1: "Հաղթողը հեռացվել է Հարթակից:",
            winnerTimeExpiredNoNext2: "կամ սկսել Սակարկությունները նորից",
            winnerTimeExpired2: "կամ ընտրել հաջորդ մասնակցին",
            waitForWinner: "Դուք կարող եք սպասել հաղթողի տվյալներին",
            finished: "Սակարկություններն ավարտվել են:",
            untilEnd: "մինչև Սակարկությունների ավարտը:",
            startRate: "սկզբնական դրույքաչափ:",
            participants: {
                other: "մասնակից",
                many: "մասնակից",
                few: "մասնակից",
                one: "մասնակից"
            },
            noParticipants: "Չկան մասնակիցներ",
            Participant: {
                atrucksTooltip: "Կողմնակի համակարգ տրանսպորտային ընկերությունների հետ աշխատանքը ավտոմատացնելու համար",
                ptParticipant: "Միջանցիկ Սակարկությունների մասնակից",
                tooltipRate: "Մասնակիցը դրույքաչափ է կատարել",
                bestRateAndDate: "Լավագույն դրույքաչափ և ամսաթիվ",
                bestDate: "Լավագույն ամսաթիվ",
                bestRate: "Լավագույն դրույքաչափ",
                or: "կամ",
                noAccessText: "Դուք չունեք իրավունք այդ գործողությունը կատարելու համար: Դիմեք ադմինիստրատորին՝ իրավունքներ ստանալու համար:",
                yearStr: "տ.",
                shouldSend: ["Հաղթողը պետք է ձեզ տրամադրի հայտի համար տվյալներ ", ""],
                dontSend: "Հաղթողը դեռ չի տրամադրել ձեզ հայտի համար տվյալներ:",
                winnerConfirmed2: "պատվերներում",
                winnerConfirmed1: "Հաղթողը վերցրել է բեռը: Տեսեք վարորդի կամ ՏՄ մասին տվյալները",
                exWinner: "Դուք մերժել եք այս մասնակցի առաջարկը:",
                shipperRefused: "Պատվերը չեղարկվել է բեռի սեփականատիրոջ կողմից",
                carrierRefused: "Փոխադրողը հրաժարվել է Պատվերին մասնակցությունից",
                refused: "Մասնակիցը հրաժարվել է Սակարկություններին մասնակցությունից:",
                skipped: "Չի տրամադրել տվյալները ժամանակին:",
                winnerRemovedFromBoard: "Հաղթողը հեռացված է Հարթակից:",
                removedFromBoard: "Մասնակիցը հեռացված է Հարթակից:"
            },
        },
        loadingDate: "Պատրաստ է",
        participant: "Մասնակից",
        outputStrings: "Հանել տողեր",
        orderLoadNumber: "Բեռի/լոտի/պատվերի № ",
        orderNumber: "Պատվերի № ",
        "as-ui-kit/src/components/OfferTracker/TrackerSummary/LinkToRouteOnMap/strings": {
            "js/ru/routeOnMap": "Երթուղին քարտեզի վրա"
        },
        "as-ui-kit/src/components/OfferTracker/TrackerSummary/FinishedStatusView/strings": {
            "js/ru/eventDateTime": "{{day}} {{time}}-ին",
            "js/ru/driverRevoked": "Վարորդին հետ են կանչել պատվերից",
            "js/ru/driverRejectedDeal": "Վարորդը հրաժարվել է պատվերից",
            "js/ru/driverFinishedDeal": "Վարորդն ավարտել է պատվերը",
            "js/ru/cancelledDeal": "չեղարկել է պատվերը",
            "js/ru/finishedDeal": "ավարտել է պատվերը"
        },
        "as-ui-kit/src/components/OfferTracker/TrackerSummary/Accidents/strings": {
            "js/ru/4": "տվյալներ չկային",
            "js/ru/3": "երթուղու մի հատվածն՝ անջատված GPS-ով",
            "js/ru/2": "խափանում",
            "js/ru/1": "ՃՏՊ",
            "js/ru/0": "GPS կեղծման փորձ"
        },
        "as-ui-kit/src/components/OfferTracker/TrackerInWorkStatus/strings": {
            "js/ru/driverWillSendDataFromApp": "Վարորդը վերցրել է պատվերը, բայց դեռ չի սկսել աշխատել",
            "js/ru/ed": "փոխ.",
            "js/ru/fromApp": "ԱՏԻ Վարորդ հավելվածից"
        },
        "as-ui-kit/src/components/OfferTracker/TooltipMessage/strings": {
            "js/ru/gpsSpoof": "վարորդի հեռախոսի մեջ միացված է ֆունկցիա, որը հնարավորություն է տալիս կեղծել GPS ({{initialPhone}}):",
            "js/ru/gpsOff": "վարորդի հեռախոսի կարգավորումներում անջատված է GPS-ը ({{initialPhone}}): Գտնվելու վայրի մասին տեղեկություններ չկան:",
            "js/ru/noData": "տվյալները դադարել են գալ: Հնարավոր է, որ վարորդի հեռախոսն անջատված է կամ միացված չէ համացանցին ({{initialPhone}}):",
            "js/ru/youAndOwner": "ձեզ և պատվիրատուին",
            "js/ru/onlyYou": "միայն ձեր ընկերությանը",
            "js/ru/rejectionInfoAvailable": "Մերժման վերաբերյալ տեղեկատվությունը հասանելի է",
            "js/ru/infoAvailable": "Տեղեկատվությունը հասանելի է",
            "js/ru/dataAvailable": "Հավելվածի քարտեզն ու պատվերի կարգավիճակը հասանելի են",
            "js/ru/activity": "{{lastActive}} Ակտիվությունը ԱՏԻ Վարորդ  հավելվածում ({{initialPhone}}):"
        },
        "as-ui-kit/src/components/OfferTracker/StatusDescriptions/strings": {
            "js/ru/notConfirmed": "Վարորդը չի հաստատել հավելվածում պատվերի ընդունումն ",
            "js/ru/finishedByCounterpart": "[[FirmName]] ավարտել է պատվերը",
            "js/ru/finished": "Վարորդն ավարտել է պատվերը",
            "js/ru/revoked": "Դուք հետ եք կանչել պատվերը",
            "js/ru/notSentDataExpected": "Նշեք տվյալները բեռնափոխադրման համար, որպեսզի պատվերն ուղարկեք վարորդին",
            "js/ru/notSent": "Վարորդի համար տվյալները նշված չեն",
            "js/ru/rejectionReason": "հրաժարվելու պատճառը",
            "js/ru/rejected": "Վարորդը հրաժարվել է պատվերից",
            "js/ru/sent": "Պատվերն ուղարկվել է [[DriverPhone]]: Վարորդը դեռ չի ընդունել պատվերն աշխատանքի մեջ",
            "js/ru/sentShort": "Պատվերն ուղարկվել է",
            "js/ru/sendToSeeOnMap": "Պատվերն ուղարկեք հավելված, որպեսզի տեսնեք բեռը քարտեզի վրա",
            "js/ru/awaitingDriver": "Սպասում ենք մինչև վարորդն սկսի պատվերը",
            "js/ru/carrierRevoked": "Փոխադրողը պատվերը հետ է կանչել վարորդից: Նոր տվյալներ դեռ չկան"
        },
        "as-ui-kit/src/components/OfferTracker/StatusBadge/strings": {
            "js/ru/gpsSpoof": "GPS-ի կեղծում",
            "js/ru/gpsOff": "GPS անջատված է",
            "js/ru/finished": "պատվերն ավարտված է",
            "js/ru/revoked": "պատվերը հետ է կանչվել",
            "js/ru/rejected": "հրաժարում պատվերից",
            "js/ru/notInWork": "աշխատանքի մեջ չէ",
            "js/ru/inWork": "աշխատանքի մեջ է",
            "js/ru/sent": "պատվերն ուղարկվել է",
            "js/ru/notSent": "պատվերը չի ուղարկվել",
            "js/ru/noData": "տվյալներ չկան",
            "js/ru/atiTrucker": "ԱՏԻ Վարորդ"
        },
        "as-ui-kit/src/components/OfferTracker/StateWithoutDriver/strings": {
            "js/ru/toWatchCargoOnMap": ", որպեսզի տեսնեք բեռը քարտեզի վրա",
            "js/ru/inAtiDriver": "ԱՏԻ Վարորդ",
            "js/ru/addDriverInOrder": "Ավելացրեք վարորդին պատվերին և հրավիրեք նրան",
            "js/ru/addDriver": "Ավելացրեք վարորդին պատվերին և նրան հրավեր ուղարկեք"
        },
        "as-ui-kit/src/components/OfferTracker/PresenceLoading/strings": {
            "js/ru/loading": "ներբեռնում ենք տվյալները...",
            "js/ru/hasTracker": "ԱՏԻ Վարորդ"
        },
        "as-ui-kit/src/components/OfferTracker/NoTrackerAccess/strings": {
            "js/ru/atiTrucker": "ԱՏԻ Վարորդ"
        },
        "as-ui-kit/src/components/OfferTracker/NoInWorkAccess/strings": {
            "js/ru/carrierReceivesFromApp": "Փոխադրողը ստանում է կարգավիճակները ԱՏԻ Վարորդ հավելվածից",
            "js/ru/changingStatuses": "Կարգավիճակների փոփոխությունն անհասանելի է"
        },
        "as-ui-kit/src/components/OfferTracker/MapActionsContainer/strings": {
            "js/ru/dialogDescription": "ԱՏԻ Վարորդ",
            "js/ru/chat": "Չաթ",
            "js/ru/shareLinkDescription": "կիսվել հղումով",
            "js/ru/shareLink": "կիսվել հղումով",
            "js/ru/sharedWithCounterpartyDescription": "տեսանելի է ձեզ և պատվիրատուին",
            "js/ru/onlyForYouDescription": "տեսանելի է միայն ձեզ",
            "js/ru/sharedWithCounterparty": "Տեսանելի է ձեզ և պատվիրատուին",
            "js/ru/onlyForYou": "Տեսանելի է միայն ձեզ",
            "js/ru/map": "Քարտեզ"
        },
        "as-ui-kit/src/components/OfferTracker/MainActions/strings": {
            "js/ru/revokeData": "Հետ կանչել պատվերը",
            "js/ru/dataForDriver": "Տվյալներ վարորդի համար",
            "js/ru/configure": "Կարգավորել",
            "js/ru/resendOrder": "Ուղարկել կրկնակի",
            "js/ru/sendOrder": "Ուղարկել պատվերը",
            "js/ru/setData": "Նշել տվյալները"
        },
        ActionsButtons: {
            dialogDescription: "ԱՏԻ Վարորդ",
            chat: "Չաթ",
            shareLink: "կիսվել հղումով",
            sharedWithCounterpartyDescription: "տեսանելի է ձեզ և պատվիրատուին",
            onlyForYouDescription: "տեսանելի է միայն ձեզ",
            sharedWithCounterparty: "Տեսանելի է ձեզ և պատվիրատուին",
            onlyForYou: "Տեսանելի է միայն ձեզ",
            map: "Քարտեզ"
        },
        InDevelopmentButton: {
            inDev: "Մշակվում է"
        },
        OfferInformationDriver: {
            willProvideDataLater: "Կնշեմ տվյալներն ավելի ուշ",
            fromDealModifier: "(գործարքից)",
            registration: "Գրանցում",
            seriesNumber: "Սերիա, համար",
            selectDriver: "Ընտրեք վարորդ",
            searchDrivers: "Որոնում ըստ վարորդների",
            driverLicense: "Վարորդական իրավունք",
            passportIssuedWhen: "Տրման ամսաթիվը",
            passportIssued: "Տրվել է",
            passportNumber: "Համարը",
            passportSeries: "Սերիա",
            passport: "Անձնագիր",
            enlistedDriver: "ներգրավված վարորդ",
            enlisted: "ներգրավված",
            edit: "Խմբագրել",
            driverNotFound: "Վարորդը չի գտնվել",
            driver: "Վարորդ",
            clickToAddDriver: "Սեղմեք, որպեսզի ավելացնեք նորը",
            addDriver: "Ավելացնել վարորդ"
        },
        UseTrackerCheck: {
            fromTracker: "ԱՏԻ Վարորդից",
            shareData: "Կիսվել տվյալներով պատվիրատուի հետ"
        },
        OfferInformationDriverFooter: {
            editHint: "որպեսզի այս վարորդին պատվերներ ուղարկեք ԱՏԻ Վարորդ",
            editHintLink: "Նշեք բջջ. հեռախոսի համարը",
            willNotShare: "ԱՏԻ Վարորդից քարտեզը և պատվերի կարգավիճակը հասանելի են միայն ձեզ",
            willShare: "Դուք պատվիրատուի հետ կիսվում եք ԱՏԻ Վարորդի քարտեզով և պատվերի կարգավիճակով",
            nlistedDriver: "ներգրավված վարորդ"
        },
        TrackerSharing: {
            howTrackerWorks: "Ինչպես է աշխատում ԱՏԻ Վարորդը",
            youWillSee: "Դուք կարող եք տեսնել բեռը քարտեզի վրա և պատվերի ակտուալ կարգավիճակը:",
            carrierWillShare: "Փոխադրողը կիսվելու է ԱՏԻ Վարորդի տվյալներով"
        },
        OfferInformationCar: {
            willProvideDataLater: "Կնշեմ տվյալներն ավելի ուշ",
            fromDealTip: "Պատվերից",
            fromDealModifier: "(գործարքից)",
            remove: "Հեռացնել",
            unknownCarType: "թափքի անհայտ տեսակ",
            vehicle: "ՏՄ",
            clickToAddVehicle: "Սեղմեք, որպեսզի ավելացնեք նոր",
            vehicleNotFound: "Մեքենան չի գտնվել",
            edit: "Խմբագրել",
            chooseSemiTrailer: "Ընտրեք կիսակցորդ",
            chooseTrailer: "Ընտրեք կցորդ",
            chooseVehicle: "Ընտրեք ՏՄ",
            searchVehicles: "Որոնում ըստ ՏՄ",
            addVehicle: "Ավելացնել ՏՄ",
            addSemiTrailer: "Ավելացնել կիսակցորդ",
            addTrailer: "Ավելացնել կցորդ",
            addTruck: "Ավելացնել բեռնատար",
            carTypeNames: {
                trailer: "Կցորդ",
                semitrailer: "Կիսակցորդ",
                tractor: "Քարշակ",
                truck: "Բեռնատար"
            }
        },
        Contractors: {
            readMoreLink: {
                text: "Մանրամասն տեղեկատուի մասին",
            },
            button: "Ավելացնել կոնտրագենտ",
            header: "Ձեր կոնտրագենտները",
        },
        Organizations: {
            readMoreLink: {
                text: "Մանրամասն տեղեկատուի մասին",
            },
            narrow: {
                text: [
                    "Եվ նշեք նրանց փաստաթղթերում՝ կայքի միջոցով պատվեր գրանցելիս",
                ]
            },
            button: "Ավելացնել կազմակերպություն",
            header: "Ավելացրեք ձեր ձեռնարկության տվյալները և նրանց տվյալները, ում հետ հաճախ եք աշխատում",
        },
        Drivers: {
            readMoreLink: {
                text: "Մանրամասն տեղեկատուի մասին",
            },
            button: "Ավելացնել վարորդ",
            header: "Ավելացնել վարորդ",
        },
        Transport: {
            readMoreLink: {
                text: "Մանրամասն տեղեկատուի մասին",
            },
            header: "Ավելացնել տրանսպորտ",
        },
        CompletedItems: {
            wide: {
                header: "Պատվեր",
                text: [
                    "Պայմանավորվեք փոխադրման մասին մի քանի քայլով՝ ATI.SU կայքի միջոցով: Պատվերի ձևակերպումը հնարավոր է, եթե բեռ ուղարկողը առաջարկել է ձեզ բեռ Հարթակում կամ անձնական հրավերով: ",
                    "Դուք տեղեկանում եք նման բեռի մասին «Վերցնել բեռը» կոճակի օգնությամբ: Հենց դուք սեղմեք այն, բեռը ձերն է: Կայքն ինքը կկազմի պայմանագիր-հայտ, ձեզ կմնա միայն ստորագրել այն: ",
                ],
            },
            button: "Իմանալ ավելին",
            header: "Այստեղ պահպանվում են բեռները, որոնք անցել են Պատվերներով",
        },
        Completed: {
            wide: {
                header: "Պատվեր",
                text: [
                    "Պայմանավորվեք փոխադրման մասին մի քանի քայլով՝ ATI.SU կայքի միջոցով: Պատվերի ձևակերպումը հնարավոր է, եթե բեռ ուղարկողը առաջարկել է ձեզ բեռ Հարթակում կամ անձնական հրավերով: ",
                    "Դուք տեղեկանում եք նման բեռի մասին «Վերցնել բեռը» կոճակի օգնությամբ: Հենց դուք սեղմեք այն, բեռը ձերն է: Կայքն ինքը կկազմի պայմանագիր-հայտ, ձեզ կմնա միայն ստորագրել այն: ",
                ],
            },
            button: "Իմանալ ավելին",
            header: "Այստեղ պահպանվում են բեռները, որոնք անցել են Պատվերներով",
        },
        Payments: {
            wide: {
                header: "Պատվեր",
                text: [
                    "Պայմանավորվեք փոխադրման մասին մի քանի քայլով՝ ATI.SU կայքի միջոցով: Պատվերի ձևակերպումը հնարավոր է, եթե բեռ ուղարկողը առաջարկել է ձեզ բեռ Հարթակում կամ անձնական հրավերով: ",
                    "Դուք տեղեկանում եք նման բեռի մասին «Վերցնել բեռը» կոճակի օգնությամբ: Հենց դուք սեղմեք այն, բեռը ձերն է: Կայքն ինքը կկազմի պայմանագիր-հայտ, ձեզ կմնա միայն ստորագրել այն: ",
                ],
            },
            text: [
                "Դուք կկարողանաք հետևել՝ երբ են ուղարկվել և ստացվել Պատվերի փաստաթղթերը ու վճարումը:",
            ],
            button: "Իմանալ ավելին",
            header: "Այստեղ կլինեն վճարման կարգավիճակները և փաստաթղթերի շարժը",
        },
        InProgressItems: {
            wide: {
                header: "Պատվեր",
                text: [
                    "Պայմանավորվեք փոխադրման մասին մի քանի քայլով՝ ATI.SU կայքի միջոցով: Պատվերի ձևակերպումը հնարավոր է, եթե բեռ ուղարկողը առաջարկել է ձեզ բեռ Հարթակում կամ անձնական հրավերով: ",
                    "Դուք տեղեկանում եք նման բեռի մասին «Վերցնել բեռը» կոճակի օգնությամբ: Հենց դուք սեղմեք այն, բեռը ձերն է: Կայքն ինքը կկազմի պայմանագիր-հայտ, ձեզ կմնա միայն ստորագրել այն: ",
                ],
            },
            text: [
                "Սրանք այն բեռներն են, որոնք ձևակերպվել են Պատվերներով, որոնց հայտն արդեն ստորագրվել է,  իսկ բեռը սպասում է փոխադրմանը կամ արդեն ճանապարհին է:",
            ],
            button: "Իմանալ ավելին",
            header: "Այստեղ կլինեն աշխատանքի մեջ եղող բեռները",
        },
        InProgress: {
            wide: {
                header: "Պատվեր",
                text: [
                    "Պայմանավորվեք փոխադրման մասին մի քանի քայլով՝ ATI.SU կայքի միջոցով: Պատվերի ձևակերպումը հնարավոր է, եթե բեռ ուղարկողը առաջարկել է ձեզ բեռ Հարթակում կամ անձնական հրավերով: ",
                    "Դուք տեղեկանում եք նման բեռի մասին «Վերցնել բեռը» կոճակի օգնությամբ: Հենց դուք սեղմեք այն, բեռը ձերն է: Կայքն ինքը կկազմի պայմանագիր-հայտ, ձեզ կմնա միայն ստորագրել այն: ",
                ],
            },
            text: [
                "Սրանք այն բեռներն են, որոնք ձևակերպվել են Պատվերներով, որոնց հայտն արդեն ստորագրվել է,  իսկ բեռը սպասում է փոխադրմանը կամ արդեն ճանապարհին է:",
            ],
            button: "Իմանալ ավելին",
            header: "Այստեղ կլինեն աշխատանքի մեջ եղող բեռները",
        },
        ReconciliationItems: {
            wide: {
                header: "Պատվեր",
                text: [
                    "Պայմանավորվեք փոխադրման մասին մի քանի քայլով՝ ATI.SU կայքի միջոցով: Պատվերի ձևակերպումը հնարավոր է, եթե բեռ ուղարկողը առաջարկել է ձեզ բեռ Հարթակում կամ անձնական հրավերով: ",
                    "Դուք տեղեկանում եք նման բեռի մասին «Վերցնել բեռը» կոճակի օգնությամբ: Հենց դուք սեղմեք այն, բեռը ձերն է: Կայքն ինքը կկազմի պայմանագիր-հայտ, ձեզ կմնա միայն ստորագրել այն: ",
                ],
            },
            text: [
                "Սրանք այն բեռներն են, որոնք փոխադրողները կվերցնեն ըստ Պատվերների, սակայն դեռ չեն ստորագրի պայմանագիր-հայտը:",
            ],
            button: "Իմանալ ավելին",
            header: "Այստեղ կլինեն համաձայնեցման փուլում գտնվող բեռները",
        },
        Reconciliation: {
            wide: {
                header: "Պատվեր",
                text: [
                    "Պայմանավորվեք փոխադրման մասին մի քանի քայլով՝ ATI.SU կայքի միջոցով: Պատվերի ձևակերպումը հնարավոր է, եթե բեռ ուղարկողը առաջարկել է ձեզ բեռ Հարթակում կամ անձնական հրավերով: ",
                    "Դուք տեղեկանում եք նման բեռի մասին «Վերցնել բեռը» կոճակի օգնությամբ: Հենց դուք սեղմեք այն, բեռը ձերն է: Կայքն ինքը կկազմի պայմանագիր-հայտ, ձեզ կմնա միայն ստորագրել այն: ",
                ],
            },
            text: [
                "Սրանք այն բեռներն են, որոնք դուք կվերցնեք ըստ Պատվերների, սակայն դեռ չեք ստորագրի պայմանագիր-հայտը:",
            ],
            button: "Իմանալ ավելին",
            header: "Այստեղ կլինեն համաձայնեցման փուլում գտնվող բեռները",
        },
        archive: {
            narrow: {
                text: [
                    "Այստեղ կցուցադրվեն այն բեռները, որոնք հիմա հրապարակվում են կայքում",
                ],
            },
            button: "Ավելացնել բեռ",
            header: "Բեռների պահոցը դատարկ է",
        },
        published: {
            actions: {
                restore: "վերականգնեք պահոցից",
                add: "Ավելացրեք դրանք կամ ",
            },
            button: "Ավելացնել բեռ",
            header: "Այստեղ կլինեն ձեր բեռները",
        },
        noAccessToAddingLoadText: "Դուք բեռ ավելացնելու իրավունք չունեք:  Դիմեք ադմինիստրատորին իրավունքներ ստանալու համար:",
        noFilteredLoads: "Ցուցակում չկան նման բեռներ: Փորձեք չեղարկել ֆիլտրը կամ որոնել այլ չափորոշիչներով ",
        clearFilter: "Չեղարկել ֆիլտրը",
        trailer: "Կցորդ",
        semitrailer: "Կիսակցորդ",
        tractor: "Քարշակ",
        truck: "Բեռնատար",
        add: "Ավելացնել",
        notFound: "Չի գտնվել",
        // "en": {
        //     "js/DEFAULT_EXPORT/Organizations/header": "Մուտքագրեք ձեր ընկերության տվյալները և նրանց տվյալները, ում հետ հաճախակի եք աշխատում"
        // },
        pressToCalculate: "Սեղմեք հաշվարկելու համար:",
        insureLoadAndGetCashback: "Ապահովագրեք բեռը և ստացեք քեշբեք՝ սկսած 5%-ից: ",
        insureLoad: "Ապահովագրել բեռը",
        LoadFiles: {
            otherDocuments: "փաստաթուղթ",
            oneDocument: "փաստաթուղթ",
            manyDocuments: "փաստաթուղթ",
            fewDocuments: "փաստաթուղթ"
        },
        LargeCities: {
            km: "կմ",
            bkg: "մոտակա խոշոր քաղաքները"
        },
        InviteButton: {
            invite: "Հրավիրել "
        },
        LimitsPopover: {
            orders: {
                other: "պատվեր",
                many: "պատվեր",
                few: "պատվեր",
                one: "պատվեր",
            },
            doNotInvite: "Չհրավիրել",
            invite: "Հրավիրել",
            doInviteCarrier: "Հրավիրեք փոխադրողին, եթե դուք ցանկանում եք, որպեսզի նա ընդունի պատվերն՝ անկախ սահմանաչափից:",
            editInCatalogs: "Խմբագրել տեղեկատուի մեջ",
            max: "առավ.",
            youSetLimit: "Դուք սահմանել եք սահմանաչափ միաժամանակ աշխատանքի մեջ գտնվող պատվերների համար.",
            title: "Դուք հասել եք պատվերների սահմանաչափին"
        },
        insuranceConditions: "Ապահովագրության պայմանները",
        promoText: "Ապահովագրեք բեռը, որպեսզի փոխհատուցում ստանաք ցանկացած պատահական պատճառով բեռի  կորստի, վնասվելու կամ փչանալու դեպքում: ",
        InWorkStatusSelect: {
            visibleForOwnerControlledFromTracker: "Կարգավիճակը տեսանելի է ձեզ և փոխադրողին: Կարգավիճակը կարող է փոխել միայն վարորդը:",
            youAndOwner: "Կարգավիճակը տեսանելի է ձեզ և  պատվիրատուին: Կարգավիճակը կարող է փոխել միայն վարորդը:",
            onlyYou: "Կարգավիճակը տեսանելի է միայն ձեր ընկերությանը: Կարգավիճակը կարող է փոխել միայն վարորդը:",
            ownerInfo: "Կարգավիճակը տեսանելի է ձեզ և փոխադրողին",
            info: "Կարգավիճակը տեսանելի է ձեզ և պատվիրատուին",
            noStatus: "Կարգավիճակ չկա",
            placeholder: "Ընտրեք կարգավիճակը"
        },
        ImagesUploader: {
            carsPhotos: "ՏՄ Լուսանկարը"
        },
        HistoryPopup: {
            load: "Բեռ #",
            emptyHistory: "Այս բեռի հետ կապված Պատվերներ, Սակարկություններ (աճուրդ) և պատասխան առաջարկներ չեն եղել",
            actionColumnName: "Գործողություն",
            timeColumnName: "ժամանակ",
            dateColumnName: "Ամսաթիվ",
            title: "Սակարկությունների և Պատվերների Պատմություն"
        },
        FileDownloadButton: {
            downloadExcel: "Ներբեռնել Պատմությունը (Excel)"
        },
        ChooseDropdown: {
            offer: "Բոլոր պատասխան առաջարկները",
            deal: "Գործարքի ամբողջ պատմությունը",
            auctionrate: "Սակարկությունների բոլոր դրույքաչափերը",
            auction: "Սակարկությունների ամբողջ պատմությունը",
            all: "Բոլոր գործողությունները",
            show: "Ցուցադրել"
        },
        GlyphButtonHistory: {
            history: "Պատվերների պատմություն"
        },
        GeoPositionPromo: {
            promoNotice: 'Հետևեք ձեր պատվերներին իրական ժամանակի\nռեժիմում ԱՏԻ Վարորդ անվճար ծառայության միջոցով:',
            sensorSharingNotice: 'Պատվիրատուն բեռով մեքենայի գտնվելու վայրը\n կտեսնի GPS-մոնիթորինգի համակարգի քարտեզի վրա, որտեղ գրանցված է տպիչը:',
            moreAboutShipperTracker: "Ինչպես է աշխատում ԱՏԻ Վարորդը",
            trackerShipperNotice: "և ստանալ պատվերի ակտուալ կարգավիճակ",
            sensorShipperNotice: "GPS-մոնիթորինգի համակարգեր",
            shipperNotice: "Դուք կկարողանաք տեսնել բեռը քարտեզի վրա",
            shipperHeader: "Փոխադրողը կկիսվի տեղադիրքի տվյալներով",
            moreAboutTracker: "Մանրամասն ԱՏԻ Վարորդի մասին",
            trackerSharingNotice: "Պատվիրատուն քարտեզի վրա կտեսնի պատվերի կարգավիճակը և բեռով մեքենան:",
            sharingNotice: "Դա կարող է մեծացնել վստահությունը և ազդել ձեզ՝ որպես կատարող ընտրելու որոշման վրա:",
            showGeoData: "Պատվիրատուին ցուցադրել տեղադիրքի տվյալները",
            sectionName: "Վերահսկեք բեռնափոխադրումները"
        },
        FirmReputation: {
            unfairPartnerAbbr: "ագ",
            claimAbbr: "ա",
            recommendationAbbr: "Խ.",
            otherFirms: "ընկերությունից",
            manyFirms: "ընկերությունից",
            twoFirms: "ընկերությունից",
            oneFirm: "ընկերություններ",
            unfairPartners: "Հիշատակումներ «Անբարեխիղճ գործընկերները» ֆորումում. սկսած {0} {1}",
            claims: "Առարկություններ.",
            recommendations: "Խորհուրդներ."
        },
        Firm: {
            claimsAbbr: "ա.",
            unfairPartnerAbbr: "ագ.",
            recommendationAbbr: "խ.",
            otherDocs: "փաստաթուղթ",
            manyDocs: "փաստաթուղթ",
            twoDocs: "փաստաթուղթ",
            oneDoc: "փաստաթուղթ ",
            otherFirms: "ընկերությունից",
            manyFirms: "ընկերությունից",
            twoFirms: "ընկերությունից",
            oneFirm: "ընկերություններ",
            unfairPartners: "Հիշատակումներ «Անբարեխիղճ գործընկերները» ֆորումում. սկսած {{count}} {{string}}",
            claims: "Առարկություններ.",
            recommendations: "Խորհուրդներ.",
            document: "Ներկայացված է.{{count}} {{string}}",
            code: "Կոդ"
        },
        drop: "Չեղարկել",
        allParametersCompact: "Ավելին",
        allParameters: "Ավելի շատ ֆիլտրեր",
        ExtraPoints: {
            unloading: "բեռնաթափումներ",
            otherPoints: "կետերից",
            onePoint: "տեղ",
            manyPoints: "կետերից",
            loading: "բեռնումներ",
            fewPoints: "տեղի",
            extraPointsAbbr: "լրաց. {{point}} {{type}}"
        },
        take_lot_access_denied: "Դուք չունեք բավարար իրավունքներ այս գործողության համար",
        take_load_access_denied: "Դուք չունեք բավարար իրավունքներ այս գործողության համար",
        access_denied: "Դուք չունեք բավարար իրավունքներ այս գործողության համար",
        ui_error: "Տեղի է ունեցել սխալ",
        contact_access_denied_error: "Անբավարար իրավունքներ",
        cannot_choose_winner: "Հնարավոր չէ փոխել հաղթողին",
        invitation_not_found_error: "Տեղի է ունեցել սխալ",
        load_not_found_error: "Հնարավոր չէ վերցնել բեռը",
        load_cant_reserve: "Հնարավոր չէ ամրագրել բեռը",
        load_cant_take: "Հնարավոր չէ վերցնել բեռը",
        close: "Փակել",
        access_denied_reason: `<p>Для того, чтобы работать с Заказами, у вас должны быть следующие доступы:</p>
        <ul>
            <li>Работать с площадками</li>
            <li>Брать грузы для оформления Заказов</li>
        </ul>
         <p>Чтобы вы могли одобрить заявку, потребуется доступ:</p>
            <ul>
                <li>Подписывать и одобрять документы в АТИ-Доках</li>
             </ul>
         </p>
         <p>Эти права вам может дать администратор или руководитель аккаунта. Права настраиваются в кабинете, в окне редактирования контакта.</p>`,
        take_load_access_denied_reason: `<p>Для того, чтобы работать с Заказами, у вас должен быть следующий доступ:</p>
        <ul>
            <li>Брать грузы для оформления Заказов</li>
        </ul>
         <p>Это право вам может дать администратор или руководитель аккаунта. Права настраиваются в кабинете, в окне редактирования контакта.</p>`,
        take_lot_access_denied_reason: `<p>Для того, чтобы работать с Заказами, у вас должен быть следующий доступ:</p>
        <ul>
            <li>Брать грузы для оформления Заказов</li>
        </ul>
         <p>Это право вам может дать администратор или руководитель аккаунта. Права настраиваются в кабинете, в окне редактирования контакта.</p>`,
        defaultError: {
            reason: "Փորձեք վերաբեռնել էջը"
        },
        EditArea: {
            cancel: "Չեղարկում"
        },
        DriverSelect: {
            driver: "Վարորդ",
            clear: "Մաքրել"
        },
        DriverEmployedToAnother: {
            carFromAnother: "Դուք չեք կարող ՏՄ կցել [[AppLink]] հավելվածին, քանի որ այն կցված է ընկերությանը",
            employedToAnotherFirm: "Դուք չեք կարող պատվերներ ուղարկել այս վարորդին [[AppLink]] հավելվածով, քանի որ նա հանդիսանում է ընկերության աշխատակից",
            atiTrucker: "ԱՏԻ Վարորդ"
        },
        toWhere: "Որտեղ",
        fromWhere: "Որտեղից",
        clear: "Մաքրել",
        selectedDepartments: "ընտրվել է",
        allDepartments: "Բոլոր ստորաբաժանումները",
        deletedDepartments: "Հեռացված ստորաբաժանումները",
        allDocsWithoutCount: {
            allDocsWithoutCount: "Փաստաթղթեր և լուսանկար",
            allDocs: "Փաստաթղթեր և լուսանկար ({{docsCount}})",
            edited: "Ուղղումներ",
            notSent: "չի ուղարկվել",
            document: "Փաստաթուղթ"
        },
        CounterpartySelect: {
            auctionsWinner: "Սակարկությունների հաղթողը",
            firm: "ԱՏԻ ընկերությունը",
            clear: "Մաքրել",
            counterparty: "Կոնտրագենտ"
        },
        willBeShown: "Կցուցադրվեն ակտիվ կոնտակտի բեռները:",
        areShownNow: "Այժմ ցուցադրվում են ակտիվ կոնտակտի բեռները:",
        loadsForAllContacts: "բոլոր կոնտակտների բեռները՝ Ձեր բեռներ մուտք գործելու ժամանակ:",
        dontShow: "Չցուցադրել",
        show: "Ցուցադրել",
        allContacts: "Բոլոր կոնտակտները",
        City: {
            unloading: "բեռնաթափումներ",
            loading: "բեռնումներ",
            tooltipCoords: "Կետի կոորդինատները {{type}}"
        },
        CargoOwnerHelpPopover: {
            moreAboutOrders: "Մանրամասն Պատվերների մասին",
            carrierHasReservedTheLoad: "Փոխադրողը ամրագրել է բեռը:"
        },
        CancelWinnerPopover: {
            notChooseAsWinner: "Չընտրել",
            goingToChooseNewWinnerText: "Ընթացիկ հաղթողին արդեն ուղարկվել է պատվեր՝ ձեր բեռով: Նրան Սակարկություններից մերժում կուղարկվի: Պատվերը կուղարկվի նոր հաղթողի: ",
            goingToChooseNewWinner: "Դուք պատրաստվում եք ընտրել նոր հաղթող",
            chooseAsWinner: "Ընտրել հաղթող"
        },
        orderWillBeCancelled: 'Заказ будет перемещён в архив\n' + 'и отмечен как отменённый',
        notCancel: "Չչեղարկել",
        confirmCancelOrder: "Չեղարկել պատվերը",
        CancelAuctionActions: {
            noAccessText: "Դուք իրավունք չունեք չեղարկել Սակարկությունները: Դիմեք ադմինիստրատորին իրավունքներ ստանալու համար",
            willFinished: "Սակարկությունները կավարտվեն:\nՀաղթող կընտրվի լավագույն\nդրույքաչափ առաջարկողը",
            willLoseBids: "Սակարկությունների\nդրույքաչափերը կկորչեն",
            cancelFinish: "Չավարտել",
            cancelCancel: "Չչեղարկել",
            cancel: "Չեղարկել",
            cancelAuction: "Չեղարկել Սակարկությունները",
            finish: "Ավարտել",
            finishAheadOfTime: "Ավարտել հիմա"
        },
        BlackListLabel: {
            tooltipText: "Վարորդը ձեր սև ցուցակում է",
            carrier: {
                full: "Վարորդը պատվիրատուի սև ցուցակում է",
                short: "Պատվիրատուի սև ցուցակում"
            },
            cargoOwner: {
                full: "Վարորդը ձեր սև ցուցակում է",
                short: "սև ցուցակում"
            },
        },
        AuctionTimer: {
            at: "-ին",
            auctionEndDateBoundary: "Եթե դրույքաչափեր չառաջարկվեն, Սակարկությունը կավարտվի",
            auction: "Սակարկություններ",
            beforeAuctionStart: "մինչ Սակարկության սկիզբը",
            untilAuctionEnd: "մինչ Սակարկության ավարտը"
        },
        AttachCar: {
            headerText: {
                semitrailer: "Կիսակցորդ",
                trailer: "Կցորդ",
                tractorAndTruck: "Քարշակ կիսակցորդով կամ բեռնատար",
                truck: "Բեռնատար",
                tractor: "Քարշակ",
            },
            noResultsText: "չի գտնվել",
            select: "Ընտրեք...",
            trailer: "կցորդ",
            tractorAndTruck: "Քարշակ կիսակցորդով կամ բեռնատար",
            semitrailer: "կիսակցորդ",
            truck: "բեռնատար",
            tractor: "քարշակ",
            add: "Ավելացնել",
            edit: "Փոխել",
            cancel: "Չեղարկում"
        },
        notToSave: "Չպահպանել",
        save: "Պահպանել",
        edit: "Խմբագրել",
        p2Text: "Փոփոխությունները կարող են կորչել:",
        p1Text: "Դուք չեք պահպանել փոփոխությունները և փորձում եք փակել պատուհանը:",
        headerText: "Ի՞նչ անել փոփոխությունների հետ:",
        AtiPopup: {
            cancel: "Չեղարկում"
        },
        FileUploadWrapper: {
            invalidFile: "Ընտրվել է անհամապատասխան ֆայլ"
        },
        FileUploadItemInfo: {
            uploadError: "Չի հաջողվել ներբեռնել: Փորձեք ևս մեկ անգամ ",
            uploaded: "ներբեռնվել է",
            removeItem: "Հեռացնել",
            abortUpload: "Ընդհատել ներբեռնումը"
        },
        AtiFileUploader: {
            uploadRequired: "Ներբեռնեք ֆայլերը",
            upload: "Ներբեռնել"
        },
        PopupOrganization: {
            removePopover: {
                contactPerson: "Հեռացնե՞լ կոնտակտային անձին Տեղեկատուից:",
                address: "Հեռացնե՞լ կազմակերպության հասցեն Տեղեկատուից:",
            },
            notLocation: "Մենք չենք գտել նման բնակավայր",
            documentExample: "Օրինակ՝ IDNO 1234567-123-123",
            documentType: "Փաստաթղթի տեսակն ու համարը",
            bin: "ԲՆՀ (БИН)",
            unp: "ՀՎՀՀ (Բելառուս)",
            edrpou: "ՈւԸՁՊՄԳ",
            officeTooltip: "Մուտքագրեք գրասենյակը, տարածքը, բոքսը, բնակարանը, սենյակը և այլն:",
            office: "Գրասենյակ, տարածք և այլն:",
            building: "Շենք, շինություն, մասնաշենք, մուտք",
            street: "Փողոց, պողոտա, նրբանցք, զբոսայգի և այլն",
            locality: "Բնակավայր",
            postcode: "Ինդեքս",
            organizationPhone: "Կազմակերպության հեռախոսահամարը",
            locationAddress: "Գտնվելու հասցեն փաստաթղթերի համար",
            inn: "ՀՎՀՀ",
            residency: "Ռեզիդենտություն",
            fullOrganizationName: "Ամբողջական անվանումը",
            other: "(այլ)",
            available: "Հասանելի է",
            notResultOwnership: "ՍՁ (սեփականության ձև) չի գտնվել",
            nameFirm: "Ընկերության անվանումը",
            editOrganization: "Խմբագրել կազմակերպությունը",
            addOrganization: "Ավելացնել կազմակերպություն",
            addAddressDescription: "(պահեստի, խանութի կամ գրասենյակի հասցե)",
            addAddress: "Ավելացնել պահեստ",
            addresses: "Հասցեներ",
            addContactPerson: "Ավելացնել կոնտակտային անձ",
            contactPersons: "Կոնտակտային անձեր",
            extraPhone: "Ավել. համար",
            add: "Ավելացնել",
            save: "Պահպանել"
        },
        RevokedBinding: {
            popover: {
                deleteLink: "Հեռացնել կապը",
                header: "Պահեստ անջատված է «Ժամանակավոր պատուհաններ» ծառայությունից սեփականատիրոջ կողմից:",
            },
            timeslots: "«Ժամանակավոր պատուհաններ»"
        },
        AcceptedBinding: {
            popover: {
                writeToPartner: "Գրել գործընկերոջը",
                showTimeslots: "Դիտել բեռնումը",
                address: "Պահեստի հասցեն",
                faq: "Մանրամասն ծառայության մասին",
                header: "Պահեստը միացված է «Ժամանակավոր պատուհաններ» ծառայությանը",
            },
            timeslots: "«Ժամանակավոր պատուհաններ»"
        },
        UnbindTimeslots: {
            breakNotification: "Դուք խզել եք կապը գործընկերոջ պահեստի հետ:",
            breakQuestion: "Խզե՞լ կապը գործընկերոջ պահեստի հետ:",
            dontBreak: "Չխզել",
            break: "Խզել",
            breakLink: "Խզել կապը"
        },
        EntityRemovePopup: {
            dontDelete: "Չհեռացնել",
            delete: "Հեռացնել"
        },
        Entity: {
            edit: "Փոխել",
            remove: "Հեռացնել"
        },
        DepartmentsSelector: {
            selectedDepartments: "ընտրված ստորաբաժանումներին",
            allDepartments: "բոլոր ստորաբաժանումներին"
        },
        ContactEntity: {
            extraPhone: "Ավել. համար"
        },
        AddressEntity: {
            shortCity: "տ."
        },
        AddOrganizationContactPopup: {
            editContactPerson: "Խմբագրել կոնտակտային անձը",
            addContactPerson: "Ավելացնել կոնտակտային անձ",
            fullName: "ԱԱՀ",
            extraPhone: "Ավել. համար",
            phone: "Հեռախոսահամար",
            add: "Ավելացնել",
            "save": "Պահպանել"
        },
        AddOrganizationAddressPopup: {
            placeholderAddress: "մարզ, փողոց, տուն",
            coordinates: "Կոորդինատներ",
            selectOnMap: "Ընտրել քարտեզի վրա",
            enter: "Սկսեք մուտքագրել",
            addressWithoutCity: "Հասցե (առանց քաղաքի)",
            locality: "Բնակավայր",
            withoutContactPerson: "Առանց կոնտակտային անձի",
            nothingFound: "Ոչինչ չի գտնվել:",
            selectAddressContactPerson: "Ընտրեք հասցեի կոնտակտային անձը",
            placeholderShedule: "Երկ.-Ուրբ.՝ 09:00-ից 20:00, շբթ-կիր՝ Հանգստյան օրեր",
            note: "Նշում",
            schedule: "Աշխատանքային ժամերը",
            type: "Տեսակ",
            editAddress: "Խմբագրել հասցեն {{addressTypeName}}",
            addAddress: "Ավելացնել հասցեն {{addressTypeName}}",
            addContactPerson: "Ավելացնել կոնտակտային անձ",
            contactPerson: "Կոնտակտային անձ",
            add: "Ավելացնել",
            save: "Պահպանել"
        },
        AddEditCarPopup: {
            cancel: "Չեղարկել",
            semitrailer: "կիսակցորդ",
            save: "Պահպանել",
            trailer: "կցորդ",
            tractor: "քարշակ",
            truck: "բեռնատար",
            edit: "Խմբագրել",
            add: "Ավելացնել",
            ts: "ՏՄ",
            description: {
                own_duplicate_error: "Այն արդեն հրապարակված է ձեր Ավտոպարկում:",
                duplicate_error: "Այն արդեն նշված է որպես սեփական ATI.SU-ի այլ մասնակցի մոտ: Եթե դա ամեն դեպքում ձեր ավտոմեքենան է, ժամանակավորապես դրեք «Ներգրավված ՏՄ» նշան, կցեք ՏՄՏԱ կամ պլաստիկի սքանը և դիմեք տեխ. աջակցությանը. ստեղծեք թիքեթ կամ զանգահարեք 8 812 602-01-09 ավ. 160: Մենք ամեն ինչ կկարգավորենք:"
            },
            header: {
                duplicate_error: "Դուք չեք կարող նշեք մեքենան որպես սեփական:",
                own_duplicate_error: "Չի կարելի ավելացնել տրանսպորտային միջոց",
            }
        },
        CarPopupForm: {
            truck: "Բեռնատար",
            tractorWithSemitrailer: "Քարշակ՝ կիսակցորդով"
        },
        GeneralCarFormWrapper: {
            semitrailer: "կիսակցորդ",
            trailer: "կցորդ",
            tractor: "քարշակ",
            truck: "բեռնատար",
            edit: "Խմբագրել",
            add: "Ավելացնել"
        },
        GeneralCarForm: {
            semitrailer: "Կիսակցորդ",
            trailer: "Կցորդ",
            truck: "Բեռնատար",
            tractor: "Քարշակ",
            rentContactHintText: "Լուսանկար կամ սքան",
            marriageHintText: "Վկայականի լուսանկարը կամ սքանը",
            documentHintText: "Փաստաթղթերի սքանը կամ լուսանկարը 2 կողմից կամ էլեկտրոնային ՏՄՏԱ",
            contractHintText: "Եթե ՏՄ սեփական չէ",
            ownershipType: "ՏՄ սեփականության տեսակը",
            required: "(պարտադիր)",
            uploadGratuitousContractScan: "Ներբեռնել անհատույց օգտագործման պայմանագիրը",
            uploadMarriageScan: "Ներբեռնել ամուսնության վկայականը",
            uploadPhotos: "Ներբեռնել ՏՄ լուսանկարը",
            uploadLeasingContractScan: "Ներբեռնել լիզինգի պայմանագիրը",
            uploadRentContractScan: "Ներբեռնել վարձակալության պայմանագիրը",
            uploadPTSScanOrPlastic: "Ներբեռնել ՏՄՊԳՎ և ՏՄՏԱ",
            attractedCar: "Ներգրավված ՏՄ",
            documentsHeader: "ՏՄ փաստաթղթեր"
        },
        TractorAdditionallyParams: {
            header: "Լրացուցիչ",
            canCarryHeavyContainer: "կարելի է տեղափոխել ծանր կոնտեյներներ",
            hasGenset: "առկա է Genset (մոտաժված գեներատոր)",
            canRefrigerator: "կարելի է տեղափոխել ռեֆ-կոնտեյներներ",
            externalId: 'Նույնացուցիչ'
        },
        ShowInFirmInfo: {
            tooltipDisabled: "Քարտի մեջ երևալու համար ՏՄ չպետք է ներգրավված լինի",
            tooltip: "Բեռի սեփականատիրոջ համար կարևոր է ոչ միայն ընկերության հեղինակությունը, այլ նաև փոխադրողի սեփական ավտոպարկի առկայությունը ",
            text: "Ցուցադրել ATI.SU-ի մասնակցի ձեր անձնագրում"
        },
        ReserveByDriverBlock: {
            noAvailableDrivers: "Հասանելի վարորդներ չկան",
            cancel: "Չեղարկում",
            select: "Ընտրեք...",
            addDriver: "Ավելացնել վարորդ",
            reserve: "Կցել վարորդին",
            reserveByDriver: "Ավեձլացնել և կցել վարորդին"
        },
        CarSensors: {
            delete: "Հեռացնել",
            update: "Փոխել",
            addSensor: "Ավելացնել ցուցիչ",
            helperText: "GPS/ԳԼՈՆԱԱՀ ցուցիչ",
            geoposition: "ՏՄ տեղադիրք"
        },
        CarOwnershipType: {
            gratuitousUse: "անհատույց օգտագործում",
            spousesJoint: "ամուսինների համատեղ սեփականություն",
            leasing: "լիզինգ",
            rental: "վարձակալություն",
            hired: "Ներգրավված ՏՄ",
            owned: "սեփականություն",
            ownerName: "Սեփականատեր՝ ըստ ՏՄ գրանցման վկայականի",
            ownershipType: "Սեփականության տեսակը"
        },
        CarInfo: {
            pts: "ՏՄՏԱ սերիան և համարը",
            vin: "VIN",
            vrcFull: "Տրանսպորտային միջոցի պետական գրանցման վկայականի սերիան և համարը",
            manufactureYear: "Թողարկման տարեթիվը",
            number: "Պետհամարանիշ",
            noBrandText: "Նման մակնիշ գոյություն չունի: Մուտքագրեք մեկ ուրիշը:",
            vrc: "Տրանսպորտային միջոցի պետական գրանցման վկայական",
            hasBodyNumber: "VIN բացակայում է",
            hasVin: "VIN առկա է",
            bodyNumber: "Թափք",
            model: "Տեսակ",
            mark: "Մակնիշ",
            clear: "Մաքրել",
            cancel: "Չեղարկում",
            exampleHint: {
                bodyNumber: "Թափքի/շասսիի համարի օրինակ",
                electronicPts: "Էլեկտրոնային ՏՄՏԱ համարի օրինակ",
                pts: "ՏՄՏԱ համարի օրինակ",
                vin: "VIN-ի օրինակ ",
                vrc: "Տրանսպորտային միջոցի պետական գրանցման վկայականի համարի օրինակ",
            },
            description: {
                bodyNumber: "Տրանսպորտային միջոցի անձնագրում, տրանսպորտային միջոցի գրանցման վկայականում, երաշխիքային կտրոնում/տեխզննման կտրոնում կամ ավտոմեքենայի ապահովագրական պոլիսում : \n\nԹափքի չառանձնացվող բաղադրիչների կամ շասսիի վրա և հատուկ պատրաստված համարանիշների ցուցատախտակի վրա (անվանատախտակի վրա):",
                pts: "Տրանսպորտային միջոցի տեխնիկական անձնագիրը (ՏՄՏԱ) ավտոմեքենայի հիմնական փաստաթղթերից մեկն է, որն իր մեջ ներառում է ավտոմեքենայի տեխնիկական բնութագրիչները, \n\nսեփականատերերի և տրանսպորտային միջոցի հաշվառման/հաշվառումից հանելու մասին փաստեր:",
                vin: "Տրանսպորտային միջոցի անձնագրում, տրանսպորտային միջոցի գրանցման վկայականում, երաշխիքային կտրոնում/տեխզննման կտրոնում կամ ավտոմեքենայի ապահովագրական պոլիսում: Թափքի չառանձնացվող բաղադրիչների կամ շասսիի վրա և հատուկ պատրաստված համարանիշների ցուցատախտակի վրա (անվանատախտակի վրա):",
                vrc: "Տրանսպորտային միջոցի պետական գրանցման վկայականը (ՏՄՊԳՎ) տրասպորտային միջոցի հիմնական փաստաթղթերից մեկն է: Այն տրամադրում են ՌԴ ՆԳՆ ՃԵԱՊՏ գրանցման բաժիններում՝ տրանսպորտային միջոցի (ավտոմեքենայի, մոտոցիկլի, կցորդի և այլն.) հաշվառումից հետո: Փաստաթուղթը տպված է «Գոսզնակ» գործարանում և լամինացվել է, ունի պաշտպանիչ շերտ:",
            },
            header: {
                bodyNumber: "Ինչպես իմանալ թափքի/շասսիի համարը",
                pts: "Ինչ տեսք ունի ՏՄ անձնագիրը",
                vin: "Ինչպես իմանալ VIN",
                vrc: "Ինչ տեսք ունի ՏՄ պետական գրանցման վկայականը"
            },
        },
        CarDimensions: {
            fillDimensions: "Նշեք ստույգ չափսերը",
            height: "Բարձրությունը, մ",
            width: "Լայնությունը, մ",
            length: "Երկարությունը, մ",
            internalDimensions: "Ներքին չափսերը"
        },
        CarBodySize: {
            capacity: "Բեռնատարողունակությունը, տ.",
            meter: "մ",
            volume: "Ծավալ"
        },
        CarBody: {
            containerSizes: [
                "20' մեկտեղանի",
                "20' պլատֆորմ",
                "20' մեկտեղանի + կցորդ",
                "40' պլատֆորմ հատակով",
                "40' պլատֆորմ առանց հատակի",
                "45' պլատֆորմ հատակով",
                "45' պլատֆորմ առանց հատակի",
                "20' տանկի պլատֆորմ",
                "40' տանկի պլատֆորմ",
                "40' առանձնացվող պլատֆորմ"
            ],
            dimension: "Կոնտեյների տարողունակությունը",
            select: "Թափքի տեսակը",
            body: "ՏՄ բնութագրիչները"
        },
        CanCarryTallContainers: {
            canCarryTallContainer: "Կարելի է տանել բարձր կոնտեյներներ"
        }
    },
    "en": {
        of: (count: number, total: number) => <>{count} of {total}</>,
        phoneWrong: "Enter a number in the format +7 (999) 999 99 99",
        extraDigits: "Please check the number, there are extra digits in it",
        missingDigits: "Please check the number, it's missing digits",
        emailWrong: "This is not an e-mail. Please check it for typos",
        lessThanMinDate: "The date must be no less than {{minDate}}",
        notValidDepartmentCode: "The subdivision code must be in the format 000-000",
        onlyNumbers: "Only numbers can be entered",
        choosePackageType: "You need to select the type of packaging",
        notValidTrackNumber: "The track number must contain only numbers, Latin letters, symbols . and -",
        notValidUrl: "Incorrect URL address",
        emptyCoordinates: "Select the address from the list or show it on the map",
        invalidDateString: "Incorrect date",
        invalidTimeString: "Incorrect time",
        wrongRangeEnd: "Incorrect range",
        wrongCheckSum: "Incorrect checksum",
        symbols: {
            many: "symbols",
            few: "symbols",
            one: "symbol"
        },
        numbers: {
            many: "digits",
            few: "digits",
            one: "digit"
        },
        numberFromTo: "Enter a number between {{from}} and {{to}}",
        symbolsRange: "Enter from {{from}} to {{to}} characters",
        enterPositiveNumber: "Enter a positive number",
        numberLessThen: "The value must not exceed ",
        korrSchetParams: "20 digits, beginning with 301 and ending with the last 3 digits of the BIC",
        OKPOLength: "8 or 10 digits",
        OKPOCheckNumber: "Incorrect check digit",
        twentySymbolsNoSpaces: "20 digits with no spaces",
        enterValue: "This field should not be empty",
        selectValue: "Select a value",
        requiredDigits: "You need to enter {{number}} digits",
        fifteenDigits: "15 digits",
        thirteenDigits: "13 digits",
        datesNotInThePast: "You can't select dates in the past",
        dateInTheFuture: "You can't select a date in the past",
        dateInThePast: "You can't select a date in the future",
        isInvalidDate: "Invalid date",
        invalidDateFormat: "Enter the date in the format DD.MM.YYYY.",
        wrongPhoneNumber: "Invalid phone number",
        region: "Enter the region",
        carNumber: "Enter the number",
        lengthMessage: "symbols",
        maxLengthMessage: "Max. {{max}} digits",
        upToEightSymbols: "Up to 8 digits",
        sixSevenSymbols: "6-7 digits",
        sixDigits: "Six digits",
        fourDigits: "Four digits",
        notAfterCurrent: "The year cannot be more than {{currentYear}}",
        notBeforeMinYear: "The year cannot be less than {{minYear}}",
        registrationNumber: "Registration number",
        egrpou: "EDRPOU",
        unp: "TIN",
        inn: "TIN",
        bin: "BIN",
        iin: "TIN",
        // strings: {
        //     rateNds: "including VAT",
        //     rateWithoutNds: "without VAT",
        //     direct: "direct contract",
        //     torg: "bargaining.",
        //     payDays: "in {0} business days",
        //     inFuel: "fuel",
        //     prepayAlone: "prepayment",
        //     prepay: "prepayment {0}%",
        //     onLoad: "on the unloading",
        //     onlyToSepCar: "separate car",
        //     dogruzPossible: "possible partial load",
        //     dogruz: "LTL",
        //     sborgruz: "groupage cargo"
        // },
        duplicate_contractor_error: "You cannot add a contractor. It has already been added to your Catalog.",
        unknown_error: "Unknown error",
        json_validation_error: "Validation error json",
        partial_execution_error: "An error occurred while establishing a connection, the vehicles were saved",
        failed_save_trucks: "Some vehicles failed to be saved",
        failed_save_truck: "Failed to save vehicle",
        customColumns: {
            historyBtn: "Load history",
            copyBtn: "Copy",
            addCommentBtn: "Write a comment",
            map: "Map",
            orderStatus: "Status",
            completion: "Compl",
            date: "Date",
            carrierContactPhone: "Carrier contact phone number",
            carrierContact: "Carrier contact",
            carrier: "Carrier",
            cashRate: "Cash rate",
            rateWithoutVAT: "Rate without VAT",
            rateWithVAT: "Rate including VAT",
            offers: "Offers",
            contact: "Contact",
            contactWithDate: "Contact, added/changed",
            driver: "Driver",
            car: "Vehicle",
            separateCar: "Separate vehicle",
            loadingUnloadingCar: "Loading / unloading the vehicle",
            bodyType: "Body type",
            loadParams: "Load parameters",
            unloading: "Unloading",
            loading: "Loading",
            routeAddress: "Route addresses",
            route: "Route",
            loadNumber: "Load number"
        },
        byDefault: "By default",
        columns: "Columns",
        informer: "Now you can customize\nthe display of data\nin compact cards",
        verify: "Verify",
        toTime: "to",
        fromTime: "from",
        dateInputPlaceHolder: "select a date",
        timeInputPlaceholder: '09:00',
        rate: "Bid",
        unloading: "Unloading",
        loading: "Loading",
        loadParams: {
            __html: "Weight, t / volume, m<sup>3</sup>, cargo type"
        },
        transport: "Transport",
        direction: "Direction",
        roundTheClock: "24 hours",
        workdays: "on working days",
        everyday: "every day",
        loadReady: "ready",
        alwaysReady: "always ready",
        ExpandingSection: {
            showFullInfo: "Show all"
        },
        "as-ui-kit/src/controls/DocumentBlock/strings": {
            "js/ru/previousVersion": "the previous redaction is valid",
            "js/ru/forContragent": "Changed by the counterpart. Prior to your confirmation,",
            "js/ru/forChanger": "Before the counterparty does not confirm the change,",
            "js/ru/transportationOrder": "Transportation order",
            "js/ru/sentToCounterparty": "Sent to counterparty",
            "js/ru/sentThroughAtiDocs": "Sent through ATI.Docs",
            "js/ru/documentApprovedByTrucker": "Document approved by trucker",
            "js/ru/documentApprovedByYou": "Document approved by you",
            "js/ru/documentSignedByTrucker": "Document signed by trucker",
            "js/ru/documentSignedByYou": "Document signed by you",
            "js/ru/documentCreated": "Document created",
            "js/ru/awaitsReview": "Awaits review"
        },
        DealUpdateTime: {
            at: "at"
        },
        ConsultantsInfo: {
            workHours: "9-18 Moscow time (UTC +3)",
            autoparkConsultants: "We can help you fill your fleet",
            dealsConsultants: "Call us for information about Orders"
        },
        CancelButton: {
            moveToArchive: "To archive"
        },
        "as-ui-kit/src/controls/AtiSelect/AtiSelect": {
            "jsx/strings/clearValue": "Clear"
        },
        AtiCarNumberInput: {
            otherCountries: "Other countries",
            russia: "Russia"
        },
        "as-ui-kit/src/controls/AtiCarNumberInput/AtiCarNumberInput": {
            "jsx/carPlaceholder": "M 123 MM 78"
        },
        "as-ui-kit/src/controls/AddressCoordinatesInput/strings": {
            "js/ru/pickOnMap": "Select on the map",
            "js/ru/clearAddress": "Clear",
            "js/ru/addressNotFound": "Address not found, try",
            "js/ru/pointOnMap": "Point on map",
            "en": {
                "js/DEFAULT_EXPORT/pickOnMap": "Select on the map"
            }
        },
        "as-ui-kit/src/const/unilateralOrder": {
            "js/paymentTypesOptions/paymentTypes": {
                "cash/name": "Cash",
                "cashlessWithNds/name": "With VAT, cashless",
                "cashlessWithoutNds/name": "Without VAT, cashless"
            }
        },
        weekDaysLowerShortList: [
            "su",
            "mo",
            "tu",
            "we",
            "th",
            "fr",
            "sa",
        ],
        weekDaysShortList: [
            "Su",
            "Mo",
            "Tu",
            "We",
            "Th",
            "Fr",
            "Sa",
        ],
        timeStrings: {
            months: [
                "january",
                "february",
                "march",
                "april",
                "may",
                "june",
                "july",
                "august",
                "september",
                "october",
                "november",
                "december",
            ],
            shortMonths: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec",
            ],
            year: "yr.",
            h: "h",
            d: "d",
            min: "min",
            sec: "sec",
            tomorrow: "tomorrow",
            yesterday: "yesterday",
            today: "today",
            at: "at",
        },
        MonthList: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
        ],
        "as-ui-kit/src/const/sensors": {
            "js/errors/ru/errorCodes": {
                "AuthLimitError": "Access denied. Please try again later",
                "BLError": "An error has occurred. Please try again later"
            },
            "js/providers/scout/name": "Scout",
            "js/providers/wialon/name": "Vialon"
        },
        "as-ui-kit/src/const/scans": {
            "js/scanTypeNames/ru/scanTypes": {
                "marriage": "Marriage certificate",
                "rentContract": "Rental agreement",
                "carPhoto": "Photo",
                "plasticTechPassport": "Reg. cert.",
                "techPassport": "Vehicle Title",
                "passport": "Passport",
                "driverLicense": "Driver's license"
            }
        },
        "as-ui-kit/src/const/requisites": {
            "js/defaultAddress/officeType": "off.",
            "js/defaultAddress/partType": "bldg.",
            "js/defaultAddress/houseType": "bldg.",
            "js/dictionaries/officeTypes/2/label": "premise",
            "js/dictionaries/officeTypes/2/value": "prem.",
            "js/dictionaries/officeTypes/1/label": "apartment",
            "js/dictionaries/officeTypes/1/value": "apt.",
            "js/dictionaries/officeTypes/0/label": "office",
            "js/dictionaries/officeTypes/0/value": "off.",
            "js/dictionaries/partTypes/1/label": "building",
            "js/dictionaries/partTypes/1/value": "bldg.",
            "js/dictionaries/partTypes/0/label": "building",
            "js/dictionaries/partTypes/0/value": "bldg.",
            "js/dictionaries/houseTypes/1/label": "building",
            "js/dictionaries/houseTypes/1/value": "bldg.",
            "js/dictionaries/houseTypes/0/label": "building",
            "js/dictionaries/houseTypes/0/value": "bldg.",
            "js/dictionaries/streetTypes/13/label": "PO Box",
            "js/dictionaries/streetTypes/12/label": "line",
            "js/dictionaries/streetTypes/11/label": "tract",
            "js/dictionaries/streetTypes/10/label": "channel",
            "js/dictionaries/streetTypes/9/label": "passage",
            "js/dictionaries/streetTypes/8/label": "boulevard",
            "js/dictionaries/streetTypes/7/label": "alley",
            "js/dictionaries/streetTypes/6/label": "square",
            "js/dictionaries/streetTypes/5/label": "waterfront",
            "js/dictionaries/streetTypes/4/label": "alley",
            "js/dictionaries/streetTypes/3/label": "highway",
            "js/dictionaries/streetTypes/2/label": "avenue",
            "js/dictionaries/streetTypes/1/label": "street",
            "js/dictionaries/streetTypes/0/label": "(other)",
            "js/dictionaries/residences/ru/4/label": "Other",
            "js/dictionaries/residences/ru/3/label": "Kazakhstan",
            "js/dictionaries/residences/ru/2/label": "Belarus",
            "js/dictionaries/residences/ru/1/label": "Ukraine",
            "js/dictionaries/residences/ru/0/label": "Russia"
        },
        "as-ui-kit/src/const/payDocs": {
            "js/mappedTransportCompanyNames/ru/1": "other",
            "js/payDocsLabels/ru/ClosingDocuments": "Closing",
            "js/payDocsLabels/ru/Payment": "Paid",
            "js/payDocsLabels/ru/DocumentsOriginalTrack": "Track number",
            "js/payDocsLabels/ru/DocumentsOriginal": "Originals",
            "js/payDocsLabels/ru/DocumentsCopies": "Copies",
            "js/payDocsName/ru/carrier/ClosingDocuments/name": "Received closing document",
            "js/payDocsName/ru/carrier/Payment/name": "Payment received",
            "js/payDocsName/ru/carrier/DocumentsOriginal/name": "Originals sent",
            "js/payDocsName/ru/carrier/DocumentsCopies/name": "Copies sent",
            "js/payDocsName/ru/cargoOwner/Payment/name": "Paid",
            "js/payDocsName/ru/cargoOwner/DocumentsOriginal/name": "Originals received",
            "js/payDocsName/ru/cargoOwner/DocumentsCopies/name": "Copies received"
        },
        "as-ui-kit/src/const/index": {
            "js/undefinedError": "Unknown error"
        },
        "as-ui-kit/src/const/files": {
            "js/fileSourceTypeNames/ru/dealFileSourceFileTypes": {
                "freeUse": "Contract for free use",
                "truckPhoto": "Photo",
                "truckPlasticTechPassport": "Plastic Vehicle license",
                "truckTechPassport": "Vehicle Title",
                "driverPassport": "Passport",
                "driverLicense": "Driver license"
            },
            "js/fileSourceNames/ru/dealFileSourceTypes": {
                "tractor": "tractor unit",
                "semiTrailer": "semi-trailer",
                "trailer": "trailer",
                "truck": "lorry",
                "driver": "driver"
            }
        },
        documentTypes: {
            poa: "power of attorney",
            uniliteralDissolution: "notice of refusal to perform",
            invoice: "invoice",
            act: "act",
            commission: "freight forwarder order",
            tableRequest: "application to the contract (tabular form)",
            request: "application (to the contract)",
            order: "order",
            tableOrder: "order (tabular view)",
            contract: "order (contract application)"
        },
        displayedDocumentTypes: {
            commission: "Forwarding Instructions",
            request: "Application as a document",
            tableRequest: "application in tabular form",
            order: "Order as a document",
            tableOrder: "Order in tabular form",
        },
        docTypesGroups: [
            "Working with a contractor for the first time",
            "There is a contract",
            "Working under a freight forwarding contract",
        ],
        additionalDocuments: {
            cancelDeal: "Notice of refusal to perform",
            poa: "Power of attorney",
            invoice: "Invoice for the request",
            act: "Certificate (bilateral)",
        },
        cancelDocuments: {
            refusalOfFulfilment: "Notice of refusal to perform",
        },
        "as-ui-kit/src/const/documents": {
            "js/docTypeTemplates/contract": "contract",
        },
        auctionPaymentTypes: {
            25: "w/o VAT",
            24: "w/ VAT",
            23: "card",
            1: "cash",
            0: "all"
        },
        ton: "t",
        weight: "Wt",
        to: "to",
        from: "from",
        meter: "m",
        volume: "Vol",
        TruckIcon: {
            carInGratuitousUseVerifiedTooltip: "Verified car in gratuitous use",
            carInGratuitousUseTooltip: "Car in gratuitous use",
            carInSousesJointOwnershipVerifiedTooltip: "Verified car in joint property of spouses",
            carInSousesJointOwnershipTooltip: "Car in joint property of spouses",
            carExternalTooltip: "External car",
            carOwnVerifiedTooltip: "Own verified car",
            carOwnTooltip: "Own car",
            carInLeasingVerifiedTooltip: "Verified car in leasing",
            carInLeasingTooltip: "Car in leasing",
            carInRentVerifiedTooltip: "Verified car rented",
            carInRentTooltip: "Car rented"
        },
        TrackerStatus: {
            promoAction: "How it works",
            promoHeader: "Now you can track load\non map in the app for\ntrucker"
        },
        LastActive: {
            exclusivePopoverLinkText: "exclusive access.",
            ago: "ago",
            activity: "activity",
            exclusiveAccess: "Exclusive access from another company",
            installed: "installed",
            hasTracker: "ATI Driver "
        },
        Invite: {
            car: {
                cantInviteTooltip: 'Приглашение можно выслать только на мобильный номер телефона. У водителя указан не мобильный. Телефон можно изменить в вашем Справочнике Водителей',
                tooManyRequests: "Too many attempts to send an invitation. Please try again later",
                toApp: "install",
                invited: "Invitation sent",
                invite: "Send an invitation",
                undefinedError: "Undefined error",
                cantInvite: "Driver from this order can't be invited to",
                alreadyInvited: "You have sent invite to this driver. Try again later",
                resend: "Invite again",
                atiTrucker: "the ATI Driver"
            },
            driver: {
                                cantInviteTooltip: 'Приглашение можно выслать только на мобильный номер телефона. У водителя указан не мобильный. Телефон можно изменить в вашем Справочнике Водителей',

                tooManyRequests: "Too many attempts to invite the driver. Please try again later",
                toApp: "install",
                invited: "The driver is invited",
                sent: "sent",
                invite: "Invitation",
                inviteDriver: "Invite a driver",
                undefinedError: "Undefined error",
                cantInvite: "Driver from this order can't be invited to",
                alreadyInvited: "You have sent invite to this driver. Try again later",
                resend: "Invite again",
                atiTrucker: "the ATI Driver"
            }
        },
        InvitePopover: {
            car: {
                exclusiveDescription:
                    'Только вы сможете отправлять\n' +
                    'заказы водителю, получать\n' +
                    'актуальные статусы перевозки,\n' +
                    'отслеживать местоположение\n' +
                    'груза на карте.',
                smsIsSent: "A text message was sent to your phone number",
                caption: "A text message with a link to download the application will be sent to your phone number",
                invite: "Send an invitation",
                exclusiveAccess: "Exclusive access to his/her ATI Driver",
                onlyAndroid: "The application only works on Android.",
                sendSms: "Send SMS",
                atiDriver: "ATI Driver"
            },
            driver: {
                exclusiveDescription:
                    'Только вы сможете отправлять\n' +
                    'заказы водителю, получать\n' +
                    'актуальные статусы перевозки,\n' +
                    'отслеживать местоположение\n' +
                    'груза на карте.',
                smsIsSent: "A text message was sent to the driver",
                caption: "The driver will be sent a text message with a link to download the application",
                invite: "Invite a driver",
                exclusiveAccess: "Exclusive access to his/her ATI Driver",
                onlyAndroid: "The application only works on Android.",
                sendSms: "Send SMS",
                atiDriver: "ATI Driver"
            }
        },
        "as-ui-kit/src/components/TrackerLink/strings": {
            "js/ru/atiTrucker": "ATI Trucker"
        },
        "as-ui-kit/src/components/TrackerIcon/strings": {
            "js/ru/howToUseTracker": "ATI Trucker — how to\nget and use"
        },
        "as-ui-kit/src/components/TrackerAppInfoPopover/strings": {
            "js/ru/trackerFeatures": "ATI Trucker features",
            "js/ru/atiTracker": "ATI Trucker"
        },
        "as-ui-kit/src/components/Tabs/Tab/TabCounter/strings": {
            "js/ru/of": "of"
        },
        "as-ui-kit/src/components/Signee/Signee": {
            "jsx/strings/useByDefault": "Use by default",
            "jsx/strings/signee": "Signatory",
            "jsx/strings/remove": "delete",
            "jsx/strings/positionInGenitive": "Position in the genitive case",
            "jsx/strings/fullNameInGenitive": "Full name in the genitive case",
            "jsx/strings/actUponWhatText": "Based on what is being acted upon. For example: \"Charter...\", \"Power of Attorney # ...\"."
        },
        ShortFirmInfo: {
            recommend: "Recommend"
        },
        "as-ui-kit/src/components/SensorActivateLink/strings": {
            "js/ru/reauthorizationRequired": "Re-authorization required",
            "js/ru/inactive": "Inactive"
        },
        "as-ui-kit/src/components/SearchLoad/strings": {
            "js/ru/unloading": "Unloading",
            "js/ru/loading": "Loading",
            "js/ru/loadParams/__html": "Weight, t / volume, m<sup>3</sup>, cargo type",
            "js/ru/transport": "Transport",
            "js/ru/direction": "Direction"
        },
        "as-ui-kit/src/components/SearchLoad/SearchLoadParams/strings": {
            "js/ru/widthShort": "W",
            "js/ru/sborgruz": "groupage cargo",
            "js/ru/onlyToSepCar": "separate car",
            "js/ru/meters": "m",
            "js/ru/load": "Cargo ",
            "js/ru/lengthShort": "L",
            "js/ru/items": "pieces",
            "js/ru/heightShort": "H",
            "js/ru/dogruzPossible": "possible partial load",
            "js/ru/dogruz": "partial load"
        },
        "as-ui-kit/src/components/SearchLoad/LoadUnloading/RouteThrough/strings": {
            "js/ru/through": "drive through:"
        },
        "as-ui-kit/src/components/SearchLoad/LoadUnloading/CustomsOnRoute/strings": {
            "js/ru/custom": "customs:"
        },
        "as-ui-kit/src/components/SearchLoad/LoadTransport/strings": {
            "js/ru/capacity": "LC {{number}} t,",
            "js/ru/onlyToSepCar": "separate car",
            "js/ru/dogruzPossible": "possible partial load",
            "js/ru/dogruz": "partial load",
            "js/ru/beltOther": "straps",
            "js/ru/beltMany": "straps",
            "js/ru/beltFew": "straps",
            "js/ru/beltOne": "strap",
            "js/ru/sanPassport": "sanitary passport for the vehicle",
            "js/ru/loadUnload": "load/unload",
            "js/ru/unload": "unload",
            "js/ru/load": "load",
            "js/ru/pnevmohod": "Air suspension",
            "js/ru/stsepka": "combination truck",
            "js/ru/koniki": "bolsters",
            "js/ru/cars": "vehicle"
        },
        "as-ui-kit/src/components/SearchLoad/LoadRate/strings": {
            "js/ru/allTermsInATIDocs": "see full terms in ATI-Docs",
            "js/ru/cashlessAll": "cashless with VAT, without VAT",
            "js/ru/cashlessWithoutVat": "cashless without VAT",
            "js/ru/cashlessWithVat": "cashless with VAT",
            "js/ru/cash": "cash",
            "js/ru/bargainOff": "bargain off",
            "js/ru/undefined": "with VAT",
            "js/ru/direct": "direct contract",
            "js/ru/bargainOn": "bargain on",
            "js/ru/payDays": "within {0} banking days",
            "js/ru/prepayAlone": "advance payment",
            "js/ru/inFuel": "in fuel",
            "js/ru/prepay": "advance payment {0}%",
            "js/ru/onLoad": "on the unloading",
            "js/ru/inquireLoad": "request rate",
            "js/ru/noLoad": "no load, request rate"
        },
        "as-ui-kit/src/components/SearchLoad/LoadDirection/strings": {
            "js/ru/km": "km",
            "js/ru/seePath": "view route",
            "js/ru/krugoreis": "round trip"
        },
        cardsCompact: "Compact cards view",
        cards: "Normal cards view",
        appearance: "Appearance",
        RejectOrder: {
            restoreLot: "Lot will be republished on the same sites.",
            restoreLoad: "restore the load",
            toArchive: "to Archive",
            move: "move\n",
            cancelDeals: ", cancel the Bidding",
            inArchive: "in Archive",
            leftLoad: "leave the load\n",
            publicLoadWithoutDeal: "publish the load without Bidding",
            restartDeal: "restart the Bidding",
            rubles: "\nbid",
            withRate: "\nwith a\n",
            chooseWinner: "choose as a winner\n",
            noReasonWarning: "Specify the reason for declining",
            reasonRejectionOffer: "Specify the reason for declining",
            whatHappenedWithLoads: "What to do with the load?",
            popoverWarning: "The Order will be moved to Archive as cancelled"
        },
        "as-ui-kit/src/components/PopupWarning/strings": {
            "js/ru/notToSave": "Don't save",
            "js/ru/save": "Save",
            "js/ru/edit": "Edit",
            "js/ru/p2": "Changes may be lost.",
            "js/ru/p1": "You haven't saved any changes and are trying to close the window.",
            "js/ru/header": "What to do with the changes?"
        },
        Selected: {
            showAll: "Show all"
        },
        "as-ui-kit/src/components/PhoneForm/strings": {
            "js/ru/phoneInCar": "Mobile device\nin truck",
            "js/ru/exclusiveAccess": "Exclusive access to his ATI-Trucker",
            "js/ru/phone": "Phone"
        },
        "as-ui-kit/src/components/PhoneForm/TrackerInfo/strings": {
            "js/ru/promo": "Enter the driver's mobile phone to send him a link to the application",
            "js/ru/invitedHint": "sms with link will be sent",
            "js/ru/atiTrucker": "ATI Trucker"
        },
        "as-ui-kit/src/components/PhoneForm/TrackerInfo/BindOwn/strings": {
            "js/ru/bindingTypes": {
                "driver": "to Driver",
                "car": "to Car"
            },
            "js/ru/goToAutopark": "Go to Autopark",
            "js/ru/goToCatalog": "Go to Catalog",
            "js/ru/alreadyAttached": "This number is already attached in app"
        },
        "as-ui-kit/src/components/PhoneForm/TrackerInfo/BindOther/strings": {
            "js/ru/carFromAnother": "You can't attach this Car to app [[AppLink]][[Break]]because it already attached to another firm",
            "js/ru/employedToAnotherFirm": "You can't send orders to this driver via [[AppLink]] because he is staff of firm",
            "js/ru/atiTrucker": "ATI Trucker"
        },
        "as-ui-kit/src/components/PhoneForm/BindingStatus/strings": {
            "js/ru/resend": "Send again",
            "js/ru/driverRejected": "Request is rejected",
            "js/ru/cancel": "Cancel",
            "js/ru/sent": "Request is sent",
            "js/ru/sendRequest": "Send request"
        },
        PayDocsStatus: {
            infoTextForCargoOwner:
                'Перевозчик может добавить трек-номер \nотправленных документов прямо к Заказу.\n' +
                'Вы получите уведомление, добавится статус \nв разделе «Документооборот и оплата», после чего \nвы сможете отслеживать посылку на сайте Службы \nдоставки.',
            trackNotExist: "Track number not specified",
            learnMore: "Learn more",
            carrierTrack: "Track number of the parcel from the Carrier",
            addTrackNumber: "Add track number for shipment",
            choosePaymentStatus: "Choose the status of documents and payments",
            tooltipText: "As soon as you add the track number \nCustomer will receive notifications \nand be able to track the direction \non the website of the transport company.",
            availableToCustomer: "(available to Customer)",
            trackNumber: "track number",
            status: "status",
            paymentStatusHint: "(only visible to you)",
            paymentStatus: "Payment status"
        },
        "as-ui-kit/src/components/PayDocsStatus/StatusLabel/strings": {
            "js/ru/changeTrackNumber": "Change track number for shipment",
            "js/ru/cancelDelete": "Cancel",
            "js/ru/delete": "Delete",
            "js/ru/deleteTrackNumber": "Delete track number\npermanently?",
            "js/ru/defaultCompanyName": "the transport company",
            "js/ru/ofCompany": "of company ",
            "js/ru/trackInWebsite": "Track on site ",
            "js/ru/trackNumberCopied": "Track number copied",
            "js/ru/header": "Track number",
            "js/ru/trackNumber": "track number"
        },
        "as-ui-kit/src/components/PayDocsStatus/PayDocTrackPopover/strings": {
            "js/ru/trackNotExist": "Track number not specified",
            "js/ru/learnMore": "Learn more",
            "js/ru/carrierTrack": "Track number of the parcel from the Carrier",
            "js/ru/trackNumberForShipment": "track number for shipment",
            "js/ru/trackNumber": "track number",
            "js/ru/change": "Change",
            "js/ru/add": "Add"
        },
        "as-ui-kit/src/components/PayDocsStatus/ChooseStatusForm/StatusFormRow/strings": {
            "js/ru/availableToCustomer": "(available to Customer)",
            "js/ru/tooltipText": "As soon as you add the track number \nCustomer will receive notifications \nand be able to track the direction \non the website of the transport company.",
            "js/ru/trackNumber": "track number",
            "js/ru/addTrackNumber": "Add track number",
            "js/ru/chooseDate": "choose a date"
        },
        cancel: "Cancel",
        "as-ui-kit/src/components/PayDocsStatus/ChooseStatusForm/StatusFormFooter/strings": {
            "js/ru/finishOfferRequestError": "An error occurred while completing the shipment.",
            "js/ru/saveAndArchive": "Archive",
            "js/ru/save": "Save"
        },
        "as-ui-kit/src/components/PayDocsStatus/ChangeTrackForm/TrackFormRow/strings": {
            "js/ru/chooseDate": "Choose a date",
            "js/ru/sendDate": "Sending date",
            "js/ru/inputError": "Track number must contain only numbers and Latin letters",
            "js/ru/trackNumber": "Track number",
            "js/ru/trackUrl": "Link to the website of the delivery service",
            "js/ru/chooseTransportCompany": "Choose a transport company",
            "js/ru/transportCompany": "Transport company",
            "js/ru/body": "As soon as you add the track number Customer will receive\n notifications and be able to track the direction on the website\n of the transport company."
        },
        "as-ui-kit/src/components/PayDocsStatus/ChangeTrackForm/TrackFormFooter/strings": {
            "js/ru/cantSaveForm": "You cannot save the track number, \nuntil all required fields are filled",
            "js/ru/delete": "Delete track number",
            "js/ru/save": "Save",
            "js/ru/cancel": "Cancel",
            "js/ru/add": "Add track number"
        },
        "as-ui-kit/src/components/PayDocsStatus/ChangeTrackForm/TrackFormFooter/ConfirmDeletePopover/strings": {
            "js/ru/dontDelete": "Do not delete",
            "js/ru/delete": "Delete",
            "js/ru/confirmDelete": "Delete track number permanently?"
        },
        ParticipantsPopup: {
            noPermissionsText: "Only contacts with access to load unit can work with load",
            anotherPtWinner: "Another bidder through the auction won.",
            update: "Update",
            noWinners2: "Cancel the auction and start it over",
            noWinners1: "There are no winners.",
            winnerRemovedFromBoard2: "Select other",
            winnerRemovedFromBoard1: "The winner has been removed from a Platform.",
            winnerTimeExpiredNoNext2: "or start the auction over",
            winnerTimeExpired2: "or select the next participant",
            waitForWinner: "You can wait for the data from the winner",
            finished: "Auction has ended",
            untilEnd: " until end of Auction.",
            startRate: "start rate.",
            participants: {
                other: "participants",
                many: "participants",
                few: "participants",
                one: "participant"
            },
            noParticipants: "No participants",
            Participant: {
                atrucksTooltip: "Third-party system for automating work with transport companies",
                ptParticipant: "Participant of redeployed auction",
                tooltipRate: "Participant make bid",
                bestRateAndDate: "Best rate and date",
                bestDate: "Best date",
                bestRate: "Best rate",
                or: " or ",
                noAccessText: "You don't have rights for this operation. Contact administrator to get rights",
                at: "in",
                yearStr: "yr.",
                shouldSend: ["Winner should send docs in ", ""],
                dontSend: "Winner do not send docs yet.",
                winnerConfirmed2: "orders",
                winnerConfirmed1: "Winner has taken a load. Please, see info about a driver and a truck in ",
                exWinner: "You have refused the proposal of the participant",
                shipperRefused: "Order is rejected by cargo owner",
                carrierRefused: "Carrier refused Order",
                refused: "Participant refused to participate in the auction.",
                skipped: "Do not send docs in time.",
                winnerRemovedFromBoard: "Winner is removed from Platform.",
                removedFromBoard: "Participant is removed from Platform.",
            },
        },
        loadingDate: "Loading date",
        participant: "Participant",
        outputStrings: "Display rows",
        "as-ui-kit/src/components/PaginationBlock/Pagination/strings": {
            "js/ru/from": "from"
        },
        orderLoadNumber: "Load/lot/order № ",
        orderNumber: "Order №",
        "as-ui-kit/src/components/OfferTracker/TrackerSummary/LinkToRouteOnMap/strings": {
            "js/ru/routeOnMap": "Route on map"
        },
        "as-ui-kit/src/components/OfferTracker/TrackerSummary/FinishedStatusView/strings": {
            "js/ru/eventDateTime": "{{day}} at {{time}}",
            "js/ru/driverRevoked": "Driver was revoked from deal",
            "js/ru/driverRejectedDeal": "Driver rejected deal",
            "js/ru/driverFinishedDeal": "Driver finished deal",
            "js/ru/cancelledDeal": "cancelled deal",
            "js/ru/finishedDeal": "finished deal"
        },
        "as-ui-kit/src/components/OfferTracker/TrackerSummary/Accidents/strings": {
            "js/ru/4": "data wasn't available",
            "js/ru/3": "part of the route with GPS turned off",
            "js/ru/2": "breakdown",
            "js/ru/1": "accident",
            "js/ru/0": "GPS fake attempt"
        },
        "as-ui-kit/src/components/OfferTracker/TrackerInWorkStatus/strings": {
            "js/ru/driverWillSendDataFromApp": "Driver took the order, but has not yet started working on it",
            "js/ru/from": "from",
            "js/ru/ed": "ed.",
            "js/ru/fromApp": "from ATI Driver app"
        },
        "as-ui-kit/src/components/OfferTracker/TooltipMessage/strings": {
            "js/ru/gpsSpoof": "in driver's phone\nenabled feature allowed to\nspoof GPS ({{initialPhone}}).",
            "js/ru/gpsOff": "GPS is off in settings\nof driver's phone ({{initialPhone}}).\nThere is no data about location.",
            "js/ru/noData": "data stopped coming.\nDriver's phone may be off or not\nconnected to internet ({{initialPhone}}).",
            "js/ru/youAndOwner": "to you and load owner",
            "js/ru/onlyYou": "only to your firm",
            "js/ru/rejectionInfoAvailable": "Information about\nrejection is available",
            "js/ru/infoAvailable": "Information is available",
            "js/ru/dataAvailable": "Map and\norders status from app is available",
            "js/ru/activity": "Last active {{lastActive}} in\nATI Driver app ({{initialPhone}})."
        },
        "as-ui-kit/src/components/OfferTracker/StatusDescriptions/strings": {
            "js/ru/notConfirmed": "The driver did not confirm receipt of the order in the application",
            "js/ru/finishedByCounterpart": "[[FirmName]] finished order",
            "js/ru/finished": "Driver finished order",
            "js/ru/revoked": "You've revoked order",
            "js/ru/notSentDataExpected": "Enter the data for transportation\nto send the order to the driver",
            "js/ru/notSent": "Data for driver\nis not set",
            "js/ru/rejectionReason": "rejection reason",
            "js/ru/rejected": "Driver has rejected order",
            "js/ru/sent": "Order is sent to [[DriverPhone]]\nDriver not started order yet.",
            "js/ru/sentShort": "The order has been sent to",
            "js/ru/sendToSeeOnMap": "Send order in app,\nto see load on the map.",
            "js/ru/awaitingDriver": "Waiting, wile driver won't start order.",
            "js/ru/carrierRevoked": "Carrier has revoked order\nfrom driver. There is no new data yet."
        },
        "as-ui-kit/src/components/OfferTracker/StatusBadge/strings": {
            "js/ru/gpsSpoof": "GPS spoof",
            "js/ru/gpsOff": "GPS off",
            "js/ru/finished": "order finished",
            "js/ru/revoked": "order revoked",
            "js/ru/rejected": "order rejection",
            "js/ru/notInWork": "not in work",
            "js/ru/inWork": "in work",
            "js/ru/sent": "order is sent",
            "js/ru/notSent": "order is not sent",
            "js/ru/noData": "no data",
            "js/ru/atiTrucker": "ATI Driver"
        },
        "as-ui-kit/src/components/OfferTracker/StateWithoutDriver/strings": {
            "js/ru/toWatchCargoOnMap": "to see the cargo on the map",
            "js/ru/inAtiDriver": "to ATI Driver",
            "js/ru/addDriverInOrder": "Add a driver to the order and invite him\n ",
            "js/ru/addDriver": "Add a driver to the order and send him an invitation "
        },
        "as-ui-kit/src/components/OfferTracker/PresenceLoading/strings": {
            "js/ru/loading": "loading...",
            "js/ru/hasTracker": "ATI Trucker"
        },
        "as-ui-kit/src/components/OfferTracker/NoTrackerAccess/strings": {
            "js/ru/atiTrucker": "ATI Driver"
        },
        "as-ui-kit/src/components/OfferTracker/NoInWorkAccess/strings": {
            "js/ru/carrierReceivesFromApp": "Carrier receives statuses from ATI Driver app",
            "js/ru/changingStatuses": "Changing of status unavailable"
        },
        "as-ui-kit/src/components/OfferTracker/MapActionsContainer/strings": {
            "js/ru/dialogDescription": "ATI Driver",
            "js/ru/chat": "Chat",
            "js/ru/shareLinkDescription": "share link",
            "js/ru/shareLink": "Share link",
            "js/ru/sharedWithCounterpartyDescription": "visible to you and the customer",
            "js/ru/onlyForYouDescription": "only visible to you",
            "js/ru/sharedWithCounterparty": "Visible to you and the customer",
            "js/ru/onlyForYou": "Only visible to you",
            "js/ru/map": "Map"
        },
        "as-ui-kit/src/components/OfferTracker/MainActions/strings": {
            "js/ru/revokeData": "Revoke order",
            "js/ru/dataForDriver": "Data for driver",
            "js/ru/configure": "Configure",
            "js/ru/resendOrder": "Send order again",
            "js/ru/sendOrder": "Send order",
            "js/ru/setData": "Set data"
        },
        ActionsButtons: {
            dialogDescription: "ATI Driver",
            chat: "Chat",
            shareLink: "Share the link",
            sharedWithCounterpartyDescription: "visible to you and the customer",
            onlyForYouDescription: "visible only to you",
            sharedWithCounterparty: "Visible to you and the customer",
            onlyForYou: "Visible only to you",
            map: "Map"
        },
        InDevelopmentButton: {
            inDev: "In development"
        },
        OfferInformationDriver: {
            willProvideDataLater: "Provide data later",
            fromDealModifier: "(from deal)",
            registration: "Registration",
            seriesNumber: "Series, number",
            selectDriver: "Select driver",
            searchDrivers: "Search drivers",
            driverLicense: "Driver license",
            passportIssuedWhen: "Issue date",
            passportIssued: "Issued",
            passportNumber: "Number",
            passportSeries: "Series ",
            passport: "Passport",
            enlistedDriver: "enlisted driver",
            enlisted: "enlisted",
            edit: "Edit",
            driverNotFound: "Driver not found",
            driver: "Driver",
            clickToAddDriver: "Click to add new one",
            addDriver: "Add driver"
        },
        UseTrackerCheck: {
            fromTracker: "from ATI Trucker",
            shareData: "Share data with customer"
        },
        OfferInformationDriverFooter: {
            editHint: "Provide a phone number to send orders to this driver in ATI Driver",
            editHintLink: "Please provide a phone number",
            willNotShare: "map and status from ATI Trucker are available only for you",
            willShare: "you share map and status from ATI Trucker with cargo owner",
            nlistedDriver: "enlisted driver"
        },
        TrackerSharing: {
            howTrackerWorks: "How ATI Tracker works",
            youWillSee: "You could see the load on map and actual order status.",
            carrierWillShare: "Carrier will share information from ATI Trucker"
        },
        OfferInformationCar: {
            willProvideDataLater: "Provide data later",
            fromDealTip: "from deal",
            fromDealModifier: "(from deal)",
            remove: "Remove",
            unknownCarType: "unknown car body type",
            vehicle: "vehicle",
            clickToAddVehicle: "Click to add new one",
            vehicleNotFound: "Vehicle not found",
            edit: "edit",
            chooseSemiTrailer: "Choose the semitrailer",
            chooseTrailer: "Choose the trailer",
            chooseVehicle: "Choose vehicle",
            searchVehicles: "Search vehicles",
            addVehicle: "Add vehicle",
            addSemiTrailer: "Add semitrailer",
            addTrailer: "Add trailer",
            addTruck: "Add lorry",
            carTypeNames: {
                trailer: "Trailer",
                semitrailer: "Semitrailer",
                tractor: "Tractor Unit",
                truck: "Truck"
            }
        },
        Contractors: {
            readMoreLink: {
                text: "Read more about catalog",
            },
            button: "Add a counterparty",
            header: "Your counterparties",
        },
        Organizations: {
            readMoreLink: {
                text: "Read more about catalog",
            },
            narrow: {
                text: [
                    "And use them in the documents when ordering on the website",
                ]
            },
            button: "Add an organization",
            header: "Add the details of your organization and those you often work with",
        },
        Drivers: {
            readMoreLink: {
                text: "Read more about catalog",
            },
            button: "Add a driver",
            header: "Add a driver",
        },
        Transport: {
            readMoreLink: {
                text: "Read more about catalog",
            },
            header: "Add a transport",
        },
        CompletedItems: {
            wide: {
                header: "Order",
                text: [
                    "Make shipping arrangements in a few steps through the ATI.SU website. You can make an Order if the shipper offers you the load on the Platform, or in a personal invitation.",
                    "You will recognize such a load by the \"Accept the load\" button. As soon as you click it, the load is yours. The site itself will draw up a contract(request), you only have to sign it.",
                ],
            },
            button: "Learn more",
            header: "The loads for which the Orders are completed will be stored here",
        },
        Completed: {
            wide: {
                header: "Order",
                text: [
                    "Make shipping arrangements in a few steps through the ATI.SU website. You can make an Order if the shipper offers you the load on the Platform, or in a personal invitation.",
                    "You will recognize such a load by the \"Accept the load\" button. As soon as you click it, the load is yours. The site itself will draw up a contract(request), you only have to sign it.",
                ],
            },
            button: "Learn more",
            header: "The loads for which the Orders are completed will be stored here",
        },
        Payments: {
            wide: {
                header: "Order",
                text: [
                    "Make shipping arrangements in a few steps through the ATI.SU website. You can make an Order if the shipper offers you the load on the Platform, or in a personal invitation.",
                    "You will recognize such a load by the \"Accept the load\" button. As soon as you click it, the load is yours. The site itself will draw up a contract(request), you only have to sign it.",
                ],
            },
            text: [
                "You will be able to track when documents and payment for the Order are sent and received.",
            ],
            button: "Learn more",
            header: "Here will be the status of payment and movement of documents",
        },
        InProgressItems: {
            wide: {
                header: "Order",
                text: [
                    "Make shipping arrangements in a few steps through the ATI.SU website. You can make an Order if the shipper offers you the load on the Platform, or in a personal invitation.",
                    "You will recognize such a load by the \"Accept the load\" button. As soon as you click it, the load is yours. The site itself will draw up a contract(request), you only have to sign it.",
                ],
            },
            text: [
                "These are the loads from Orders for which the request has been signed, and the load is awaiting transportation or is in transit.",
            ],
            button: "Learn more",
            header: "Here will be loads in progress",
        },
        InProgress: {
            wide: {
                header: "Order",
                text: [
                    "Make shipping arrangements in a few steps through the ATI.SU website. You can make an Order if the shipper offers you the load on the Platform, or in a personal invitation.",
                    "You will recognize such a load by the \"Accept the load\" button. As soon as you click it, the load is yours. The site itself will draw up a contract(request), you only have to sign it.",
                ],
            },
            text: [
                "These are the loads from Orders for which the request has been signed, and the load is awaiting transportation or is in transit.",
            ],
            button: "Learn more",
            header: "Here will be loads in progress",
        },
        ReconciliationItems: {
            wide: {
                header: "Order",
                text: [
                    "Make shipping arrangements in a few steps through the ATI.SU website. You can make an Order if the shipper offers you the load on the Platform, or in a personal invitation.",
                    "You will recognize such a load by the \"Accept the load\" button. As soon as you click it, the load is yours. The site itself will draw up a contract(request), you only have to sign it.",
                ],
            },
            text: [
                "These are loads that carriers will take on Orders but have not yet signed the contract",
            ],
            button: "Learn more",
            header: "Here will be the loads at the coordination",
        },
        Reconciliation: {
            wide: {
                header: "Order",
                text: [
                    "You will recognize such a load by the \"Accept the load\" button. As soon as you click it, the load is yours. The site itself will draw up a contract(request), you only have to sign it.",
                    "You will recognize this load by the \"Pick up load\" button. As soon as you click it, the load is yours. The website itself will draw up a contract, you just need to sign it.",
                ],
            },
            text: [
                "These are loads that you will take on Orders, but have not yet signed a contract",
            ],
            button: "Learn more",
            header: "Here will be the loads at the coordination",
        },
        archive: {
            narrow: {
                text: [
                    "Here will be displayed loads that are not currently published on the website",
                ],
            },
            button: "Add a load",
            header: "Archive of loads is empty",
        },
        published: {
            actions: {
                restore: "restore them from the archive",
                add: "Add them or ",
            },
            button: "Add a load",
            header: "Here will be your loads",
        },
        noAccessToAddingLoadText: "You are not allowed to add a load. Contact your administrator to get the access.",
        noFilteredLoads: "There are no such loads in the list. Try removing the filter or searching using other parameters",
        clearFilter: "Remove a filter",
        trailer: "Trailer",
        semitrailer: "Semi-Trailer",
        tractor: "Tractor Unit",
        truck: "Lorry",
        add: "Add",
        notFound: "Not found",
        // "en": {
        //     "js/DEFAULT_EXPORT/Organizations/header": "Add details of your organization and of those with whom you often work"
        // },
        pressToCalculate: "Press to calculate.",
        insureLoadAndGetCashback: "Insure the load and get cashback from 5%.",
        insureLoad: "Insure the load",
        LoadFiles: {
            otherDocuments: "documents",
            oneDocument: "document",
            manyDocuments: "documents",
            fewDocuments: "documents"
        },
        LargeCities: {
            km: "km",
            bkg: "nearby large cities"
        },
        InviteButton: {
            invite: "Invite"
        },
        LimitsPopover: {
            orders: {
                other: "orders",
                many: "orders",
                few: "orders",
                one: "order",
            },
            doNotInvite: "Do not invite",
            invite: "Invite",
            doInviteCarrier: "Invite the carrier if you want him to take the order despite the limit.",
            editInCatalogs: "Edit in the Catalogs",
            max: "max.",
            youSetLimit: "You set a limit on the simultaneous number of orders in work:",
            title: "Order limit reached"
        },
        insuranceConditions: "Insurance conditions",
        promoText: "Insure the load to receive compensation for loss or damage to the load for any accidental reason.",
        InWorkStatusSelect: {
            visibleForOwnerControlledFromTracker: "The status is visible to you and the carrier. \nStatus can only be changed by the driver.",
            youAndOwner: "The status is visible to you and the customer. Only the driver can change the status \n. ",
            onlyYou: "The status is visible only to your company. \nStatus can only be changed by the driver.",
            ownerInfo: "The status is visible to you and the carrier",
            info: "The status is visible to you and the customer",
            noStatus: "No status",
            placeholder: "Select status"
        },
        ImagesUploader: {
            carsPhotos: "Vehicle photos"
        },
        HistoryPopup: {
            load: "Load #",
            emptyHistory: "There were no Orders, Bidding and counteroffers for this load",
            actionColumnName: "Activity",
            timeColumnName: "time",
            dateColumnName: "Date",
            title: "History of Bidding and Orders"
        },
        FileDownloadButton: {
            downloadExcel: "Download History (Excel)"
        },
        ChooseDropdown: {
            offer: "All counter offers",
            deal: "The entire history of the trade",
            auctionrate: "All bids on the Bidding",
            auction: "The entire history of the Bidding",
            all: "All activities",
            show: "Show"
        },
        GlyphButtonHistory: {
            history: "History"
        },
        GeoPositionPromo: {
            promoNotice: 'Track your orders in real time\n using the free ATI Driver service.',
            sensorSharingNotice: 'The customer will see the location of the vehicle with the cargo on the map\n of the GPS monitoring system in which the sensor is registered.',
            moreAboutShipperTracker: "How ATI Driver works",
            trackerShipperNotice: "and get the current order status",
            sensorShipperNotice: "GPS tracking systems",
            shipperNotice: "You will be able to see the shipment on the map",
            shipperHeader: "Shipper will share location data",
            moreAboutTracker: "More about ATI Driver",
            trackerSharingNotice: "The customer will see the order status and the loaded truck on the map.",
            sharingNotice: "It can increase trust and influence your choice of performer.\n",
            showGeoData: "Show the customer location data",
            sectionName: "Control cargo transportation"
        },
        FirmReputation: {
            unfairPartnerAbbr: "UP",
            claimAbbr: "c",
            recommendationAbbr: "r",
            otherFirms: "firms",
            manyFirms: "firms",
            twoFirms: "firms",
            oneFirm: "firm",
            unfairPartners: "Mentions on \"Unfair Partners\" forum: from {0} {1}",
            claims: "Claims: ",
            recommendations: "Recommendations: "
        },
        Firm: {
            claimsAbbr: "c",
            unfairPartnerAbbr: "up",
            recommendationAbbr: "r",
            otherDocs: "documents",
            manyDocs: "documents",
            twoDocs: "documents",
            oneDoc: "document",
            otherFirms: "firms",
            manyFirms: "firms",
            twoFirms: "firms",
            oneFirm: "firm",
            unfairPartners: "Mentions on \"Unfair Partners\" forum: from {{count}} {{string}}",
            claims: "Claims: ",
            recommendations: "Recommendations: ",
            document: "Granted {{count}} {{string}}",
            code: "Code"
        },
        drop: "Clear",
        allParametersCompact: "More",
        allParameters: "More",
        ExtraPoints: {
            unloading: "unloading",
            otherPoints: "points",
            onePoint: "point",
            manyPoints: "points",
            loading: "loading",
            fewPoints: "points",
            extraPointsAbbr: "add. {{type}} {{point}}"
        },
        take_lot_access_denied: "You are not authorized to perform this action.",
        take_load_access_denied: "You are not authorized to perform this action.",
        access_denied: "You are not authorized to perform this action.",
        ui_error: "Error occurred",
        contact_access_denied_error: "Insufficient rights",
        cannot_choose_winner: "Cannot change winner",
        invitation_not_found_error: "Error occurred",
        load_not_found_error: "Can't take load",
        load_cant_reserve: "Can't reserve load",
        load_cant_take: "Can't take load",
        close: "Close",
        access_denied_reason: `<p>Для того, чтобы работать с Заказами, у вас должны быть следующие доступы:</p>
        <ul>
            <li>Работать с площадками</li>
            <li>Брать грузы для оформления Заказов</li>
        </ul>
         <p>Чтобы вы могли одобрить заявку, потребуется доступ:</p>
            <ul>
                <li>Подписывать и одобрять документы в АТИ-Доках</li>
             </ul>
         </p>
         <p>Эти права вам может дать администратор или руководитель аккаунта. Права настраиваются в кабинете, в окне редактирования контакта.</p>`,
        take_load_access_denied_reason: `<p>Для того, чтобы работать с Заказами, у вас должен быть следующий доступ:</p>
        <ul>
            <li>Брать грузы для оформления Заказов</li>
        </ul>
         <p>Это право вам может дать администратор или руководитель аккаунта. Права настраиваются в кабинете, в окне редактирования контакта.</p>`,
        take_lot_access_denied_reason: `<p>Для того, чтобы работать с Заказами, у вас должен быть следующий доступ:</p>
        <ul>
            <li>Брать грузы для оформления Заказов</li>
        </ul>
         <p>Это право вам может дать администратор или руководитель аккаунта. Права настраиваются в кабинете, в окне редактирования контакта.</p>`,
        defaultError: {
            reason: "Please try reloading the page."
        },
        EditArea: {
            cancel: "Cancel"
        },
        DriverSelect: {
            driver: "Driver",
            clear: "Clear"
        },
        DriverEmployedToAnother: {
            carFromAnother: "You can't link a vehicle to the [[AppLink]] app because it is linked to a company",
            employedToAnotherFirm: "You can't send orders to this driver via [[AppLink]] because he is staff of firm",
            atiTrucker: "ATI Trucker"
        },
        toWhere: "To",
        fromWhere: "From",
        clear: "Clear",
        selectedDepartments: "selected",
        allDepartments: "All units",
        deletedDepartments: "Deleted units",
        allDocsWithoutCount: {
            allDocsWithoutCount: "All documents",
            allDocs: "All documents ({{docsCount}})",
            edited: "edited",
            notSent: "not sent",
            document: "Document "
        },
        CounterpartySelect: {
            auctionsWinner: "Auction Winner",
            firm: "ATI Firm",
            clear: "Clear",
            counterparty: "Carrier"
        },
        willBeShown: "Loads of active contact will be displayed.",
        areShownNow: "Loads of active contact are being displayed now.",
        loadsForAllContacts: " loads of all contacts on Your freight offers page.",
        dontShow: "Don't show",
        show: "Show",
        allContacts: "All contacts",
        City: {
            unloading: "Unloading",
            loading: "Loading",
            tooltipCoords: "{{type}} location"
        },
        CargoOwnerHelpPopover: {
            moreAboutOrders: "More about Orders",
            carrierHasReservedTheLoad: "Carrier has reserved the load."
        },
        CancelWinnerPopover: {
            notChooseAsWinner: "Do not choose",
            goingToChooseNewWinnerText: "The current winner has already got an order\nwith your cargo. Then he will be refused of the auction.\nThe order with be sent to a new winner.",
            goingToChooseNewWinner: "You are going to choose\na new winner",
            chooseAsWinner: "Choose as a winner"
        },
        orderWillBeCancelled: 'Заказ будет перемещён в архив\n' + 'и отмечен как отменённый',
        notCancel: "Don't cancel",
        confirmCancelOrder: "Cancel order",
        CancelAuctionActions: {
            noAccessText: "You do not have permission to cancel Bidding. Please contact your administrator to get the rights",
            willFinished: "Auction will be finished.\nAs winner will be chosen\none who offered the best bet.",
            willLoseBids: "All auction bids\nwill be lost",
            cancelFinish: "Don't finish",
            cancelCancel: "Don't cancel",
            cancel: "Cancel",
            cancelAuction: "Cancel auction",
            finish: "Finish",
            finishAheadOfTime: "Finish ahead of time"
        },
        BlackListLabel: {
            tooltipText: "The driver is on your blacklist",
            carrier: {
                full: "The driver is on the customer's blacklist",
                short: "blacklisted by the customer"
            },
            cargoOwner: {
                full: "The driver is on your blacklist",
                short: "Blacklisted"
            },
        },
        AuctionTimer: {
            at: "at",
            auctionEndDateBoundary: "If there are no bids, the auction will end",
            auction: "Auction",
            beforeAuctionStart: "before the start of the auction",
            untilAuctionEnd: "until the end of the auction"
        },
        AttachCar: {
            headerText: {
                semitrailer: "Semi-Trailer",
                trailer: "Trailer",
                tractorAndTruck: "Tractor unit with semi-trailer or lorry",
                truck: "Lorry",
                tractor: "Tractor Unit",
            },
            noResultsText: "not found",
            select: "Select...",
            trailer: "trailer",
            tractorAndTruck: "tractor unit with semi-trailer or lorry",
            semitrailer: "semi-trailer",
            truck: "lorry",
            tractor: "tractor unit",
            add: "Add",
            edit: "Edit",
            cancel: "Cancel"
        },
        notToSave: "Don't save",
        save: "Save",
        edit: "Edit",
        p2Text: "Changes may be lost.",
        p1Text: "You haven't saved any changes and are trying to close the window.",
        headerText: "What to do with the changes?",
        AtiPopup: {
            cancel: "Cancel"
        },
        FileUploadWrapper: {
            invalidFile: "Invalid file selected"
        },
        FileUploadItemInfo: {
            uploadError: "Failed to load. Please try again",
            uploaded: "uploaded",
            removeItem: " Delete",
            abortUpload: "Abort uploading"
        },
        AtiFileUploader: {
            uploadRequired: "Upload the files",
            upload: "Upload"
        },
        PopupOrganization: {
            removePopover: {
                contactPerson: "Delete an contact person\nfrom Catalog?",
                address: "Delete an organization's\naddress from Catalog?",
            },
            notLocation: "We did not find such a settlement",
            documentExample: "For example, IDNO 1234567-123-123",
            documentType: "Type of document and number",
            bin: "BIN",
            unp: "TIN",
            edrpou: "EDRPOU (National State Registry of Ukrainian Enterprises and Organizations)",
            officeTooltip: "Enter office, room, cubicle, apartment, etc.",
            office: "Office, space, etc.",
            building: "House, building, block, building name",
            street: "Street, Avenue, Alley, Boulevard, etc.",
            locality: "Locality",
            postcode: "Index",
            organizationPhone: "Organization phone number",
            locationAddress: "Location address for documents",
            inn: "TIN",
            residency: "Residency",
            fullOrganizationName: "Full name",
            other: "(other)",
            available: "Available",
            notResultOwnership: "form of ownership was not found",
            nameFirm: "Company name",
            editOrganization: "Edit the organization",
            addOrganization: "Add organization",
            addAddressDescription: "(address of warehouse, store or office)",
            addAddress: "Add a warehouse",
            addresses: "Addresses",
            addContactPerson: "Add a contact person",
            contactPersons: "Contact persons",
            extraPhone: "Ext.",
            add: "Add",
            save: "Save"
        },
        RevokedBinding: {
            popover: {
                deleteLink: "Delete link",
                header: "The warehouse\nis disconnected from «Time slots»\nservice by its owner.",
            },
            timeslots: "«Time slots»"
        },
        AcceptedBinding: {
            popover: {
                writeToPartner: "Write to a partner",
                showTimeslots: "View availability",
                address: "Warehouse address",
                faq: "Read more about service",
                header: "The warehouse is connected to the\n«Time slots» service",
            },
            timeslots: "«Time slots»"
        },
        UnbindTimeslots: {
            breakNotification: "You broke the link with your partner's warehouse.",
            breakQuestion: "Break the link with the partner's warehouse?",
            dontBreak: "Don't break",
            break: "Break",
            breakLink: "Break the link"
        },
        EntityRemovePopup: {
            dontDelete: "Don't delete",
            delete: "Delete"
        },
        Entity: {
            edit: "Edit",
            remove: "Delete"
        },
        DepartmentsSelector: {
            selectedDepartments: "to selected units",
            allDepartments: "to all units"
        },
        ContactEntity: {
            extraPhone: "Ext."
        },
        AddressEntity: {
            shortCity: "yr."
        },
        AddOrganizationContactPopup: {
            editContactPerson: "Edit contact person",
            addContactPerson: "Add a contact person",
            fullName: "Full name",
            extraPhone: "Ext.",
            phone: "Phone",
            add: "Add",
            "save": "Save"
        },
        AddOrganizationAddressPopup: {
            placeholderAddress: "district, street, house",
            coordinates: "Coordinates",
            selectOnMap: "Select on the map",
            enter: "Start typing",
            addressWithoutCity: "Address (without city)",
            locality: "Locality",
            withoutContactPerson: "No contact person",
            nothingFound: "Nothing found.",
            selectAddressContactPerson: "Select contact person address",
            placeholderShedule: "Mon-Fri: 9 a.m. to 8 p.m., Sat-Sun: –",
            note: "Note",
            schedule: "Working hours",
            type: "Type",
            editAddress: "Edit {{addressTypeName}} address",
            addAddress: "Add {{addressTypeName}} address",
            addContactPerson: "Add a contact person",
            contactPerson: "Contact person",
            add: "Add",
            save: "Save"
        },
        AddEditCarPopup: {
            cancel: "Cancel",
            semitrailer: "semi-trailer ",
            save: "Save",
            trailer: "trailer",
            tractor: "tractor unit",
            truck: "lorry",
            edit: "Edit",
            add: "Add",
            ts: "Vehicle",
            description: {
                own_duplicate_error: "It is already listed in your Vehicle Fleet.",
                duplicate_error: "It is already listed as an owned vehicle by another ATI.SU participant. However, if it is your vehicle, temporarily check the \"Hired Transport\" box, attach a scan of the title or vehicle registration certificate, and contact Technical Support to create a Ticket or call 8 812 602-01-09 ext. 160. We will fix it."
            },
            header: {
                duplicate_error: "You can't list a vehicle as your own.",
                own_duplicate_error: "You cannot add a vehicle."
            }
        },
        CarPopupForm: {
            truck: "Lorry",
            tractorWithSemitrailer: "Tractor unit with semi-trailer"
        },
        GeneralCarFormWrapper: {
            semitrailer: "semi-trailer",
            trailer: "trailer",
            tractor: "tractor unit",
            truck: "lorry",
            edit: "Edit",
            add: "Add"
        },
        GeneralCarForm: {
            semitrailer: "Semi-Trailer",
            trailer: "Trailer",
            truck: "Lorry",
            tractor: "Tractor Unit",
            rentContactHintText: "Photo or scan",
            marriageHintText: "Photo or scan of the certificate",
            documentHintText: "Photos or scans of documents on 2 sides",
            contractHintText: "If the vehicle is not in the ownership",
            ownershipType: "Type of vehicle ownership",
            required: " (required)",
            uploadGratuitousContractScan: "Upload the gratuitous contract",
            uploadMarriageScan: "Upload a marriage certificate",
            uploadPhotos: "Upload Vehicle photos",
            uploadLeasingContractScan: "Upload the leasing agreement",
            uploadRentContractScan: "Upload the rental agreement",
            uploadPTSScanOrPlastic: "Upload the vehicle registration certificate and title",
            attractedCar: "Hired vehicle",
            documentsHeader: "Vehicle documents"
        },
        TractorAdditionallyParams: {
            header: "More",
            canCarryHeavyContainer: "possible to carry heavy containers",
            hasGenset: "Genset (mounted generator) is available",
            canRefrigerator: "possible to carry refrigerated containers",
            externalId: 'ID'
        },
        ShowInFirmInfo: {
            tooltipDisabled: "To be displayed in the card, the vehicle must not be hired",
            tooltip: "For freight owners it is important not only the reputation of the company, but also the availability of the carrier's own fleet of vehicles",
            text: "Show in your ATI.SU participant passport"
        },
        ReserveByDriverBlock: {
            noAvailableDrivers: "No available drivers",
            cancel: "Cancel",
            select: "Select...",
            addDriver: "Add a driver",
            reserve: "Assign to the driver",
            reserveByDriver: "Add and assign a driver"
        },
        CarSensors: {
            delete: "Delete",
            update: "Edit",
            addSensor: "Add a sensor",
            helperText: "GPS/GLONASS sensor in the vehicle",
            geoposition: "Vehicle geoposition"
        },
        CarOwnershipType: {
            gratuitousUse: "gratuitous use",
            spousesJoint: "joint property of spouses",
            leasing: "leasing",
            rental: "rental",
            hired: "hired",
            owned: "owned",
            ownerName: "Owner according to the vehicle registration certificate",
            ownershipType: "Type of ownership"
        },
        CarInfo: {
            pts: "Vehicle Title",
            vin: "VIN",
            vrcFull: "Vehicle Registration Certificate series and number",
            manufactureYear: "Year of manufacture",
            number: "License plate",
            noBrandText: "This make doesn't exist. Please type in a different one.",
            vrc: "Registration Certificate",
            hasBodyNumber: "no VIN",
            hasVin: "there is a VIN",
            bodyNumber: "Body",
            model: "Model",
            mark: "Make",
            clear: "Clear",
            cancel: "Cancel",
            exampleHint: {
                bodyNumber: "Example of chassis number",
                electronicPts: "Example of electronic title number",
                pts: "Example of title number",
                vin: "Example of VIN",
                vrc: "Example of vehicle registration certificate number",
            },
            description: {
                bodyNumber: "In the vehicle title, vehicle registration certificate, warranty/technical inspection certificate or in the insurance policy for the vehicle. \n\nOn non-detachable components of the body or chassis and on specially made license plates (nameplates).",
                pts: "The vehicle title is one of the main documents for a car, which contains information about the technical characteristics of the vehicle, \n\ninformation about the owners and registration of the vehicle.",
                vin: "In the vehicle title, vehicle registration certificate, warranty/technical inspection certificate or in the insurance policy for the vehicle. On non-detachable components of the body or chassis and on specially made license plates (nameplates).",
                vrc: "The Vehicle Registration Certificate (VRC) is one of the main documents for a vehicle. The VRC is issued at the registration departments of the Traffic Police of the Ministry of Internal Affairs of the Russian Federation after the vehicle (car, motorcycle, trailer, etc.) is registered. The document is printed at the \"Goznak\" factory and is laminated, featuring various degrees of protection.",
            },
            header: {
                bodyNumber: "How to find the chassis number",
                pts: "What the vehicle title looks like",
                vin: "How to find VIN",
                vrc: "What the vehicle registration certificate looks like"
            },
        },
        CarDimensions: {
            fillDimensions: "Enter the correct dimensions",
            height: "Height, m",
            width: "Width, m",
            length: "Length, m",
            internalDimensions: "Internal dimensions"
        },
        CarBodySize: {
            capacity: "Load capacity, t",
            meter: "m",
            volume: "Volume"
        },
        CarBody: {
            containerSizes: [
                "20' container single",
                "20' container chassis",
                "20' double container chassis",
                "40' flatbed container chassis",
                "40' standard container chassis",
                "45' flatbed container chassis",
                "45' standard container chassis",
                "20' tank container chassis",
                "40' tank container chassis",
                "40' extendable container semitrailer"
            ],
            dimension: "Container size",
            select: "Type of body",
            body: "Vehicle characteristics"
        },
        CanCarryTallContainers: {
            canCarryTallContainer: "Possible to carry high cube containers"
        }
    },
    "ky": {
        of: (count: number, total: number) => <>{total}-дан {count}</>,
        phoneWrong: "+7 (999) 999 99 99 форматында номурду киргизиңиз",
        extraDigits: "Номурду текшериңиз - анда ашык сандан бар",
        missingDigits: "Номурду текшериңиз - анда сандар жетишсиз",
        emailWrong: "Бул email эмес. Анда ката жок бекен, текшериңиз.",
        lessThanMinDate: "Дата {{minDate}} кем эмес болушу керек",
        notValidDepartmentCode: "Бөлүмдүн коду 000-000 форматында болушу керек",
        onlyNumbers: "Сандарды гана киргизүү болот",
        choosePackageType: "Таңгактоо типин тандоо керек",
        notValidTrackNumber: "Трек-номуру сандарды, латын тамгаларын, символдорду камтыш керек.",
        notValidUrl: "Туура эмес URL дарек",
        emptyCoordinates: "Тизмедеги даректи тандаңыз же картадан көрсөтүңүз",
        invalidDateString: "Туура эмес дата",
        invalidTimeString: "Туура эмес убакыт",
        wrongRangeEnd: "Туура эмес диапазон",
        wrongCheckSum: "Туура эмес контролдук сумма",
        symbols: {
            many: "символ",
            few: "символ",
            one: "символ"
        },
        numbers: {
            many: "сан",
            few: "сан",
            one: "сан"
        },
        numberFromTo: "{{from}} жана {{to}} ортосундагы санды киргизиңиз",
        symbolsRange: "{from}} {{to}} чейин символ киргизиңиз",
        enterPositiveNumber: "Оң санды киргизиңиз",
        numberLessThen: "Мааниси ашпоого тийиш",
        korrSchetParams: "20 сан - 301ден баштап жана БИКтин 3 акыркы саны менен аяктап.",
        OKPOLength: "8 же 10 сан",
        OKPOCheckNumber: "Жараксыз контролсук сан",
        twentySymbolsNoSpaces: "Боштугу жок 20 сан",
        enterValue: "Бул талаа бош болбошу керек",
        selectValue: "Маанини тандаңыз",
        requiredDigits: "{{number}} сан киргизүү керек",
        fifteenDigits: "15 сан",
        thirteenDigits: "13 сан",
        datesNotInThePast: "Өткөн датаны тандоо мүмкүн эмес",
        dateInTheFuture: "Өткөн датаны тандоо мүмкүн эмес",
        dateInThePast: "Келечекте датаны тандоо мөмкүн эмес",
        isInvalidDate: "Жараксыз дата",
        invalidDateFormat: "КК.АА.ЖЖЖЖ. форматындагы датаны киргизиңиз",
        wrongPhoneNumber: "Жараксыз телефондун номуру",
        region: "Аймакты киргизиңиз",
        carNumber: "Номурду киргизиңиз",
        lengthMessage: "символ",
        maxLengthMessage: "Макс. {{max}} символ",
        upToEightSymbols: "8 символго чейин",
        sixSevenSymbols: "6-7 символ",
        sixDigits: "Алты сан",
        fourDigits: "Төрт сан",
        notAfterCurrent: "Жыл {{currentYear}} көп болушу мүмкүн эмес",
        notBeforeMinYear: "Жыл {{minYear}} кем болушу мүмкүн эмес",
        registrationNumber: "Катталуучу номуру",
        egrpou: "ЕГРПОУ",
        unp: "ТКН",
        inn: "ИСН",
        bin: "БИН",
        iin: "ЖИН",
        // strings: {
        //     rateNds: "КНС менен",
        //     rateWithoutNds: "КНС-сиз",
        //     direct: "түз келишим",
        //     torg: "тоорук",
        //     payDays: "{0} б/к кийин",
        //     inFuel: "күй.май",
        //     prepayAlone: "алд.төлөм",
        //     prepay: "{0}% алд.төлөм",
        //     onLoad: "жүк түш.",
        //     onlyToSepCar: "өзүнчө унаа",
        //     dogruzPossible: "кош.жүктөө мүмк.",
        //     dogruz: "кошумча жүктөө",
        //     sborgruz: "чог.жүк"
        // },
        duplicate_contractor_error: "Контрагентти кошуу болбойт. Ал сиздин маалыматнаамаңызга мурунтан эле кошулган.",
        unknown_error: "Белгисиз ката",
        json_validation_error: "json валидация катасы",
        partial_execution_error: "Байланышты түзүүдө ката кетти, ТК сакталды",
        failed_save_trucks: "Кээбир ТК-ды сакталбай калды",
        failed_save_truck: "ТК сактоо болбой калды",
        customColumns: {
            historyBtn: "Жүктүн тарыхы",
            copyBtn: "Көчүрүү",
            addCommentBtn: "Сын жазуу",
            map: "Карта",
            orderStatus: "Статус",
            completion: "Бүтүрүү",
            date: "Дата",
            carrierContactPhone: "Ташуучунун байланышынын номуру",
            carrierContact: "Ташуучунун байланышы",
            carrier: "Ташуучу",
            cashRate: "Накталай чен",
            rateWithoutVAT: "Чен КНС-сиз",
            rateWithVAT: "Чен КНС менен ",
            offers: "Сунуш",
            contact: "Байланыш",
            contactWithDate: "Байланыш, кошулду/өзг.",
            driver: "Айдоочу",
            car: "ТК",
            separateCar: "Өзүнчө унаа",
            loadingUnloadingCar: "ТК-ка жүк./жүк түш.",
            bodyType: "Кузовдун түрү",
            loadParams: "Жүктүн параметрлери",
            unloading: "Жүк түшүрүү",
            loading: "Жүктөө",
            routeAddress: "Каттамдын дареги",
            route: "Каттам",
            loadNumber: "Жүктун номуру"
        },
        byDefault: "Демейки боюнча",
        columns: "Мамычалар",
        informer: "Эми сиз компакт карталарда\nмаалыматтарды көрсөтүүнү орното аласыз",
        dateInputPlaceHolder: "датаны тандаңыз",
        timeInputPlaceholder: '09:00',
        verify: "Текшерүү",
        toTime: "чейин",
        fromTime: "баштап",
        rate: "Чен (баа)",
        unloading: "Түшүрүү",
        loading: "Жүктөө",
        loadParams: {
            __html: "Салмагы, т / көлөмү, м<sup>3</sup>, жүк"
        },
        transport: "Унаа",
        direction: "Багыт",
        roundTheClock: "күнү-түнү",
        workdays: "иш күндөрүндө",
        everyday: "күн сайын",
        loadReady: "даяр",
        alwaysReady: "дайыма",
        ExpandingSection: {
            showFullInfo: "Толук көрсөтүү"
        },
        "as-ui-kit/src/controls/DocumentBlock/strings": {
            "js/ru/previousVersion": "мурунку басылышы",
            "js/ru/forContragent": "Контрагент тарабынана өзортүлдү. Сиздин ырастооңузга чейин жарактуу",
            "js/ru/forChanger": "Контрагент өзгөртүүлөрдү ырастаганга чейин, жарактуу ",
            "js/ru/transportationOrder": "Ташууга өтүнмө",
            "js/ru/sentToCounterparty": "Контрагентке жөнөтүлдү",
            "js/ru/sentThroughAtiDocs": "АТИ.Доки аркылуу жөнөтүлдү",
            "js/ru/documentApprovedByTrucker": "Документ ташуучу тарабынан бекитилди",
            "js/ru/documentApprovedByYou": "Документ сиз тарабынан бекитилди",
            "js/ru/documentSignedByTrucker": "Ташуучу документке кол койду",
            "js/ru/documentSignedByYou": "Сиз документке кол койдуңуз",
            "js/ru/documentCreated": "Документ түзүлдү",
            "js/ru/awaitsReview": "Кароону күтүп жатат"
        },
        DealUpdateTime: {
            at: "в"
        },
        ConsultantsInfo: {
            workHours: "9дан 18ге чейин МСК",
            autoparkConsultants: "Сиздин унаапаркыңызды толтурууга жардам беребиз",
            dealsConsultants: "Буйрутмалар боюнча суроолорго жооп беребиз"
        },
        CancelButton: {
            moveToArchive: "Архивге"
        },
        "as-ui-kit/src/controls/AtiSelect/AtiSelect": {
            "jsx/strings/clearValue": "Тазалоо"
        },
        AtiCarNumberInput: {
            otherCountries: "Башка өлкөлөр",
            russia: "Орусия"
        },
        "as-ui-kit/src/controls/AtiCarNumberInput/AtiCarNumberInput": {
            "jsx/carPlaceholder": "М 123 ММ 78"
        },
        "as-ui-kit/src/controls/AddressCoordinatesInput/strings": {
            "js/ru/pickOnMap": "Картадан тандоо",
            "js/ru/clearAddress": "Тазалоо",
            "js/ru/addressNotFound": "Дарек табылгын жок, аракет кылыңыз",
            "js/ru/pointOnMap": "Картадан көрсөтүү",
            "en": {
                "js/DEFAULT_EXPORT/pickOnMap": "Картадан тандоо"
            }
        },
        "as-ui-kit/src/const/unilateralOrder": {
            "js/paymentTypesOptions/paymentTypes": {
                "cash/name": "Накталай",
                "cashlessWithNds/name": "КНС менен, нак эмес",
                "cashlessWithoutNds/name": "КНСсиз, нак эмес"
            }
        },
        weekDaysLowerShortList: [
            "же",
            "дү",
            "ше",
            "ша",
            "бе",
            "жу",
            "иш",
        ],
        weekDaysShortList: [
            "Же",
            "Дү",
            "Ше",
            "Ша",
            "Бе",
            "Жу",
            "Иш",
        ],
        timeStrings: {
            months: [
                "үчтүн айынын",
                "бирдин айынын",
                "жалган куран айынын",
                "чын куран айынын",
                "бугу айынын",
                "кулжа айынын",
                "июл",
                "август",
                "сентябр",
                "октябрь",
                "ноябрь",
                "декабрда",
            ],
            shortMonths: [
                "янв",
                "фев",
                "мар",
                "апр",
                "май",
                "июн",
                "июл",
                "авг",
                "сен",
                "окт",
                "ноя",
                "дек",
            ],
            year: "ш.",
            h: "с",
            d: "к",
            min: "мүн",
            sec: "сек",
            tomorrow: "эртең",
            yesterday: "кече",
            today: "бүгүн",
            at: " ",
        },
        MonthList: [
            "Январ",
            "Феврал",
            "Март",
            "Чын куран ",
            "Бугу ",
            "Кулжа ",
            "Теке ",
            "Баш оона",
            "Сентябр",
            "Октябр",
            "Ноябр",
            "Декабр",
        ],
        "as-ui-kit/src/const/sensors": {
            "js/errors/ru/errorCodes": {
                "AuthLimitError": "Кирүү четке кагылды. Кийинчерээк кайра аракет кылыңыз",
                "BLError": "Ката кетти. Кийинчерээк кайра аракет кылыңыз"
            },
            "js/providers/scout/name": "Скаут",
            "js/providers/wialon/name": "Виалон"
        },
        "as-ui-kit/src/const/scans": {
            "js/scanTypeNames/ru/scanTypes": {
                "marriage": "Нике тууралуу күбөлүк",
                "rentContract": "Ижара келишими",
                "carPhoto": "Сүрөт",
                "plasticTechPassport": "ТККК",
                "techPassport": "ТКП",
                "passport": "Паспорт",
                "driverLicense": "АК"
            }
        },
        "as-ui-kit/src/const/requisites": {
            "js/defaultAddress/officeType": "кең.",
            "js/defaultAddress/partType": "корп.",
            "js/defaultAddress/houseType": "үй",
            "js/dictionaries/officeTypes/2/label": "бөлмө",
            "js/dictionaries/officeTypes/2/value": "бөл.",
            "js/dictionaries/officeTypes/1/label": "батир",
            "js/dictionaries/officeTypes/1/value": "бат.",
            "js/dictionaries/officeTypes/0/label": "кеңсе",
            "js/dictionaries/officeTypes/0/value": "кең.",
            "js/dictionaries/partTypes/1/label": "түзүлүш",
            "js/dictionaries/partTypes/1/value": "түз.",
            "js/dictionaries/partTypes/0/label": "корпус",
            "js/dictionaries/partTypes/0/value": "корп.",
            "js/dictionaries/houseTypes/1/label": "түзүлүш",
            "js/dictionaries/houseTypes/1/value": "түз.",
            "js/dictionaries/houseTypes/0/label": "үй",
            "js/dictionaries/houseTypes/0/value": "үй",
            "js/dictionaries/streetTypes/13/label": "а/я",
            "js/dictionaries/streetTypes/12/label": "линия",
            "js/dictionaries/streetTypes/11/label": "тракт",
            "js/dictionaries/streetTypes/10/label": "канал",
            "js/dictionaries/streetTypes/9/label": "жүрүү",
            "js/dictionaries/streetTypes/8/label": "бульвар",
            "js/dictionaries/streetTypes/7/label": "аллея",
            "js/dictionaries/streetTypes/6/label": "аянт",
            "js/dictionaries/streetTypes/5/label": "жээк",
            "js/dictionaries/streetTypes/4/label": "кыска көчө",
            "js/dictionaries/streetTypes/3/label": "шоссе",
            "js/dictionaries/streetTypes/2/label": "проспект",
            "js/dictionaries/streetTypes/1/label": "көчө",
            "js/dictionaries/streetTypes/0/label": "(башка)",
            "js/dictionaries/residences/ru/4/label": "Башка",
            "js/dictionaries/residences/ru/3/label": "Казакстан",
            "js/dictionaries/residences/ru/2/label": "Беларус",
            "js/dictionaries/residences/ru/1/label": "Украина",
            "js/dictionaries/residences/ru/0/label": "Орусия"
        },
        "as-ui-kit/src/const/payDocs": {
            "js/mappedTransportCompanyNames/ru/1": "башка",
            "js/payDocsLabels/ru/ClosingDocuments": "Жапкандар",
            "js/payDocsLabels/ru/Payment": "Төлөнгөн",
            "js/payDocsLabels/ru/DocumentsOriginalTrack": "Трек-номур",
            "js/payDocsLabels/ru/DocumentsOriginal": "Түп нускалар",
            "js/payDocsLabels/ru/DocumentsCopies": "Көчүрмөлөр",
            "js/payDocsName/ru/carrier/ClosingDocuments/name": "Жабуучу документтер алынды",
            "js/payDocsName/ru/carrier/Payment/name": "Төлөм алынды",
            "js/payDocsName/ru/carrier/DocumentsOriginal/name": "Түп нускалары жөнөтүлдү",
            "js/payDocsName/ru/carrier/DocumentsCopies/name": "Документтердин көчүрмөлөрү жөнөтүлдү",
            "js/payDocsName/ru/cargoOwner/Payment/name": "Төлөндү",
            "js/payDocsName/ru/cargoOwner/DocumentsOriginal/name": "Түп нускалар алынды",
            "js/payDocsName/ru/cargoOwner/DocumentsCopies/name": "Документтердин көчүрмөлөрү алынды"
        },
        "as-ui-kit/src/const/index": {
            "js/undefinedError": "Белгисиз ката"
        },
        "as-ui-kit/src/const/files": {
            "js/fileSourceTypeNames/ru/dealFileSourceFileTypes": {
                "freeUse": "Акысыз пайдалануу келишими",
                "truckPhoto": "Сүрөт",
                "truckPlasticTechPassport": "Пластик",
                "truckTechPassport": "ПТС",
                "driverPassport": "Паспорт",
                "driverLicense": "ВУ"
            },
            "js/fileSourceNames/ru/dealFileSourceTypes": {
                "tractor": "тягачты",
                "semiTrailer": "жарым чиркегичтин",
                "trailer": "чиркегичтин",
                "truck": "грузовиктин",
                "driver": "айдоочунун"
            }
        },
        documentTypes: {
            poa: "ишеним кат",
            uniliteralDissolution: "аткаруудан баш тартуу жөнүндөгү билдирүү",
            invoice: "эсеп",
            act: "акт",
            commission: "экспедиторго тапшырма",
            tableRequest: "келишимге өтүнмө (мамыча түрү)",
            request: "өтүнмө (келишимге)",
            order: "буйрутма",
            tableOrder: "буйрутма (мамыча түрү)",
            contract: "буйрутма (келишим-өтүнмө)"
        },
        displayedDocumentTypes: {
            commission: "Экспедиторго табыштоо",
            request: "Документ түрүндөгу өтүнмө",
            tableRequest: "Мамыча түрүндөгү өтүнмө",
            order: "Документ түрүндөгу буйрутма",
            tableOrder: "Мамыча түрүндө буйрутма",
        },
        docTypesGroups: [
            "Контрагент менен биринчи жолу иштешиңиз",
            "Келишим бар",
            "Транспорттук экспедиция келишими боюнча иштейсиз",
        ],
        additionalDocuments: {
            cancelDeal: "Аткаруудан баш тартуу тууралуу билдирүү",
            poa: "Ишеним кат",
            invoice: "Өтүнмө боюнча эсеп",
            act: "Акт (эти тараптуу)"
        },
        cancelDocuments: {
            refusalOfFulfilment: "Аткаруудан баш тартуу тууралуу билдирүү",
        },
        "as-ui-kit/src/const/documents": {
            "js/docTypeTemplates/contract": "келишим",
        },
        auctionPaymentTypes: {
            25: "КНС-сиз",
            24: "КНС менен",
            23: "картага",
            1: "нак",
            0: "каалаган"
        },
        ton: "т",
        weight: "Салмак",
        to: "чейин",
        from: "баштап",
        meter: "м",
        volume: "Көлөм",
        TruckIcon: {
            carInGratuitousUseVerifiedTooltip: "Бекер колдонуудагы тастыкталган ТК",
            carInGratuitousUseTooltip: "Бекер колдонуудагы ТК",
            carInSousesJointOwnershipVerifiedTooltip: "Жубайлардын биргелешкен менчиги болгон тастыкталган ТК",
            carInSousesJointOwnershipTooltip: "Жубайлардын биргелешкен менчиги болгон ТК",
            carExternalTooltip: "Тартылган ТК",
            carOwnVerifiedTooltip: "Тастыкталган менчик ТК",
            carOwnTooltip: "Менчик ТК",
            carInLeasingVerifiedTooltip: "Лизингтеги тастыкталган ТК",
            carInLeasingTooltip: "Лизингтеги ТК",
            carInRentVerifiedTooltip: "Ижарадагы тастыкталган ТК",
            carInRentTooltip: "Ижарадагы ТК"
        },
        TrackerStatus: {
            promoAction: "Бул кантип иштейт?",
            promoHeader: "Эми жүккө картадан айдоочулар үчүн тиркеме аркылуу көз салса болот"
        },
        LastActive: {
            exclusivePopoverLinkText: "эксклюзивдүү кирүү мүмкүндүгү",
            ago: "артка",
            activity: "активдүү",
            exclusiveAccess: "Эксклюзивдүү мүмкүндүк башка фирмада",
            installed: "орнотулду",
            hasTracker: "АТИ Айдоочу"
        },
        Invite: {
            car: {
                cantInviteTooltip: 'Приглашение можно выслать только на мобильный номер телефона. У водителя указан не мобильный. Телефон можно изменить в вашем Справочнике Водителей',
                tooManyRequests: "Чакыруу жөнөтүү аракети өтө көп. Кечирээк аракет кылыңыз.",
                toApp: "орнотууга",
                invited: "Чакыруу жөнөтүлдү",
                invite: "Чакырууну жөнөтүү",
                undefinedError: "Белгисиз ката",
                cantInvite: "Бул буйрутмадагы айдоочуну ... чакырууга болбойт",
                alreadyInvited: "Сиз мурунтан эле бул айдоочуга чакыруу жөнөткөнсүз. Кечирээк аракет кылыңыз",
                resend: "Кайталап чакыруу",
                atiTrucker: "АТИ Айдоочу"
            },
            driver: {
                                cantInviteTooltip: 'Приглашение можно выслать только на мобильный номер телефона. У водителя указан не мобильный. Телефон можно изменить в вашем Справочнике Водителей',

                tooManyRequests: "Айдоочуну чакыруу аракети өтө көп. Кечирээк аракет кылыңыз.",
                toApp: "орнотуу",
                invited: "Айдоочу чакырылды",
                sent: "жөнөтүлдү",
                invite: "Чакыруу",
                inviteDriver: "Айдоочунун чакыруу",
                undefinedError: "Белгисиз ката",
                cantInvite: "Бул буйрутмадагы айдоочуну ... чакырууга болбойт",
                alreadyInvited: "Сиз мурунтан эле бул айдоочуга чакыруу жөнөткөнсүз. Кечирээк аракет кылыңыз",
                resend: "Кайталап чакыруу",
                atiTrucker: "АТИ Айдоочу"
            }
        },
        InvitePopover: {
            car: {
                exclusiveDescription:
                    'Только вы сможете отправлять\n' +
                    'заказы водителю, получать\n' +
                    'актуальные статусы перевозки,\n' +
                    'отслеживать местоположение\n' +
                    'груза на карте.',
                smsIsSent: "Телефондун номурурна смс жөнөтүлдү",
                caption: "Сиздин телефонуңуздун номуруна тиркемени жүктөп алуу шилтемеси менен смс жөнөтүлөт",
                invite: "Чакырууну жөнөтүү",
                exclusiveAccess: "Анын АТИ-Айдоочусуна эксклюзивдүү мүмкүндүк",
                onlyAndroid: "Тиркеме Android-те гана иштейт",
                sendSms: "СМС жөнөтүү",
                atiDriver: "АТИ Айдоочу"
            },
            driver: {
                exclusiveDescription:
                    'Только вы сможете отправлять\n' +
                    'заказы водителю, получать\n' +
                    'актуальные статусы перевозки,\n' +
                    'отслеживать местоположение\n' +
                    'груза на карте.',
                smsIsSent: "Айдоочуга смс жөнөтүлдү",
                caption: "Айдоочуга тиркемени жүктөп алуу шилтемеси менен смс жөнөтүлөт",
                invite: "Айдоочуну чакыруу",
                exclusiveAccess: "Анын АТИ-Айдоочусуна эксклюзивдүү мүмкүндүк",
                onlyAndroid: "Тиркеме Android-те гана иштейт",
                sendSms: "СМС жөнөтүү",
                atiDriver: "АТИ Айдоочу"
            }
        },
        "as-ui-kit/src/components/TrackerLink/strings": {
            "js/ru/atiTrucker": "АТИ Айдоочу"
        },
        "as-ui-kit/src/components/TrackerIcon/strings": {
            "js/ru/howToUseTracker": "АТИ Айдоочу - кантип жүктөп алып жана колдонсо болот"
        },
        "as-ui-kit/src/components/TrackerAppInfoPopover/strings": {
            "js/ru/trackerFeatures": "АТИ Айдоочунун мүмкүнчүлүктөрү",
            "js/ru/atiTracker": "АТИ Айдоочу"
        },
        "as-ui-kit/src/components/Signee/Signee": {
            "jsx/strings/useByDefault": "Демейки колдонуу",
            "jsx/strings/signee": "Кол коюучу",
            "jsx/strings/remove": "жок кылуу",
            "jsx/strings/positionInGenitive": "Кызматы табыш жөндөмөсүндө",
            "jsx/strings/fullNameInGenitive": "Толук аты табыш жөндөмөсүндө",
            "jsx/strings/actUponWhatText": "Эмненин негизинде иш алып барат. Мисалы: \"Уставдын...\", \"Ишеним кат №....\""
        },
        ShortFirmInfo: {
            recommend: "Сунуштоо"
        },
        "as-ui-kit/src/components/SensorActivateLink/strings": {
            "js/ru/reauthorizationRequired": "Кайра авторизация талап кылынат",
            "js/ru/inactive": "Жигерсиз"
        },
        "as-ui-kit/src/components/SearchLoad/strings": {
            "js/ru/unloading": "Түшурүү",
            "js/ru/loading": "Жүктөө",
            "js/ru/loadParams/__html": "Салмак, т / көлөм, м<sup>3</sup>, жүк",
            "js/ru/transport": "Транспорт",
            "js/ru/direction": "Багыт"
        },
        "as-ui-kit/src/components/SearchLoad/SearchLoadParams/strings": {
            "js/ru/widthShort": "Т",
            "js/ru/sborgruz": "топт.жүк",
            "js/ru/onlyToSepCar": "өз.унаа",
            "js/ru/meters": "м",
            "js/ru/load": "Жүк",
            "js/ru/lengthShort": "У",
            "js/ru/items": "даана",
            "js/ru/heightShort": "Б",
            "js/ru/dogruzPossible": "кош.жуктөө мумк.",
            "js/ru/dogruz": "кошумча жүктөө"
        },
        "as-ui-kit/src/components/SearchLoad/LoadUnloading/RouteThrough/strings": {
            "js/ru/through": "аркылу айдоо"
        },
        "as-ui-kit/src/components/SearchLoad/LoadUnloading/CustomsOnRoute/strings": {
            "js/ru/custom": "бажы:"
        },
        "as-ui-kit/src/components/SearchLoad/LoadTransport/strings": {
            "js/ru/capacity": "ж/к {{number}} т,",
            "js/ru/onlyToSepCar": "өз.унаа.",
            "js/ru/dogruzPossible": "кош.жүктөө мүмк.",
            "js/ru/dogruz": "кошумча жүктөө",
            "js/ru/beltOther": "кур",
            "js/ru/beltMany": "кур",
            "js/ru/beltFew": "кур",
            "js/ru/beltOne": "кур",
            "js/ru/sanPassport": "медкитепче",
            "js/ru/loadUnload": "жүкт/түш",
            "js/ru/unload": "түш",
            "js/ru/load": "жүкт",
            "js/ru/pnevmohod": "пневмо",
            "js/ru/stsepka": "илгич",
            "js/ru/koniki": "кониктер",
            "js/ru/cars": "унаа"
        },
        "as-ui-kit/src/components/SearchLoad/LoadRate/strings": {
            "js/ru/allTermsInATIDocs": "Бардык шарртары өтүнмөдө АТИ-Доктордо",
            "js/ru/cashlessAll": "нак эмес КНС менен, КНС-сиз",
            "js/ru/cashlessWithoutVat": "нак эмес КНС-сиз",
            "js/ru/cashlessWithVat": "нак эмес КНС менен",
            "js/ru/cash": "нак",
            "js/ru/bargainOff": "тооруксуз",
            "js/ru/undefined": "КНС менен",
            "js/ru/direct": "түз келишим",
            "js/ru/bargainOn": "тоорук менен",
            "js/ru/payDays": "{0} б/к кийин",
            "js/ru/prepayAlone": "алдын ала төлөм",
            "js/ru/inFuel": "күй.май",
            "js/ru/prepay": "алдын ала төлөм {0}%",
            "js/ru/onLoad": "жүк түш.",
            "js/ru/inquireLoad": "баасын суроо",
            "js/ru/noLoad": "жүк жок, баасын суроо"
        },
        "as-ui-kit/src/components/SearchLoad/LoadDirection/strings": {
            "js/ru/km": "км",
            "js/ru/seePath": "каттамды көрүү",
            "js/ru/krugoreis": "айлана рейс"
        },
        cardsCompact: "Картанын чакан түрү",
        cards: "Картанын кадимки турү",
        appearance: "Турү",
        RejectOrder: {
            restoreLot: "Лот кайрадан ошол эле аянтчаларда жарыяланат",
            restoreLoad: "жүктү калыбына келтирүү",
            toArchive: "Архивге",
            move: "которуу",
            cancelDeals: ", Тооруктары жокко чыгаруу",
            inArchive: "Архивге",
            leftLoad: "жүктү калтыруу",
            publicLoadWithoutDeal: "Тооруксуз жүкту чыгаруу",
            restartDeal: "Тооруктары кайра иштетүү",
            rubles: "рубль",
            withRate: "чени менен",
            chooseWinner: "жеңүүчүнү тандоо",
            noReasonWarning: "Жокко чыгаруунун себебин көрсөтүңүз",
            reasonRejectionOffer: "Сунушту жокко чыгаруунун себебин көрсөтүңүз",
            whatHappenedWithLoads: "Жүк менен эмне кылыш керек",
            popoverWarning: "Буйрутма архивге которулат дагы жана жокко чыгарылган болуп белгиленет"
        },
        "as-ui-kit/src/components/PopupWarning/strings": {
            "js/ru/notToSave": "Сактаба",
            "js/ru/save": "Сактоо",
            "js/ru/edit": "Түзөтүү",
            "js/ru/p2": "Өзгөртүүлөр жоголушу мүмкүн",
            "js/ru/p1": "Сиз өзгөртүүлөрдү сактабастан терезени жапканга аракет кылып жатасыз",
            "js/ru/header": "Өзгөртүүлөр менен эмне кылыш керек?"
        },
        Selected: {
            showAll: "Толук көрсөтүү"
        },
        "as-ui-kit/src/components/PhoneForm/strings": {
            "js/ru/phoneInCar": "Транспорттук каражатка орнотулган мобилдик шайман",
            "js/ru/exclusiveAccess": "Анын АТИ Айдоочусуна эксклюзивдүү мүмкүндүк",
            "js/ru/phone": "Телефон"
        },
        "as-ui-kit/src/components/PhoneForm/TrackerInfo/strings": {
            "js/ru/promo": "Тиркемеге шилтеме жөнөтүү үчүн мобилдик телефонуңузду киргизиңиз",
            "js/ru/invitedHint": "шилтеме менен смс жөнөтүлөт",
            "js/ru/atiTrucker": "АТИ Айдоочу"
        },
        "as-ui-kit/src/components/PhoneForm/TrackerInfo/BindOwn/strings": {
            "js/ru/bindingTypes": {
                "driver": "Айдоочуга",
                "car": "ТК-ка"
            },
            "js/ru/goToAutopark": "Унаапаркка өтүү",
            "js/ru/goToCatalog": "Маалыматнаамага өтүү",
            "js/ru/alreadyAttached": "Бул номур тиркемеде мурунтан эле байланган"
        },
        "as-ui-kit/src/components/PhoneForm/TrackerInfo/BindOther/strings": {
            "js/ru/carFromAnother": "Унааны [[AppLink]][[Break]] тиркемесине байланыштыра албайсыз, анткени ал фирмага байланган",
            "js/ru/employedToAnotherFirm": "Бул айдоочуга [[Break]][[AppLink]] аркылуу буйрутмаларды жөнөтө албайсыз, анткени ал фирманын кызматкери",
            "js/ru/atiTrucker": "АТИ Айдоочу"
        },
        "as-ui-kit/src/components/PhoneForm/BindingStatus/strings": {
            "js/ru/resend": "Кайра жөнөтүү",
            "js/ru/driverRejected": "Сурам четке кагылды",
            "js/ru/cancel": "Жокко чыгаруу",
            "js/ru/sent": "Сурам жөнөтүлдү",
            "js/ru/sendRequest": "Сурамды жөнөтүү"
        },
        PayDocsStatus: {
            infoTextForCargoOwner:
                'Перевозчик может добавить трек-номер \nотправленных документов прямо к Заказу.\n' +
                'Вы получите уведомление, добавится статус \nв разделе «Документооборот и оплата», после чего \nвы сможете отслеживать посылку на сайте Службы \nдоставки.',
            trackNotExist: "Трек-номур көрсөтүлгөн эмес",
            learnMore: "Кененирээк билүү",
            carrierTrack: "Ташуучудан жөнөтүүнүн трек-номуру",
            addTrackNumber: "Жөнөтүү үчүн трек-номурду кошуу (көз салуу үчүн)",
            choosePaymentStatus: "ДО ",
            tooltipText: "Сиз трек-номурду кошкондон кийин, Кардар билдирүү алат жана жеткирүү кызматынын сайтында жөнөтүүнү көзөмөлдөй алат.",
            availableToCustomer: "(Кардарга жеткиликтүү)",
            trackNumber: "трек-номур",
            status: "статус",
            paymentStatusHint: "(сизге гана көрүнүктүү)",
            paymentStatus: "Документ жүгүртүү жана төлөм"
        },
        "as-ui-kit/src/components/PayDocsStatus/StatusLabel/strings": {
            "js/ru/changeTrackNumber": "Жөнөтүү үчүн трек-номурун (көз салуу номурун) өзгөртүү",
            "js/ru/cancelDelete": "Жок кылба",
            "js/ru/delete": "Жок кылуу",
            "js/ru/deleteTrackNumber": "Трек-номурур биротоло жок кылынсынбы?",
            "js/ru/defaultCompanyName": "жеткирүү кызматы",
            "js/ru/ofCompany": "компаниянын",
            "js/ru/trackInWebsite": "Сайттан көз салуу",
            "js/ru/trackNumberCopied": "Трек-номур көчүрүлдү",
            "js/ru/header": "Трек-номур",
            "js/ru/trackNumber": "трек-номур"
        },
        "as-ui-kit/src/components/PayDocsStatus/PayDocTrackPopover/strings": {
            "js/ru/trackNotExist": "Трек-номур көрсөтүлгөн жок",
            "js/ru/learnMore": "Кененирээк билүү",
            "js/ru/carrierTrack": "Ташуучудан жөнөтүүнүн трек-номуру",
            "js/ru/trackNumberForShipment": "жөнөтүү үчүн трек-номуру (көзөмөлдөө номуру)",
            "js/ru/trackNumber": "трек-номур",
            "js/ru/change": "Өзгөртүү",
            "js/ru/add": "Кошуу"
        },
        "as-ui-kit/src/components/PayDocsStatus/ChooseStatusForm/StatusFormRow/strings": {
            "js/ru/availableToCustomer": "(Кардарга жеткиликтүү)",
            "js/ru/tooltipText": "Сиз трек-номурун кошкондон кийин, Кардар билдирүү алат жана жеткирүү кызматынын сайтында жөнөтүүнү көзөмөлдөй алат.",
            "js/ru/trackNumber": "трек-номур",
            "js/ru/addTrackNumber": "Трек-номурду кошуу",
            "js/ru/chooseDate": "датаны тандаңыз"
        },
        cancel: "Жокко чыгаруу",
        "as-ui-kit/src/components/PayDocsStatus/ChooseStatusForm/StatusFormFooter/strings": {
            "js/ru/finishOfferRequestError": "Ташууну аяктоодо ката кетти.",
            "js/ru/saveAndArchive": "Архивге",
            "js/ru/save": "Сактоо"
        },
        "as-ui-kit/src/components/PayDocsStatus/ChangeTrackForm/TrackFormRow/strings": {
            "js/ru/chooseDate": "Датаны тандаңыз",
            "js/ru/sendDate": "Жөнөтүү жатасы",
            "js/ru/inputError": "Трек-номур сандарды жана латын тамгаларын гана камтышы керек",
            "js/ru/trackNumber": "Трек-номур",
            "js/ru/trackUrl": "Жеткирүү кызматынын сайтына шилтеме",
            "js/ru/chooseTransportCompany": "Жеткирүү кызматын тандаңыз",
            "js/ru/transportCompany": "Жеткирүү кызматы",
            "js/ru/body": "Сиз трек-номурун кошкондон кийин, Кардар билдирүү алат жана жеткирүү кызматынын сайтында жөнөтүүнү көзөмөлдөй алат."
        },
        "as-ui-kit/src/components/PayDocsStatus/ChangeTrackForm/TrackFormFooter/strings": {
            "js/ru/cantSaveForm": "Бардык талап кылынган талаалар толтурулмайынча сиз трек-номурду сактай албайсыз",
            "js/ru/delete": "Трек-номурду жок кылуу",
            "js/ru/save": "Сактоо",
            "js/ru/cancel": "Кошпо",
            "js/ru/add": "Трек-номур"
        },
        "as-ui-kit/src/components/PayDocsStatus/ChangeTrackForm/TrackFormFooter/ConfirmDeletePopover/strings": {
            "js/ru/dontDelete": "Жок кылба",
            "js/ru/delete": "Жок кылуу",
            "js/ru/confirmDelete": "Трек-номур биротоло жок кылынсынбы?"
        },
        ParticipantsPopup: {
            noPermissionsText: "Жүк менен иштөөнү жүк бөлүмүнө кирүү мүмкүндүгү бар кызматкерлер гана жүргүзүшөт",
            anotherPtWinner: "Өтмө тооруктардын башка катышуучусу жеңип чыкты",
            update: "Жаңыртуу",
            noWinners2: "Тооруктарды жокко чыгарып жана жаңыдан баштаңыз",
            noWinners1: "Жеңүүчүлөр жок.",
            winnerRemovedFromBoard2: "Башканы тандаңыз",
            winnerRemovedFromBoard1: "Жеңүүчү Аянтчадан жок кылынды.",
            winnerTimeExpiredNoNext2: "же Тооруктарды жаңыдан баштоо",
            winnerTimeExpired2: "же кийинки катышуучуну тандоо",
            waitForWinner: "Сиз жеңүүчүдөн  маалымдарды күтсөңүз болот",
            finished: "Тооруктар аяктады.",
            untilEnd: "Тооруктардын аягына чейин.",
            startRate: "баштапкы чен.",
            participants: {
                other: "катышуучу",
                many: "катышуучу",
                few: "катышуучу",
                one: "катышуучу"
            },
            noParticipants: "Катышуучулар жок",
            Participant: {
                atrucksTooltip: "Транспорттук компаниялар менен ишти автоматташтыруу боюнча үчүнчү тарап системасы",
                ptParticipant: "Өтмөк тооруктардын катышуучусу",
                tooltipRate: "Катышуучу чен койду",
                bestRateAndDate: "Эң мыкты чен жана дата",
                bestDate: "Эң мыкты дата",
                bestRate: "Эң мыкты чен",
                or: "же",
                noAccessText: "Бул операцияны аткарууга укутарыңыз жок. Укуктарды алуу үчүн администраторуңузга кайрылыңыз",
                yearStr: "ж.",
                shouldSend: ["Жеңүүчү өтүнмө үчүн маалымдарды  сизге ", " ичинде бериши керек "],
                dontSend: "Жеңүүчү али сизге өтүнмө үчүн маалымдарды бере элек.",
                winnerConfirmed2: "буйрутмаларда",
                winnerConfirmed1: "Жеңүүчү жүктү алды. Айдоочу жана ТК жөнундө маалымдарды ... көрүңүз",
                exWinner: "Сиз бул катышуучунун сунушун четке кактыңыз",
                shipperRefused: "Буйрутма жүк ээси тарабынана четке кагылды",
                carrierRefused: "Ташуучу Буйрутмага катышуудан баш тартты",
                refused: "Катышуучу Тооруктаргакатышуудан баш тартты.",
                skipped: "Маалымдарды убагында камсыз кылган жок.",
                winnerRemovedFromBoard: "Жеңүүчү Аянтчадан жок кылынды.",
                removedFromBoard: "Катышуучу Аянтчадан жок кылынды."
            },
        },
        loadingDate: "Даяр",
        participant: "Катышуучу",
        outputStrings: "Сап чыгаруу",
        orderLoadNumber: "жүктүн №/лоттун/буйрутманын",
        orderNumber: "Буйрутманын №",
        "as-ui-kit/src/components/OfferTracker/TrackerSummary/LinkToRouteOnMap/strings": {
            "js/ru/routeOnMap": "Каттам картада"
        },
        "as-ui-kit/src/components/OfferTracker/TrackerSummary/FinishedStatusView/strings": {
            "js/ru/eventDateTime": "{{day}} {{time}}",
            "js/ru/driverRevoked": "Айдоочу буйрутмадан чакырылды",
            "js/ru/driverRejectedDeal": "Айдоочу буйрутмадан баш тартты",
            "js/ru/driverFinishedDeal": "Айдоочу буйрутманы аяктады",
            "js/ru/cancelledDeal": "буйрутманы жокко чыгарды",
            "js/ru/finishedDeal": "буйрутманы аяктады"
        },
        "as-ui-kit/src/components/OfferTracker/TrackerSummary/Accidents/strings": {
            "js/ru/4": "маалымдар жок болчу",
            "js/ru/3": "өчүрүлгөн GPS менен каттамдын бир бөлүгү",
            "js/ru/2": "бузулуш",
            "js/ru/1": "ЖТК",
            "js/ru/0": "GPS-ти жасалмалоо аракети"
        },
        "as-ui-kit/src/components/OfferTracker/TrackerInWorkStatus/strings": {
            "js/ru/driverWillSendDataFromApp": "Айдоочу буйрутманы алды, бирок анын үстүнөн ишти баштай элек",
            "js/ru/ed": "өзг.",
            "js/ru/fromApp": "АТИ Айдоочу тиркемесинен"
        },
        "as-ui-kit/src/components/OfferTracker/TooltipMessage/strings": {
            "js/ru/gpsSpoof": "айдоочунун телефонунда GPS-ти жасалмалоого жол берүүчү функция иштетилген ({{initialPhone}}) ",
            "js/ru/gpsOff": "айдоочунун телефонунун тескөөлөрүндө GPS өчүрүлгөн ({{initialPhone}}). Жайгашкан жери тууралуу маалыматтар жок.",
            "js/ru/noData": "маалыматтар келбей калды. Мүмкүн, айдоочунун телефону өчүрүлгөн же интернетке кошулган эмес ({{initialPhone}}).",
            "js/ru/youAndOwner": "сизге жана кардарга",
            "js/ru/onlyYou": "сиздин фирмаңызга гана",
            "js/ru/rejectionInfoAvailable": "Баш тартуу жөнүндө маалымат жеткиликтүү",
            "js/ru/infoAvailable": "Маалымат жеткиликтүү",
            "js/ru/dataAvailable": "Тиркемеден карта жана буйрутманын статусу жеткиликтүү",
            "js/ru/activity": "АТИ Айдоочу тиркемесинде {{lastActive}} активдүүлүк ({{initialPhone}})."
        },
        "as-ui-kit/src/components/OfferTracker/StatusDescriptions/strings": {
            "js/ru/notConfirmed": "Айдоочу буйрутманы тиркемеде алганын ырастай элек.",
            "js/ru/finishedByCounterpart": "[[FirmName]]  буйрутманы бүтүрдү",
            "js/ru/finished": "Айдоочу буйрутманы бүтүрдү",
            "js/ru/revoked": "Сиз буйрутманы жокко чыгардыңыз",
            "js/ru/notSentDataExpected": "Айдоочуга буйрутманы жөнөтүү үчүн, ташуу маалымдарын көрсөтүңуз.",
            "js/ru/notSent": "Айдоочу үчүн маалымдар көрсөтүлгөн эмес",
            "js/ru/rejectionReason": "баш тартуунун себеби",
            "js/ru/rejected": "Айдоочу буйрутмадан баш тартты",
            "js/ru/sent": "Буйрутма [[DriverPhone]]  жөнөтүлдү Айдоочу буйрутманы али ишке ала элек",
            "js/ru/sentShort": "Буйрутма ... жөнөтүлдү",
            "js/ru/sendToSeeOnMap": "Жүктү картадан көрүү үчүн, буйрутманы тиркемеге жөнөтүңүз",
            "js/ru/awaitingDriver": "Айдоочу буйрутманы ишке киргизүүсүн күтүүдөбүз",
            "js/ru/carrierRevoked": "Ташуучу айдоочудагы буйрутманы жокко чыгарды. Жаңы маалымдар азырынча жок"
        },
        "as-ui-kit/src/components/OfferTracker/StatusBadge/strings": {
            "js/ru/gpsSpoof": "GPS жасалмалоо",
            "js/ru/gpsOff": "GPS өчүрүлгөн",
            "js/ru/finished": "буйрутма бүтүрүлдү",
            "js/ru/revoked": "буйрутма жокко чыгарылды",
            "js/ru/rejected": "буйрутмадан баш тартуу",
            "js/ru/notInWork": "иште эмес",
            "js/ru/inWork": "иштетилүүдө",
            "js/ru/sent": "буйрутма жөнөтүлдү",
            "js/ru/notSent": "буйрутма жөнөтүлгөн жок",
            "js/ru/noData": "маалымдар жок",
            "js/ru/atiTrucker": "АТИ Айдоочу"
        },
        "as-ui-kit/src/components/OfferTracker/StateWithoutDriver/strings": {
            "js/ru/toWatchCargoOnMap": ", жүктү картадан көрүү үчүн",
            "js/ru/inAtiDriver": "АТИ-Айдоочуда",
            "js/ru/addDriverInOrder": "Айдоочунун буйрутмага кошуңуз жана аны чакырыңыз",
            "js/ru/addDriver": "Айдоочунун буйрутмага кошуңуз жана ага чакыруу жөнөтүңүз"
        },
        "as-ui-kit/src/components/OfferTracker/PresenceLoading/strings": {
            "js/ru/loading": "маалымдарды жүктөөдөбүз...",
            "js/ru/hasTracker": "АТИ Айдоочу"
        },
        "as-ui-kit/src/components/OfferTracker/NoTrackerAccess/strings": {
            "js/ru/atiTrucker": "АТИ Айдоочу"
        },
        "as-ui-kit/src/components/OfferTracker/NoInWorkAccess/strings": {
            "js/ru/carrierReceivesFromApp": "Ташуучу статустарды АТИ Айдоочу тиркемесинен алып жатат",
            "js/ru/changingStatuses": "Статустарды алмаштыруу жеткиликсиз"
        },
        "as-ui-kit/src/components/OfferTracker/MapActionsContainer/strings": {
            "js/ru/dialogDescription": "АТИ Айдоочу",
            "js/ru/chat": "Чат",
            "js/ru/shareLinkDescription": "шилтемени бөлүшүү",
            "js/ru/shareLink": "Шилтемени бөлүшүү",
            "js/ru/sharedWithCounterpartyDescription": "сизге жана кардарга көрүнүктүү",
            "js/ru/onlyForYouDescription": "сизге гана көрүнүктүү",
            "js/ru/sharedWithCounterparty": "Сизге жана кардарга көрүнүктүү",
            "js/ru/onlyForYou": "Сизге гана көрүнүктүү",
            "js/ru/map": "Карта"
        },
        "as-ui-kit/src/components/OfferTracker/MainActions/strings": {
            "js/ru/revokeData": "Буйрутманы  чакырып алуу",
            "js/ru/dataForDriver": "Айдоочу үчүн маалымдар",
            "js/ru/configure": "Орнотуу",
            "js/ru/resendOrder": "Кайталар жөнөтүү",
            "js/ru/sendOrder": "Буйрутманы жөнөтүү",
            "js/ru/setData": "Маалымдарды көрсөтүү"
        },
        ActionsButtons: {
            dialogDescription: "АТИ Айдоочу",
            chat: "Чат",
            shareLink: "Шилтемени бөлүшүү",
            sharedWithCounterpartyDescription: "сизге жана кардарга көрүнүктүү",
            onlyForYouDescription: "сизге гана көрүнүктүү",
            sharedWithCounterparty: "Сизге гана көрүнүктүү",
            onlyForYou: "Сизге гана көрүнүктүү",
            map: "Карта"
        },
        InDevelopmentButton: {
            inDev: "Иштетилүүдө"
        },
        OfferInformationDriver: {
            willProvideDataLater: "Маалымдарды кечирээк көрсөтөм",
            fromDealModifier: "(келишимден)",
            registration: "Катталуу",
            seriesNumber: "Сериясы, номуру",
            selectDriver: "Айдоочунун тандаңыз",
            searchDrivers: "Айдоочулар боюнча издөө",
            driverLicense: "Айдоочунун күбөлүгү",
            passportIssuedWhen: "Берилген датасы",
            passportIssued: "Берилди",
            passportNumber: "Номуру",
            passportSeries: "Сериясы",
            passport: "Паспорт",
            enlistedDriver: "тартылган айдоочу",
            enlisted: "тартылган",
            edit: "Түзөтүү",
            driverNotFound: "Айдоочу табылган жок",
            driver: "Айдоочу",
            clickToAddDriver: "Жаңыны тандоо үчүн, басыңыз",
            addDriver: "Айдоочунун тандоо"
        },
        UseTrackerCheck: {
            fromTracker: "АТИ Айдоочудан",
            shareData: "Кардар менен маалымдарды бөлүшүү"
        },
        OfferInformationDriverFooter: {
            editHint: "бул айдоочуга буйрутмаларды  \"АТИ Айдоочуга\" жөнөтүү үчүн",
            editHintLink: "Уюл.телефондун номурун көрсөтүңүз",
            willNotShare: "АТИ Айдоочудан карта жана буйрутманын статусу сизге гана  жеткиликтүуү",
            willShare: "сиз кардар менен АТИ Айдоочудагы карта жанан статусту бөлүшүп жатасыз",
            nlistedDriver: "тартылган айдоочу"
        },
        TrackerSharing: {
            howTrackerWorks: "АТИ Айдоочу кантип иштейт",
            youWillSee: "Сиз жүктү картадан көрө аласыз жана буйрутманын акталдуу статусун.",
            carrierWillShare: "Ташуучу маалымдар менен АТИ Айдоочудан бөлүшөт"
        },
        OfferInformationCar: {
            willProvideDataLater: "Маалымдарды кечирээк көрсөтөм",
            fromDealTip: "Буйрутмадан",
            fromDealModifier: "(тооруктан)",
            remove: "Алып салуу",
            unknownCarType: "кузовдун белгисиз түрү",
            vehicle: "ТК",
            clickToAddVehicle: "Жаңыны кошуу үчүн, басыңыз",
            vehicleNotFound: "Унаа табылган жок",
            edit: "Түзөтүү",
            chooseSemiTrailer: "Жарым чиркегичти тандаңыз",
            chooseTrailer: "Чиркегичти тандаңыз",
            chooseVehicle: "ТК тандаңыз",
            searchVehicles: "ТК боюнча издөө",
            addVehicle: "ТК кошуу",
            addSemiTrailer: "Жарым чиркегичти кошуу",
            addTrailer: " Чиркегичти кошуу",
            addTruck: "Жүк ташуучу унааны кошуңуз",
            carTypeNames: {
                trailer: "Чиркегич",
                semitrailer: "Жарым чиркегич",
                tractor: "Тягач",
                truck: "Жүк ташуучу унаа"
            }
        },
        Contractors: {
            readMoreLink: {
                text: "Маалымдама тууралуу кененирээк",
            },
            button: "Контрагентти кошуу",
            header: "Сиздин контрагеннтериңиз",
        },
        Organizations: {
            readMoreLink: {
                text: "Маалымдама тууралуу кененирээк",
            },
            narrow: {
                text: [
                    "Сайт аркылуу буйрутма бергенде аларды документтериңизге киргизиңиз.",
                ]
            },
            button: "Уюмду кошуу",
            header: "Уюмуңуз жана сиз көп иштегендер тууралуу маалыматты кошуңуз",
        },
        Drivers: {
            readMoreLink: {
                text: "Маалымдама тууралуу кененирээк",
            },
            button: "Айдоочуну кошуу",
            header: "Айдоочуну кошуңуз",
        },
        Transport: {
            readMoreLink: {
                text: "Маалымдама тууралуу кененирээк",
            },
            header: "Транспортту кошуңуз",
        },
        CompletedItems: {
            wide: {
                header: "Буйрутма",
                text: [
                    "ATI.SU сайты аркылуу - бир нече кадам менен ташуу тууралуу макулдашыңыз. Эгерде жүк жөнөтүүчү сизге жүктү Аянтчада же жеке чакырууда сунуш кылса, Буйрутманы тариздөө мүмкүн.",
                    "Сиз мындай жүктү \"Жүк алуу\" баскычы аркылуу тааныйсыз. Аны басканда жүк сиздики. Сайт өзү келишимге арыз түзөт, сиз ага кол гана коесуз.",
                ],
            },
            button: "Кененирээк билүү",
            header: "Бул жерде Буйрутмалардан өткөн жүктөр сакталат",
        },
        Completed: {
            wide: {
                header: "Буйрутма",
                text: [
                    "ATI.SU сайты аркылуу - бир нече кадам менен ташуу тууралуу макулдашыңыз. Эгерде жүк жөнөтүүчү сизге жүктү Аянтчада же жеке чакырууда сунуш кылса, Буйрутманы тариздөө мүмкүн.",
                    "Сиз мындай жүктү \"Жүк алуу\" баскычы аркылуу тааныйсыз. Аны басканда жүк сиздики. Сайт өзү келишимге арыз түзөт, сиз ага кол гана коесуз.",
                ],
            },
            button: "Кененирээк билүү",
            header: "Бул жерде Буйрутмалардан өткөн жүктөр сакталат",
        },
        Payments: {
            wide: {
                header: "Буйрутма",
                text: [
                    "ATI.SU сайты аркылуу - бир нече кадам менен ташуу тууралуу макулдашыңыз. Эгерде жүк жөнөтүүчү сизге жүктү Аянтчада же жеке чакырууда сунуш кылса, Буйрутманы тариздөө мүмкүн.",
                    "Сиз мындай жүктү \"Жүктү алуу\" баскычы аркылуу тааныйсыз. Аны басканда жүк сиздики. Сайт өзү келишимге арыз түзөт, сиз ага кол гана коесуз.",
                ],
            },
            text: [
                "Документтер жана Буйрутма үчүн төлөм качан жөнөтүлүп жана кабыл алынгандарын көзөмөлдөй аласыз.",
            ],
            button: "Кененирээк билүү",
            header: "Бул жерде төлөмдүн статустары жана документтердин кыймылы болот",
        },
        InProgressItems: {
            wide: {
                header: "Буйрутма",
                text: [
                    "Бир нече кадам менен ташуу жөнүндө сүйлөшүңүз - ATI.SU сайты аркылуу. Эгерде жүк жөнөтүүчү сизге жүктү Аянтчада же жеке чакырууда сунуш кылса, Буйрутманы тариздөө мүмкүн.",
                    "Сиз мындай жүктү \"Жүк алуу\" баскычы аркылуу тааныйсыз. Аны басканда жүк сиздики болот. Сайт өзү өтүнмө келиш түзөт, сизден ага кол коюу жетиштүү.",
                ],
            },
            text: [
                "Бул Буйрутмалар боюнча таризделген жүктөр, алар боюнча өтүнмөгө кол коюлган, ал эми жүк ташууну күтүп жатат же жолдо.",
            ],
            button: "Кененирээк билүү",
            header: "Иштеги жүктөр бул жерде болушат",
        },
        InProgress: {
            wide: {
                header: "Буйрутма",
                text: [
                    "Бир нече кадам менен ташуу жөнүндө сүйлөшүңүз - ATI.SU сайты аркылуу. Эгерде жүк жөнөтүүчү сизге жүктү Аянтчада же жеке чакырууда сунуш кылса, Буйрутманы тариздөө мүмкүн.",
                    "Сиз мындай жүктү \"Жүк алуу\" баскычы аркылуу тааныйсыз. Аны басканда жүк сиздики болот. Сайт өзү өтүнмө келиш түзөт, сизден ага кол коюу жетиштүү.",
                ],
            },
            text: [
                "Бул Буйрутмалар боюнча таризделген жүктөр, алар боюнча өтүнмөгө кол коюлган, ал эми жүк ташууну күтүп жатат же жолдо.",
            ],
            button: "Кененирээк билүү",
            header: "Иштеги жүктөр бул жерде болушат",
        },
        ReconciliationItems: {
            wide: {
                header: "Буйрутма",
                text: [
                    "Бир нече кадам менен ташуу жөнүндө сүйлөшүңүз - ATI.SU сайты аркылуу. Эгерде жүк жөнөтүүчү сизге жүктү Аянтчада же жеке чакырууда сунуш кылса, Буйрутманы тариздөө мүмкүн.",
                    "Сиз мындай жүктү \"Жүк алуу\" баскычы аркылуу тааныйсыз. Аны басканда жүк сиздики болот. Сайт өзү өтүнмө келиш түзөт, сизден ага кол коюу жетиштүү.",
                ],
            },
            text: [
                "Бул Буйрутмалар боюнча ташуучулар алчу, бирок өтүнмө-келишимге кол коё элек жүктөр.",
            ],
            button: "Кененирээк билүү",
            header: "Макулдашуудагы жүктөр бул жерде болушат",
        },
        Reconciliation: {
            wide: {
                header: "Буйрутма",
                text: [
                    "Бир нече кадам менен ташуу жөнүндө сүйлөшүңүз - ATI.SU сайты аркылуу. Эгерде жүк жөнөтүүчү сизге жүктү Аянтчада же жеке чакырууда сунуш кылса, Буйрутманы тариздөө мүмкүн.",
                    "Сиз мындай жүктү \"Жүк алуу\" баскычы аркылуу тааныйсыз. Аны басканда жүк сиздики болот. Сайт өзү өтүнмө келиш түзөт, сизден ага кол коюу жетиштүү.",
                ],
            },
            text: [
                "Бул Буйрутмалар боюнча сиз алчу бирок кол коё элек жүктөр.",
            ],
            button: "Кененирээк билүү",
            header: "Макулдашуудагы жүктөр бул жерде болушат",
        },
        archive: {
            narrow: {
                text: [
                    "Бул жерде азыр сайтта жарыяланбаган жуктөр көрсөтүлөт",
                ],
            },
            button: "Жүктү кошуу",
            header: "Жүктөрдүн архиви бош",
        },
        published: {
            actions: {
                restore: "архивден кайра калыбына келтирүү",
                add: "Аларды кошуу же ",
            },
            button: "Жүктү кошуу",
            header: "Бул жерде сиздин жүктөрүңүз болот",
        },
        noAccessToAddingLoadText: "Сиздин жүктү кошууга укугуңуз жок. Укуктарды алуу үчүн администраторуңузга кайрылыңыз.",
        noFilteredLoads: "Тизмеде мындай жүктөр жок. Чыпканы баштапкы абалга келтирип көрүңүз же башка параметрлер боюнча издеп көрүңүз",
        clearFilter: "Чыпканы баштапкы абалга келтирүү",
        trailer: "Чиркегич",
        semitrailer: "Жарым чиркегич",
        tractor: "Сүйрөөчү унаа",
        truck: "Жүк ташуучу унаа",
        add: "Кошуу",
        notFound: "Табылган жок",
        // "en": {
        //     "js/DEFAULT_EXPORT/Organizations/header": "Уюмуңуздун жана сиз көп иштешкендердин маалымдарын кошуңуз"
        // },
        pressToCalculate: "Эсептөө үчүн, басыңыз",
        insureLoadAndGetCashback: "Жүктү камсыздандырыңыз жана 5%дан жогору кэшбэк алыңыз.",
        insureLoad: "Жүктү камсыздандыруу",
        LoadFiles: {
            otherDocuments: "документ",
            oneDocument: "документ",
            manyDocuments: "документ",
            fewDocuments: "документ"
        },
        LargeCities: {
            km: "км",
            bkg: "жакынкы ири шаарлар"
        },
        InviteButton: {
            invite: "Чакыруу"
        },
        LimitsPopover: {
            orders: {
                other: "буйрутма",
                many: "буйрутма",
                few: "буйрутма",
                one: "буйрутма",
            },
            doNotInvite: "Чакырба",
            invite: "Чакыруу",
            doInviteCarrier: "Эгер сиз чекке карабай буйрутманы кабыл алышын кааласаңыз, ташуучуну чакырыңыз.",
            editInCatalogs: "Маалыматнаамада түзөтүү",
            max: "макс.",
            youSetLimit: "Сиз иштетилип жаткан бир убактагы буйрутмалардын санына чек койдуңуз:",
            title: "Буйрутмаларга чеги жетти"
        },
        insuranceConditions: "Камсыздандыруунун шарттары",
        promoText: "Кокус кандайдыр бир себептерден улам жүктүн жоголушу же бузулушу үчүн компенсация алуу үчүн жүктү камсыздандырыңыз.",
        InWorkStatusSelect: {
            visibleForOwnerControlledFromTracker: "Статус сизге жана Ташуучуга көрүнүктүү. Статусту айдоочу гана өзгөртө алат.",
            youAndOwner: "Статус сизге жана Кардарга көрүнүктүү. Статусту айдоочу гана өзгөртө алат.",
            onlyYou: "Статус сиздин фирмаңызга гана көрүнүктүү. Статусту айдоочу гана өзгөртө алат.",
            ownerInfo: "Статус сизге жана Ташуучуга көрүнүктүү",
            info: "Статус сизге жана кардарга көрүнүктүү",
            noStatus: "Статусу жок",
            placeholder: "Статусту тандаңыз"
        },
        ImagesUploader: {
            carsPhotos: "ТК сүрөттөрү"
        },
        HistoryPopup: {
            load: "Жүк #",
            emptyHistory: "Бул жүк боюнча Буйрутмалар, Тооруктар (соодалашуулар) жана каршы сунуштар болгон эмес",
            actionColumnName: "Иш-аракет",
            timeColumnName: "убакыт",
            dateColumnName: "Дата",
            title: "Тооруктардын жана Буйрутмалардын тарыхы"
        },
        FileDownloadButton: {
            downloadExcel: "Тарыхты жүктөп алуу (Excel)"
        },
        ChooseDropdown: {
            offer: "Бардык каршы сунуштар",
            deal: "Келишимдин бүт тарыхын",
            auctionrate: "Тооруктар боюнча бардык чендери",
            auction: "Тооруктардын бүт тарыхын",
            all: "Бардык аракеттер",
            show: "Көрсөтүү"
        },
        GlyphButtonHistory: {
            history: "Буйрутмалардын тарыхы"
        },
        GeoPositionPromo: {
            promoNotice: 'АТИ Айдоочу акысыз кызматынын жардамы менен буйрутмаларыңызды\n реалдуу убакыт режиминде көзөмөлдөңүз.',
            sensorSharingNotice: 'Кардар жүгү бар унаанын жайгашкан жерин датчик\n катталган GPS - мониторинг тутумунун картасында көрөт.',
            moreAboutShipperTracker: "АТИ Айдоочу кантип иштейт",
            trackerShipperNotice: "жана буйрутманын актуалдуу статусун алуу",
            sensorShipperNotice: "GPS-мониторинг тутумдары",
            shipperNotice: "Сиз жүктү картадан көрө аласыз",
            shipperHeader: "Ташуучу геолокация дайындарын бөлүшөт",
            moreAboutTracker: "АТИ Айдоочу тууралуу кененирээк",
            trackerSharingNotice: "Кардар картадан буйрутманын статусун жана жүгү бар унааны көрөт.",
            sharingNotice: "Бул ишенимди арттырып, аткаруучунун сизди тандоосуна таасир этет.",
            showGeoData: "Кардарга геопозиция маалымдарын көрсөтүү",
            sectionName: "Жүк ташууларды көзөмөлдөңүз"
        },
        FirmReputation: {
            unfairPartnerAbbr: "ыө",
            claimAbbr: "д",
            recommendationAbbr: "с",
            otherFirms: "фирмадан",
            manyFirms: "фирмадан",
            twoFirms: "фирмадан",
            oneFirm: "фирмадан",
            unfairPartners: "\"Ыймансыз өнөктөштөр\" форумунда эскерүүлөр: {0} {1} баштап",
            claims: "Дооматтар:",
            recommendations: "Сунуштар:"
        },
        Firm: {
            claimsAbbr: "д",
            unfairPartnerAbbr: "ыө",
            recommendationAbbr: "с",
            otherDocs: "документ",
            manyDocs: "документ",
            twoDocs: "документ",
            oneDoc: "документ",
            otherFirms: "фирмадан",
            manyFirms: "фирмадан",
            twoFirms: "фирмадан",
            oneFirm: "фирмадан",
            unfairPartners: "\"Ыймансыз өнөктөштөр\" форумунда эскерүүлөр:  {{count}} {{string}} баштап",
            claims: "Дооматтар:",
            recommendations: "Сунуштар:",
            document: "{{count}} {{string}} берилди",
            code: "Код"
        },
        drop: "Калыбына келтирүү",
        allParametersCompact: "Дагы",
        allParameters: "Дагы чыпкалар",
        ExtraPoints: {
            unloading: "тушүрүүлөр",
            otherPoints: "пункттары",
            onePoint: "пункт",
            manyPoints: "пункттары",
            loading: "жүктөөлөр",
            fewPoints: "пункт",
            extraPointsAbbr: "кош. {{point}} {{type}}"
        },
        take_lot_access_denied: "Бул аракетти аткарууга сиздин укугуңуз жетишпейт",
        take_load_access_denied: "Бул аракетти аткарууга сиздин укугуңуз жетишпейт",
        access_denied: "Бул аракетти аткарууга сиздин укугуңуз жетишпейт",
        ui_error: "Ката кетти",
        contact_access_denied_error: "Укук жетишсиз",
        cannot_choose_winner: "Жеңүүчүнү алмаштыруу мүмкүн эмес",
        invitation_not_found_error: "Ката кетти",
        load_not_found_error: "Жүктү алуу мүмкүн эмес",
        load_cant_reserve: "Жүктү ээлөө мүмкүн эмес",
        load_cant_take: "Жүктү алуу мүмкүн эмес",
        close: "Жабуу",
        access_denied_reason: `<p>Для того, чтобы работать с Заказами, у вас должны быть следующие доступы:</p>
        <ul>
            <li>Работать с площадками</li>
            <li>Брать грузы для оформления Заказов</li>
        </ul>
         <p>Чтобы вы могли одобрить заявку, потребуется доступ:</p>
            <ul>
                <li>Подписывать и одобрять документы в АТИ-Доках</li>
             </ul>
         </p>
         <p>Эти права вам может дать администратор или руководитель аккаунта. Права настраиваются в кабинете, в окне редактирования контакта.</p>`,
        take_load_access_denied_reason: `<p>Для того, чтобы работать с Заказами, у вас должен быть следующий доступ:</p>
        <ul>
            <li>Брать грузы для оформления Заказов</li>
        </ul>
         <p>Это право вам может дать администратор или руководитель аккаунта. Права настраиваются в кабинете, в окне редактирования контакта.</p>`,
        take_lot_access_denied_reason: `<p>Для того, чтобы работать с Заказами, у вас должен быть следующий доступ:</p>
        <ul>
            <li>Брать грузы для оформления Заказов</li>
        </ul>
         <p>Это право вам может дать администратор или руководитель аккаунта. Права настраиваются в кабинете, в окне редактирования контакта.</p>`,
        defaultError: {
            reason: "Баракты кайра жуктөп көрүңүз"
        },
        EditArea: {
            cancel: "Жокко чыгаруу"
        },
        DriverSelect: {
            driver: "Айдоочу",
            clear: "Тазалоо"
        },
        DriverEmployedToAnother: {
            carFromAnother: "ТК [[AppLink]] тиркемесине байланыштыра албайсыз, анткени ал компанияга байланган",
            employedToAnotherFirm: "Бул айдоочуга [[AppLink]] аркылуу буйрутмаларды жөнөтө албайсыз, анткени ал компаниянын кызматкери",
            atiTrucker: "АТИ Айдоочу"
        },
        toWhere: "Кайсы жерге",
        fromWhere: "Кайсы жерден",
        clear: "Тазалоо",
        selectedDepartments: "тандалган",
        allDepartments: "Бардык бөлүмдөр",
        deletedDepartments: "Алыскы бөлүмдөр",
        allDocsWithoutCount: {
            allDocsWithoutCount: "Документтер жана сүрөттөр",
            allDocs: "Документтер жана сүрөттөр ({{docsCount}})",
            edited: "Түзөтүүлөр",
            notSent: "жөнөтүлгөн эмес",
            document: "Документ"
        },
        CounterpartySelect: {
            auctionsWinner: "Тооруктардын жеңүүчүсү",
            firm: "АТИ фирмасы",
            clear: "Тазалоо",
            counterparty: "Контрагент"
        },
        willBeShown: "Активдүү байланыштын жүктөрү көрсөтүлөт.",
        areShownNow: "Азыр активдүү байланыштын жүктөрү көрсөтүлүп жатат",
        loadsForAllContacts: "\"Сиздин жүктөрүңуз\"-гө кирүүдө бардык байланыштардын жүктөрү",
        dontShow: "Көрсөтпө",
        show: "Көрсөтүү",
        allContacts: "Бардык байланыштар",
        City: {
            unloading: "жүк түшүрүүлөр",
            loading: "жүктөөлөр",
            tooltipCoords: "{{type}} чекитинин координаттары"
        },
        CargoOwnerHelpPopover: {
            moreAboutOrders: "Буйрутмалар тууралуу кененирээк",
            carrierHasReservedTheLoad: "Ташуучу жүктү ээлеп койду."
        },
        CancelWinnerPopover: {
            notChooseAsWinner: "Тандаба",
            goingToChooseNewWinnerText: "Сиздин жүк менен буйрутма мурунтан эле учурдагы жеңүүчүгө жөнөтүлгөн. Ага Тооруктарга катышуудан баш тартуу келет. Буйрутма жаңы жеңүүчүгө жөнөтүлөт.",
            goingToChooseNewWinner: "Сиз жаңы жеңүүчүнү тандаганы турасыз",
            chooseAsWinner: "Жеңүүчүнү тандоо"
        },
        orderWillBeCancelled: 'Заказ будет перемещён в архив\n' + 'и отмечен как отменённый',
        notCancel: "Жокко чыгарба",
        confirmCancelOrder: "Буйрутманы жокко чыгаруу",
        CancelAuctionActions: {
            noAccessText: "Тооруктарды жокко чыгарууга сиздин укугуңуз жок. Укуктарды алуу үчүн администраторуңузга кайрылыңыз",
            willFinished: "Тооруктар аяктайт.\nЭң жакшы ченди сунуштаган\nадам жеңүүчү болуп тандалат",
            willLoseBids: "Тооруктар боюнча бардык\nчендер жоголот",
            cancelFinish: "Бүтүрбө",
            cancelCancel: "Жокко чыгарба",
            cancel: "Жокко чыгаруу",
            cancelAuction: "Тооруктарды жокко чыгаруу",
            finish: "Бүтүрүү",
            finishAheadOfTime: "Азыр бүтүрүү"
        },
        BlackListLabel: {
            tooltipText: "Айдоочу сиздин кара тизмеңизде",
            carrier: {
                full: "Айдоочу кардардын кара тизмесинде",
                short: "кардардын Кара тизмесинде"
            },
            cargoOwner: {
                full: "Айдоочу сиздин кара тизмеңизде",
                short: "кара тизмеде"
            },
        },
        AuctionTimer: {
            at: "",
            auctionEndDateBoundary: "Эгер чендер болбосо, Тооруктар аяктайт",
            auction: "Тооруктар",
            beforeAuctionStart: "Тооруктардын башталышына чейин",
            untilAuctionEnd: "Тооруктардын аяктоосуна чейин"
        },
        AttachCar: {
            headerText: {
                semitrailer: "Жарым чиркегич",
                trailer: "Чиркегич",
                tractorAndTruck: "Жарым чиркегичи бар сүйрөөчү унаа же жүк ташуучу унаа",
                truck: "Жүк ташуучу унаа",
                tractor: "Сүйрөөчү унаа",
            },
            noResultsText: "табылган жок",
            select: "Тандаңыз",
            trailer: "чиркегич",
            tractorAndTruck: "жарым чиркегичи бар сүйрөөчү унаа же жүк ташуучу унаа",
            semitrailer: "жарым чиркегич",
            truck: "жүк ташуучу унаа",
            tractor: "сүйрөөчү унаа",
            add: "Кошуу",
            edit: "Өзгөртүү",
            cancel: "Жокко чыгаруу"
        },
        notToSave: "Сактаба",
        save: "Сактоо",
        edit: "Түзөтүү",
        p2Text: "Өзгөртүүлөр сакталбай калышы мүмкүн",
        p1Text: "Сиз өзгөртүүлөрдү сактабастан терезени жабууга аракет кылып жатасыз",
        headerText: "Өзгөртүүлөр менен эмне кылыш керек?",
        AtiPopup: {
            cancel: "Жокко чыгаруу"
        },
        FileUploadWrapper: {
            invalidFile: "Ылайыксыз файл тандалды"
        },
        FileUploadItemInfo: {
            uploadError: "Жүктөө болбой калды. Дагы бир жолу аракет кылыңыз",
            uploaded: "жүктөлдү",
            removeItem: "Жок кылуу",
            abortUpload: "Жүктөөнү токтотуу"
        },
        AtiFileUploader: {
            uploadRequired: "Файлдарды жүктөңүз",
            upload: "Жүктөө"
        },
        PopupOrganization: {
            removePopover: {
                contactPerson: "Маалымдамадан байланыш адам өчүрүлсүнбү?",
                address: "Маалымдамадан уюмдун дареги өчүрүлсүнбү?",
            },
            notLocation: "Биз мындай жерликти таппадык",
            documentExample: "Мисалы, IDNO 1234567-123-123",
            documentType: "Документтин түрү жана номуру",
            bin: "БИН",
            unp: "ТЭН",
            edrpou: "УМУЖМР",
            officeTooltip: "Кеңсени, бөлмөнү, боксту, батирди ж.б. киргизиңиз",
            office: "Кеңсе, бөлмө ж.б.",
            building: "Үй, курулуш, корпус, литера",
            street: "Көчө, проспект, кыска көчө, бульвар ж.б.",
            locality: "Жерлик",
            postcode: "Индекс",
            organizationPhone: "Уюмдун телефону",
            locationAddress: "Документтер үчүн жайгашкан жердин дареги",
            inn: "ИСН",
            residency: "Резиденттик",
            fullOrganizationName: "Толук аталышы",
            other: "(башка)",
            available: "Жектиликтүү",
            notResultOwnership: "МФ табылган жок",
            nameFirm: "Фирманын аталышы",
            editOrganization: "уюмду түзөтүү",
            addOrganization: "Уюмду кошуу",
            addAddressDescription: "(кампанын, дүкөндүн же кеңсенин дареги) ",
            addAddress: "Кампаны кошуу",
            addresses: "Даректер",
            addContactPerson: "Байланыш адамды кошуу",
            contactPersons: "Байланыш адамдар",
            extraPhone: "Кош.номур",
            add: "Кошуу",
            save: "Сактоо"
        },
        RevokedBinding: {
            popover: {
                deleteLink: "Байланышты жок кылуу",
                header: "Кампа \"Убактылуу терезелер\" кызматынан ээси тарабынан өчүрүлдү.",
            },
            timeslots: "\"Убактылуу терезелер\""
        },
        AcceptedBinding: {
            popover: {
                writeToPartner: "Өнөктөшкө жазуу",
                showTimeslots: "Жүктөөнү көрүү",
                address: "Кампанын дареги",
                faq: "Кызмат тууралуу ",
                header: "Кампа \"Убакыт терезелери\" кызматына кошулган",
            },
            timeslots: " \"Убакыт терезелери\""
        },
        UnbindTimeslots: {
            breakNotification: "Сиз өнөктөшүңүздүн кампасы менен байланышты үздүңүз.",
            breakQuestion: "Өнөктөшүңүздүн кампасы менен байланыш үзүлсүнбү?",
            dontBreak: "Үзбөө",
            break: "Үзүү",
            breakLink: "Байланышты үзүү"
        },
        EntityRemovePopup: {
            dontDelete: "Жок кылба",
            delete: "Жок кылуу"
        },
        Entity: {
            edit: "Өзгөртүү",
            remove: "Жок кылуу"
        },
        DepartmentsSelector: {
            selectedDepartments: "тандалган бөлүмдөргө",
            allDepartments: "бардын бөлүмдөргө"
        },
        ContactEntity: {
            extraPhone: "Кош.номур"
        },
        AddressEntity: {
            shortCity: "ш."
        },
        AddOrganizationContactPopup: {
            editContactPerson: "Байланыш адамды түзөтүү",
            addContactPerson: "Байланыш адамды кошуу",
            fullName: "Толук аты",
            extraPhone: "Кош.номур",
            phone: "Телефон",
            add: "Кошуу",
            "save": "Сактоо"
        },
        AddOrganizationAddressPopup: {
            placeholderAddress: "район, көчө, үй",
            coordinates: "Координаттар",
            selectOnMap: "Картадан тандоо",
            enter: "Киргизип баштаңыз",
            addressWithoutCity: "Дарек (шаарсыз)",
            locality: "Жерлик",
            withoutContactPerson: "Байланыш адамсыз",
            nothingFound: "Эч нерсе табылган жок",
            selectAddressContactPerson: "Даректин байланыш адамын тандаңыз",
            placeholderShedule: "Дү-Жу: 9:00дан 20:00 чейин",
            note: "Эскертүү",
            schedule: "Иш убактысы",
            type: "Түрү",
            editAddress: "{{addressTypeName}} дарегин түзөтүү",
            addAddress: "{{addressTypeName}} даректи кошуу",
            addContactPerson: "Байланыш адамды кошуу",
            contactPerson: "Байланыш адам",
            add: "Кошуу",
            save: "Сактоо"
        },
        AddEditCarPopup: {
            cancel: "Жокко чыгаруу",
            semitrailer: "жарым чиркегич",
            save: "Сактоо",
            trailer: "чиркегич",
            tractor: "сүйрөөчү унаа",
            truck: "жүк ташуучу унаа",
            edit: "Түзөтүү",
            add: "Кошуу",
            ts: "ТК",
            description: {
                own_duplicate_error: "Ал сиздин Автопаркыңызда жарыяланган",
                duplicate_error: "Ал мурунтан эле ATI.SUнун башка мүчөсүнө таандык деп көрсөтүлгөн. Эгер бул дагы эле сиздин унааңыз болсо, убактылуу \"Тартылган унаа\" кутучасын белгилеңиз, ТКП же пластиктин сканерин тиркеңиз жана техникалык колдоого кайрылыңыз: Тикет түзүңүз же 8 812 602-01-09 кош.160 чалыңыз. Биз баарын оңдойбуз."
            },
            header: {
                duplicate_error: "Сиз унааны менчигиңиз катары жокко чыгара албайсыз.",
                own_duplicate_error: "Транспорттук каражатты кошуу мүмкүн эмес."
            }
        },
        CarPopupForm: {
            truck: "Жүк ташуучу унаа",
            tractorWithSemitrailer: "Жарым чиркегичи менен сүйрөөчү унаа"
        },
        GeneralCarFormWrapper: {
            semitrailer: "жарым чиркегич",
            trailer: "чиркегич",
            tractor: "сүйрөөчү унаа",
            truck: "жүк ташуучу унаа",
            edit: "Тузөтүү",
            add: "Кошуу"
        },
        GeneralCarForm: {
            semitrailer: "Жарым чиркегич",
            trailer: "Чиркегич",
            truck: "Жүк ташуучу унаа",
            tractor: "Сүйрөөчү унаа",
            rentContactHintText: "Сүрөт же скан",
            marriageHintText: "Күбөлүктүн сүрөтү же сканы",
            documentHintText: "Документтердин 2 бетинин сүрөтү же скандары же электрондук ТКП",
            contractHintText: "Эгер ТК менчик болбосо",
            ownershipType: "ТК менчик түрү",
            required: "(сөзсүз)",
            uploadGratuitousContractScan: "Акысыз колдонуу келишимин жүктөө",
            uploadMarriageScan: "Никени каттоо күбөлүгүн жүктөө",
            uploadPhotos: "ТК сүрөттөрүн жүктөө",
            uploadLeasingContractScan: "Лизинг келишимин жүктөө",
            uploadRentContractScan: "Ижара келишимин жүктөө",
            uploadPTSScanOrPlastic: "ТКП жана ТККК жүктөө",
            attractedCar: "Тартылган ТК",
            documentsHeader: "ТК-тын документтери"
        },
        TractorAdditionallyParams: {
            header: "Кошумча",
            canCarryHeavyContainer: "оор контейнерлерди алып жүрүү болот",
            hasGenset: "Genset бар (илме генератор) ",
            canRefrigerator: "реф-контейнерлерди алып жүрүү болот",
            externalId: 'Идентификатор'
        },
        ShowInFirmInfo: {
            tooltipDisabled: "Картада көрсөтүлүшү үчүн, ТК четтен тартылбаган болушу керек",
            tooltip: "Жүк ээлери үчүн компаниянын аброю гана эмес, ошондой эле ташуучунун өзүнүн транспорттук паркынын бар болушу да маанилүү.",
            text: "Сиздин ATI.SU катышуучусунун паспортунда көрсөтүү"
        },
        ReserveByDriverBlock: {
            noAvailableDrivers: "Жеткиликтүү айдоочулар жок",
            cancel: "Жокко чыгаруу",
            select: "Тандаңыз",
            addDriver: "Айдоочуну кошуу",
            reserve: "Айдоочуга бекитүү",
            reserveByDriver: "Айдоочуну кошуу жана бекитүү"
        },
        CarSensors: {
            delete: "Жок кылуу",
            update: "Өзгөртүү",
            addSensor: "Датчикти кошуу",
            helperText: "GPS/ГЛОНАСС датчиги",
            geoposition: "ТК геопозициясы"
        },
        CarOwnershipType: {
            gratuitousUse: "акысыз колдонуу",
            spousesJoint: "жубайлардын биргелешкен менчиги",
            leasing: "лизинг",
            rental: "ижара",
            hired: "тартылган ТК",
            owned: "менчик",
            ownerName: "ТК-нын каттоо жөнүндө күбөлүк боюнча ээси",
            ownershipType: "Ээликтин түрү"
        },
        CarInfo: {
            pts: "ТКП сериясы жана номуру",
            vin: "VIN",
            vrcFull: "ТККК сериясы жана номуру",
            manufactureYear: "Чыгарылган жылы",
            number: "Мамномур",
            noBrandText: "Мындай марка жок. Башкасын киргизиңиз.",
            vrc: "ТККК",
            hasBodyNumber: "VIN жок",
            hasVin: "VIN бар",
            bodyNumber: "Кузову",
            model: "Модели",
            mark: "Маркасы",
            clear: "Тазалоо",
            cancel: "Жокко чыгаруу",
            exampleHint: {
                bodyNumber: "Кузовдун/шассинин номурунун мисалы",
                electronicPts: "Электрондук ТКП номурунун мисалы",
                pts: "ТКП номурунун мисалы",
                vin: "VIN-дин мисалы",
                vrc: "ТККК номурунун мисалы",
            },
            description: {
                bodyNumber: "Транспорт каражатынын паспортунда, транспорт каражатынын каттоо күбөлүгүндө, кепилдик талондо/техникалык кароо талондо же унаанын камсыздандыруу полисинде. \n\nКузовдун же шассидин ажырагыс тетиктеринде жана атайын жасалган номур белгилеринде (шильдиктерде).",
                pts: "Транспорт каражатынын паспорту (ТКП) - бул унаанын техникалык мүнөздөмөлөрү, \n\nээлери жана транспорт каражатын каттоо/каттоодон чыгаруу жөнүндө маалыматтарды камтыган негизги документтердин бири.",
                vin: "Транспорт каражатынын паспортунда, транспорт каражатынын каттоо күбөлүгүндө, кепилдик талондо/техникалык кароо талондо же унаанын камсыздандыруу полисинде. Кузовдун же шассидин ажырагыс тетиктеринде жана атайын жасалган номур белгилеринде (шильдиктерде).",
                vrc: "Транспорт каражатынын каттоо күбөлүгү (ТККК) - унаанын негизги документтеринин бири. ТККК транспорт каражатын (Автоунаа, мотоцикл, чиркегич ж.б.) каттоого койгондон кийин РФнын ИИМинин МАИ каттоо бөлүмдөрүндө берилет. Документ \"Госзнак\" фабрикасында басылып, ламинатталган, коргоо даражасына ээ.",
            },
            header: {
                bodyNumber: "Кузовдун/шассинин номурун кантип билүү болот",
                pts: "ТК паспортту кандай",
                vin: "VIN-ди кантип билүү болот",
                vrc: "ТК-тын каттоо жөнүндөгү күбөлүгү кандай"
            },
        },
        CarDimensions: {
            fillDimensions: "Туура габариттерди көрсөтүңүз",
            height: "Бийиктиги, м",
            width: "Туурасы, м",
            length: "Узундугу, м",
            internalDimensions: "Ички габариттер"
        },
        CarBodySize: {
            capacity: "Жүк көтөрүмдүүлүгү, т",
            meter: "м",
            volume: "Көлөмү"
        },
        CarBody: {
            containerSizes: [
                "20' жалгыз",
                "20' платформа",
                "20' жалгыз + чиркегич",
                "40' платформа полу менен",
                "40' платформа полу жок",
                "45' платформа полу менен",
                "45' платформа полу жок",
                "20' платформа танк үчүн",
                "40' платформа танк үчүн",
                "40' платформа алынуучу"
            ],
            dimension: "Контейнердин өлчөмү",
            select: "Кузовдун түрү",
            body: "ТК характеристикасы"
        },
        CanCarryTallContainers: {
            canCarryTallContainer: "Бийик контейнерлерди ташуу мүмкүн"
        }
    },
    "kk": {
        of: (count: number, total: number) => <>{count} ішінен {total}</>,
        phoneWrong: "Пішімдегі нөмірді енгізіңіз +7 (999) 999 99 99",
        extraDigits: "Нөмірді тексеріңіз ― онда артық сандар бар",
        missingDigits: "Нөмірді тексеріңіз ― онда сандар жетіспейді",
        emailWrong: "Бұл email емес. Онда қатенің бар-жоғын тексеріңіз",
        lessThanMinDate: "Күн {{minDate}} кем болмауы керек",
        notValidDepartmentCode: "Бөлімше коды 000-000 форматында болуы тиіс",
        onlyNumbers: "Тек сандар енгізуге болады",
        choosePackageType: "Қаптама түрін таңдау қажет",
        notValidTrackNumber: "Трек-нөмірде тек цифрлар, латын әріптері, символдар болуы тиіс  және -",
        notValidUrl: "Дұрыс емес URL мекенжайы",
        emptyCoordinates: "Тізімнен мекенжайды таңдаңыз немесе картада көрсетіңіз",
        invalidDateString: "Дұрыс емес күн",
        invalidTimeString: "Дұрыс емес уақыт",
        wrongRangeEnd: "Дұрыс емес ауқым",
        wrongCheckSum: "Дұрыс емес бақылау сомасы",
        symbols: {
            many: "таңбалар",
            few: "таңба",
            one: "таңба"
        },
        numbers: {
            many: "сан",
            few: "сандар",
            one: "сан"
        },
        numberFromTo: "{{from} және {{to}} арасында сан енгізіңіз",
        symbolsRange: "{{from} -ден {{to}} -ге дейінгі таңбаларды енгізіңіз",
        enterPositiveNumber: "Оң санды енгізіңіз",
        numberLessThen: "Мән аспауы тиіс",
        korrSchetParams: "20 сан - 301-ден бастап БСК соңғы 3 санға дейін  ",
        OKPOLength: "8 немесе 10 саны",
        OKPOCheckNumber: "Қате бақылау саны",
        twentySymbolsNoSpaces: "бос орынсыз 20 сан",
        enterValue: "Бұл өріс бос болмауы керек",
        selectValue: "Мәнді таңдау",
        requiredDigits: "{{number}} сан енгізу қажет",
        fifteenDigits: "15 сан",
        thirteenDigits: "13 сан\t",
        datesNotInThePast: "Өткен күндерді таңдауға болмайды",
        dateInTheFuture: "Өткен күнді таңдауға болмайды",
        dateInThePast: "Болашақта күнді таңдауға болмайды",
        isInvalidDate: "Жарамсыз күн",
        invalidDateFormat: "КК.АА.ЖЖЖЖ форматында күнді енгізіңіз",
        wrongPhoneNumber: "Жарамсыз телефон нөмірі",
        region: "Аймақты енгізіңіз",
        carNumber: "Нөмірді енгізіңіз",
        lengthMessage: "таңба",
        maxLengthMessage: "Макс. {{max}} таңба",
        upToEightSymbols: "8 таңбаға дейін",
        sixSevenSymbols: "6-7 таңба",
        sixDigits: "Алты цифр",
        fourDigits: "Төрт цифр",
        notAfterCurrent: "Бір жыл {{currentYear}} көп болмауы керек",
        notBeforeMinYear: "Бір жыл {{minYear}} кем болмауы керек",
        registrationNumber: "Тіркеу нөмірі",
        egrpou: "УКҰМТН",
        unp: "КБН",
        inn: "ЖСН",
        bin: "БСН",
        iin: "ЖСН",
        // strings: {
        //     rateNds: "ҚҚС-пен",
        //     rateWithoutNds: "ҚҚС-сыз",
        //     direct: "тiкелей шарт",
        //     torg: "сауда-саттық.",
        //     payDays: "{0} б/к кейін",
        //     inFuel: "отын",
        //     prepayAlone: "алдын ала төлеу",
        //     prepay: "Алдын ала төлеу: {0}%",
        //     onLoad: "жүк түсіруде",
        //     onlyToSepCar: "жеке машина ",
        //     dogruzPossible: "қосымша жүк тиеу мүмкін",
        //     dogruz: "қосымша жүк тиеу ",
        //     sborgruz: "құрама жүк"
        // },
        duplicate_contractor_error: "Контрагентті қосу мүмкін емес. Ол анықтамалыққа қосылды.",
        unknown_error: "Белгісіз қате",
        json_validation_error: "json валидация қатесі",
        partial_execution_error: "Байланысты жасау кезінде қате пайда болды, КҚ сақталды",
        failed_save_trucks: "Кейбір КҚ сақталмады",
        failed_save_truck: "КҚ сақтау мүмкін болмады",
        customColumns: {
            historyBtn: "Жүк тарихы",
            copyBtn: "Көшіру",
            addCommentBtn: "Түсіндірме жазу",
            map: "Карта",
            orderStatus: "Мәртебе",
            completion: "Аяқ.",
            date: "Күні",
            carrierContactPhone: "Тасымалдаушының контактісінің нөмірі",
            carrierContact: "Тасымалдаушының контактісі",
            carrier: "Тасымалдаушы",
            cashRate: "Қолма-қол ақша мөлшерлемесі",
            rateWithoutVAT: "ҚҚС-сыз мөлшерлеме",
            rateWithVAT: "ҚҚС қосқандағы мөлшерлеме ",
            offers: "Ұсыныс",
            contact: "Контакті",
            contactWithDate: "Контакті, қосылды/өзгертілді",
            driver: "Жүргізуші",
            car: "КҚ  ",
            separateCar: "Жеке машина",
            loadingUnloadingCar: "КҚ тиеу/түсіру",
            bodyType: "Шанақ түрі",
            loadParams: "Жүк параметрлері",
            unloading: "Жүк түсіру",
            loading: "Тиеу",
            routeAddress: "Маршрут мекенжайы",
            route: "Маршрут",
            loadNumber: "Жүк нөмірі"
        },
        byDefault: "Әдепкі қалпы бойынша",
        columns: "Бағандар",
        informer: "Енді деректерді ықшам\nкарталардакөрсетуді теңшей аласыз",
        verify: "Тексеру",
        toTime: "дейін",
        fromTime: "бастап",
        dateInputPlaceHolder: "күнді таңдау",
        timeInputPlaceholder: '09:00',
        rate: "Мөлшерлеме",
        unloading: "Жүк түсіру",
        loading: "Жүктеу",
        loadParams: {
            __html: "Салмағы, т/көлемі, м < sup > 3 </sup >, жүк"
        },
        transport: "Көлік",
        direction: "Жолдау.",
        roundTheClock: "тәулік бойы",
        workdays: "жұмыс күндері бойынша",
        everyday: "күн сайын",
        loadReady: "дайын",
        alwaysReady: "үнемі",
        ExpandingSection: {
            showFullInfo: "Толық көрсету"
        },
        "as-ui-kit/src/controls/DocumentBlock/strings": {
            "js/ru/previousVersion": "алдыңғы редакция",
            "js/ru/forContragent": "Контрагент өзгерткен. Сіздің растауыңызға дейін жарамды",
            "js/ru/forChanger": "Контрагент өзгерістерді растамай тұрып әрекет етеді",
            "js/ru/transportationOrder": "Тасымалдауға арналған өтінім",
            "js/ru/sentToCounterparty": "Контрагентке жіберілді",
            "js/ru/sentThroughAtiDocs": "АТИ.Док арқылы жіберілді",
            "js/ru/documentApprovedByTrucker": "Құжатты тасымалдаушы мақұлдады",
            "js/ru/documentApprovedByYou": "Құжатты сіз мақұлдадыңыз",
            "js/ru/documentSignedByTrucker": "Құжатқа тасымалдаушы қол қойды",
            "js/ru/documentSignedByYou": "Құжатқа сіз қол қойдыңыз",
            "js/ru/documentCreated": "Құжат жасалды",
            "js/ru/awaitsReview": "Қарауды күтеді"
        },
        DealUpdateTime: {
            at: ""
        },
        ConsultantsInfo: {
            workHours: "9-дан 18 MСК дейін",
            autoparkConsultants: "Автопаркті толтыруға көмектесеміз",
            dealsConsultants: "Тапсырыстар бойынша сұрақтарға жауап береміз"
        },
        CancelButton: {
            moveToArchive: "Мұрағатқа"
        },
        "as-ui-kit/src/controls/AtiSelect/AtiSelect": {
            "jsx/strings/clearValue": "Тазалау"
        },
        AtiCarNumberInput: {
            otherCountries: "Басқа елдер",
            russia: "Ресей"
        },
        "as-ui-kit/src/controls/AtiCarNumberInput/AtiCarNumberInput": {
            "jsx/carPlaceholder": "М 123 ММ 78"
        },
        "as-ui-kit/src/controls/AddressCoordinatesInput/strings": {
            "js/ru/pickOnMap": "Картада таңдау",
            "js/ru/clearAddress": "Тазалау",
            "js/ru/addressNotFound": "Мекенжай табылмады, қайта әрекет жасаңыз",
            "js/ru/pointOnMap": "Картада көрсету",
            "en": {
                "js/DEFAULT_EXPORT/pickOnMap": "Картада таңдау"
            }
        },
        "as-ui-kit/src/const/unilateralOrder": {
            "js/paymentTypesOptions/paymentTypes": {
                "cash/name": "Қолма-қол ақшамен",
                "cashlessWithNds/name": "ҚҚС-пен, салықсыз",
                "cashlessWithoutNds/name": "ҚҚС-сыз, салықсыз"
            }
        },
        weekDaysLowerShortList: [
            "жк",
            "дс",
            "сс",
            "ср",
            "бс",
            "жм",
            "сн",
        ],
        weekDaysShortList: [
            "Жк",
            "Дс",
            "Сс",
            "Ср",
            "Бс",
            "Жм",
            "Сн",
        ],
        timeStrings: {
            months: [
                "қаңтар",
                "ақпан",
                "наурыз",
                "сәуір",
                "мамыр",
                "маусым",
                "шілде",
                "тамыз",
                "қыркүйек",
                "қазан",
                "қараша",
                "желтоқсан",
            ],
            shortMonths: [
                "Қаңтар",
                "Ақпан",
                "Наурыз",
                "Сәуір",
                "Мамыр",
                "Маусым",
                "Шілде",
                "Тамыз",
                "Қыркүйек",
                "Қазан",
                "Қараша",
                "Желтоқсан",
            ],
            year: "қ.",
            h: "сағат",
            d: "күн",
            min: "мин",
            sec: "сек",
            tomorrow: "ертең",
            yesterday: "кеше",
            today: "бүгін",
            at: " ",
        },
        MonthList: [
            "Қаңтар",
            "Ақпан",
            "Наурыз",
            "Сәуір",
            "Мамыр",
            "Маусым",
            "Шілде",
            "Тамыз",
            "Қыркүйек",
            "Қазан",
            "Қараша",
            "Желтоқсан",
        ],
        "as-ui-kit/src/const/sensors": {
            "js/errors/ru/errorCodes": {
                "AuthLimitError": "Қолжеткізуден бас тартылды. Кейінірек қайталап көріңіз",
                "BLError": "Қате орын алды. Кейінірек қайталап көріңіз"
            },
            "js/providers/scout/name": "Скаут",
            "js/providers/wialon/name": "Виалон"
        },
        "as-ui-kit/src/const/scans": {
            "js/scanTypeNames/ru/scanTypes": {
                "marriage": "Неке туралы куәлік",
                "rentContract": "Жалдау шарты",
                "carPhoto": "Фото",
                "plasticTechPassport": "КҚК",
                "techPassport": "ККТ",
                "passport": "Төлқұжат",
                "driverLicense": "СҚ"
            }
        },
        "as-ui-kit/src/const/requisites": {
            "js/defaultAddress/officeType": "оф.",
            "js/defaultAddress/partType": "корп.",
            "js/defaultAddress/houseType": "үй",
            "js/dictionaries/officeTypes/2/label": "үй-жай",
            "js/dictionaries/officeTypes/2/value": "үй-жай",
            "js/dictionaries/officeTypes/1/label": "пәтер",
            "js/dictionaries/officeTypes/1/value": "п.",
            "js/dictionaries/officeTypes/0/label": "кеңсе",
            "js/dictionaries/officeTypes/0/value": "кеңсе",
            "js/dictionaries/partTypes/1/label": "құрылым ",
            "js/dictionaries/partTypes/1/value": "құр.",
            "js/dictionaries/partTypes/0/label": "корпус",
            "js/dictionaries/partTypes/0/value": "корп.",
            "js/dictionaries/houseTypes/1/label": "құрылым ",
            "js/dictionaries/houseTypes/1/value": "құр.",
            "js/dictionaries/houseTypes/0/label": "үй",
            "js/dictionaries/houseTypes/0/value": "үй",
            "js/dictionaries/streetTypes/13/label": "а/ж",
            "js/dictionaries/streetTypes/12/label": "сызық",
            "js/dictionaries/streetTypes/11/label": "келісім-шарт",
            "js/dictionaries/streetTypes/10/label": "арна",
            "js/dictionaries/streetTypes/9/label": "өтпе",
            "js/dictionaries/streetTypes/8/label": "бульвар",
            "js/dictionaries/streetTypes/7/label": "аллея",
            "js/dictionaries/streetTypes/6/label": "алаң",
            "js/dictionaries/streetTypes/5/label": "жағалау",
            "js/dictionaries/streetTypes/4/label": "тұйық көше",
            "js/dictionaries/streetTypes/3/label": "тас жол",
            "js/dictionaries/streetTypes/2/label": "даңғыл",
            "js/dictionaries/streetTypes/1/label": "көше",
            "js/dictionaries/streetTypes/0/label": "(басқа)",
            "js/dictionaries/residences/ru/4/label": "Басқа",
            "js/dictionaries/residences/ru/3/label": "Қазақстан  ",
            "js/dictionaries/residences/ru/2/label": "Беларусь",
            "js/dictionaries/residences/ru/1/label": "Украина",
            "js/dictionaries/residences/ru/0/label": "Ресей"
        },
        "as-ui-kit/src/const/payDocs": {
            "js/mappedTransportCompanyNames/ru/1": "басқа ",
            "js/payDocsLabels/ru/ClosingDocuments": "Жабатын",
            "js/payDocsLabels/ru/Payment": "Төленді",
            "js/payDocsLabels/ru/DocumentsOriginalTrack": "Трек нөмірі",
            "js/payDocsLabels/ru/DocumentsOriginal": "Түпнұсқалар",
            "js/payDocsLabels/ru/DocumentsCopies": "Көшірмелер",
            "js/payDocsName/ru/carrier/ClosingDocuments/name": "Жабатын құжаттар алынды\nТөлем алынды",
            "js/payDocsName/ru/carrier/Payment/name": "Төлем алынды",
            "js/payDocsName/ru/carrier/DocumentsOriginal/name": "Түпнұсқалар жіберілді",
            "js/payDocsName/ru/carrier/DocumentsCopies/name": "Құжаттардың көшірмелері жіберілді",
            "js/payDocsName/ru/cargoOwner/Payment/name": "Төленді",
            "js/payDocsName/ru/cargoOwner/DocumentsOriginal/name": "Түпнұсқалар алынды",
            "js/payDocsName/ru/cargoOwner/DocumentsCopies/name": "Құжаттардың көшірмелері алынды"
        },
        "as-ui-kit/src/const/index": {
            "js/undefinedError": "Белгісіз қате"
        },
        "as-ui-kit/src/const/files": {
            "js/fileSourceTypeNames/ru/dealFileSourceFileTypes": {
                "freeUse": "Өтеусіз пайдалану шарты",
                "truckPhoto": "Сурет",
                "truckPlasticTechPassport": "Пластик",
                "truckTechPassport": "КҚТ",
                "driverPassport": "Төлқұжат",
                "driverLicense": "СҚ"
            },
            "js/fileSourceNames/ru/dealFileSourceTypes": {
                "tractor": "тартқыш",
                "semiTrailer": "жартылай тіркеме",
                "trailer": "тіркеме",
                "truck": "жүк көлігі",
                "driver": "жүргізушінің"
            }
        },
        documentTypes: {
            poa: "сенімхат",
            uniliteralDissolution: "орындаудан бас тарту туралы хабарлама",
            invoice: "шот",
            act: "акт",
            commission: "экспедиторға тапсырма",
            tableRequest: "шартқа өтінім (кестелік түрі)",
            request: "өтінім (шартқа)",
            order: "тапсырыс",
            tableOrder: "тапсырыс (кестелік түрі)",
            contract: "тапсырыс (шарт-өтінім)"
        },
        displayedDocumentTypes: {
            commission: "Экспедиторға тапсырма",
            request: "Құжат түріндегі өтінім",
            tableRequest: "кесте түріндегі өтінім",
            order: "Құжат түріндегі тапсырыс",
            tableOrder: "Кесте түріндегі тапсырыс",
        },
        docTypesGroups: [
            "Контрагентпен алғаш рет жұмыс істеп жатырсыз",
            "Шарт бар",
            "Көлік экспедициясы шарты бойынша жұмыс істейсіз",
        ],
        additionalDocuments: {
            cancelDeal: "Орындаудан бас тарту туралы хабарлама",
            poa: "Сенімхат",
            invoice: "Өтінім бойынша шот",
            act: "Акт (екі жақты)",
        },
        cancelDocuments: {
            refusalOfFulfilment: "Орындаудан бас тарту туралы хабарлама",
        },
        "as-ui-kit/src/const/documents": {
            "js/docTypeTemplates/contract": "шарт",
        },
        auctionPaymentTypes: {
            25: "ҚҚС-сыз",
            24: "ҚҚС-пен",
            23: "картаға  ",
            1: "қолма-қол ақша",
            0: "кез келген"
        },
        ton: "т",
        weight: "Салмақ",
        to: "дейін",
        from: "бастап",
        meter: "м",
        volume: "Көлемі",
        TruckIcon: {
            carInGratuitousUseVerifiedTooltip: "Өтеусіз пайдалануда расталған КҚ",
            carInGratuitousUseTooltip: "Өтеусіз пайдаланудағы КҚ",
            carInSousesJointOwnershipVerifiedTooltip: "Ерлі-зайыптылардың бірлескен меншігінде расталған КҚ",
            carInSousesJointOwnershipTooltip: "Ерлі-зайыптылардың бірлескен меншігіндегі КҚ",
            carExternalTooltip: "Тартылған КҚ",
            carOwnVerifiedTooltip: "Расталған жеке КҚ",
            carOwnTooltip: "Жеке КҚ",
            carInLeasingVerifiedTooltip: "Лизингте расталған КҚ",
            carInLeasingTooltip: "лизингтегі КҚ",
            carInRentVerifiedTooltip: "Жалдаудағы расталған КҚ",
            carInRentTooltip: "Жалдаудағы КҚ"
        },
        TrackerStatus: {
            promoAction: "Бұл қалай жұмыс істейді",
            promoHeader: "Енді жүкті картада жүргізушіге арналған қосымша арқылы бақылауға болады"
        },
        LastActive: {
            exclusivePopoverLinkText: "эксклюзивті қолжетімділік.",
            ago: "артқа",
            activity: "белсенділік",
            exclusiveAccess: "Басқа фирмаға эксклюзивті кіру",
            installed: "орнатылды",
            hasTracker: "ATИ Жүргізуші"
        },
        Invite: {
            car: {
                cantInviteTooltip: 'Приглашение можно выслать только на мобильный номер телефона. У водителя указан не мобильный. Телефон можно изменить в вашем Справочнике Водителей',
                tooManyRequests: "Шақыруды жіберу әрекеті тым көп. Кейінірек көріңіз",
                toApp: "орнату",
                invited: "Шақыру жіберілді",
                invite: "Шақыруды жіберу",
                undefinedError: "Белгісіз қате",
                cantInvite: "Осы тапсырыстан жүргізушіні шақыруға болмайды",
                alreadyInvited: "Сіз осы жүргізушіге шақыру жіберген едіңіз. Кейінірек көріңіз",
                resend: "Қайта шақыру",
                atiTrucker: "ATИ Жүргізуші"
            },
            driver: {
                                cantInviteTooltip: 'Приглашение можно выслать только на мобильный номер телефона. У водителя указан не мобильный. Телефон можно изменить в вашем Справочнике Водителей',

                tooManyRequests: "Жүргізушіні шақыру әрекеті тым көп. Кейінірек көріңіз",
                toApp: "орнату",
                invited: "Жүргізуші шақырылды",
                sent: "жіберілді",
                invite: "Шақыру",
                inviteDriver: "Жүргізушіні шақыру",
                undefinedError: "Белгісіз қате",
                cantInvite: "Осы тапсырыстан жүргізушіні шақыруға болмайды",
                alreadyInvited: "Сіз осы жүргізушіге шақыру жіберген едіңіз. Кейінірек көріңіз",
                resend: "Қайта шақыру",
                atiTrucker: "ATИ Жүргізуші"
            }
        },
        InvitePopover: {
            car: {
                exclusiveDescription:
                    'Только вы сможете отправлять\n' +
                    'заказы водителю, получать\n' +
                    'актуальные статусы перевозки,\n' +
                    'отслеживать местоположение\n' +
                    'груза на карте.',
                smsIsSent: "Телефон нөміріне смс жіберілді",
                caption: "Бағдарламаны жүктеуге сілтеме жасай отырып, телефон нөміріне смс жіберіледі",
                invite: "Шақыруды жіберу",
                exclusiveAccess: "АТИ жүргізушісіне эксклюзивті қолжетімділік",
                onlyAndroid: "Қосымша тек Android-та жұмыс істейді",
                sendSms: "Смс жіберу",
                atiDriver: "ATИ Жүргізуші"
            },
            driver: {
                exclusiveDescription:
                    'Только вы сможете отправлять\n' +
                    'заказы водителю, получать\n' +
                    'актуальные статусы перевозки,\n' +
                    'отслеживать местоположение\n' +
                    'груза на карте.',
                smsIsSent: "Жүргізушіге смс жіберілді",
                caption: "Бағдарламаны жүктеуге сілтеме жасай отырып, жүргізушіге смс жіберіледі",
                invite: "Жүргізушіні шақыру",
                exclusiveAccess: "АТИ жүргізушісіне эксклюзивті қолжетімділік",
                onlyAndroid: "Қосымша тек Android-та жұмыс істейді",
                sendSms: "Смс жіберу",
                atiDriver: "ATИ Жүргізуші"
            }
        },
        "as-ui-kit/src/components/TrackerLink/strings": {
            "js/ru/atiTrucker": "ATИ Жүргізуші"
        },
        "as-ui-kit/src/components/TrackerIcon/strings": {
            "js/ru/howToUseTracker": "ATИ Жүргізуші - қалай жүктеу және пайдалану керек"
        },
        "as-ui-kit/src/components/TrackerAppInfoPopover/strings": {
            "js/ru/trackerFeatures": "АТИ Жүргізушінің мүмкіндіктері",
            "js/ru/atiTracker": "ATИ Жүргізуші"
        },
        "as-ui-kit/src/components/Tabs/Tab/TabCounter/strings": {
            "js/ru/of": "ішінен"
        },
        "as-ui-kit/src/components/Signee/Signee": {
            "jsx/strings/useByDefault": "Өздігінен пайдалану",
            "jsx/strings/signee": "Қол қоюшы",
            "jsx/strings/remove": "жою",
            "jsx/strings/positionInGenitive": "Ілік септігіндегі лауазым",
            "jsx/strings/fullNameInGenitive": "Ілік септігіндегі аты-жөні",
            "jsx/strings/actUponWhatText": "Ненің негізінде әрекет етеді. Мысалы: «Жарғы..\", «сенімхат №....»"
        },
        ShortFirmInfo: {
            recommend: "Ұсыныс жасау"
        },
        "as-ui-kit/src/components/SensorActivateLink/strings": {
            "js/ru/reauthorizationRequired": "Қайта авторизациялауды талап етеді",
            "js/ru/inactive": "Белсенді емес"
        },
        "as-ui-kit/src/components/SearchLoad/strings": {
            "js/ru/unloading": "Жүк түсіру",
            "js/ru/loading": "Жүктеу",
            "js/ru/loadParams/__html": "Салмағы, т/көлемі, м < sup > 3 </sup >, жүк",
            "js/ru/transport": "Көлік",
            "js/ru/direction": "Бағыт"
        },
        "as-ui-kit/src/components/SearchLoad/SearchLoadParams/strings": {
            "js/ru/widthShort": "Ш",
            "js/ru/sborgruz": "құрама жүк",
            "js/ru/onlyToSepCar": "жеке машина ",
            "js/ru/meters": "м",
            "js/ru/load": "Жүк",
            "js/ru/lengthShort": "Ұ",
            "js/ru/items": "дана",
            "js/ru/heightShort": "Б",
            "js/ru/dogruzPossible": "қос. жүк тиеу мүмкін",
            "js/ru/dogruz": "қосымша жүк тиеу"
        },
        "as-ui-kit/src/components/SearchLoad/LoadUnloading/RouteThrough/strings": {
            "js/ru/through": "___ арқылы жүру"
        },
        "as-ui-kit/src/components/SearchLoad/LoadUnloading/CustomsOnRoute/strings": {
            "js/ru/custom": "кеден:"
        },
        "as-ui-kit/src/components/SearchLoad/LoadTransport/strings": {
            "js/ru/capacity": "г/п {{number}} т,",
            "js/ru/onlyToSepCar": "ж/к {{number}} т,",
            "js/ru/dogruzPossible": "қос. жүк тиеу мүмкін",
            "js/ru/dogruz": "қосымша жүк тиеу",
            "js/ru/beltOther": "белбеу",
            "js/ru/beltMany": "белбеу",
            "js/ru/beltFew": "белбеу",
            "js/ru/beltOne": "белбеу",
            "js/ru/sanPassport": "медициналық кітапша",
            "js/ru/loadUnload": "тиеу/босату",
            "js/ru/unload": "босату",
            "js/ru/load": "тиеу ",
            "js/ru/pnevmohod": "пневмо",
            "js/ru/stsepka": "тіркеме",
            "js/ru/koniki": "кониктер",
            "js/ru/cars": "маш."
        },
        "as-ui-kit/src/components/SearchLoad/LoadRate/strings": {
            "js/ru/allTermsInATIDocs": "АТИ-Доктардағы өтінімдегі барлық шарттар",
            "js/ru/cashlessAll": "ақшасыз ҚҚС-пен, ҚҚС-сыз",
            "js/ru/cashlessWithoutVat": "ақшасыз ҚҚС-сыз",
            "js/ru/cashlessWithVat": "ақшасыз ҚҚС-пен",
            "js/ru/cash": "қолма-қол ақша",
            "js/ru/bargainOff": "сауда-саттықсыз",
            "js/ru/undefined": "ҚҚС-пен",
            "js/ru/direct": "тiкелей",
            "js/ru/bargainOn": "сауда-саттық",
            "js/ru/payDays": "{0} б/к кейін",
            "js/ru/prepayAlone": "алдын ала.",
            "js/ru/inFuel": "терек.",
            "js/ru/prepay": "Алдын ала төлеу: {0}%",
            "js/ru/onLoad": "жүк түсіруде",
            "js/ru/inquireLoad": "мөлшерлемені сұрату",
            "js/ru/noLoad": "жүк жоқ, мөлшерлемені сұрату"
        },
        "as-ui-kit/src/components/SearchLoad/LoadDirection/strings": {
            "js/ru/km": "км",
            "js/ru/seePath": "бағытты көру",
            "js/ru/krugoreis": "рейс айналымы"
        },
        cardsCompact: "Карточкалардың ықшам түрі",
        cards: "Әдеттегі карточка түрі",
        appearance: "Сыртқы түрі",
        RejectOrder: {
            restoreLot: "Лот сол алаңдарда қайта жарияланады.",
            restoreLoad: "жүкті қалпына келтіру",
            toArchive: "Мұрағатқа",
            move: "ауыстыру",
            cancelDeals: "Сауда-саттықты доғару",
            inArchive: "Мұрағатта",
            leftLoad: "жүкті қалдыру",
            publicLoadWithoutDeal: "жүкті Сауда-саттықсыз қою",
            restartDeal: "Сауда-саттықты қайта іске қосу",
            rubles: "рубль",
            withRate: "мөлшерлемемен",
            chooseWinner: "жеңімпаз етіп таңдау",
            noReasonWarning: "Доғару себебін көрсетіңіз",
            reasonRejectionOffer: "Ұсынысты доғару себебін көрсетіңіз",
            whatHappenedWithLoads: "Жүкпен не істеу керек",
            popoverWarning: "Тапсырыс мұрағатқа көшіріледі және тоқтатылған ретінде белгіленеді"
        },
        "as-ui-kit/src/components/PopupWarning/strings": {
            "js/ru/notToSave": "Сақтамау",
            "js/ru/save": "Сақтау",
            "js/ru/edit": "Редакциялау",
            "js/ru/p2": "Өзгертулер жоғалуы мүмкін.",
            "js/ru/p1": "Өзгертулерді сақтамадыңыз және терезені жабуға тырысасыз.",
            "js/ru/header": "Өзгерістермен не істеу керек?"
        },
        Selected: {
            showAll: "Толық көрсету"
        },
        "as-ui-kit/src/components/PhoneForm/strings": {
            "js/ru/phoneInCar": "Көлік құралына орнатылған мобильді құрылғы",
            "js/ru/exclusiveAccess": "Оның  АТИ жүргізушіге эксклюзивті қолжетімділігі",
            "js/ru/phone": "Телефон"
        },
        "as-ui-kit/src/components/PhoneForm/TrackerInfo/strings": {
            "js/ru/promo": "Бағдарламаға сілтеме жіберу үшін ұялы телефонды көрсетіңіз",
            "js/ru/invitedHint": "сілтеме арқылы смс жіберіледі",
            "js/ru/atiTrucker": "ATИ Жүргізуші"
        },
        "as-ui-kit/src/components/PhoneForm/TrackerInfo/BindOwn/strings": {
            "js/ru/bindingTypes": {
                "driver": "Жүргізушіге",
                "car": "КҚ-на"
            },
            "js/ru/goToAutopark": "Автопаркке өту",
            "js/ru/goToCatalog": "Анықтамалыққа өту",
            "js/ru/alreadyAttached": "Бұл нөмір бағдарламамен байланыстырылған"
        },
        "as-ui-kit/src/components/PhoneForm/TrackerInfo/BindOther/strings": {
            "js/ru/carFromAnother": "Сіз КҚ [[AppLink]] [[Break]] бағдарламасына байланыстыра алмайсыз, себебі ол фирмаға байланған",
            "js/ru/employedToAnotherFirm": "Сіз бұл жүргізушіге [[Break]] [[AppLink]] арқылы тапсырыстар жібере алмайсыз, себебі ол фирма қызметкері болып табылады",
            "js/ru/atiTrucker": "ATИ Жүргізуші"
        },
        "as-ui-kit/src/components/PhoneForm/BindingStatus/strings": {
            "js/ru/resend": "Қайта жіберу",
            "js/ru/driverRejected": "Сұрау қабылданбады",
            "js/ru/cancel": "Доғару  ",
            "js/ru/sent": "Сұрату жіберілді",
            "js/ru/sendRequest": "Сұратуды жіберу"
        },
        PayDocsStatus: {
            infoTextForCargoOwner:
                'Перевозчик может добавить трек-номер \nотправленных документов прямо к Заказу.\n' +
                'Вы получите уведомление, добавится статус \nв разделе «Документооборот и оплата», после чего \nвы сможете отслеживать посылку на сайте Службы \nдоставки.',
            trackNotExist: "Трек нөмірі көрсетілмеген",
            learnMore: "Толығырақ білу",
            carrierTrack: "Тасымалдаушыдан жөнелтілімнің трек-нөмірі",
            addTrackNumber: "Жіберу үшін трек нөмірін (бақылау нөмірін) қосу",
            choosePaymentStatus: "ДО және төлем мәртебесін таңдаңыз",
            tooltipText: "Сіз трек-нөмірін қосқаннан кейін Тапсырыс беруші хабарлама алады және жөнелтуді жеткізу қызметінің сайтында бақылай алады.",
            availableToCustomer: "(Тапсырыс берушіге қол жетімді)",
            trackNumber: "трек нөмірі",
            status: "мәртебе",
            paymentStatusHint: "(тек сізге ғана көрінеді)",
            paymentStatus: "Құжат айналымы және төлем"
        },
        "as-ui-kit/src/components/PayDocsStatus/StatusLabel/strings": {
            "js/ru/changeTrackNumber": "Жіберу үшін трек нөмірін (бақылау нөмірін) өзгерту",
            "js/ru/cancelDelete": "Жоймау",
            "js/ru/delete": "Жою",
            "js/ru/deleteTrackNumber": "Трек нөмірін қайтарымсыз жою керек пе?",
            "js/ru/defaultCompanyName": "жеткізу қызметтері",
            "js/ru/ofCompany": "компаниялар",
            "js/ru/trackInWebsite": "Торапта бақылау",
            "js/ru/trackNumberCopied": "Трек нөмірі көшірілген",
            "js/ru/header": "Трек нөмірі",
            "js/ru/trackNumber": "трек нөмірі"
        },
        "as-ui-kit/src/components/PayDocsStatus/PayDocTrackPopover/strings": {
            "js/ru/trackNotExist": "Трек нөмірі көрсетілмеген",
            "js/ru/learnMore": "Толығырақ білу",
            "js/ru/carrierTrack": "Тасымалдаушыдан жөнелтілімнің трек-нөмірі",
            "js/ru/trackNumberForShipment": "жөнелтуге арналған трек-нөмірі (бақылау нөмірі)",
            "js/ru/trackNumber": "трек нөмірі",
            "js/ru/change": "Өзгерту",
            "js/ru/add": "Қосу"
        },
        "as-ui-kit/src/components/PayDocsStatus/ChooseStatusForm/StatusFormRow/strings": {
            "js/ru/availableToCustomer": "(Тапсырыс берушіге қол жетімді)",
            "js/ru/tooltipText": "Сіз трек-нөмірін қосқаннан кейін Тапсырыс беруші хабарлама алады және жөнелтуді жеткізу қызметінің сайтында бақылай алады.",
            "js/ru/trackNumber": "трек нөмірі",
            "js/ru/addTrackNumber": "Трек нөмірін қосу",
            "js/ru/chooseDate": "күнді таңдау"
        },
        cancel: "Болдырмау",
        "as-ui-kit/src/components/PayDocsStatus/ChooseStatusForm/StatusFormFooter/strings": {
            "js/ru/finishOfferRequestError": "Тасымалдауды аяқтау кезінде қате пайда болды.",
            "js/ru/saveAndArchive": "Мұрағатқа",
            "js/ru/save": "Сақтау"
        },
        "as-ui-kit/src/components/PayDocsStatus/ChangeTrackForm/TrackFormRow/strings": {
            "js/ru/chooseDate": "Күнді таңдау",
            "js/ru/sendDate": "Жіберу күні",
            "js/ru/inputError": "Трек-нөмірде тек сандар мен латын әріптері болуы тиіс",
            "js/ru/trackNumber": "Трек нөмірі",
            "js/ru/trackUrl": "Жеткізу торабына сілтеме",
            "js/ru/chooseTransportCompany": "Жеткізу қызметін таңдаңыз",
            "js/ru/transportCompany": "Жеткізу қызметі",
            "js/ru/body": "Сіз трек-нөмірін қосқаннан кейін Тапсырыс беруші хабарлама алады және жөнелтуді жеткізу қызметінің сайтында бақылай алады."
        },
        "as-ui-kit/src/components/PayDocsStatus/ChangeTrackForm/TrackFormFooter/strings": {
            "js/ru/cantSaveForm": "Барлық міндетті өрістер толтырылмайынша, трек нөмірін сақтай алмайсыз",
            "js/ru/delete": "Трек нөмірін жою",
            "js/ru/save": "Сақтау",
            "js/ru/cancel": "Қоспау",
            "js/ru/add": "Трек нөмірін қосу"
        },
        "as-ui-kit/src/components/PayDocsStatus/ChangeTrackForm/TrackFormFooter/ConfirmDeletePopover/strings": {
            "js/ru/dontDelete": "Жоймау",
            "js/ru/delete": "Жою",
            "js/ru/confirmDelete": "Трек нөмірін қайтарымсыз жою керек пе?"
        },
        ParticipantsPopup: {
            noPermissionsText: "Жүкпен жүк бөлімшесіне кіре алатын  қызметкерлер ғана жұмыс істейді",
            anotherPtWinner: "Сауда-саттықтың тағы бір қатысушысы жеңіске жетті",
            update: "Жаңарту",
            noWinners2: "Сауда-саттықты доғарыңыз және қайта іске қосыңыз",
            noWinners1: "Жеңімпаздар жоқ.",
            winnerRemovedFromBoard2: "Басқасын таңдау",
            winnerRemovedFromBoard1: "Жеңімпаз Алаңнан жойылды.",
            winnerTimeExpiredNoNext2: "немесе Сауда-саттықты қайта бастау",
            winnerTimeExpired2: "немесе келесі қатысушыны таңдау",
            waitForWinner: "Жеңімпаздан деректерді күтуге болады",
            finished: "Сауда-саттық аяқталды.",
            untilEnd: "Сауда-саттықтың соңына дейін.",
            startRate: "бастапқы мөлшерлеме.",
            participants: {
                other: "қатысушы",
                many: "қатысушы",
                few: "қатысушы",
                one: "қатысушы"
            },
            noParticipants: "Қатысушылар жоқ",
            Participant: {
                atrucksTooltip: "Көлік компанияларымен жұмысты автоматтандыруға арналған бөгде жүйе",
                ptParticipant: "Тікелейз Сауда-саттыққа Қатысушы",
                tooltipRate: "Қатысушы мөлшерлеме жасады",
                bestRateAndDate: "Үздік мөлшерлеме және күн",
                bestDate: "Үздік күн",
                bestRate: "Үздік мөлшерлеме",
                or: "немесе",
                noAccessText: "Бұл әрекетті орындауға рұқсатыңыз жоқ. Құқық алу үшін әкімшіге хабарласыңыз",
                at: "",
                yearStr: "ж.",
                shouldSend: ["Жеңімпаз сізге ", " ішінде өтінім үшін деректерді ұсынуы тиіс "],
                dontSend: "Жеңімпаз өтінім үшін сізге әлі мәлімет ұсынған жоқ.",
                winnerConfirmed2: "тапсырыстар  ",
                winnerConfirmed1: "Жеңімпаз жүкті алды. Жүргізуші және КҚ туралы деректерді қараңыз",
                exWinner: "Осы қатысушының ұсынысын қабылдамадыңыз",
                shipperRefused: "Тапсырысты жүк иесі қабылдамады",
                carrierRefused: "Тасымалдаушы Тапсырысқа қатысудан бас тартты",
                refused: "Қатысушы Сауда-саттыққа қатысудан бас тартты.",
                skipped: "Деректерді уақытылы ұсынбады.",
                winnerRemovedFromBoard: "Жеңімпаз Алаңнан жойылды.",
                removedFromBoard: "Қатысушы Алаңнан жойылған.",
            },

        },
        loadingDate: "Дайын",
        participant: "Қатысушы",
        outputStrings: "Жолдарды шығару",
        "as-ui-kit/src/components/PaginationBlock/Pagination/strings": {
            "js/ru/from": "ішінен"
        },
        orderLoadNumber: "Жүктің/лоттың/тапсырыс №",
        orderNumber: "Тапсырыс №",
        "as-ui-kit/src/components/OfferTracker/TrackerSummary/LinkToRouteOnMap/strings": {
            "js/ru/routeOnMap": "Картадағы бағыт"
        },
        "as-ui-kit/src/components/OfferTracker/TrackerSummary/FinishedStatusView/strings": {
            "js/ru/eventDateTime": "{{day}}  {{time}}",
            "js/ru/driverRevoked": "Жүргізуші тапсырыстан қайтарылды",
            "js/ru/driverRejectedDeal": "Жүргізуші тапсырыстан бас тартты",
            "js/ru/driverFinishedDeal": "Жүргізуші тапсырысты аяқтады",
            "js/ru/cancelledDeal": "тапсырысты доғарды",
            "js/ru/finishedDeal": "тапсырысты аяқтады"
        },
        "as-ui-kit/src/components/OfferTracker/TrackerSummary/Accidents/strings": {
            "js/ru/4": "деректер болмады",
            "js/ru/3": "GPS ажыратылған маршрут бөлігі",
            "js/ru/2": "сыну",
            "js/ru/1": "ЖКО",
            "js/ru/0": "GPS қолдан жасау әрекеті"
        },
        "as-ui-kit/src/components/OfferTracker/TrackerInWorkStatus/strings": {
            "js/ru/driverWillSendDataFromApp": "Жүргізуші тапсырыс алды, бірақ ол бойынша әлі жұмыс істей бастаған жоқ",
            "js/ru/from": "ішінен",
            "js/ru/ed": "өзг.",
            "js/ru/fromApp": "АТИ Жүргізуші қосымшасынан"
        },
        "as-ui-kit/src/components/OfferTracker/TooltipMessage/strings": {
            "js/ru/gpsSpoof": "жүргізуші телефонында GPS ({{initialPhone}}) қолдан жасауға мүмкіндік беретін функция қосылған.",
            "js/ru/gpsOff": "Жүргізушінің телефон параметрлерінде GPS өшірілген ({{initialPhone}}). Орналасу орны туралы деректер жоқ.",
            "js/ru/noData": "деректер келмей қалды. Жүргізушінің телефоны өшірілген немесе интернетке қосылмаған болуы мүмкін ({{initialPhone}}).",
            "js/ru/youAndOwner": "сізге және тапсырыс берушіге",
            "js/ru/onlyYou": "тек сіздің фирмаңызға",
            "js/ru/rejectionInfoAvailable": "Бас тарту туралы ақпарат қол жетімді",
            "js/ru/infoAvailable": "Ақпарат қол жетімді",
            "js/ru/dataAvailable": "Бағдарламадағы карта мен тапсырыс мәртебесі қол жетімді",
            "js/ru/activity": "АТИ Жүргізуші ({{initialPhone}}) қосымшасындағы белсенділік {{lastActive}}.    "
        },
        "as-ui-kit/src/components/OfferTracker/StatusDescriptions/strings": {
            "js/ru/notConfirmed": "Жүргізуші тапсырысты қосымшада алғандығын растамады",
            "js/ru/finishedByCounterpart": "[[FirmName]] тапсырысты аяқтады",
            "js/ru/finished": "Жүргізуші тапсырысты аяқтады",
            "js/ru/revoked": "Тапсырысты қайтарып алдыңыз",
            "js/ru/notSentDataExpected": "Жүргізушіге тапсырыс жіберу үшін тасымалдау үшін деректерді көрсетіңіз",
            "js/ru/notSent": "Жүргізушіге арналған деректер көрсетілмеген",
            "js/ru/rejectionReason": "бас тарту себебі",
            "js/ru/rejected": "Жүргізуші тапсырыстан бас тартты",
            "js/ru/sent": "Тапсырыс жіберілді [[DriverPhone]] Жүргізуші тапсырысты әлі жұмысқа алмады",
            "js/ru/sentShort": "Тапсырыс жіберілді",
            "js/ru/sendToSeeOnMap": "Жүкті картадан көру үшін тапсырысты бағдарламаға жіберіңіз",
            "js/ru/awaitingDriver": "Жүргізушінің тапсырыс беруін күтеміз",
            "js/ru/carrierRevoked": "Тасымалдаушы жүргізушіден тапсырысты қайтарып алды. Жаңа деректер жоқ"
        },
        "as-ui-kit/src/components/OfferTracker/StatusBadge/strings": {
            "js/ru/gpsSpoof": "GPS қолдан жасау",
            "js/ru/gpsOff": "GPS ажыратылған",
            "js/ru/finished": "тапсырыс аяқталды",
            "js/ru/revoked": "тапсырыс қайтарып алынды",
            "js/ru/rejected": "тапсырыстан бас тарту",
            "js/ru/notInWork": "жұмыста емес",
            "js/ru/inWork": "жұмыста",
            "js/ru/sent": "тапсырыс жіберілді",
            "js/ru/notSent": "тапсырыс жіберілмеді",
            "js/ru/noData": "деректер жоқ",
            "js/ru/atiTrucker": "ATИ Жүргізуші"
        },
        "as-ui-kit/src/components/OfferTracker/StateWithoutDriver/strings": {
            "js/ru/toWatchCargoOnMap": "жүкті картадан көру үшін",
            "js/ru/inAtiDriver": "АТИ-Жүргізушіде",
            "js/ru/addDriverInOrder": "Жүргізушіні тапсырысқа қосып, шақырыңыз",
            "js/ru/addDriver": "Жүргізушіні тапсырысқа қосып, оған шақыру жіберіңіз"
        },
        "as-ui-kit/src/components/OfferTracker/PresenceLoading/strings": {
            "js/ru/loading": "деректерді жүктейміз...",
            "js/ru/hasTracker": "ATИ Жүргізуші"
        },
        "as-ui-kit/src/components/OfferTracker/NoTrackerAccess/strings": {
            "js/ru/atiTrucker": "ATИ Жүргізуші"
        },
        "as-ui-kit/src/components/OfferTracker/NoInWorkAccess/strings": {
            "js/ru/carrierReceivesFromApp": "Тасымалдаушы ATИ Жүргізуші қосымшасынан мәртебе алады",
            "js/ru/changingStatuses": "Мәртебелерді ауыстыру қол жетімсіз"
        },
        "as-ui-kit/src/components/OfferTracker/MapActionsContainer/strings": {
            "js/ru/dialogDescription": "ATИ Жүргізуші",
            "js/ru/chat": "Чат",
            "js/ru/shareLinkDescription": "сілтемені бөлісу",
            "js/ru/shareLink": "Сілтемені бөлісу",
            "js/ru/sharedWithCounterpartyDescription": "сізге және тапсырыс берушіге көрінеді",
            "js/ru/onlyForYouDescription": "тек сізге ғана көрінеді",
            "js/ru/sharedWithCounterparty": "Сізге және тапсырыс берушіге көрінеді",
            "js/ru/onlyForYou": "Тек сізге ғана көрінеді",
            "js/ru/map": "Карта"
        },
        "as-ui-kit/src/components/OfferTracker/MainActions/strings": {
            "js/ru/revokeData": "Тапсырысты қайтарып алу",
            "js/ru/dataForDriver": "Жүргізушіге арналған деректер",
            "js/ru/configure": "Баптау",
            "js/ru/resendOrder": "Қайта жіберу",
            "js/ru/sendOrder": "Тапсырысты жіберу",
            "js/ru/setData": "Деректерді көрсету"
        },
        ActionsButtons: {
            dialogDescription: "ATИ Жүргізуші",
            chat: "Чат",
            shareLink: "Сілтемені бөлісу",
            sharedWithCounterpartyDescription: "сізге және тапсырыс берушіге көрінеді",
            onlyForYouDescription: "тек сізге ғана көрінеді",
            sharedWithCounterparty: "Сізге және тапсырыс берушіге көрінеді",
            onlyForYou: "Тек сізге ғана көрінеді",
            map: "Карта"
        },
        InDevelopmentButton: {
            inDev: "Әзірлеуде"
        },
        OfferInformationDriver: {
            willProvideDataLater: "Деректерді кейінірек көрсетемін",
            fromDealModifier: "(мәміледен)",
            registration: "Тіркеу",
            seriesNumber: "Сериясы, нөмірі",
            selectDriver: "Жүргізушіні таңдау",
            searchDrivers: "Жүргізушілер бойынша іздеу",
            driverLicense: "Жүргізуші куәлігі",
            passportIssuedWhen: "Берілген күні",
            passportIssued: "Берілді",
            passportNumber: "Нөмір",
            passportSeries: "Серия",
            passport: "Төлқұжат",
            enlistedDriver: "сырттан тартылған жүргізуші",
            enlisted: "тартылған",
            edit: "Өңдеу",
            driverNotFound: "Жүргізуші табылмады",
            driver: "Жүргізуші",
            clickToAddDriver: "Жаңасын қосу үшін басыңыз",
            addDriver: "Жүргізушіні қосу"
        },
        UseTrackerCheck: {
            fromTracker: "АТИ Жүргізушіден",
            shareData: "Тапсырыс берушімен деректерді бөлісу"
        },
        OfferInformationDriverFooter: {
            editHint: "Жүргізуші осы жүргізушіге тапсырыстарды жіберу үшін",
            editHintLink: "Моб.телефон нөмірін көрсетіңіз",
            willNotShare: "Жүргізушінің картасы мен тапсырыс мәртебесі сізге ғана қолжетімді",
            willShare: "сіз тапсырыс берушімен картаны және Жүргізушінің мәртебесін бөлісесіз",
            nlistedDriver: "сырттан тартылған жүргізуші"
        },
        TrackerSharing: {
            howTrackerWorks: "Жүргізуші қалай жұмыс істейді",
            youWillSee: "Сіз картадағы жүкті және тапсырыстың өзекті мәртебесін көре аласыз.",
            carrierWillShare: "Тасымалдаушы АТИ Жүргізуші-ден  деректері бөліседі"
        },
        OfferInformationCar: {
            willProvideDataLater: "Деректерді кейінірек көрсетемін",
            fromDealTip: "Тапсырыстан",
            fromDealModifier: "(мәміледен)",
            remove: "Алып тастау",
            unknownCarType: "шанақтың белгісіз түрі",
            vehicle: "КҚ",
            clickToAddVehicle: "Жаңасын қосу үшін басыңыз",
            vehicleNotFound: "Машина табылмады",
            edit: "Өңдеу",
            chooseSemiTrailer: "Жартылай тіркемені таңдаңыз",
            chooseTrailer: "Тіркемені таңдау",
            chooseVehicle: "КҚ таңдау",
            searchVehicles: "КҚ бойынша іздеу",
            addVehicle: "КҚ қосу",
            addSemiTrailer: "Жартылай тіркемені қосу",
            addTrailer: "Тіркемені қосу",
            addTruck: "Жүк көлігін қосу",
            carTypeNames: {
                trailer: "Тіркеме",
                semitrailer: "Жартылай тіркеме",
                tractor: "Тартқыш",
                truck: "Жүк көлігі"
            }
        },
        Contractors: {
            readMoreLink: {
                text: "Анықтамалық туралы толығырақ",
            },
            button: "Контрагентті қосу",
            header: "Контрагенттеріңіз",
        },
        Organizations: {
            readMoreLink: {
                text: "Анықтамалық туралы толығырақ",
            },
            narrow: {
                text: [
                    "Тапсырысты сайт арқылы ресімдегенде оларды құжаттарға салыңыз",
                ]
            },
            button: "Ұйымды қосу",
            header: "Ұйымыңыздың және жиі жұмыс істейтіндердің деректерін қосыңыз",
        },
        Drivers: {
            readMoreLink: {
                text: "Анықтамалық туралы толығырақ",
            },
            button: "Жүргізушіні қосу",
            header: "Жүргізушіні қосу",
        },
        Transport: {
            readMoreLink: {
                text: "Анықтамалық туралы толығырақ",
            },
            header: "Көлікті қосу",
        },
        CompletedItems: {
            wide: {
                header: "Тапсырыс",
                text: [
                    "Жүк жөнелтуші сізге жүкті Алаңда немесе жеке шақыруда ұсынса, Тапсырысты ресімдеу мүмкін болады.",
                    "Сіз мұндай жүкті «Жүкті алу» түймесі арқылы білесіз. Оны басқан соң, жүк сіздікі. Сайттың өзі өтінім шартын жасайды, оған қол қоюыңыз қалады.",
                ],
            },
            button: "Толығырақ білу",
            header: "Мұнда Тапсырыс бойынша өткен жүктер сақталады",
        },
        Completed: {
            wide: {
                header: "Тапсырыс",
                text: [
                    "ATI.SU. сайты арқылы  бірнеше қадам жасап, тасымалдау туралы келісіңіз. Жүк жөнелтуші сізге жүкті Алаңда немесе жеке шақыруда ұсынса, Тапсырысты ресімдеу мүмкін болады.",
                    "Сіз мұндай жүкті «Жүкті алу» түймесі арқылы білесіз. Оны басқан соң, жүк сіздікі. Сайттың өзі өтінім шартын жасайды, оған қол қоюыңыз қалады.",
                ],
            },
            button: "Толығырақ білу",
            header: "Мұнда Тапсырыс бойынша өткен жүктер сақталады",
        },
        Payments: {
            wide: {
                header: "Тапсырыс",
                text: [
                    "ATI.SU. сайты арқылы  бірнеше қадам жасап, тасымалдау туралы келісіңіз. Жүк жөнелтуші сізге жүкті Алаңда немесе жеке шақыруда ұсынса, Тапсырысты ресімдеу мүмкін болады.",
                    "Сіз мұндай жүкті «Жүкті алу» түймесі арқылы білесіз. Оны басқан соң, жүк сіздікі. Сайттың өзі өтінім шартын жасайды, оған қол қоюыңыз қалады.",
                ],
            },
            text: [
                "Тапсырыс бойынша құжаттар мен төлемдер қашан жіберілгенін және алынғанын бақылай аласыз.",
            ],
            button: "Толығырақ білу",
            header: "Мұнда төлем және құжаттар қозғалысы мәртебесі болады",
        },
        InProgressItems: {
            wide: {
                header: "Тапсырыс",
                text: [
                    "ATI.SU сайты арқылы  бірнеше қадам жасап, тасымалдау туралы келісіңіз. Жүк жөнелтуші сізге жүкті Алаңда немесе жеке шақыруда ұсынса, Тапсырысты ресімдеу мүмкін болады.",
                    "Сіз мұндай жүкті «Жүкті алу» түймесі арқылы білесіз. Оны басқан соң, жүк сіздікі. Сайттың өзі өтінім шартын жасайды, оған қол қоюыңыз қалады.",
                ],
            },
            text: [
                "Бұл Тапсырыстар бойынша ресімделген жүктер, олар бойынша өтінімге қол қойылды, ал жүк тасымалда немесе жолда.",
            ],
            button: "Толығырақ білу",
            header: "Мұнда жүктер жұмыс істейді",
        },
        InProgress: {
            wide: {
                header: "Тапсырыс",
                text: [
                    "ATI.SU сайты арқылы  бірнеше қадам жасап, тасымалдау туралы келісіңіз. Жүк жөнелтуші сізге жүкті Алаңда немесе жеке шақыруда ұсынса, Тапсырысты ресімдеу мүмкін болады.",
                    "Сіз мұндай жүкті «Жүкті алу» түймесі арқылы білесіз. Оны басқан соң, жүк сіздікі. Сайттың өзі өтінім шартын жасайды, оған қол қоюыңыз қалады.",
                ],
            },
            text: [
                "Бұл Тапсырыстар бойынша ресімделген жүктер, олар бойынша өтінімге қол қойылды, ал жүк тасымалдауды күтеді немесе жолда.",
            ],
            button: "Толығырақ білу",
            header: "Мұнда жүктер жұмыс істейді",
        },
        ReconciliationItems: {
            wide: {
                header: "Тапсырыс",
                text: [
                    "ATI.SU. сайты арқылы  бірнеше қадам жасап, тасымалдау туралы келісіңіз. Жүк жөнелтуші сізге жүкті Алаңда немесе жеке шақыруда ұсынса, Тапсырысты ресімдеу мүмкін болады.",
                    "Сіз мұндай жүкті «Жүкті алу» түймесі арқылы білесіз. Оны басқан соң, жүк сіздікі. Сайттың өзі өтінім шартын жасайды, оған қол қоюыңыз қалады.",
                ],
            },
            text: [
                "Бұл тасымалдаушылар Тапсырыс бойынша алатын, бірақ әлі келісім-шартқа қол қоймайтын жүктер.",
            ],
            button: "Толығырақ білу",
            header: "Мұнда жүк келісімде болады",
        },
        Reconciliation: {
            wide: {
                header: "Тапсырыс",
                text: [
                    "ATI.SU сайты арқылы  бірнеше қадам жасап, тасымалдау туралы келісіңіз. Жүк жөнелтуші сізге жүкті Алаңда немесе жеке шақыруда ұсынса, Тапсырысты ресімдеу мүмкін болады.",
                    "Сіз мұндай жүкті «Жүкті алу» түймесі арқылы білесіз. Оны басқан соң, жүк сіздікі. Сайттың өзі өтінім шартын жасайды, оған қол қоюыңыз қалады.",
                ],
            },
            text: [
                "Бұл сіз Тапсырыс бойынша алатын жүктер, бірақ өтінім-шартқа әлі қол қоймайсыз.",
            ],
            button: "Толығырақ білу",
            header: "Мұнда жүк келісімде болады",
        },
        archive: {
            narrow: {
                text: [
                    "Бұл жерде қазір сайтта жарияланбайтын жүктер көрсетіледі",
                ],
            },
            button: "Жүкті қосу",
            header: "Жүктер мұрағаты бос",
        },
        published: {
            actions: {
                restore: "мұрағаттан қалпына келтіріңіз",
                add: "Оларды қосыңыз немесе ",
            },
            button: "Жүкті қосу",
            header: "Мұнда сіздердің жүктеріңіз болады",
        },
        noAccessToAddingLoadText: "Жүкті қосуға құқығыңыз жоқ. Құқық алу үшін әкімшіге хабарласыңыз.",
        noFilteredLoads: "Тізімде мұндай жүктер жоқ. Сүзгіні тастап немесе басқа параметрлер бойынша іздеп көріңіз",
        clearFilter: "Сүзгіні қайта орнату",
        trailer: "Тіркеме",
        semitrailer: "Жартылай тіркеме",
        tractor: "Тартқыш",
        truck: "Жүк көлігі",
        add: "Қосу",
        notFound: "Табылмады",
        // "en": {
        //     "js/DEFAULT_EXPORT/Organizations/header": "Ұйымыңыздың және жиі жұмыс істейтіндердің деректерін қосыңыз"
        // },
        pressToCalculate: "Есептеу үшін басыңыз.",
        insureLoadAndGetCashback: "Жүкті сақтандырыңыз және 5% -дан кешбэк алыңыз.",
        insureLoad: "Жүкті сақтандыру",
        LoadFiles: {
            otherDocuments: "құжат",
            oneDocument: "құжат",
            manyDocuments: "құжат",
            fewDocuments: "құжат"
        },
        LargeCities: {
            km: "км",
            bkg: "жақын орналасқан ірі қалалар"
        },
        InviteButton: {
            invite: "Шақыру"
        },
        LimitsPopover: {
            orders: {
                other: "тапсырыс ",
                many: "тапсырыс ",
                few: "тапсырыс ",
                one: "тапсырыс ",
            },
            doNotInvite: "Шақырмау",
            invite: "Шақыру",
            doInviteCarrier: "Егер лимитке қарамастан тапсырыс алғыңыз келсе, тасымалдаушыны шақырыңыз.",
            editInCatalogs: "Анықтамалықта редакциялау",
            max: "макс.",
            youSetLimit: "Сіз жұмыстағы тапсырыстардың бір мезгілде санына лимит белгіледіңіз:",
            title: "Тапсырыс лимитіне қол жеткізілді"
        },
        insuranceConditions: "Сақтандыру шарттары",
        promoText: "Жүкті жоғалтқаны, зақымдағаны немесе бүлінгені үшін кез келген кездейсоқ себеппен өтемақы алу үшін жүкті сақтандырыңыз.",
        InWorkStatusSelect: {
            visibleForOwnerControlledFromTracker: "Мәртебе сізге және тасымалдаушыға көрінеді. Тек жүргізуші ғана мәртебесін өзгерте алады.",
            youAndOwner: "Мәртебе сізге және тапсырыс берушіге көрінеді. Тек жүргізуші ғана мәртебесін өзгерте алады.",
            onlyYou: "Мәртебе тек сіздің фирмаңызға ғана көрінеді. Тек жүргізуші ғана мәртебесін өзгерте алады.",
            ownerInfo: "Мәртебе сізге және тасымалдаушыға көрінеді",
            info: "Мәртебе сізге және тапсырыс берушіге көрінеді",
            noStatus: "Мәртебе жоқ",
            placeholder: "Мәртебені таңдау"
        },
        ImagesUploader: {
            carsPhotos: "КҚ фотосуреттері"
        },
        HistoryPopup: {
            load: "Жүк #",
            emptyHistory: "Бұл жүк бойынша Тапсырыстар, Сауда-саттық (аукциондар) және қарсы ұсыныстар болмаған",
            actionColumnName: "Әрекет",
            timeColumnName: "уақыт",
            dateColumnName: "Күні",
            title: "Сауда-саттық және Тапсырыстар тарихы"
        },
        FileDownloadButton: {
            downloadExcel: "Тарихты Жүктеу (Excel)"
        },
        ChooseDropdown: {
            offer: "Барлық қарсы ұсыныстар",
            deal: "Мәміленің бүкіл тарихы",
            auctionrate: "Сауда-саттық бойынша барлық мөлшерлеме",
            auction: "Сауда-саттықтың бүкіл тарихы",
            all: "Барлық әрекеттер",
            show: "Көрсету"
        },
        GlyphButtonHistory: {
            history: "Тапсырыстар тарихы"
        },
        GeoPositionPromo: {
            promoNotice: 'Тегін AТИ жүргізуші қызметін пайдаланып тапсырыстарыңызды\n нақты уақыт режимінде қадағалаңыз.',
            sensorSharingNotice: 'Тапсырыс беруші тіркелген датчик арқылы жүгі бар көліктің орналасқан\n жерін GPS мониторинг жүйесінің картасында көреді.',
            moreAboutShipperTracker: "Жүргізуші қалай жұмыс істейді",
            trackerShipperNotice: "және тапсырыстың өзекті мәртебесін алу",
            sensorShipperNotice: "GPS-мониторинг жүйесі",
            shipperNotice: "Жүкті картадан көре аласыз",
            shipperHeader: "Тасымалдаушы геопозиция мәліметтерімен бөліседі",
            moreAboutTracker: "АТИ Жүргізуші туралы толығырақ",
            trackerSharingNotice: "Тапсырыс беруші тапсырыс мәртебесі мен жүгі бар машинаны картадан көреді.",
            sharingNotice: "Бұл сенімді арттырып, орындаушы ретінде таңдауыңызға әсер етуі мүмкін.",
            showGeoData: "Тапсырыс берушіге геопозиция деректерін көрсету",
            sectionName: "Жүк тасымалын бақылаңыз"
        },
        FirmReputation: {
            unfairPartnerAbbr: "жс",
            claimAbbr: "к",
            recommendationAbbr: "ұ",
            otherFirms: "фирма",
            manyFirms: "фирма",
            twoFirms: "фирма",
            oneFirm: "фирма",
            unfairPartners: "«Жосықсыз серіктестер» форумында ескертулер: {0} {1} бастап",
            claims: "Шағым:",
            recommendations: "Ұсыным:"
        },
        Firm: {
            claimsAbbr: "ш",
            unfairPartnerAbbr: "жс",
            recommendationAbbr: "ұ",
            otherDocs: "құжат ",
            manyDocs: "құжат ",
            twoDocs: "құжат ",
            oneDoc: "құжат ",
            otherFirms: "фирма",
            manyFirms: "фирма",
            twoFirms: "фирма",
            oneFirm: "фирма",
            unfairPartners: "«Жосықсыз серіктестер» форумындағы ескертулер: {{count}} {{string}}",
            claims: "Шағым:",
            recommendations: "Ұсыным:",
            document: "{{count}} {{string}} берілген",
            code: "Код"
        },
        drop: "Қайта орнату",
        allParametersCompact: "Тағы да",
        allParameters: "Тағы сүзгілер",
        ExtraPoints: {
            unloading: "жүк түсіру",
            otherPoints: "пункт ",
            onePoint: "пункт ",
            manyPoints: "пункт ",
            loading: "жүктеу",
            fewPoints: "пункт ",
            extraPointsAbbr: "қос. {{point}} {{type}}"
        },
        take_lot_access_denied: "Бұл әрекетке рұқсатыңыз жоқ",
        take_load_access_denied: "Бұл әрекетке рұқсатыңыз жоқ",
        access_denied: "Бұл әрекетке рұқсатыңыз жоқ",
        ui_error: "Қате орын алды",
        contact_access_denied_error: "Құқық жеткіліксіз",
        cannot_choose_winner: "Жеңімпазды ауыстыру мүмкін емес",
        invitation_not_found_error: "Қате орын алды",
        load_not_found_error: "Жүкті алу мүмкін емес",
        load_cant_reserve: "Жүкті сақтап қалу мүмкін емес",
        load_cant_take: "Жүкті алу мүмкін емес",
        close: "Жабу",
        access_denied_reason: `<p>Для того, чтобы работать с Заказами, у вас должны быть следующие доступы:</p>
        <ul>
            <li>Работать с площадками</li>
            <li>Брать грузы для оформления Заказов</li>
        </ul>
         <p>Чтобы вы могли одобрить заявку, потребуется доступ:</p>
            <ul>
                <li>Подписывать и одобрять документы в АТИ-Доках</li>
             </ul>
         </p>
         <p>Эти права вам может дать администратор или руководитель аккаунта. Права настраиваются в кабинете, в окне редактирования контакта.</p>`,
        take_load_access_denied_reason: `<p>Для того, чтобы работать с Заказами, у вас должен быть следующий доступ:</p>
        <ul>
            <li>Брать грузы для оформления Заказов</li>
        </ul>
         <p>Это право вам может дать администратор или руководитель аккаунта. Права настраиваются в кабинете, в окне редактирования контакта.</p>`,
        take_lot_access_denied_reason: `<p>Для того, чтобы работать с Заказами, у вас должен быть следующий доступ:</p>
        <ul>
            <li>Брать грузы для оформления Заказов</li>
        </ul>
         <p>Это право вам может дать администратор или руководитель аккаунта. Права настраиваются в кабинете, в окне редактирования контакта.</p>`,
        defaultError: {
            reason: "Бетті қайта қотарып көріңіз."
        },
        EditArea: {
            cancel: "Болдырмау"
        },
        DriverSelect: {
            driver: "Жүргізуші",
            clear: "Тазалау"
        },
        DriverEmployedToAnother: {
            carFromAnother: "Сіз КО-ны [[AppLink]] бағдарламасына байланыстыра алмайсыз, себебі ол фирмаға байланған",
            employedToAnotherFirm: "Сіз [[AppLink]] арқылы бұл жүргізушіге тапсырыс жібере алмайсыз, себебі ол фирма қызметкері",
            atiTrucker: "ATИ Жүргізуші"
        },
        toWhere: "Қайда",
        fromWhere: "Қайдан",
        clear: "Тазалау",
        selectedDepartments: "таңдалған",
        allDepartments: "Барлық бөлімшелер",
        deletedDepartments: "Жойылған бөлімшелер",
        allDocsWithoutCount: {
            allDocsWithoutCount: "Құжаттар мен суреттер",
            allDocs: "Құжаттар және суреттер ({{docsCount}})",
            edited: "Түзетулер",
            notSent: "жіберілмеген",
            document: "Құжат"
        },
        CounterpartySelect: {
            auctionsWinner: "Сауда жеңімпазы",
            firm: "ATИ фирмасы",
            clear: "Тазалау",
            counterparty: "Контрагент"
        },
        willBeShown: "Белсенді байланыс жүктері көрсетіледі.",
        areShownNow: "Қазір белсенді байланыстағы жүктер көрсетіледі.",
        loadsForAllContacts: "Сіздің жүктеріңізге кіру кезінде барлық контактілердің жүктері.",
        dontShow: "Көрсетпеу",
        show: "Көрсету",
        allContacts: "Барлық контактілер",
        City: {
            unloading: "жүк түсіру",
            loading: "жүктеу",
            tooltipCoords: "{{type}} нүктесінің координаталары"
        },
        CargoOwnerHelpPopover: {
            moreAboutOrders: "Тапсырыстар туралы толығырақ",
            carrierHasReservedTheLoad: "Тасымалдаушы жүкті сақтап қалды."
        },
        CancelWinnerPopover: {
            notChooseAsWinner: "Таңдамау",
            goingToChooseNewWinnerText: "Ағымдағы жеңімпазға жүкіңіз бар тапсырыс жіберілді. Оған Сауда-саттық бойынша бас тарту келеді. Тапсырыс жаңа жеңімпазға жіберіледі.",
            goingToChooseNewWinner: "Жаңа жеңімпазды таңдаңыз",
            chooseAsWinner: "Жеңімпаз болып таңдау"
        },
        orderWillBeCancelled: 'Заказ будет перемещён в архив\n' + 'и отмечен как отменённый',
        notCancel: "Бас тартпау",
        confirmCancelOrder: "Тапсырысты болдырмау",
        CancelAuctionActions: {
            noAccessText: "Сіздің Сауда-саттықты болдырмауға құқығыңыз жоқ. Құқық алу үшін әкімшіге хабарласыңыз",
            willFinished: "Сауда-саттық аяқталады.\nҮздік мөлшерлемені ұсынған\nжеңімпаз болып таңдалады",
            willLoseBids: "Сауда-саттық бойынша барлық\nмөлшерлемелер жоғалады",
            cancelFinish: "Аяқтамау",
            cancelCancel: "Бас тартпау",
            cancel: "Болдырмау",
            cancelAuction: "Сауда-саттықты болдырмау",
            finish: "Аяқтау",
            finishAheadOfTime: "Қазір аяқтау"
        },
        BlackListLabel: {
            tooltipText: "Жүргізуші қара тізімде",
            carrier: {
                full: "Тапсырыс берушінің қара тізіміндегі жүргізуші",
                short: " тапсырыс берушінің ҚТ-де"
            },
            cargoOwner: {
                full: "Жүргізуші қара тізімде",
                short: "қара тізімде"
            },
        },
        AuctionTimer: {
            at: "",
            auctionEndDateBoundary: "Егер мөлшерлемелер болмаса, Сауда-саттық аяқталады",
            auction: "Сауда-саттық",
            beforeAuctionStart: "Сауда-саттық басталғанға дейін",
            untilAuctionEnd: "Сауда-саттықтың соңына дейін"
        },
        AttachCar: {
            headerText: {
                semitrailer: "Жартылай тіркеме",
                trailer: "Тіркеме",
                tractorAndTruck: "Жартылай тіркемесі бар тартқыш немесе жүк машинасы",
                truck: "Жүк көлігі",
                tractor: "Тартқыш",
            },
            noResultsText: "табылмады",
            select: "Таңдаңыз...",
            trailer: "тіркеме",
            tractorAndTruck: "жартылай тіркемесі бар тартқыш немесе жүк машинасы",
            semitrailer: "жартылай тіркеме",
            truck: "жүк көлігі",
            tractor: "тартқыш",
            add: "Қосу",
            edit: "Өзгерту",
            cancel: "Болдырмау"
        },
        notToSave: "Сақтамау",
        save: "Сақтау",
        edit: "Өңдеу",
        p2Text: "Өзгертулер жоғалуы мүмкін.",
        p1Text: "Өзгертулерді сақтамадыңыз және терезені жабуға тырысасыз.",
        headerText: "Өзгерістерді не істеу керек?",
        AtiPopup: {
            cancel: "Болдырмау"
        },
        FileUploadWrapper: {
            invalidFile: "Жарамсыз файл таңдалды"
        },
        FileUploadItemInfo: {
            uploadError: "жүктеу мүмкін болмады. Әрекетті қайталап көріңіз",
            uploaded: "жүктелген",
            removeItem: "Жою",
            abortUpload: "Жүктеуді тоқтату"
        },
        AtiFileUploader: {
            uploadRequired: "Файлдарды жүктеңіз",
            upload: "Жүктеу"
        },
        PopupOrganization: {
            removePopover: {
                contactPerson: "Анықтамалықтан контактіні жою керек пе?",
                address: "Анықтамалықтан ұйымның мекенжайын жою керек пе?",
            },
            notLocation: "Біз мұндай елді мекенді тапқан жоқпыз. ",
            documentExample: "Мысалы, IDNO 1234567-123-123",
            documentType: "Құжат түрі және нөмірі",
            bin: "БСН",
            unp: "КБН ",
            edrpou: "УКҰБМТ",
            officeTooltip: "Кеңсе, үй-жай, бокс, пәтер, бөлме және т.б. енгізіңіз.",
            office: "Кеңсе, үй-жай және т.б.",
            building: "Үй, құрылыс, корпус, литера",
            street: "Көше, даңғыл, тұйық көше, бульвар және т.б.",
            locality: "Елді мекен",
            postcode: "Индекс",
            organizationPhone: "Ұйымның телефоны",
            locationAddress: "Құжаттар орналасқан жердің мекенжайы",
            inn: "СТСН",
            residency: "Резиденция",
            fullOrganizationName: "Толық атауы",
            other: "(басқа)",
            available: "Қол жетімді",
            notResultOwnership: "МН табылмады",
            nameFirm: "Фирма атауы",
            editOrganization: "Ұйымды редакциялау",
            addOrganization: "Ұйымды қосу",
            addAddressDescription: "(қойманың, дүкеннің немесе кеңсенің мекенжайы)",
            addAddress: "Қойманы қосу",
            addresses: "Мекенжайлар",
            addContactPerson: "Байланыстағы тұлғаны қосу",
            contactPersons: "Байланыстағы адамдар",
            extraPhone: "Қос. нөмір",
            add: "Қосу",
            save: "Сақтау"
        },
        RevokedBinding: {
            popover: {
                deleteLink: "Байланысты жою",
                header: "Қойманы оның иесі «Уақытша терезелер» қызметінен ажыратты.",
            },
            timeslots: "Уақытша терезелер"
        },
        AcceptedBinding: {
            popover: {
                writeToPartner: "Әріптеске жазу",
                showTimeslots: "Жүктеуді қарау",
                address: "Қойма мекенжайы",
                faq: "Сервис туралы толығырақ ақпарат",
                header: "Қойма «Уақытша терезелер» қызметіне қосылған",
            },
            timeslots: "\"Уақытша терезелер\""
        },
        UnbindTimeslots: {
            breakNotification: "Сіз серіктес қоймасымен байланысыңызды үздіңіз.",
            breakQuestion: "Серіктес қоймасымен байланысты үзу керек пе?",
            dontBreak: "Үзбеу",
            break: "Үзу",
            breakLink: "Байланысты үзу"
        },
        EntityRemovePopup: {
            dontDelete: "Жоймау",
            delete: "Жою"
        },
        Entity: {
            edit: "Өзгерту",
            remove: "Жою"
        },
        DepartmentsSelector: {
            selectedDepartments: "таңдалған бөлімшелерге",
            allDepartments: "барлық бөлімшелерге"
        },
        ContactEntity: {
            extraPhone: "Қос. нөмір"
        },
        AddressEntity: {
            shortCity: "ж."
        },
        AddOrganizationContactPopup: {
            editContactPerson: "Байланыстағы тұлғаны редакциялау",
            addContactPerson: "Байланыстағы адамды қосу",
            fullName: "Аты-жөні",
            extraPhone: "Қос. нөмір",
            phone: "Телефон",
            add: "Қосу",
            "save": "Сақтау"
        },
        AddOrganizationAddressPopup: {
            placeholderAddress: "аудан, көше, үй",
            coordinates: "Координаталар",
            selectOnMap: "Картада таңдау",
            enter: "Енгізуді бастаңыз",
            addressWithoutCity: "Мекенжайы (қаласыз)",
            locality: "Елді мекен",
            withoutContactPerson: "Байланысатын адамсыз",
            nothingFound: "Ештеңе табылмады.",
            selectAddressContactPerson: "Мекенжайдың байланыстағы тұлғасын таңдаңыз",
            placeholderShedule: "Дс-Жм: 9: 00-ден 20: 00-ге дейін, Сн-Жк: Демалыс күндері",
            note: "Ескертпе",
            schedule: "Жұмыс уақыты",
            type: "Түрі",
            editAddress: "{{addressTypeName}} мекенжайын редакциялау",
            addAddress: "{{addressTypeName}} мекенжайын қосу",
            addContactPerson: "Контактілік тұлғаны қосу",
            contactPerson: "Байланысатын адам",
            add: "Қосу",
            save: "Сақтау"
        },
        AddEditCarPopup: {
            cancel: "Болдырмау",
            semitrailer: "жартылай тіркеме",
            save: "Сақтау",
            trailer: "тіркеме",
            tractor: "тартқыш",
            truck: "жүк көлігі",
            edit: "Өңдеу",
            add: "Қосу",
            ts: "КҚ",
            description: {
                own_duplicate_error: "Ол сіздің Автопаркте жарияланған.",
                duplicate_error: "Ол ATI.SU басқа қатысушысының меншікті ретінде көрсетілген. Егер бұл сіздің машинаңыз болса, «Тартылған КҚ» белгісін уақытша қойыңыз, КҚТ сканын немесе пластикті тіркеңіз және техникалық қолдауға хабарласыңыз: Тикет жасаңыз немесе 8 812 602-01-09  (қосымша 160) қоңырау шалыңыз.  Біз бәрін түзетеміз."
            },
            header: {
                duplicate_error: "Машинаны өзіңіздікі ретінде белгілей алмайсыз.",
                own_duplicate_error: "Көлік құралын қосуға болмайды."
            }
        },
        CarPopupForm: {
            truck: "Жүк көлігі",
            tractorWithSemitrailer: "Жартылай тіркемесі бар тартқыш"
        },
        GeneralCarFormWrapper: {
            semitrailer: "жартылай тіркеме",
            trailer: "тіркеме",
            tractor: "тартқыш",
            truck: "жүк көлігі",
            edit: "Редакциялау",
            add: "Қосу"
        },
        GeneralCarForm: {
            semitrailer: "Жартылай тіркеме",
            trailer: "Тіркеме",
            truck: "Жүк көлігі",
            tractor: "Тартқыш",
            rentContactHintText: "Сурет немесе скан",
            marriageHintText: "Куәлік суреті немесе сканы",
            documentHintText: "құжаттардың 2 жағынтан фотосуреттер немесе  скандар  немесе электрондық КҚТ",
            contractHintText: "Егер КҚ меншігінде болмаса",
            ownershipType: "КҚ иелік ету түрі",
            required: "(міндетті)",
            uploadGratuitousContractScan: "Өтеусіз пайдалану шартын жүктеу",
            uploadMarriageScan: "Некені тіркеу туралы куәлікті жүктеу",
            uploadPhotos: "КҚ фотосуреттерін жүктеу",
            uploadLeasingContractScan: "Лизинг шартын жүктеу",
            uploadRentContractScan: "Жалдау шартын жүктеу",
            uploadPTSScanOrPlastic: "КҚК мен КҚТ жүктеу",
            attractedCar: "Тартылған КҚ",
            documentsHeader: "КҚ құжаттары"
        },
        TractorAdditionallyParams: {
            header: "Қосымша",
            canCarryHeavyContainer: "ауыр контейнерлерді тасымалдауға болады",
            hasGenset: "Genset бар (аспалы генератор)",
            canRefrigerator: "реф-контейнерлерді тасымалдауға болады",
            externalId: 'Сәйкестендіргіш'
        },
        ShowInFirmInfo: {
            tooltipDisabled: "Карточкада көрсету үшін КҚ тартылмауы тиіс",
            tooltip: "Жүк иелері үшін фирманың беделі ғана емес, тасымалдаушының жеке көлік паркінің болуы да маңызды",
            text: "ATI.SU қатысушысының төлқұжатында көрсету"
        },
        ReserveByDriverBlock: {
            noAvailableDrivers: "Қол жетімді жүргізушілер жоқ",
            cancel: "Болдырмау",
            select: "Таңдаңыз...",
            addDriver: "Жүргізушіні қосу",
            reserve: "Жүргізушіге бекіту",
            reserveByDriver: "Жүргізушіні қосу және бекіту"
        },
        CarSensors: {
            delete: "Жою",
            update: "Өзгерту",
            addSensor: "Өлшеуішті қосу",
            helperText: "GPS/ГЛОНАСС датчигі",
            geoposition: "КО геопозициясы"
        },
        CarOwnershipType: {
            gratuitousUse: "өтеусіз пайдалану",
            spousesJoint: "ерлі-зайыптылардың бірлескен меншігі",
            leasing: "лизинг",
            rental: "жалға беру",
            hired: "тартылған КҚ",
            owned: "меншік",
            ownerName: "КҚ тіркеу туралы куәлік бойынша иесі",
            ownershipType: "Иелік ету түрі"
        },
        CarInfo: {
            pts: "КҚТ сериясы мен нөмірі",
            vin: "VIN",
            vrcFull: "КҚК сериясы мен нөмірі",
            manufactureYear: "Шығарылған жылы",
            number: "Мемномер",
            noBrandText: "Мұндай маркасы жоқ. Басқасын енгізіңіз.",
            vrc: "КҚК",
            hasBodyNumber: "VIN жоқ",
            hasVin: "VIN бар",
            bodyNumber: "Шанақ",
            model: "Үлгі",
            mark: "Марка",
            clear: "Тазалау",
            cancel: "Болдырмау",
            exampleHint: {
                bodyNumber: "Шанақ/шасси нөмірінің мысалы",
                electronicPts: "Электрондық КҚТ нөмірінің үлгісі",
                pts: "КҚТ нөмірінің мысалы",
                vin: "VIN мысалы",
                vrc: "КҚК нөмірінің мысалы",
            },
            description: {
                bodyNumber: "Көлік құралының төлқұжатында, көлік құралын тіркеу туралы куәлікте, техникалық байқаудың кепілдік талонында/талонында немесе автомобильдің сақтандыру полисінде. \n\nШанақтың немесе шассидің ажырамас бөліктерінде және арнайы дайындалған нөмірлік тақтайшаларда (шильдиктерде).",
                pts: "Көлік құралының төлқұжаты (КҚТ) - бұл автомобильдің техникалық сипаттамалары туралы ақпаратты, \n\nкөлік құралының иелері және есепке алу/есептен шығару туралы мәліметтерді қамтитын автомобильге арналған негізгі құжаттардың бірі.",
                vin: "Көлік құралыныңтөлқұжатында, көлік құралын тіркеу туралы куәлікте, техникалық байқаудың кепілдік талонында/талонында немесе автомобильдің сақтандыру полисінде. Шанақтың немесе шассидің ажырамас бөліктерінде және арнайы дайындалған нөмірлік тақтайшаларда (шильдиктерде).",
                vrc: "Көлік құралын тіркеу туралы куәлік (КҚК) - бұл көлік құралының негізгі құжаттарының бірі. КҚК көлік құралы (автомобиль, мотоцикл, тіркеме және т.б.) есепке қойылғаннан кейін РФ ІІМ ЖҚКМИ тіркеу бөлімшелерінде береді. Құжат «Госзнак» фабрикасында басылып, ламинацияланған, қорғау дәрежесі бар.",
            },
            header: {
                bodyNumber: "Шанақ/шасси нөмірін қалай білуге болады",
                pts: "КҚ төлқұжатының түрі қандай",
                vin: "VIN қалай білуге болады  ",
                vrc: "КҚ тіркеу туралы куәліктің түрі қандай"
            },
        },
        CarDimensions: {
            fillDimensions: "Дұрыс көлемді көрсетіңіз",
            height: "Биіктігі, м",
            width: "Ені, м",
            length: "Ұзындығы, м",
            internalDimensions: "Ішкі габариттер"
        },
        CarBodySize: {
            capacity: "Жүк көтергіштігі, т",
            meter: "м",
            volume: "Көлемі"
        },
        CarBody: {
            containerSizes: [
                "20' жалғыз",
                "20' платформа",
                "20' жалғыз + тіркеме",
                "40' едені бар платформа",
                "40' еденсіз платформа",
                "45' едені бар платформа",
                "45' еденсіз платформа",
                "20' танкіге арналған платформа",
                "40' танкіге арналған платформа",
                "40' ажыратылмалы платформа"
            ],
            dimension: "Контейнердің өлшемі",
            select: "Шанақ түрі",
            body: "КҚ сипаттамалары"
        },
        CanCarryTallContainers: {
            canCarryTallContainer: "Жоғары контейнерлерді тасымалдауға болады"
        }
    },
    "uz": {
        of: (count: number, total: number) => <>{count} dan {total}</>,
        phoneWrong: "Raqamni +7 (999) 999 99 99 formatida kiriting",
        extraDigits: "Raqamni tekshiring - unda qo'shimcha raqamlar mavjud",
        missingDigits: "Raqamni tekshiring - unda raqamlar etarli emas",
        emailWrong: "Bu elektron pochta emas. Unda xatolar mavjudligini tekshiring",
        lessThanMinDate: "Sana kamida {{minDate}} boʻlishi kerak",
        notValidDepartmentCode: "Bo'linma kodi 000-000 formatida bo'lishi kerak",
        onlyNumbers: "Faqat raqamlarni kiritish mumkin",
        choosePackageType: "Qadoqlash turini tanlash kerak",
        notValidTrackNumber: "Trek raqami faqat raqamlar, lotin harflari va belgilarni o'z ichiga olishi kerak. va -",
        notValidUrl: "Noto‘g‘ri URL manzili",
        emptyCoordinates: "Ro'yxatdan manzilni tanlang yoki xaritada ko'rsating",
        invalidDateString: "Noto'g'ri sana",
        invalidTimeString: "Noto'g'ri vaqt",
        wrongRangeEnd: "Noto'g'ri diapazon",
        wrongCheckSum: "Noto'g'ri nazorat summasi",
        symbols: {
            many: "belgilar",
            few: "belgi",
            one: "belgi",
        },
        numbers: {
            many: "raqamlar",
            few: "raqamlar",
            one: "raqam",
        },
        numberFromTo: "{{from}} va {{to}} orasidagi raqamni kiriting",
        symbolsRange: "{{from}} dan {{to}} gacha belgilar kiriting",
        enterPositiveNumber: "Ijobiy raqam kiriting",
        numberLessThen: "Qiymat oshmasligi kerak",
        korrSchetParams: "20 ta raqam - 301 dan boshlab va BICning oxirgi 3 raqami bilan tugaydi",
        OKPOLength: "8 yoki 10 ta raqam",
        OKPOCheckNumber: "Tekshirish raqami noto'g'ri",
        twentySymbolsNoSpaces: "Bo'sh joysiz 20 ta raqam",
        enterValue: "Bu maydon boʻsh boʻlmasligi kerak",
        selectValue: "Qiymatni tanlang",
        requiredDigits: "{{number}}ta raqam kiritishingiz kerak",
        fifteenDigits: "15ta raqam",
        thirteenDigits: "13ta raqam",
        datesNotInThePast: "Oʻtgan sanalarni tanlab boʻlmadi",
        dateInTheFuture: "Oʻtgan sanani tanlab boʻlmadi",
        dateInThePast: "Kelajakda sanani tanlab bo‘lmaydi",
        isInvalidDate: "Qabul qilinmaydigan sana",
        invalidDateFormat: "Sanani KK.OO.YYYY formatida kiriting",
        wrongPhoneNumber: "Noto‘g‘ri telefon raqami ",
        region: "Viloyatni kiriting",
        carNumber: "Raqamni kiriting",
        lengthMessage: "belgilar",
        maxLengthMessage: "Maks. {{max}} ta belgi",
        upToEightSymbols: "8 ta belgigacha",
        sixSevenSymbols: "6-7 belgilar",
        sixDigits: "Oltita raqam",
        fourDigits: "To'rtta raqam",
        notAfterCurrent: "Yil {{currentYear}} dan katta boʻlmasligi kerak",
        notBeforeMinYear: "Yil {{minYear}} dan kam boʻlmasligi kerak",
        registrationNumber: "Ro'yxatga olish raqami",
        egrpou: "UKTYDR",
        unp: "THR",
        inn: "STIR",
        bin: "BIN",
        iin: "ShIR",
        // strings: {
        //     rateNds: "QQS bilan",
        //     rateWithoutNds: "QQSsiz",
        //     direct: "to'g'ridan-to'g'ri shartnoma",
        //     torg: "savdo qilish mumkin",
        //     payDays: "{0} b/kdan keyin",
        //     inFuel: "yoqilg'i",
        //     prepayAlone: "oldindan to'lov",
        //     prepay: "oldindan to'lov {0}%",
        //     onLoad: "yuk tushirishda",
        //     onlyToSepCar: "alohida mashina",
        //     dogruzPossible: "qo'shimcha yuklash mumkin",
        //     dogruz: "qo'shimcha yuklash",
        //     sborgruz: "Yig‘ma yuklar"
        // },
        duplicate_contractor_error: "Kontragentni qo‘shib bo‘lmaydi. U allaqachon sizning ma'lumotnomangizga qo'shilgan. ",
        unknown_error: "Noma’lum xatolik",
        json_validation_error: "json tasdiqlash xatosi",
        partial_execution_error: "Aloqa yaratishda xatolik yuz berdi, transport vositalari saqlandi",
        failed_save_trucks: "Ba'zi transport vositalarini saqlab bo'lmadi",
        failed_save_truck: "Transport vositasini saqlab bo'lmadi",
        customColumns: {
            historyBtn: "Yuk tarixi",
            copyBtn: "Nusxalash",
            addCommentBtn: "Izoh yozib qoldiring",
            map: "Xarita",
            orderStatus: "Holati",
            completion: "Tugatish",
            date: "Sana",
            carrierContactPhone: "Yuk tashuvchining kontakt raqami",
            carrierContact: "Yuk tashuvchining kontakti ",
            carrier: "Yuk tashuvchi",
            cashRate: "Naqd pul stavkasi",
            rateWithoutVAT: "QQSsiz stavka",
            rateWithVAT: "QQS bilan stavka",
            offers: "Taklif",
            contact: "Kontakt",
            contactWithDate: "Kontakt, qo'shilgan/o'zgartirilgan.",
            driver: "Haydovchi",
            car: "TV",
            separateCar: "Alohida mashina",
            loadingUnloadingCar: "Yuklash/tushirish TV",
            bodyType: "Kuzov turi",
            loadParams: "Yuk parametrlari",
            unloading: "Yuk tushirish",
            loading: "Yuklash",
            routeAddress: "Marshrut manzili",
            route: "Marshrut ",
            loadNumber: "Yuk raqami"
        },
        byDefault: "Sukut bo'yicha",
        columns: "Ustunlar",
        informer: "Endi siz ma'lumotlarni ixcham kartalarda\nko'rsatishni sozlashingiz mumkin",
        verify: "Tekshirish",
        toTime: "...gacha...",
        fromTime: "...dan...",
        dateInputPlaceHolder: "sanani tanlang",
        timeInputPlaceholder: '09:00',
        rate: "Stavka",
        unloading: "Yuk tushirish",
        loading: "Yuklash",
        loadParams: {
            __html: "Og'irligi, t/hajmi, m<sup>3</sup>, yuk"
        },
        transport: "Transport",
        direction: "Yo'nalish",
        roundTheClock: "tunu kun ",
        workdays: "ish kunlarida",
        everyday: "har kuni",
        loadReady: "tayyor",
        alwaysReady: "doimiy ravishda",
        ExpandingSection: {
            showFullInfo: "To'liq ko'rsatish"
        },
        "as-ui-kit/src/controls/DocumentBlock/strings": {
            "js/ru/previousVersion": "oldingi nashr",
            "js/ru/forContragent": "Kontragent tomonidan o'zgartirildi. Tasdiqlangunga qadar amal qiladi",
            "js/ru/forChanger": "Kontragent o'zgarishlarni tasdiqlamaguncha amal qiladi.",
            "js/ru/transportationOrder": "Yuk tashish uchun ariza",
            "js/ru/sentToCounterparty": "Kontragentga yuborilgan",
            "js/ru/sentThroughAtiDocs": "ATI Hujjatlar orqali yuborilgan",
            "js/ru/documentApprovedByTrucker": "Hujjat yuk tashuvchi tomonidan tasdiqlangan",
            "js/ru/documentApprovedByYou": "Hujjat siz tomonidan tasdiqlangan",
            "js/ru/documentSignedByTrucker": "Hujjat yuk tashuvchi tomonidan imzolangan",
            "js/ru/documentSignedByYou": "Hujjat siz tomonidan imzolangan",
            "js/ru/documentCreated": "Hujjat shakllantirildi",
            "js/ru/awaitsReview": "Ko'rib chiqishni kutmoqda"
        },
        DealUpdateTime: {
            at: "da..."
        },
        ConsultantsInfo: {
            workHours: "Moskva vaqti bilan 9 dan 18 gacha",
            autoparkConsultants: "Biz sizga avtoparkingizni to'ldirishda yordam beramiz",
            dealsConsultants: "Buyurtmalar bo'yicha savollarga javob beramiz"
        },
        CancelButton: {
            moveToArchive: "Arxivga"
        },
        "as-ui-kit/src/controls/AtiSelect/AtiSelect": {
            "jsx/strings/clearValue": "Tozalash"
        },
        AtiCarNumberInput: {
            otherCountries: "Boshqa davlatlar",
            russia: "Rossiya"
        },
        "as-ui-kit/src/controls/AtiCarNumberInput/AtiCarNumberInput": {
            "jsx/carPlaceholder": "М 123 ММ 78\t"
        },
        "as-ui-kit/src/controls/AddressCoordinatesInput/strings": {
            "js/ru/pickOnMap": "Xaritada tanlash",
            "js/ru/clearAddress": "Tozalash",
            "js/ru/addressNotFound": "Manzil topilmadi, urinib ko'ring",
            "js/ru/pointOnMap": "Xaritada ko'rsatish",
            "en": {
                "js/DEFAULT_EXPORT/pickOnMap": "Xaritada tanlash"
            }
        },
        "as-ui-kit/src/const/unilateralOrder": {
            "js/paymentTypesOptions/paymentTypes": {
                "cash/name": "Naqd pul",
                "cashlessWithNds/name": "QQS bilan, naqd pulsiz",
                "cashlessWithoutNds/name": "QQSsiz, naqd pulsiz"
            }
        },
        weekDaysLowerShortList: [
            "yaksh",
            "dush",
            "sesh",
            "chor",
            "paysh",
            "jum",
            "sh",
        ],
        weekDaysShortList: [
            "Yaksh",
            "Dush",
            "Sesh",
            "Chor",
            "Paysh",
            "Jum",
            "Sh",
        ],
        timeStrings: {
            months: [
                "yanvar",
                "fevral",
                "mart",
                "aprel",
                "may",
                "iyun",
                "iyul",
                "avgust",
                "sentyabr",
                "oktyabr",
                "noyabr",
                "dekabr",
            ],
            shortMonths: [
                "yanv",
                "fev",
                "mar",
                "apr",
                "may",
                "iyun",
                "iyul",
                "avg",
                "sen",
                "okt",
                "noya",
                "dek",
            ],
            year: "y.",
            h: "s",
            d: "k",
            min: "daq",
            sec: "son",
            tomorrow: "ertaga",
            yesterday: "kecha",
            today: "bugun",
            at: "da...",
        },
        MonthList: [
            "Yanvar",
            "Fevral",
            "Mart",
            "Aprel",
            "May",
            "Iyun",
            "Iyul",
            "Avgust",
            "Sentyabr",
            "Oktyabr",
            "Noyabr",
            "Dekabr",
        ],
        "as-ui-kit/src/const/sensors": {
            "js/errors/ru/errorCodes": {
                "AuthLimitError": "Kirish rad etildi. Keyinroq qayta urinib ko‘ring",
                "BLError": "Xato yuz berdi.Keyinroq qayta urinib ko‘ring"
            },
            "js/providers/scout/name": "Skaut",
            "js/providers/wialon/name": "Vialon"
        },
        "as-ui-kit/src/const/scans": {
            "js/scanTypeNames/ru/scanTypes": {
                "marriage": "Nikoh to'g'risida guvohnoma",
                "rentContract": "Ijara shartnomasi",
                "carPhoto": "Rasm",
                "plasticTechPassport": "(TVRoG) Transport vositalarini ro'yxatga olish guvohnomasi ",
                "techPassport": "(AVTP)Avtomototransport vositasining texnik pasport",
                "passport": "Pasport",
                "driverLicense": "(HG) Haydovchilik guvohnomasi"
            }
        },
        "as-ui-kit/src/const/requisites": {
            "js/defaultAddress/officeType": "of.",
            "js/defaultAddress/partType": "korp.",
            "js/defaultAddress/houseType": "uy",
            "js/dictionaries/officeTypes/2/label": "xona",
            "js/dictionaries/officeTypes/2/value": "xona",
            "js/dictionaries/officeTypes/1/label": "xonadon",
            "js/dictionaries/officeTypes/1/value": "xona.",
            "js/dictionaries/officeTypes/0/label": "ofis",
            "js/dictionaries/officeTypes/0/value": "of.",
            "js/dictionaries/partTypes/1/label": "bino",
            "js/dictionaries/partTypes/1/value": "bino",
            "js/dictionaries/partTypes/0/label": "korpus",
            "js/dictionaries/partTypes/0/value": "korp.",
            "js/dictionaries/houseTypes/1/label": "bino",
            "js/dictionaries/houseTypes/1/value": "bino",
            "js/dictionaries/houseTypes/0/label": "uy",
            "js/dictionaries/houseTypes/0/value": "uy",
            "js/dictionaries/streetTypes/13/label": "(a/q) abonent qutisi",
            "js/dictionaries/streetTypes/12/label": "chiziq",
            "js/dictionaries/streetTypes/11/label": "trakt",
            "js/dictionaries/streetTypes/10/label": "kanal",
            "js/dictionaries/streetTypes/9/label": "tor koʻcha",
            "js/dictionaries/streetTypes/8/label": "bulvar",
            "js/dictionaries/streetTypes/7/label": "alleya",
            "js/dictionaries/streetTypes/6/label": "maydon",
            "js/dictionaries/streetTypes/5/label": "sohilbo‘yi",
            "js/dictionaries/streetTypes/4/label": "tor ko'cha",
            "js/dictionaries/streetTypes/3/label": " shosse",
            "js/dictionaries/streetTypes/2/label": "shoh ko‘cha",
            "js/dictionaries/streetTypes/1/label": "ko‘cha",
            "js/dictionaries/streetTypes/0/label": "(boshqa)",
            "js/dictionaries/residences/ru/4/label": "Boshqa",
            "js/dictionaries/residences/ru/3/label": "Qozog'iston",
            "js/dictionaries/residences/ru/2/label": "Belarus",
            "js/dictionaries/residences/ru/1/label": "Ukraina",
            "js/dictionaries/residences/ru/0/label": "Rossiya"
        },
        "as-ui-kit/src/const/payDocs": {
            "js/mappedTransportCompanyNames/ru/1": "boshqa",
            "js/payDocsLabels/ru/ClosingDocuments": "Yakuniy ",
            "js/payDocsLabels/ru/Payment": "To'langan",
            "js/payDocsLabels/ru/DocumentsOriginalTrack": "Trek raqami",
            "js/payDocsLabels/ru/DocumentsOriginal": "Asl nusxalari",
            "js/payDocsLabels/ru/DocumentsCopies": "Nusxalari",
            "js/payDocsName/ru/carrier/ClosingDocuments/name": "Yakuniy hujjatlar qabul qilindi",
            "js/payDocsName/ru/carrier/Payment/name": "To'lov qabul qilindi",
            "js/payDocsName/ru/carrier/DocumentsOriginal/name": "Asl nusxalar yuborildi",
            "js/payDocsName/ru/carrier/DocumentsCopies/name": "Hujjatlar nusxalari yuborildi",
            "js/payDocsName/ru/cargoOwner/Payment/name": "To'langan",
            "js/payDocsName/ru/cargoOwner/DocumentsOriginal/name": "Asl nusxalar qabul qilindi",
            "js/payDocsName/ru/cargoOwner/DocumentsCopies/name": "Hujjatlarning nusxalari qabul qilindi"
        },
        "as-ui-kit/src/const/index": {
            "js/undefinedError": "Noma'lum xato"
        },
        "as-ui-kit/src/const/files": {
            "js/fileSourceTypeNames/ru/dealFileSourceFileTypes": {
                "freeUse": "Bepul foydalanish shartnomasi",
                "truckPhoto": "Rasm",
                "truckPlasticTechPassport": "Plastik",
                "truckTechPassport": "(AVTP)Avtomototransport vositasining texnik pasport",
                "driverPassport": "Pasport",
                "driverLicense": "HG"
            },
            "js/fileSourceNames/ru/dealFileSourceTypes": {
                "tractor": "tyagach",
                "semiTrailer": "yarim tirkama",
                "trailer": "tirkama",
                "truck": "Yuk mashinasi",
                "driver": "haydovchi"
            }
        },
        documentTypes: {
            poa: "ishonchnoma",
            uniliteralDissolution: "ijroni rad etish to'g'risidagi xabarnoma",
            invoice: "hisob",
            act: "dalolatnoma",
            commission: "ekspeditorga topshiriq",
            tableRequest: "shartnomaga ariza (jadval shaklida)",
            request: "ariza (shartnomaga)",
            order: "buyurtma",
            tableOrder: "buyurtma (jadval ko'rinishida)",
            contract: "buyurtma (buyurtma shartnomasi)"
        },
        displayedDocumentTypes: {
            commission: "Ekspeditorga topshiriq",
            request: "Hujjat shaklida ariza",
            tableRequest: "jadval shaklida ariza",
            order: "Hujjat shaklida buyurtma",
            tableOrder: "Jadval shaklida buyurtma",
        },
        docTypesGroups: [
            "Kontragent bilan birinchi marta ishlayapsiz",
            "Shartnoma bor",
            "Transport ekspeditsiyasi shartnomasi bo'yicha ishlash",
        ],
        additionalDocuments: {
            cancelDeal: "Ijrodan voz kechish to'g'risida xabarnoma",
            poa: "Ishonchnoma",
            invoice: "Ariza bo'yicha hisob-faktura",
            act: "Dalolatnoma (ikki tomonlama)",
        },
        cancelDocuments: {
            refusalOfFulfilment: "Ijrodan voz kechish to'g'risida xabarnoma",
        },
        "as-ui-kit/src/const/documents": {
            "js/docTypeTemplates/contract": "shartnoma",
        },
        auctionPaymentTypes: {
            25: "QQSsiz",
            24: "QQS bilan",
            23: "kartaga",
            1: "naqd pul",
            0: "har qanday"
        },
        ton: "t",
        weight: "Og'irligi",
        to: "gacha",
        from: "dan",
        meter: "m",
        volume: "Hajmi",
        TruckIcon: {
            carInGratuitousUseVerifiedTooltip: "Bepul foydalanish uchun tasdiqlangan transport vositasi",
            carInGratuitousUseTooltip: "TV bepul foydalanishda ",
            carInSousesJointOwnershipVerifiedTooltip: "Tasdiqlangan TV turmush o'rtoqlarning birgalikdagi mulki",
            carInSousesJointOwnershipTooltip: "TV turmush o'rtoqlarning birgalikdagi mulki",
            carExternalTooltip: "Jalb qilingan TV",
            carOwnVerifiedTooltip: "Tasdiqlangan o'z  TV",
            carOwnTooltip: "O'z TV",
            carInLeasingVerifiedTooltip: "Tasdiqlangan TV lizingda ",
            carInLeasingTooltip: "TV lizingda ",
            carInRentVerifiedTooltip: "Tasdiqlangan TV ijarada",
            carInRentTooltip: "TV ijarada"
        },
        TrackerStatus: {
            promoAction: "Bu qanday ishlaydi",
            promoHeader: "Endi yukni haydovchi ilovasi orqali xaritada kuzatish mumkin"
        },
        LastActive: {
            exclusivePopoverLinkText: "eksklyuziv kirish imkoniyati.",
            ago: "orqaga",
            activity: "faoliyat",
            exclusiveAccess: "Eksklyuziv kirish imkoniyati boshqa firmada",
            installed: "o'rnatilgan",
            hasTracker: "ATI Haydovchi"
        },
        Invite: {
            car: {
                cantInviteTooltip: 'Приглашение можно выслать только на мобильный номер телефона. У водителя указан не мобильный. Телефон можно изменить в вашем Справочнике Водителей',
                tooManyRequests: "Taklifnoma yuborishga urinishlar juda ko‘p. Keyinroq urinib ko'ring",
                toApp: "o'rnatish",
                invited: "Taklifnoma yuborildi",
                invite: "Taklifnoma yuborish",
                undefinedError: "Noma'lum xato",
                cantInvite: "Ushbu buyurtmadan haydovchini ... taklif qilib bo'lmaydi",
                alreadyInvited: "Siz allaqachon ushbu haydovchiga taklifnoma yuborgansiz. Keyinroq urinib ko'ring",
                resend: "Qayta taklif qiling",
                atiTrucker: "ATI Haydovchi"
            },
            driver: {
                                cantInviteTooltip: 'Приглашение можно выслать только на мобильный номер телефона. У водителя указан не мобильный. Телефон можно изменить в вашем Справочнике Водителей',

                tooManyRequests: "Haydovchini taklif qilish uchun juda ko'p urinishlar. Keyinroq harakat qilib ko'ring",
                toApp: "o'rnatish",
                invited: "Haydovchi taklif qilindi",
                sent: "yuborilgan",
                invite: "Taklifnoma",
                inviteDriver: "Haydovchini taklif qilish",
                undefinedError: "Noma'lum xato",
                cantInvite: "Ushbu buyurtmadan haydovchini ... taklif qilib bo'lmaydi",
                alreadyInvited: "Siz allaqachon ushbu haydovchiga taklifnoma yuborgansiz. Keyinroq urinib ko'ring",
                resend: "Qayta taklif qiling",
                atiTrucker: "ATI Haydovchi"
            }
        },
        InvitePopover: {
            car: {
                exclusiveDescription:
                    'Только вы сможете отправлять\n' +
                    'заказы водителю, получать\n' +
                    'актуальные статусы перевозки,\n' +
                    'отслеживать местоположение\n' +
                    'груза на карте.',
                smsIsSent: "Telefon raqamiga SMS yuborildi",
                caption: "Ilovani yuklab olish havolasi bilan telefon raqamiga SMS yuboriladi",
                invite: "Taklifnoma yuborish",
                exclusiveAccess: "Uning ATI Haydovchisiga eksklyuziv kirish",
                onlyAndroid: "Ilova faqat Androidda ishlaydi",
                sendSms: "SMS yuborish",
                atiDriver: "ATI Haydovchi"
            },
            driver: {
                exclusiveDescription:
                    'Только вы сможете отправлять\n' +
                    'заказы водителю, получать\n' +
                    'актуальные статусы перевозки,\n' +
                    'отслеживать местоположение\n' +
                    'груза на карте.',
                smsIsSent: "Haydovchiga SMS yuborildi",
                caption: "Haydovchiga ilovani yuklab olish uchun havola bilan SMS yuboriladi.",
                invite: "Haydovchini taklif qilish",
                exclusiveAccess: "Uning ATI Haydovchisiga eksklyuziv kirish",
                onlyAndroid: "Ilova faqat Androidda ishlaydi",
                sendSms: "SMS yuborish",
                atiDriver: "ATI Haydovchi"
            }
        },
        "as-ui-kit/src/components/TrackerLink/strings": {
            "js/ru/atiTrucker": "ATI Haydovchi"
        },
        "as-ui-kit/src/components/TrackerIcon/strings": {
            "js/ru/howToUseTracker": "ATI Haydovchi- qanday yuklab olish va undan foydalanish"
        },
        "as-ui-kit/src/components/TrackerAppInfoPopover/strings": {
            "js/ru/trackerFeatures": "Ati Haydovchining imkoniyatlari",
            "js/ru/atiTracker": "ATI Haydovchi"
        },
        "as-ui-kit/src/components/Tabs/Tab/TabCounter/strings": {
            "js/ru/of": "...dan..."
        },
        "as-ui-kit/src/components/Signee/Signee": {
            "jsx/strings/useByDefault": "Standart sifatida foydalaning",
            "jsx/strings/signee": "Imzolovchi",
            "jsx/strings/remove": "o'chirish",
            "jsx/strings/positionInGenitive": "Lavozim qaratqich kelishigida",
            "jsx/strings/fullNameInGenitive": "FIO ",
            "jsx/strings/actUponWhatText": "U nima asosida harakat qiladi. Masalan: \"Nizom..., Ishonchnoma raqami...\""
        },
        ShortFirmInfo: {
            recommend: "Tavsiya qilish"
        },
        "as-ui-kit/src/components/SensorActivateLink/strings": {
            "js/ru/reauthorizationRequired": "Qayta avtorizatsiya talab qilinadi",
            "js/ru/inactive": "Faol emas"
        },
        "as-ui-kit/src/components/SearchLoad/strings": {
            "js/ru/unloading": "Tushirish",
            "js/ru/loading": "Yuklash",
            "js/ru/loadParams/__html": "Og'irligi, t / hajmi, m < sup>3 < / sup>, yuk",
            "js/ru/transport": "Transport",
            "js/ru/direction": "Yo'nalish"
        },
        "as-ui-kit/src/components/SearchLoad/SearchLoadParams/strings": {
            "js/ru/widthShort": "Kengligi",
            "js/ru/sborgruz": " yigʻma yuk",
            "js/ru/onlyToSepCar": "alohida mashina",
            "js/ru/meters": "m",
            "js/ru/load": "Yuk",
            "js/ru/lengthShort": "U",
            "js/ru/items": "dona",
            "js/ru/heightShort": "B",
            "js/ru/dogruzPossible": "qo'shimcha yuklash mumkin",
            "js/ru/dogruz": "qo'shimcha yuklash "
        },
        "as-ui-kit/src/components/SearchLoad/LoadUnloading/RouteThrough/strings": {
            "js/ru/through": "orqali haydash"
        },
        "as-ui-kit/src/components/SearchLoad/LoadUnloading/CustomsOnRoute/strings": {
            "js/ru/custom": "bojxona:"
        },
        "as-ui-kit/src/components/SearchLoad/LoadTransport/strings": {
            "js/ru/capacity": "y/k {{number}} t,",
            "js/ru/onlyToSepCar": "alohida mashina",
            "js/ru/dogruzPossible": "qo'shim. yuklash mum.",
            "js/ru/dogruz": "qo'shimcha yuklash ",
            "js/ru/beltOther": "kamarlar",
            "js/ru/beltMany": "kamarlar",
            "js/ru/beltFew": "kamar",
            "js/ru/beltOne": "kamar",
            "js/ru/sanPassport": "tibbiy kitob",
            "js/ru/loadUnload": "yuklash/tushirish",
            "js/ru/unload": "tushirish",
            "js/ru/load": "yuklash",
            "js/ru/pnevmohod": "pnevmatik",
            "js/ru/stsepka": "ulagich",
            "js/ru/koniki": "konikalar",
            "js/ru/cars": "mashina"
        },
        "as-ui-kit/src/components/SearchLoad/LoadRate/strings": {
            "js/ru/allTermsInATIDocs": "Barcha shartlar ATI Hujjatlardagi arizada ",
            "js/ru/cashlessAll": "QQS bilan naqd pulsiz, QQSsiz",
            "js/ru/cashlessWithoutVat": "QQSsiz naqd pulsiz",
            "js/ru/cashlessWithVat": "QQS bilan naqd pulsiz",
            "js/ru/cash": "Naqd pul",
            "js/ru/bargainOff": "savdosiz",
            "js/ru/undefined": "QQS bilan ",
            "js/ru/direct": "to'g'ridan-to'g'ri shartnoma",
            "js/ru/bargainOn": "savdo qilish ",
            "js/ru/payDays": " {0}  bank kunida",
            "js/ru/prepayAlone": "oldindan to'lov",
            "js/ru/inFuel": "yoqilg'i bilan",
            "js/ru/prepay": " {0}% oldindan to'lov",
            "js/ru/onLoad": "tushirishda",
            "js/ru/inquireLoad": "stavka so'rovi",
            "js/ru/noLoad": "yuk yo'q,stavka so'rovi"
        },
        "as-ui-kit/src/components/SearchLoad/LoadDirection/strings": {
            "js/ru/km": "km",
            "js/ru/seePath": "marshrutni ko'rish",
            "js/ru/krugoreis": "krugoreys"
        },
        cardsCompact: "Kartochkalarning ixcham ko'rinishi",
        cards: "Oddiy ko'rinishdagi kartochkalar",
        appearance: "Ko'rinish",
        RejectOrder: {
            restoreLot: "Lot xuddi shu maydonchalarda qayta e'lon qilinadi.",
            restoreLoad: "yukni tiklash",
            toArchive: "Arxivga",
            move: "o'tkazish",
            cancelDeals: ", Savdolarni bekor qilish",
            inArchive: "Arxivga",
            leftLoad: "yukni qoldish",
            publicLoadWithoutDeal: "savdosiz yukni joylashtirish",
            restartDeal: "savdoni qayta boshlash",
            rubles: "rubl",
            withRate: "stavka bilan",
            chooseWinner: "g'olibni tanlash",
            noReasonWarning: "Bekor qilish sababini ko'rsating",
            reasonRejectionOffer: "Taklifni bekor qilish sababini ko'rsating",
            whatHappenedWithLoads: "Yuk bilan nima qilish kerak",
            popoverWarning: "Buyurtma arxivga ko'chiriladi va bekor qilingan deb belgilanadi"
        },
        "as-ui-kit/src/components/PopupWarning/strings": {
            "js/ru/notToSave": "Saqlamang",
            "js/ru/save": "Saqlash",
            "js/ru/edit": "Tahrirlash",
            "js/ru/p2": "O'zgarishlar yo'qolishi mumkin.",
            "js/ru/p1": "Siz o'zgartirishlaringizni saqlamadingiz va oynani yopishga harakat qilyapsiz.",
            "js/ru/header": "O'zgarishlar bilan nima qilish kerak?"
        },
        Selected: {
            showAll: "To'liq ko'rsatish"
        },
        "as-ui-kit/src/components/PhoneForm/strings": {
            "js/ru/phoneInCar": "Avtomobilga o'rnatilgan mobil qurilma",
            "js/ru/exclusiveAccess": "Uning ATI Haydovchisiga eksklyuziv kirish",
            "js/ru/phone": "Telefon"
        },
        "as-ui-kit/src/components/PhoneForm/TrackerInfo/strings": {
            "js/ru/promo": "Ilova havolasini yuborish uchun mobil telefoningizni kiriting",
            "js/ru/invitedHint": "havola bilan SMS yuboriladi",
            "js/ru/atiTrucker": "ATI Haydovchi"
        },
        "as-ui-kit/src/components/PhoneForm/TrackerInfo/BindOwn/strings": {
            "js/ru/bindingTypes": {
                "driver": "Haydovchiga",
                "car": "TVga"
            },
            "js/ru/goToAutopark": "Avtoparkga o'tish",
            "js/ru/goToCatalog": "Malumotnomaga o'tish",
            "js/ru/alreadyAttached": "Bu raqam ilovaga allaqachon bog‘langan"
        },
        "as-ui-kit/src/components/PhoneForm/TrackerInfo/BindOther/strings": {
            "js/ru/carFromAnother": "Siz transport vositasini [[AppLink]][[Break]] ilovasiga bog‘lay olmaysiz, chunki u firmaga bog‘langan",
            "js/ru/employedToAnotherFirm": "Bu haydovchiga [[Break]][[AppLink]] orqali buyurtma yubora olmaysiz, chunki u firmani xodimi",
            "js/ru/atiTrucker": "ATI Haydovchi"
        },
        "as-ui-kit/src/components/PhoneForm/BindingStatus/strings": {
            "js/ru/resend": "Qayta yuborish",
            "js/ru/driverRejected": "So‘rov rad etildi",
            "js/ru/cancel": "Bekor qilish",
            "js/ru/sent": "So'rov yuborildi",
            "js/ru/sendRequest": "So'rov yuborish"
        },
        PayDocsStatus: {
            infoTextForCargoOwner:
                'Перевозчик может добавить трек-номер \nотправленных документов прямо к Заказу.\n' +
                'Вы получите уведомление, добавится статус \nв разделе «Документооборот и оплата», после чего \nвы сможете отслеживать посылку на сайте Службы \nдоставки.',
            trackNotExist: "Trek raqami ko'rsatilmagan",
            learnMore: "Batafsil bilib olish",
            carrierTrack: "Tashuvchidan posilkaning trek raqami",
            addTrackNumber: "Yuk tashish uchun trek raqamini (kuzatuv raqami) qo'shing",
            choosePaymentStatus: "HA va to'lov holatini tanlang",
            tooltipText: "Trek raqamini qo'shganingizdan so'ng, Buyurtmachi xabarnoma oladi va etkazib berish xizmati veb-saytida jo'natishni kuzatishi mumkin.",
            availableToCustomer: "(buyurtmachi uchun mavjud)",
            trackNumber: "trek raqami",
            status: "holati",
            paymentStatusHint: "(faqat sizga ko'rinadi)",
            paymentStatus: "Hujjatlar aylanishi va to'lov"
        },
        "as-ui-kit/src/components/PayDocsStatus/StatusLabel/strings": {
            "js/ru/changeTrackNumber": "Jo'natish uchun trek raqamini (kuzatuv raqamini) o'zgartirish",
            "js/ru/cancelDelete": "O'chirmang",
            "js/ru/delete": "Oʻchirish",
            "js/ru/deleteTrackNumber": "Trek raqamini qaytarib bo'lmaydigan qilib o'chirish ",
            "js/ru/defaultCompanyName": "yetkazib berish xizmati",
            "js/ru/ofCompany": "kompaniyalar",
            "js/ru/trackInWebsite": "Saytda kuzatib borish",
            "js/ru/trackNumberCopied": "Trek raqami nusxa ko'chirildi",
            "js/ru/header": "Trek raqam",
            "js/ru/trackNumber": "trek raqam"
        },
        "as-ui-kit/src/components/PayDocsStatus/PayDocTrackPopover/strings": {
            "js/ru/trackNotExist": "Trek raqami ko'rsatilmagan",
            "js/ru/learnMore": "Batafsil bilib olish",
            "js/ru/carrierTrack": "Yuk tashuvchidan posilkaning trek raqami",
            "js/ru/trackNumberForShipment": "jo'natish uchun trek raqami (kuzatuv raqami).",
            "js/ru/trackNumber": "trek raqam",
            "js/ru/change": "O'zgartirish",
            "js/ru/add": "Qo'shish"
        },
        "as-ui-kit/src/components/PayDocsStatus/ChooseStatusForm/StatusFormRow/strings": {
            "js/ru/availableToCustomer": "(buyurtmachi uchun mavjud)",
            "js/ru/tooltipText": "Trek raqamini qo'shganingizdan so'ng, buyurtmachi xabarnoma oladi va etkazib berish xizmati veb-saytida jo'natishni kuzatishi mumkin.",
            "js/ru/trackNumber": "trek raqam",
            "js/ru/addTrackNumber": "Trek raqamini qo'shish",
            "js/ru/chooseDate": "sanani tanlang"
        },
        cancel: "Bekor qilish",
        "as-ui-kit/src/components/PayDocsStatus/ChooseStatusForm/StatusFormFooter/strings": {
            "js/ru/finishOfferRequestError": "Yuk tashishda yakunlashda xatolik yuz berdi.",
            "js/ru/saveAndArchive": "Arxivga",
            "js/ru/save": "Saqlash"
        },
        "as-ui-kit/src/components/PayDocsStatus/ChangeTrackForm/TrackFormRow/strings": {
            "js/ru/chooseDate": "Sanani tanlang",
            "js/ru/sendDate": "Jo'natish sanasi",
            "js/ru/inputError": "Trek raqami faqat raqamlar va lotin harflaridan iborat bo'lishi kerak",
            "js/ru/trackNumber": "Trek-raqami",
            "js/ru/trackUrl": "Yetkazib berish xizmati saytiga havola",
            "js/ru/chooseTransportCompany": "Yetkazib berish xizmatini tanlang",
            "js/ru/transportCompany": "Yetkazib berish xizmati",
            "js/ru/body": "Trek raqamini qo'shganingizdan so'ng, buyurtmachi xabarnoma oladi va etkazib berish xizmati veb-saytida jo'natishni kuzatishi mumkin."
        },
        "as-ui-kit/src/components/PayDocsStatus/ChangeTrackForm/TrackFormFooter/strings": {
            "js/ru/cantSaveForm": "Barcha kerakli maydonlar to'ldirilmaguncha trek raqamini saqlay olmaysiz",
            "js/ru/delete": "Trek raqamini o'chirish",
            "js/ru/save": "Saqlash",
            "js/ru/cancel": "Qo'shmang",
            "js/ru/add": "Trek raqamini qo'shish"
        },
        "as-ui-kit/src/components/PayDocsStatus/ChangeTrackForm/TrackFormFooter/ConfirmDeletePopover/strings": {
            "js/ru/dontDelete": "O'chirmang",
            "js/ru/delete": "Oʻchirish",
            "js/ru/confirmDelete": "Trek raqamini qaytarib bo'lmaydigan qilib o'chirish?"
        },
        ParticipantsPopup: {
            noPermissionsText: "Yuk bilan ishlash faqat yuk bo'linmasiga kirish huquqiga ega bo'lgan xodimlar tomonidan amalga oshiriladi",
            anotherPtWinner: "O'zaro savdolarda boshqa ishtirokchi g'alaba qozondi",
            update: "Yangilash",
            noWinners2: "Savdolarni bekor qiling va qaytadan boshlang",
            noWinners1: "G'oliblar yo'q.",
            winnerRemovedFromBoard2: "Boshqasini tanlang",
            winnerRemovedFromBoard1: "G'olib maydonchadan olib tashlandi.",
            winnerTimeExpiredNoNext2: "yoki yana savdoni boshlash",
            winnerTimeExpired2: "yoki keyingi ishtirokchini tanlash",
            waitForWinner: "Siz g'olibdan ma'lumotlarni kutishingiz mumkin",
            finished: "Savdolar yakunlandi.",
            untilEnd: "savdolar oxirigacha.",
            startRate: "boshlang'ich stavka",
            participants: {
                other: "ishtirokchilar",
                many: "ishtirokchilar",
                few: "ishtirokchilar",
                one: "ishtirokchi"
            },
            noParticipants: "Ishtirokchilar yo'q",
            Participant: {
                atrucksTooltip: "Transport kompaniyalari bilan ishlashni avtomatlashtirish uchun uchinchi tomon tizimi",
                ptParticipant: "O'zaro savdo ishtirokchisi",
                tooltipRate: "Ishtirokchi stavka qildi",
                bestRateAndDate: "Eng yaxshi stavka va sana",
                bestDate: "Eng yaxshi sana",
                bestRate: "Eng yaxshi stavka",
                or: "yoki",
                noAccessText: "Sizda bu operatsiyani bajarish uchun ruxsat yo'q. Ruxsat olish uchun administratoringizga murojaat qiling",
                at: "da...",
                yearStr: "y.",
                shouldSend: ["G'olib sizga ariza uchun ma'lumotlarni taqdim etishi kerak davomida ", ""],
                dontSend: "G'olib sizga ariza uchun hali ma'lumot bermadi.",
                winnerConfirmed2: "buyurtmalar",
                winnerConfirmed1: "G'olib yukni oldi. Haydovchi va transport vositasi haqidagi ma'lumotlarni ko'ring",
                exWinner: "Siz bu ishtirokchining taklifini rad etdingiz",
                shipperRefused: "Buyurtma yuk egasi tomonidan rad etilgan",
                carrierRefused: "Yuk tashuvchi Buyurtmada ishtirok etishdan bosh tortdi",
                refused: "Ishtirokchi Savdolarda qatnashishdan bosh tortdi.",
                skipped: "Ma'lumotlarni o'z vaqtida taqdim etmadi.",
                winnerRemovedFromBoard: "G'olib Maydonchadan olib tashlandi.",
                removedFromBoard: "Ishtirokchi Maydonchadan olib tashlandi.",
            },
        },
        loadingDate: "Tayyor",
        participant: "Ishtirokchi",
        outputStrings: "Satrlarni chiqarish",
        "as-ui-kit/src/components/PaginationBlock/Pagination/strings": {
            "js/ru/from": "dan"
        },
        orderLoadNumber: "yuk/lot/buyurtma № ",
        orderNumber: "Buyurtma № ",
        "as-ui-kit/src/components/OfferTracker/TrackerSummary/LinkToRouteOnMap/strings": {
            "js/ru/routeOnMap": "Xaritada marshrut"
        },
        "as-ui-kit/src/components/OfferTracker/TrackerSummary/FinishedStatusView/strings": {
            "js/ru/eventDateTime": "{{day}} {{time}}da",
            "js/ru/driverRevoked": "Haydovchini buyurtmadan chaqirib olindi",
            "js/ru/driverRejectedDeal": "Haydovchi buyurtmani rad etdi",
            "js/ru/driverFinishedDeal": "Haydovchi buyurtmani yakunladi",
            "js/ru/cancelledDeal": "buyurtmani bekor qildi",
            "js/ru/finishedDeal": "buyurtmani yakunladi"
        },
        "as-ui-kit/src/components/OfferTracker/TrackerSummary/Accidents/strings": {
            "js/ru/4": "ma'lumotlar yo'q edi",
            "js/ru/3": "GPS o'chirilgan marshrutning bir qismi",
            "js/ru/2": "buzilish",
            "js/ru/1": "YTH",
            "js/ru/0": "GPS-ni soxtalashtirishga urinish"
        },
        "as-ui-kit/src/components/OfferTracker/TrackerInWorkStatus/strings": {
            "js/ru/driverWillSendDataFromApp": "Haydovchi buyurtmani oldi, lekin u ustida ishlashni hali boshlamadi",
            "js/ru/from": "dan",
            "js/ru/ed": "o'zgart.",
            "js/ru/fromApp": "ATI Haydovchi ilovasidan"
        },
        "as-ui-kit/src/components/OfferTracker/TooltipMessage/strings": {
            "js/ru/gpsSpoof": "Haydovchi telefonida GPS ({{initialPhone}})ni soxtalashtirish imkonini beruvchi funksiya yoqilgan.",
            "js/ru/gpsOff": "Haydovchi telefon sozlamalarida ({{initialPhone}}) GPS o‘chirilgan. Joylashuv maʼlumotlari mavjud emas.",
            "js/ru/noData": "ma'lumotlar kelishi to'xtadi. Haydovchining telefoni o‘chirilgan yoki internetga ulanmagan bo‘lishi mumkin ({{initialPhone}}).",
            "js/ru/youAndOwner": "siz va buyurtmachiga",
            "js/ru/onlyYou": "faqat sizning firmangizga",
            "js/ru/rejectionInfoAvailable": "Rad etish to'g'risidagi ma'lumotlar mavjud",
            "js/ru/infoAvailable": "Ma'lumot mavjud",
            "js/ru/dataAvailable": "Ilovadan xarita va buyurtma holati mavjud",
            "js/ru/activity": "ATI Haydovchi ilovasida faolligi {{lastActive}} ({{initialPhone}})."
        },
        "as-ui-kit/src/components/OfferTracker/StatusDescriptions/strings": {
            "js/ru/notConfirmed": "Haydovchi ilovada buyurtma qabul qilinganligini tasdiqlamadi",
            "js/ru/finishedByCounterpart": "[[FirmName]] buyurtmani yakunladi",
            "js/ru/finished": "Haydovchi buyurtmani yakunladi",
            "js/ru/revoked": "Siz buyurtmani bekor qildingiz",
            "js/ru/notSentDataExpected": "Buyurtmani haydovchiga yuborish uchun yuk tashish ma'lumotlarini kiriting",
            "js/ru/notSent": "Haydovchi uchun ma'lumotlar ko'rsatilmagan",
            "js/ru/rejectionReason": "rad etish sababi",
            "js/ru/rejected": "Haydovchi buyurtmani rad etdi",
            "js/ru/sent": "Buyurtma [[DriverPhone]] ga yuborildi Haydovchi hali ishga buyurtmani qabul qilmagan",
            "js/ru/sentShort": "Buyurtma yuborildi",
            "js/ru/sendToSeeOnMap": "Yukni xaritada ko'rish uchun ilovaga buyurtmani yuboring",
            "js/ru/awaitingDriver": "Haydovchi buyurtmani boshlashini kutamiz",
            "js/ru/carrierRevoked": "Yuk tashuvchi haydovchidan buyurtmani qaytarib oldi. Hali yangi ma'lumotlar yo'q"
        },
        "as-ui-kit/src/components/OfferTracker/StatusBadge/strings": {
            "js/ru/gpsSpoof": "soxta GPS",
            "js/ru/gpsOff": "GPS o'chirilgan",
            "js/ru/finished": "buyurtma tugallandi",
            "js/ru/revoked": "buyurtma bekor qilindi",
            "js/ru/rejected": "buyurtmani rad etish",
            "js/ru/notInWork": "ishda emas",
            "js/ru/inWork": "ishda",
            "js/ru/sent": "buyurtma yuborildi",
            "js/ru/notSent": "buyurtma yuborilmagan",
            "js/ru/noData": "ma'lumotlar yo'q",
            "js/ru/atiTrucker": "ATI Haydovchi"
        },
        "as-ui-kit/src/components/OfferTracker/StateWithoutDriver/strings": {
            "js/ru/toWatchCargoOnMap": "xaritada yukni ko'rish uchun",
            "js/ru/inAtiDriver": "ATI haydovchiga",
            "js/ru/addDriverInOrder": "Haydovchini buyurtmaga qo'shing va uni taklif qiling ",
            "js/ru/addDriver": "Buyurtmaga haydovchini qo'shing va uni taklif qiling"
        },
        "as-ui-kit/src/components/OfferTracker/PresenceLoading/strings": {
            "js/ru/loading": "maʼlumotlar yuklanmoqda...",
            "js/ru/hasTracker": "ATI Haydovchi"
        },
        "as-ui-kit/src/components/OfferTracker/NoTrackerAccess/strings": {
            "js/ru/atiTrucker": "ATI Haydovchi"
        },
        "as-ui-kit/src/components/OfferTracker/NoInWorkAccess/strings": {
            "js/ru/carrierReceivesFromApp": "Yuk tashuvchi ATI Haydovchi ilovasidan statuslarni oladi",
            "js/ru/changingStatuses": "Statuslarni o'zgartirish mavjud emas"
        },
        "as-ui-kit/src/components/OfferTracker/MapActionsContainer/strings": {
            "js/ru/dialogDescription": "ATI Haydovchi",
            "js/ru/chat": "Chat",
            "js/ru/shareLinkDescription": "havolani ulashing",
            "js/ru/shareLink": "Havolani ulashing",
            "js/ru/sharedWithCounterpartyDescription": "sizga va buyurtmachiga ko'rinadi",
            "js/ru/onlyForYouDescription": "faqat sizga ko'rinadi",
            "js/ru/sharedWithCounterparty": "Sizga va buyurtmachiga ko'rinadi",
            "js/ru/onlyForYou": "Faqat sizga ko'rinadi",
            "js/ru/map": "Xarita"
        },
        "as-ui-kit/src/components/OfferTracker/MainActions/strings": {
            "js/ru/revokeData": "Buyurtmani bekor qilish",
            "js/ru/dataForDriver": "Haydovchi uchun ma'lumotlar",
            "js/ru/configure": "Sozlash",
            "js/ru/resendOrder": "qayta yuborish",
            "js/ru/sendOrder": "Buyurtmani yuborish",
            "js/ru/setData": "Ma'lumotlarni ko'rsating"
        },
        ActionsButtons: {
            dialogDescription: "ATI Haydovchi",
            chat: "Chat",
            shareLink: "Havolani ulashing",
            sharedWithCounterpartyDescription: "sizga va buyurtmachiga ko'rinadi",
            onlyForYouDescription: "faqat sizga ko'rinadi",
            sharedWithCounterparty: "Sizga va buyurtmachiga ko'rinadi",
            onlyForYou: "Faqat sizga ko'rinadi",
            map: "Xarita"
        },
        InDevelopmentButton: {
            inDev: "Ishlab chiqishda"
        },
        OfferInformationDriver: {
            willProvideDataLater: "Ma'lumotlarni keyinroq ko'rsataman",
            fromDealModifier: "(bitimdan)",
            registration: "Roʻyxatdan oʻtish",
            seriesNumber: "Seriya, raqam",
            selectDriver: "Haydovchi tanlang",
            searchDrivers: "Haydovchilar bo'yicha izlash",
            driverLicense: "Haydovchilik guvohnomasi",
            passportIssuedWhen: "Berilgan sana",
            passportIssued: "Berilgan",
            passportNumber: "Raqam",
            passportSeries: "Seriya",
            passport: "Pasport",
            enlistedDriver: "jalb qilingan haydovchi",
            enlisted: "jalb qilingan",
            edit: "Tahrirlash",
            driverNotFound: "Haydovchi topilmadi",
            driver: "Haydovchi ",
            clickToAddDriver: "Yangisini qo'shish uchun bosing",
            addDriver: "Haydovchi qo'shish"
        },
        UseTrackerCheck: {
            fromTracker: "ATI Haydovchisidan",
            shareData: "Buyurtmachi bilan ma'lumot almashish"
        },
        OfferInformationDriverFooter: {
            editHint: "ATI Haydovchisida ushbu haydovchiga buyurtmalar yuborish uchun",
            editHintLink: "Mobil raqamingizni ko'rsating.",
            willNotShare: "ATI Haydovchisidan karta va buyurtma holati faqat siz uchun mavjud",
            willShare: "Siz ATI haydovchisidan karta va holatini buyurtmachi bilan baham ko'rasiz",
            nlistedDriver: "jalb qilingan haydovchi"
        },
        TrackerSharing: {
            howTrackerWorks: "Ati Haydovchisi qanday ishlaydi",
            youWillSee: "Siz xaritada yukni va joriy buyurtma holatini ko'rishingiz mumkin bo'ladi.",
            carrierWillShare: "Yuk tashuvchi ATI Haydovchisidan ma'lumotlarini baham ko'radi"
        },
        OfferInformationCar: {
            willProvideDataLater: "Ma'lumotlarni keyinroq ko'rsataman",
            fromDealTip: "Buyurtmadan",
            fromDealModifier: "(bitimdan)",
            remove: "Olib tashlash",
            unknownCarType: "noma'lum kuzov turi",
            vehicle: "TV",
            clickToAddVehicle: "Yangisini qo'shish uchun bosing",
            vehicleNotFound: "Mashina topilmadi",
            edit: "Tahrirlash",
            chooseSemiTrailer: "Yarim tirkama tanlang",
            chooseTrailer: "Tirkamani tanlang",
            chooseVehicle: "TV tanlang",
            searchVehicles: "TV qidirish",
            addVehicle: "TV qo'shish",
            addSemiTrailer: "Yarim tirkamani qo'shish",
            addTrailer: "Tirkamani qo'shish",
            addTruck: "Yuk mashinasi qo'shish",
            carTypeNames: {
                trailer: "Tirkama",
                semitrailer: "Yarim tirkama",
                tractor: "Tyagach",
                truck: "Yuk mashinasi"
            }
        },
        Contractors: {
            readMoreLink: {
                text: "Malumotnoma haqida batafsil",
            },
            button: "Kontragentni qo'shish",
            header: "Sizning kontragentlaringiz",
        },
        Organizations: {
            readMoreLink: {
                text: "Malumotnoma haqida batafsil",
            },
            narrow: {
                text: [
                    "Va ularni hujjatlarga qo'ying, sayt orqali buyurtma berganingizda",
                ]
            },
            button: "Tashkilot qo'shish",
            header: "Tashkilotingiz va siz tez-tez ishlaydiganlar haqida ma'lumotlarni qo'shing",
        },
        Drivers: {
            readMoreLink: {
                text: "Malumotnoma haqida batafsil",
            },
            button: "Haydovchini qo'shish",
            header: "Haydovchini qo'shing",
        },
        Transport: {
            readMoreLink: {
                text: "Malumotnoma haqida batafsil",
            },
            header: "Transportni qo'shing",
        },
        CompletedItems: {
            wide: {
                header: "Buyurtma",
                text: [
                    "Yuk tashishni bir necha bosqichda - ATI.SU sayti orqali muzokara  qiling. Buyurtmani rasmiylashtirish mumkin, agar yuk jo'natuvchi sizga Maydonchada yoki shaxsiy taklifnomada yukni taklif qilsa.",
                    "Siz bunday yukni \"yukni olish\"tugmasi bilan taniysiz. Uni bosganingizdan so'ng, yuk sizniki. Saytning o'zi shartnoma arizasini tuzadi, siz uni faqat imzolashingiz kerak bo'ladi.",
                ],
            },
            button: "Batafsil bilib olish",
            header: "Bu erda buyurtmalar bo'yicha bajarilgan yuklar saqlanadi.",
        },
        Completed: {
            wide: {
                header: "Buyurtma",
                text: [
                    "Yuk tashishni bir necha bosqichda - ATI.SU sayti orqali muzokara  qiling. Buyurtmani rasmiylashtirish mumkin, agar yuk jo'natuvchi sizga Maydonchada yoki shaxsiy taklifnomada yukni taklif qilsa.",
                    "Siz bunday yukni \"yukni olish\"tugmasi bilan taniysiz. Uni bosganingizdan so'ng, yuk sizniki. Saytning o'zi shartnoma arizasini tuzadi, siz uni faqat imzolashingiz kerak bo'ladi.",
                ],
            },
            button: "Batafsil bilib olish",
            header: "Bu erda buyurtmalar bo'yicha bajarilgan yuklar saqlanadi.",
        },
        Payments: {
            wide: {
                header: "Buyurtma",
                text: [
                    "Yuk tashishni bir necha bosqichda - ATI.SU sayti orqali muzokara  qiling. Buyurtmani rasmiylashtirish mumkin, agar yuk jo'natuvchi sizga Maydonchada yoki shaxsiy taklifnomada yukni taklif qilsa.",
                    "Siz bunday yukni \"yukni olish\"tugmasi bilan taniysiz. Uni bosganingizdan so'ng, yuk sizniki. Saytning o'zi shartnoma arizasini tuzadi, siz uni faqat imzolashingiz kerak bo'ladi.",
                ],
            },
            text: [
                "Hujjatlar va Buyurtma uchun to'lov qachon yuborilgani va qabul qilinganligini kuzatishingiz mumkin.",
            ],
            button: "Batafsil bilib olish",
            header: "Bu erda siz to'lov holati va hujjatlarning harakatini ko'rasiz",
        },
        InProgressItems: {
            wide: {
                header: "Buyurtma",
                text: [
                    "Yuk tashishni bir necha bosqichda - ATI.SU sayti orqali muzokara  qiling. Buyurtmani rasmiylashtirish mumkin, agar yuk jo'natuvchi sizga Maydonchada yoki shaxsiy taklifnomada yukni taklif qilsa.",
                    "Siz bunday yukni \"yukni olish\"tugmasi bilan taniysiz. Uni bosganingizdan so'ng, yuk sizniki. Saytning o'zi shartnoma arizasini tuzadi, siz uni faqat imzolashingiz kerak bo'ladi.",
                ],
            },
            text: [
                "Bu Buyurtmalar bo'yicha berilgan yuklar bo'lib, ular uchun ariza imzolangan va yuk tashishni kutmoqda yoki allaqachon yo'lda.",
            ],
            button: "Batafsil bilib olish",
            header: "Bu yerda yuklar bajarishda bo'ladi",
        },
        InProgress: {
            wide: {
                header: "Buyurtma",
                text: [
                    "Yuk tashishni bir necha bosqichda - ATI.SU sayti orqali muzokara  qiling. Buyurtmani rasmiylashtirish mumkin, agar yuk jo'natuvchi sizga Maydonchada yoki shaxsiy taklifnomada yukni taklif qilsa.",
                    "Siz bunday yukni \"yukni olish\"tugmasi bilan taniysiz. Uni bosganingizdan so'ng, yuk sizniki. Saytning o'zi shartnoma arizasini tuzadi, siz uni faqat imzolashingiz kerak bo'ladi.",
                ],
            },
            text: [
                "Bu Buyurtmalar bo'yicha berilgan yuklar bo'lib, ular uchun ariza imzolangan va yuk tashishni kutmoqda yoki allaqachon yo'lda.",
            ],
            button: "Batafsil bilib olish",
            header: "Bu yerda yuklar bajarishda bo'ladi",
        },
        ReconciliationItems: {
            wide: {
                header: "Buyurtma",
                text: [
                    "Yuk tashishni bir necha bosqichda - ATI.SU sayti orqali muzokara  qiling. Buyurtmani rasmiylashtirish mumkin, agar yuk jo'natuvchi sizga Maydonchada yoki shaxsiy taklifnomada yukni taklif qilsa.",
                    "Siz bunday yukni \"yukni olish\"tugmasi bilan taniysiz. Uni bosganingizdan so'ng, yuk sizniki. Saytning o'zi shartnoma arizasini tuzadi, siz uni faqat imzolashingiz kerak bo'ladi.",
                ],
            },
            text: [
                "Bu Buyurtmalar bo'yicha berilgan yuklar bo'lib, ular uchun ariza imzolangan va yuk tashishni kutmoqda yoki allaqachon yo'lda.",
            ],
            button: "Batafsil bilib olish",
            header: "Bu erda yuklar kelishiladi",
        },
        Reconciliation: {
            wide: {
                header: "Buyurtma",
                text: [
                    "Yuk tashishni bir necha bosqichda - ATI.SU sayti orqali muzokara  qiling. Buyurtmani rasmiylashtirish mumkin, agar yuk jo'natuvchi sizga Maydonchada yoki shaxsiy taklifnomada yukni taklif qilsa.",
                    "Siz bunday yukni \"yukni olish\"tugmasi bilan taniysiz. Uni bosganingizdan so'ng, yuk sizniki. Saytning o'zi shartnoma arizasini tuzadi, siz uni faqat imzolashingiz kerak bo'ladi.",
                ],
            },
            text: [
                "Bu siz buyurtmalar bo'yicha oladigan yuklar, lekin siz hali shartnoma-arizani imzolamaysiz.",
            ],
            button: "Batafsil bilib olish",
            header: "Bu erda yuklar kelishiladi",
        },
        archive: {
            narrow: {
                text: [
                    "Bu erda hozirda saytda e'lon qilinmagan yuklar ko'rsatiladi",
                ],
            },
            button: "Yukni qo'shish",
            header: "Yuklar arxivi bo'sh",
        },
        published: {
            actions: {
                restore: "arxivdan tiklash",
                add: "Ularni qo'shing yoki ",
            },
            button: "Yukni qo'shish",
            header: "Bu erda sizning yuklaringiz bo'ladi",
        },
        noAccessToAddingLoadText: "Siz yuk qo'shish huquqiga ega emassiz. Ruxsat olish uchun administratoringizga murojaat qiling.",
        noFilteredLoads: "Ro'yxatda bunday yuklar yo'q. Filtrni qayta tiklashga yoki boshqa variantlarni qidirishga harakat qiling",
        clearFilter: "Filtrni tiklash",
        trailer: "tirkama",
        semitrailer: "Yarim tirkama",
        tractor: "Tyagach",
        truck: "Yuk mashinasi",
        add: "Qo'shish",
        notFound: "Topilmadi",
        // "en": {
        //     "js/DEFAULT_EXPORT/Organizations/header": "Tashkilotingiz va siz tez-tez ishlaydiganlar haqida ma'lumotlarni qo'shing"
        // },
        pressToCalculate: "Hisoblash uchun bosing.",
        insureLoadAndGetCashback: "Yukingizni sug'urta qiling va 5%dan keshbek oling.",
        insureLoad: "Yukni sug'urtalash",
        LoadFiles: {
            otherDocuments: "hujjat",
            oneDocument: "hujjat",
            manyDocuments: "hujjatlar",
            fewDocuments: "hujjat"
        },
        LargeCities: {
            km: "km",
            bkg: "yaqin yirik shaharlar"
        },
        InviteButton: {
            invite: "Taklif qilish"
        },
        LimitsPopover: {
            orders: {
                other: "buyurtmalar",
                many: "buyurtmalar",
                few: "buyurtmaning",
                one: "buyurtma",
            },
            doNotInvite: "Taklif qilmang",
            invite: "Taklif qilish",
            doInviteCarrier: "Buyurtmani qabul qilinishini istasangiz, limitga qaramay yuk tashuvchini taklif qiling.",
            editInCatalogs: "Ma'lumotnomda tahrirlash",
            max: "maks.",
            youSetLimit: "Siz bir vaqtning o'zida ishlayotgan buyurtmalar soniga limit o'rnatdingiz:",
            title: "Buyurtmalar uchun limit yetdi"
        },
        insuranceConditions: "Sug'urta shartlari",
        promoText: "Tasodifiy sabablarga ko'ra yukning yo'qolishi, shikastlanishi yoki yomonlashishi uchun kompensatsiya olish uchun yukingizni sug'urtalang.",
        InWorkStatusSelect: {
            visibleForOwnerControlledFromTracker: "Status sizga va yuk tashuvchiga ko'rinadi. Statusni faqat haydovchi o'zgartirishi mumkin.",
            youAndOwner: "Status sizga va buyurtmachiga ko'rinadi. Statusni faqat haydovchi o'zgartirishi mumkin.",
            onlyYou: "Status faqat sizning kompaniyangizga ko'rinadi. Statusni faqat haydovchi o'zgartirishi mumkin.",
            ownerInfo: "Status sizga va yuk tashuvchiga ko'rinadi",
            info: "Status sizga va buyurtmachiga ko'rinadi",
            noStatus: "Status yo'q",
            placeholder: "Statusni tanlang"
        },
        ImagesUploader: {
            carsPhotos: "TV fotosuratlari"
        },
        HistoryPopup: {
            load: "Yuk #",
            emptyHistory: "Ushbu yuk bo'yicha buyurtmalar, savdolar (auktsionlar) va qarshi takliflar yo'q edi",
            actionColumnName: "Harakat",
            timeColumnName: "vaqt",
            dateColumnName: "Sana",
            title: "Savdolar va buyurtmalar tarixi"
        },
        FileDownloadButton: {
            downloadExcel: "Tarixni Yuklab Olish (Excel)"
        },
        ChooseDropdown: {
            offer: "Barcha qarshi takliflar",
            deal: "Bitimning butun tarixi",
            auctionrate: "Barcha stavkalar savdolar bo'yicha",
            auction: "Savdoning butun tarixi",
            all: "Barcha harakatlar",
            show: "Ko'rsatish"
        },
        GlyphButtonHistory: {
            history: "Buyurtmalar tarixi"
        },
        GeoPositionPromo: {
            promoNotice: 'ATI Haydovchi bepul xizmatidan foydalanib,\n buyurtmalaringizni real vaqtda kuzatib boring',
            sensorSharingNotice: 'Buyurtmachi yuk bilan mashinaning joylashishini datchig\n ro\'yxatdan o\'tgan GPS monitoring tizimining xaritasida ko\'radi',
            moreAboutShipperTracker: "ATI Haydovchisi qanday ishlaydi",
            trackerShipperNotice: "va joriy buyurtma statusini olish",
            sensorShipperNotice: "GPS monitoring tizimlari",
            shipperNotice: "Siz yukni xaritada ko'rishingiz mumkin",
            shipperHeader: "Yuk tashuvchi geopozitsiya ma'lumotlarini baham ko'radi",
            moreAboutTracker: "ATI Haydovchisi haqida batafsil",
            trackerSharingNotice: "Buyurtmachi buyurtma statusini va yuki bo'lgan mashinani xaritada ko'radi.",
            sharingNotice: "Bu ishonchni oshirishi va ijrochining sizni tanlashiga ta'sir qilishi mumkin.",
            showGeoData: "Buyurtmachiga geopozitsiya ma'lumotlarini ko'rsatish",
            sectionName: "Yuk tashishni nazorat qilish"
        },
        FirmReputation: {
            unfairPartnerAbbr: "vh",
            claimAbbr: "d",
            recommendationAbbr: "t",
            otherFirms: "firmadan",
            manyFirms: "firmadan",
            twoFirms: "firmadan",
            oneFirm: "firmalar",
            unfairPartners: "“Vijdonsiz hamkorlar” forumidagi eslatmalar: {0} {1} dan",
            claims: "Da'volar:",
            recommendations: "Tavsiyalar:"
        },
        Firm: {
            claimsAbbr: "d",
            unfairPartnerAbbr: "vh",
            recommendationAbbr: "t",
            otherDocs: "hujjat",
            manyDocs: "hujjat",
            twoDocs: "hujjat",
            oneDoc: "hujjat",
            otherFirms: "firmadan",
            manyFirms: "firmadan",
            twoFirms: "firmadan",
            oneFirm: "firmalar",
            unfairPartners: "firmadan",
            claims: "Da'volar:",
            recommendations: "Tavsiyalar:",
            document: "{{count}} {{string}} tomonidan taqdim etilgan",
            code: "Kod"
        },
        drop: "Qayta tiklash",
        allParametersCompact: "Ko'proq",
        allParameters: "Ko'proq filtrlar",
        ExtraPoints: {
            unloading: "tushirish",
            otherPoints: "puntklari",
            onePoint: "punkt",
            manyPoints: "puntklari",
            loading: "yuklash",
            fewPoints: "punktga",
            extraPointsAbbr: "qo'sh. {{point}} {{type}}"
        },
        take_lot_access_denied: "Sizda bu harakat uchun etarli huquq yo'q",
        take_load_access_denied: "Sizda bu harakat uchun etarli huquq yo'q",
        access_denied: "Sizda bu harakat uchun etarli huquq yo'q",
        ui_error: "Xatolik yuz berdi",
        contact_access_denied_error: "Huquqlar yetarli emas",
        cannot_choose_winner: "G'olibni o'zgartirish mumkin emas",
        invitation_not_found_error: "Xatolik yuz berdi",
        load_not_found_error: "Yukni olish mumkin emas",
        load_cant_reserve: "Yukni rezerv qilish mumkin emas",
        load_cant_take: "Yukni olish mumkin emas",
        close: "Yopish",
        access_denied_reason: `<p>Для того, чтобы работать с Заказами, у вас должны быть следующие доступы:</p>
        <ul>
            <li>Работать с площадками</li>
            <li>Брать грузы для оформления Заказов</li>
        </ul>
         <p>Чтобы вы могли одобрить заявку, потребуется доступ:</p>
            <ul>
                <li>Подписывать и одобрять документы в АТИ-Доках</li>
             </ul>
         </p>
         <p>Эти права вам может дать администратор или руководитель аккаунта. Права настраиваются в кабинете, в окне редактирования контакта.</p>`,
        take_load_access_denied_reason: `<p>Для того, чтобы работать с Заказами, у вас должен быть следующий доступ:</p>
        <ul>
            <li>Брать грузы для оформления Заказов</li>
        </ul>
         <p>Это право вам может дать администратор или руководитель аккаунта. Права настраиваются в кабинете, в окне редактирования контакта.</p>`,
        take_lot_access_denied_reason: `<p>Для того, чтобы работать с Заказами, у вас должен быть следующий доступ:</p>
        <ul>
            <li>Брать грузы для оформления Заказов</li>
        </ul>
         <p>Это право вам может дать администратор или руководитель аккаунта. Права настраиваются в кабинете, в окне редактирования контакта.</p>`,
        defaultError: {
            reason: "Sahifani qayta yuklashga harakat qiling."
        },
        EditArea: {
            cancel: "Bekor qilish"
        },
        DriverSelect: {
            driver: "Haydovchi",
            clear: "Tozalash"
        },
        DriverEmployedToAnother: {
            carFromAnother: "Siz TVni [[AppLink]] ilovasiga bog‘lay olmaysiz, chunki u firmaga bog‘langan",
            employedToAnotherFirm: "Siz bu haydovchiga [[AppLink]] orqali buyurtma yubora olmaysiz, chunki u firmani xodimi",
            atiTrucker: "ATI Haydovchi"
        },
        toWhere: "Qayerga",
        fromWhere: "Qayerdan",
        clear: "Tozalash",
        selectedDepartments: "tanlangan",
        allDepartments: "Barcha bo'linmalar",
        deletedDepartments: "O'chirilgan bo'linmalar",
        allDocsWithoutCount: {
            allDocsWithoutCount: "Hujjatlar va fotosuratlar",
            allDocs: "({{docsCount}}) Hujjatlar va fotosuratlar ",
            edited: "Tahrirlar",
            notSent: "yuborilmagan",
            document: "Hujjat"
        },
        CounterpartySelect: {
            auctionsWinner: "Savdolar G'olibi",
            firm: "ATI firmasi",
            clear: "Tozalash",
            counterparty: "Kontragent"
        },
        willBeShown: "Faol kontaktning yuklari ko'rsatiladi.",
        areShownNow: "Hozir faol kontaktning yuklari ko'rsatilmoqda.",
        loadsForAllContacts: "Sizning yuklaringizga kirishda barcha kontaktlarning yuklari.",
        dontShow: "Ko'rsatmaslik",
        show: "Ko'rsatish",
        allContacts: "Barcha kontaktlar",
        City: {
            unloading: "tushirish",
            loading: "yuklashlar",
            tooltipCoords: "Nuqta koordinatalari {{type}}"
        },
        CargoOwnerHelpPopover: {
            moreAboutOrders: "Buyurtmalar haqida batafsil",
            carrierHasReservedTheLoad: "Yuk tashuvchi yukni rezerv qildi"
        },
        CancelWinnerPopover: {
            notChooseAsWinner: "Tanlamang",
            goingToChooseNewWinnerText: "Joriy g'olibga sizning yukingiz bilan buyurtma allaqachon yuborilgan.U taklifni rad etish haqida xabar oladi. Buyurtma yangi g'olibga yuboriladi.",
            goingToChooseNewWinner: "Siz yangi g'olibni tanlamoqchisiz",
            chooseAsWinner: "G'olibni tanlash"
        },
        orderWillBeCancelled: 'Заказ будет перемещён в архив\n' + 'и отмечен как отменённый',
        notCancel: "Bekor qilmaslik",
        confirmCancelOrder: "Buyurtmani bekor qilish",
        CancelAuctionActions: {
            noAccessText: "Savdolarni bekor qilish huquqiga ega emassiz.Ruxsatlar uchun administratorga murojaat qiling",
            willFinished: "Savdolar yakunlanadi.\nEng yaxshi stavkani taklif\nqilgan g'olib tanlanadi",
            willLoseBids: "Barcha Savdo stavkalari\nyo'qoladi",
            cancelFinish: "Tugatmaslik",
            cancelCancel: "Bekor qilmaslik",
            cancel: "Bekor qilish",
            cancelAuction: "Savdolarni bekor qilish",
            finish: "Tugatish",
            finishAheadOfTime: "Hozir tugatish"
        },
        BlackListLabel: {
            tooltipText: "Haydovchi sizning qora ro'yxatingizda",
            carrier: {
                full: "Haydovchi buyurtmachini qora ro'yxatida",
                short: "Buyurtmachining QR"
            },
            cargoOwner: {
                full: "Haydovchi sizning qora ro'yxatingizda",
                short: "qora ro'yxatda"
            },
        },
        AuctionTimer: {
            at: "da",
            auctionEndDateBoundary: "Agar stavkalar bo'lmasa, savdolar tugaydi",
            auction: "Savdolar",
            beforeAuctionStart: "Savdolar boshlanishidan oldin",
            untilAuctionEnd: "Savdolar oxirigacha"
        },
        AttachCar: {
            headerText: {
                semitrailer: "yarim tirkama",
                trailer: "Tirkama",
                tractorAndTruck: "Yarim tirkama bilan tyagach yoki yuk mashinasi",
                truck: "Yuk mashinasi",
                tractor: "Tyagach",
            },
            noResultsText: "topilmadi",
            select: "Tanlang...",
            trailer: "tirkama",
            tractorAndTruck: "Yarim tirkama bilan tyagach yoki yuk mashinasi",
            semitrailer: "yarim tirkama",
            truck: "yuk mashinasi",
            tractor: "tyagach",
            add: "Qo'shish",
            edit: "O'zgartirish",
            cancel: "Bekor qilish"
        },
        notToSave: "Saqlamang",
        save: "Saqlash",
        edit: "Tahrirlash",
        p2Text: "O'zgarishlar yo'qolishi mumkin.",
        p1Text: "Siz o'zgarishlarni saqlamadingiz va oynani yopishga harakat qilyapsiz.",
        headerText: "O'zgarishlar bilan nima qilish kerak?",
        AtiPopup: {
            cancel: "Bekor qilish"
        },
        FileUploadWrapper: {
            invalidFile: "Noto'g'ri fayl tanlangan"
        },
        FileUploadItemInfo: {
            uploadError: "Yuklab bo‘lmadi. Yana bir bor urinib ko `ring",
            uploaded: "yuklangan",
            removeItem: "Oʻchirish",
            abortUpload: "Yuklashni to'xtatish"
        },
        AtiFileUploader: {
            uploadRequired: "Fayllarni yuklash",
            upload: "Yuklash"
        },
        PopupOrganization: {
            removePopover: {
                contactPerson: "Bog‘lanish mumkin bo‘lgan shaxs Malumotnomadan olib tashlansinmi?",
                address: "Tashkilot manzili Malumotnomadan olib tashlansinmi?",
            },
            notLocation: "Biz bunday aholi punktini topmadik",
            documentExample: "Masalan, IDNO 1234567-123-123",
            documentType: "Hujjat turi va raqami",
            bin: "BIN",
            unp: "THR",
            edrpou: "UKvaTYaDR",
            officeTooltip: "Ofis, bino, boks, xonadon, xona va boshqalarni kiriting.",
            office: "Ofis, bino va boshqalar.",
            building: "Uy, imorat, bino, litera",
            street: "Ko'cha, prospekt, torko'cha, bulvar va boshqalar.",
            locality: "Aholi punkti",
            postcode: "Indeks",
            organizationPhone: "Tashkilot telefon raqami",
            locationAddress: "Hujjatlar uchun joylashuv manzili ",
            inn: "STIR",
            residency: "Rezidentlik",
            fullOrganizationName: "To'liq nomi",
            other: "(boshqa)",
            available: "Mavjud",
            notResultOwnership: "Mulk shakli topilmadi",
            nameFirm: "Firmaning nomi",
            editOrganization: "Tashkilotni tahrirlash",
            addOrganization: "Tashkilotni qo'shing",
            addAddressDescription: "(ombor, do'kon yoki ofis manzili)",
            addAddress: "Omborni qo'shish",
            addresses: "Manzil",
            addContactPerson: "Bog‘lanish mumkin bo‘lgan shaxsni qo'shish",
            contactPersons: "Bog‘lanish mumkin bo‘lgan shaxs",
            extraPhone: "Qo'shim. raqam",
            add: "Qo'shish",
            save: "Saqlash"
        },
        RevokedBinding: {
            popover: {
                deleteLink: "Aloqani o'chirish",
                header: "Ombor egasi tomonidan \"Vaqt Oraliqlari\" xizmatidan uzilgan.",
            },
            timeslots: "\"Vaqt Oraliqlari\" "
        },
        AcceptedBinding: {
            popover: {
                writeToPartner: "Hamkorga yozish",
                showTimeslots: "Yuklashni ko'rish",
                address: "Ombor manzili",
                faq: "Xizmat haqida batafsil",
                header: "Ombor \"Vaqt Oraliqlari\"  xizmatiga ulangan",
            },
            timeslots: "\"Vaqt Oraliqlari\" "
        },
        UnbindTimeslots: {
            breakNotification: "Siz sherikingizning ombori bilan aloqani uzib qo'ydingiz.",
            breakQuestion: "Hamkorning ombori bilan aloqani uzasizmi?",
            dontBreak: "Aloqani uzmaslik",
            break: "Aloqani uzish",
            breakLink: "Aloqani uzish"
        },
        EntityRemovePopup: {
            dontDelete: "O'chirmaslik",
            delete: "O'chirish"
        },
        Entity: {
            edit: "O'zgartirish",
            remove: "O'chirish"
        },
        DepartmentsSelector: {
            selectedDepartments: "tanlangan bo'linmalarga",
            allDepartments: "barcha bo'linmalarga"
        },
        ContactEntity: {
            extraPhone: "Qo'shim. raqam"
        },
        AddressEntity: {
            shortCity: "y."
        },
        AddOrganizationContactPopup: {
            editContactPerson: "Bog‘lanish mumkin bo‘lgan shaxsni tahrirlash ",
            addContactPerson: "Bog‘lanish mumkin bo‘lgan shaxsni qo'shish",
            fullName: "FIO",
            extraPhone: "Qo'shim. raqam",
            phone: "Telefon",
            add: "Qo'shish",
            "save": "Saqlash"
        },
        AddOrganizationAddressPopup: {
            placeholderAddress: "tuman, ko'cha, uy",
            coordinates: "Koordinatalar",
            selectOnMap: "Xaritada tanlash",
            enter: "Kiritishni boshlash",
            addressWithoutCity: "Manzil (shaharsiz)",
            locality: "Aholi punkti",
            withoutContactPerson: "Bog‘lanish mumkin bo‘lgan shaxs yo'q",
            nothingFound: "Hech narsa topilmadi.",
            selectAddressContactPerson: "Bog‘lanish mumkin bo‘lgan shaxs manzilini tanlash",
            placeholderShedule: "Dushanba-Juma: soat 9:00 dan 20:00 gacha, shanba-yakshanba: dam olish kunlari",
            note: "Izoh",
            schedule: "Ish vaqti",
            type: "Turi",
            editAddress: "{{addressTypeName}} manzilini tahrirlash",
            addAddress: "{{addressTypeName}} manzilini qo‘shish",
            addContactPerson: "Bog‘lanish mumkin bo‘lgan shaxsni qo'shish",
            contactPerson: "Bog‘lanish mumkin bo‘lgan shaxs",
            add: "Qo'shish",
            save: "Saqlash"
        },
        AddEditCarPopup: {
            cancel: "Bekor qilish",
            semitrailer: "yarim tirkama",
            save: "Saqlash",
            trailer: "tirkama",
            tractor: "tyagach",
            truck: "yuk mashinasi",
            edit: "Tahrirlash",
            add: "Qo'shish",
            ts: "TV",
            description: {
                own_duplicate_error: "U allaqachon sizning Avtoparkingizda e'lon qilingan",
                duplicate_error: "U allaqachon boshqa ATI.SU ishtiroksiga tegishli sifatida ko'rsatilgan. Agarda bu hali ham sizning mashinangiz bo'lsa, vaqtincha \"Jalb qilingan TV\" katagiga belgi qo'ying, TVP yoki plastik skanerini ilova qiling va texnik yordamga murojaat qiling: Tiket yarating yoki 8 812 602-01-09 raqamiga ichki raqami 160 qo'ng'iroq qiling. Biz hamma narsani tuzatamiz."
            },
            header: {
                duplicate_error: "Siz mashinani o'zingizniki deb belgilay olmaysiz.",
                own_duplicate_error: "Transport vositasini qo'shish mumkin emas"
            }
        },
        CarPopupForm: {
            truck: "Yuk mashinasi",
            tractorWithSemitrailer: "Yarim tirkama bilan tyagach "
        },
        GeneralCarFormWrapper: {
            semitrailer: "yarim tirkama",
            trailer: "tirkama",
            tractor: "tyagach ",
            truck: "Yuk mashinasi",
            edit: "Tahrirlash",
            add: "Qo'shish"
        },
        GeneralCarForm: {
            semitrailer: "Yarim tirkama",
            trailer: "Tirkama",
            truck: "Yuk mashinasi",
            tractor: "Tyagach ",
            rentContactHintText: "Fotosurat yoki skanerlash",
            marriageHintText: "Guvohnomaning fotosurati yoki skaneri",
            documentHintText: "Ikki tomondan hujjatlarning fotosuratlari yoki skanerlari yoki elektron TVP",
            contractHintText: "Agar TVga egalik qilmasa",
            ownershipType: "TVga egalik qilish turi",
            required: "(majburiy)",
            uploadGratuitousContractScan: "Bepul foydalanish shartnomasini yuklab olish",
            uploadMarriageScan: "Nikohni ro'yxatdan o'tkazish to'g'risidagi guvohnoma yuklash",
            uploadPhotos: "TV rasmlarini yuklash",
            uploadLeasingContractScan: "Lizing shartnomasini yuklash",
            uploadRentContractScan: "Ijara shartnomasini yuklash",
            uploadPTSScanOrPlastic: "TVRoG va TVP yuklash",
            attractedCar: "Jalb qilingan TV",
            documentsHeader: "TVning hujjatlari "
        },
        TractorAdditionallyParams: {
            header: "Qo'shimcha",
            canCarryHeavyContainer: "og'ir konteynerlarni tashish mumkin",
            hasGenset: "Genset (o'rnatilgan generator)mavjud",
            canRefrigerator: "refregirator konteynerlarni tashish mumkin",
            externalId: 'Identifikator'
        },
        ShowInFirmInfo: {
            tooltipDisabled: "Kartochkada ko'rsatilishi uchun transport vositasi jalb qilinmagan bo'lishi kerak",
            tooltip: "Yuk egalari uchun nafaqat kompaniyaning obro'si, balki tashuvchida o'z transport parkining mavjudligi ham muhimdir",
            text: "ATI.SU Ishtirokchi Pasportingizda ko'rsatish "
        },
        ReserveByDriverBlock: {
            noAvailableDrivers: "Mavjud haydovchilar yo'q ",
            cancel: "Bekor qilish",
            select: "Tanlang...",
            addDriver: "Haydovchi qo'shish",
            reserve: "Haydovchiga biriktirish",
            reserveByDriver: "Haydovchini qo'shish va biriktirish"
        },
        CarSensors: {
            delete: "Oʻchirish",
            update: "O'zgartirish",
            addSensor: "Datchik qo'shish",
            helperText: "GPS/GLONASS datchiki",
            geoposition: "TVning geopozitsiyasi"
        },
        CarOwnershipType: {
            gratuitousUse: "bepul foydalanish",
            spousesJoint: "turmush o'rtoqlarning umumiy mulki",
            leasing: "lizing",
            rental: "ijara",
            hired: "Jalb qilingan TV",
            owned: "mulk",
            ownerName: "TVni ro'yxatdan o'tkazish guvohnomasiga ko'ra egasi",
            ownershipType: "Egalik turi"
        },
        CarInfo: {
            pts: "TVP seriyasi va raqami",
            vin: "VIN",
            vrcFull: "TVRoG seriyasi va raqami",
            manufactureYear: "Ishlab chiqarilgan yili",
            number: "Davlat raqami",
            noBrandText: "Bunday marka yo'q. Boshqasini kiriting.",
            vrc: "TVRoG",
            hasBodyNumber: "VIN yo'q",
            hasVin: "VIN bor",
            bodyNumber: "Kuzov",
            model: "Model",
            mark: "Marka",
            clear: "Tozalash",
            cancel: "Bekor Bekor qilish",
            exampleHint: {
                bodyNumber: "Kuzov / shassi raqami misoli",
                electronicPts: "Elektron TVP raqamining namunasi",
                pts: "TVP raqamining misoli",
                vin: "Vin misoli",
                vrc: "TVRoGraqamining namunasi",
            },
            description: {
                bodyNumber: "Transport vositasining pasportida, transport vositasini ro'yxatdan o'tkazish to'g'risidagi guvohnomada, \n\nkafolat/texnik ko'rik talonida yoki transport vositasining sug'urta polisida.Kuzovning yoki shassining ajralmas qismlarida va maxsus ishlab chiqarilgan davlat raqamlarida (belgilar).",
                pts: "Transport vositasining pasporti (TVP) – bu avtomobil uchun asosiy hujjatlardan biri bo'lib, unda avtomobilning texnik xususiyatlari, \n\negalari to'g'risidagi ma'lumotlar va transport vositasini ro'yxatdan o'tkazish/ro'yxatdan chiqarish to'g'risidagi ma'lumotlar mavjud.",
                vin: "Transport vositasining pasportida, transport vositasini ro'yxatdan o'tkazish to'g'risidagi guvohnomada, kafolat/texnik ko'rik talonida yoki transport vositasining sug'urta polisida.Kuzovning yoki shassining ajralmas qismlarida va maxsus ishlab chiqarilgan davlat raqamlarida (belgilar).",
                vrc: "Transport vositasini ro'yxatga olish guvohnomasi (TVRoG) avtomobil uchun asosiy hujjatlardan biridir. TVRoG Rossiya Federatsiyasi IIVning DYHXIning ro'yxatga olish idoralarida transport vositasi (avtomobil, mototsikl, tirkama va boshqalar) ro'yxatga olinganidan keyin beriladi. Hujjat «Gosznak» fabrikasida chop etilgan va laminatlangan va xavfsizlik darajalariga ega.",
            },
            header: {
                bodyNumber: "Kuzov/shassi raqamini qanday aniqlash mumkin",
                pts: "TVning pasporti qanday ko'rinishga ega",
                vin: "VINni qanday topish mumkin",
                vrc: "TVni ro'yxatdan o'tkazish guvohnomasi qanday ko'rinishga ega"
            },
        },
        CarDimensions: {
            fillDimensions: "To'g'ri gabaritlarni ko'rsating",
            height: "Balandligi, m",
            width: "Eni, m",
            length: "Uzunligi, m",
            internalDimensions: "Ichki gabaritlari"
        },
        CarBodySize: {
            capacity: "Yuk ko'tarish quvvati, t",
            meter: "m",
            volume: "Hajmi"
        },
        CarBody: {
            containerSizes: [
                "20' bittali",
                "20' platforma",
                "20' bittali + tirkama",
                "40 'platforma pol bilan ",
                "40 'polsiz platforma",
                "45 'platforma pol bilan ",
                "45 'polsiz platforma",
                "20' platforma tank uchun ",
                "40' platforma tank uchun ",
                "40 'ajraladigan platforma"
            ],
            dimension: "Konteyner o‘lchamligi",
            select: "Kuzov turi",
            body: "TVning xususiyatlari"
        },
        CanCarryTallContainers: {
            canCarryTallContainer: "Baland konteynerlarni tashish mumkin"
        }
    },
    "ru": {
        of: (count: number, total: number) => <>{count} из {total}</>,
        phoneWrong: "Введите номер в формате +7 (999) 999 99 99",
        extraDigits: "Проверьте номер ― в нём лишние цифры",
        missingDigits: "Проверьте номер ― в нём не хватает цифр",
        emailWrong: "Это не email. Проверьте, нет ли в нём опечаток",
        lessThanMinDate: "Дата должна быть не меньше {{minDate}}",
        notValidDepartmentCode: "Код подразделения должен быть в формате 000-000",
        onlyNumbers: "Можно вводить только цифры",
        choosePackageType: "Необходимо выбрать тип упаковки",
        notValidTrackNumber: "Трек-номер должен содержать только цифры, латинские буквы, символы . и -",
        notValidUrl: "Некорректный URL адрес",
        emptyCoordinates: "Выберите адрес из списка или укажите на карте",
        invalidDateString: "Некорректная дата",
        invalidTimeString: "Некорректное время",
        wrongRangeEnd: "Некорректный диапазон",
        wrongCheckSum: "Неверная контрольная сумма",
        symbols: {
            many: "символов",
            few: "символа",
            one: "символ",
        },
        numbers: {
            many: "цифр",
            few: "цифры",
            one: "цифра",
        },
        numberFromTo: "Введите число между {{from}} и {{to}}",
        symbolsRange: "Введите от {{from}} до {{to}} символов",
        enterPositiveNumber: "Введите положительное число",
        numberLessThen: "Значение не должно превышать ",
        korrSchetParams: "20 цифр — начиная с 301 и заканчивая 3 последними цифрами БИК",
        OKPOLength: "8 или 10 цифр",
        OKPOCheckNumber: "Неверное контрольное число",
        twentySymbolsNoSpaces: "20 цифр без пробелов",
        enterValue: "Это поле не должно быть пустым",
        selectValue: "Выберите значение",
        requiredDigits: "Необходимо ввести {{number}} цифр",
        fifteenDigits: "15 цифр",
        thirteenDigits: "13 цифр",
        datesNotInThePast: "Нельзя выбрать даты в прошлом",
        dateInTheFuture: "Нельзя выбрать дату в прошлом",
        dateInThePast: "Нельзя выбрать дату в будущем",
        isInvalidDate: "Недопустимая дата",
        invalidDateFormat: "Введите дату в формате ДД.ММ.ГГГГ",
        wrongPhoneNumber: "Недопустимый номер телефона",
        region: "Введите регион",
        carNumber: "Введите номер",
        lengthMessage: "символов",
        maxLengthMessage: "Макс. {{max}} символов",
        upToEightSymbols: "До 8 символов",
        sixSevenSymbols: "6-7 символов",
        sixDigits: "Шесть цифр",
        fourDigits: "Четыре цифры",
        notAfterCurrent: "Год не может быть больше {{currentYear}}",
        notBeforeMinYear: "Год не может быть меньше {{minYear}}",
        registrationNumber: "Регистрационный номер",
        egrpou: "ЕГРПОУ",
        unp: "УНП",
        inn: "ИНН",
        bin: "БИН",
        iin: "ИИН",
        // strings: {
        //     rateNds: "с НДС",
        //     rateWithoutNds: "без НДС",
        //     direct: "прям.дог.",
        //     torg: "торг.",
        //     payDays: "через {0} б/д",
        //     inFuel: "топл.",
        //     prepayAlone: "предопл.",
        //     prepay: "предопл. {0}%",
        //     onLoad: "на выгр.",
        //     onlyToSepCar: "отд.машина",
        //     dogruzPossible: "возм.догруз",
        //     dogruz: "догруз",
        //     sborgruz: "сборн.груз"
        // },
        duplicate_contractor_error: "Нельзя добавить контрагента. Он уже добавлен в ваш справочник.",
        unknown_error: "Неизвестная ошибка",
        json_validation_error: "Ошибка валидации json",
        partial_execution_error: "Возникла ошибка при создании связи, ТС сохранены",
        failed_save_trucks: "Некоторые ТС не удалось сохранить",
        failed_save_truck: "Не удалось сохранить ТС",
        customColumns: {
            historyBtn: "История груза",
            copyBtn: "Копировать",
            addCommentBtn: "Написать комментарий",
            map: "Карта",
            orderStatus: "Статус",
            completion: "Заверш.",
            date: "Дата",
            carrierContactPhone: "Номер конт. перевозчика",
            carrierContact: "Контакт перевозчика",
            carrier: "Перевозчик",
            cashRate: "Ставка нал.",
            rateWithoutVAT: "Ставка без НДС",
            rateWithVAT: "Ставка с НДС",
            offers: "Предлож.",
            contact: "Контакт",
            contactWithDate: "Контакт, добавлено/изм.",
            driver: "Водитель",
            car: "ТС",
            separateCar: "Отд. машина",
            loadingUnloadingCar: "Загр./выгр. ТС",
            bodyType: "Тип кузова",
            loadParams: "Параметры груза",
            unloading: "Разгрузка",
            loading: "Погрузка",
            routeAddress: "Адрес маршрута",
            route: "Маршрут",
            loadNumber: "Номер груза"
        },
        byDefault: "По умолчанию",
        columns: "Столбцы",
        informer: "Теперь вы можете настроить отображение данных\nв компактных карточках",
        verify: "Проверить",
        toTime: " по",
        fromTime: "с",
        dateInputPlaceHolder: "выберите дату",
        timeInputPlaceholder: '09:00',
        rate: "Ставка",
        unloading: "Разгрузка",
        loading: "Загрузка",
        loadParams: {
            __html: "Вес, т / объем, м<sup>3</sup>, груз"
        },
        transport: "Транспорт",
        direction: "Направл.",
        roundTheClock: "круглосуточно",
        workdays: "по раб. дням",
        everyday: "ежедн.",
        loadReady: "готов",
        alwaysReady: "постоянно",
        ExpandingSection: {
            showFullInfo: "Показать полностью"
        },
        "as-ui-kit/src/controls/DocumentBlock/strings": {
            "js/ru/previousVersion": "предыдущая редакция",
            "js/ru/forContragent": "Изменена контрагентом. До вашего подтвеждения действительна",
            "js/ru/forChanger": "До того как контрагент не подтвердит изменения, действует",
            "js/ru/transportationOrder": "Заявка на перевозку",
            "js/ru/sentToCounterparty": "Отправлено контрагенту",
            "js/ru/sentThroughAtiDocs": "Отправлено через АТИ.Доки",
            "js/ru/documentApprovedByTrucker": "Документ одобрен перевозчиком",
            "js/ru/documentApprovedByYou": "Документ одобрен вами",
            "js/ru/documentSignedByTrucker": "Документ подписан перевозчиком",
            "js/ru/documentSignedByYou": "Документ подписан вами",
            "js/ru/documentCreated": "Документ сформирован",
            "js/ru/awaitsReview": "Ожидает рассмотрения"
        },
        DealUpdateTime: {
            at: "в"
        },
        ConsultantsInfo: {
            workHours: "c 9 до 18 МСК",
            autoparkConsultants: "Поможем заполнить ваш автопарк",
            dealsConsultants: "Ответим на вопросы по Заказам"
        },
        CancelButton: {
            moveToArchive: "В архив"
        },
        "as-ui-kit/src/controls/AtiSelect/AtiSelect": {
            "jsx/strings/clearValue": "Очистить"
        },
        AtiCarNumberInput: {
            otherCountries: "Другие страны",
            russia: "Россия"
        },
        "as-ui-kit/src/controls/AtiCarNumberInput/AtiCarNumberInput": {
            "jsx/carPlaceholder": "М 123 ММ 78"
        },
        "as-ui-kit/src/controls/AddressCoordinatesInput/strings": {
            "js/ru/pickOnMap": "Выбрать на карте",
            "js/ru/clearAddress": "Очистить",
            "js/ru/addressNotFound": "Адрес не найден, попробуйте",
            "js/ru/pointOnMap": "Указать на карте",
            "en": {
                "js/DEFAULT_EXPORT/pickOnMap": "Выбрать на карте"
            }
        },
        "as-ui-kit/src/const/unilateralOrder": {
            "js/paymentTypesOptions/paymentTypes": {
                "cash/name": "Наличными",
                "cashlessWithNds/name": "С НДС, безнал",
                "cashlessWithoutNds/name": "Без НДС, безнал"
            }
        },
        weekDaysLowerShortList: [
            "вс",
            "пн",
            "вт",
            "ср",
            "чт",
            "пт",
            "сб",
        ],
        weekDaysShortList: [
            "Вс",
            "Пн",
            "Вт",
            "Ср",
            "Чт",
            "Пт",
            "Сб",
        ],
        timeStrings: {
            months: [
                "января",
                "февраля",
                "марта",
                "апреля",
                "мая",
                "июня",
                "июля",
                "августа",
                "сентября",
                "октября",
                "ноября",
                "декабря",
            ],
            shortMonths: [
                "янв",
                "фев",
                "мар",
                "апр",
                "мая",
                "июн",
                "июл",
                "авг",
                "сен",
                "окт",
                "ноя",
                "дек",
            ],
            year: "г.",
            h: "ч",
            d: "д",
            min: "мин",
            sec: "сек",
            tomorrow: "завтра",
            yesterday: "вчера",
            today: "сегодня",
            at: "в",
        },
        MonthList: [
            "Январь",
            "Февраль",
            "Март",
            "Апрель",
            "Май",
            "Июнь",
            "Июль",
            "Август",
            "Сентябрь",
            "Октябрь",
            "Ноябрь",
            "Декабрь",
        ],
        "as-ui-kit/src/const/sensors": {
            "js/errors/ru/errorCodes": {
                "AuthLimitError": "Отказано в доступе. Попробуйте повторить позднее",
                "BLError": "Произошла ошибка. Попробуйте повторить позднее"
            },
            "js/providers/scout/name": "Скаут",
            "js/providers/wialon/name": "Виалон"
        },
        "as-ui-kit/src/const/scans": {
            "js/scanTypeNames/ru/scanTypes": {
                "marriage": "Свидетельство о браке",
                "rentContract": "Договор аренды",
                "carPhoto": "Фото",
                "plasticTechPassport": "СТС",
                "techPassport": "ПТС",
                "passport": "Паспорт",
                "driverLicense": "ВУ"
            }
        },
        "as-ui-kit/src/const/requisites": {
            "js/defaultAddress/officeType": "оф.",
            "js/defaultAddress/partType": "корп.",
            "js/defaultAddress/houseType": "д.",
            "js/dictionaries/officeTypes/2/label": "помещение",
            "js/dictionaries/officeTypes/2/value": "пом.",
            "js/dictionaries/officeTypes/1/label": "квартира",
            "js/dictionaries/officeTypes/1/value": "кв.",
            "js/dictionaries/officeTypes/0/label": "офис",
            "js/dictionaries/officeTypes/0/value": "оф.",
            "js/dictionaries/partTypes/1/label": "строение",
            "js/dictionaries/partTypes/1/value": "стр.",
            "js/dictionaries/partTypes/0/label": "корпус",
            "js/dictionaries/partTypes/0/value": "корп.",
            "js/dictionaries/houseTypes/1/label": "строение",
            "js/dictionaries/houseTypes/1/value": "стр.",
            "js/dictionaries/houseTypes/0/label": "дом",
            "js/dictionaries/houseTypes/0/value": "д.",
            "js/dictionaries/streetTypes/13/label": "а/я",
            "js/dictionaries/streetTypes/12/label": "линия",
            "js/dictionaries/streetTypes/11/label": "тракт",
            "js/dictionaries/streetTypes/10/label": "канал",
            "js/dictionaries/streetTypes/9/label": "проезд",
            "js/dictionaries/streetTypes/8/label": "бульвар",
            "js/dictionaries/streetTypes/7/label": "аллея",
            "js/dictionaries/streetTypes/6/label": "площадь",
            "js/dictionaries/streetTypes/5/label": "набережная",
            "js/dictionaries/streetTypes/4/label": "переулок",
            "js/dictionaries/streetTypes/3/label": "шоссе",
            "js/dictionaries/streetTypes/2/label": "проспект",
            "js/dictionaries/streetTypes/1/label": "улица",
            "js/dictionaries/streetTypes/0/label": "(другое)",
            "js/dictionaries/residences/ru/4/label": "Другое",
            "js/dictionaries/residences/ru/3/label": "Казахстан",
            "js/dictionaries/residences/ru/2/label": "Беларусь",
            "js/dictionaries/residences/ru/1/label": "Украина",
            "js/dictionaries/residences/ru/0/label": "Россия"
        },
        "as-ui-kit/src/const/payDocs": {
            "js/mappedTransportCompanyNames/ru/1": "другая",
            "js/payDocsLabels/ru/ClosingDocuments": "Закрывающие",
            "js/payDocsLabels/ru/Payment": "Оплачено",
            "js/payDocsLabels/ru/DocumentsOriginalTrack": "Трек-номер",
            "js/payDocsLabels/ru/DocumentsOriginal": "Оригиналы",
            "js/payDocsLabels/ru/DocumentsCopies": "Копии",
            "js/payDocsName/ru/carrier/ClosingDocuments/name": "Получены закрывающие документы",
            "js/payDocsName/ru/carrier/Payment/name": "Получена оплата",
            "js/payDocsName/ru/carrier/DocumentsOriginal/name": "Отправлены оригиналы",
            "js/payDocsName/ru/carrier/DocumentsCopies/name": "Отправлены копии документов",
            "js/payDocsName/ru/cargoOwner/Payment/name": "Оплачено",
            "js/payDocsName/ru/cargoOwner/DocumentsOriginal/name": "Получены оригиналы",
            "js/payDocsName/ru/cargoOwner/DocumentsCopies/name": "Получены копии документов"
        },
        "as-ui-kit/src/const/index": {
            "js/undefinedError": "Неизвестная ошибка"
        },
        "as-ui-kit/src/const/files": {
            "js/fileSourceTypeNames/ru/dealFileSourceFileTypes": {
                "freeUse": "Договор безвозмездного пользования",
                "truckPhoto": "Фото",
                "truckPlasticTechPassport": "Пластик",
                "truckTechPassport": "ПТС",
                "driverPassport": "Паспорт",
                "driverLicense": "ВУ"
            },
            "js/fileSourceNames/ru/dealFileSourceTypes": {
                "tractor": "тягача",
                "semiTrailer": "полуприцепа",
                "trailer": "прицепа",
                "truck": "грузовика",
                "driver": "водителя"
            }
        },
        documentTypes: {
            poa: "доверенность",
            uniliteralDissolution: "уведомление об отказе от исполнения",
            invoice: "счет",
            act: "акт",
            commission: "поручение экспедитору",
            tableRequest: "заявка к договору (табличный вид)",
            request: "заявка (к договору)",
            order: "заказ",
            tableOrder: "заказ (табличный вид)",
            contract: "заказ (договор-заявка)"
        },
        displayedDocumentTypes: {
            commission: "Поручение экспедитору",
            request: "Заявка к договору",
            tableRequest: "Заявка к договору в табличном виде",
            order: "Заказ (договор-заявка)",
            tableOrder: "Заказ в табличном виде (договор-заявка)",
        },
        docTypesGroups: [
            "Впервые работаете с контрагентом",
            "Есть договор",
            "Работаете по договору транспортной экспедиции",
        ],
        additionalDocuments: {
            cancelDeal: "Уведомление об отказе от исполнения",
            poa: "Доверенность",
            invoice: "Счет по заявке",
            act: "Акт (двухсторонний)",
        },
        cancelDocuments: {
            refusalOfFulfilment: "Уведомление об отказе от исполнения",
        },
        "as-ui-kit/src/const/documents": {
            "js/docTypeTemplates/contract": "договор",
        },
        auctionPaymentTypes: {
            25: "без НДС",
            24: "с НДС",
            23: "на карту",
            1: "нал",
            0: "любой"
        },
        ton: "т",
        weight: "Вес",
        to: "до",
        from: "от",
        meter: "м",
        volume: "Объём",
        TruckIcon: {
            carInGratuitousUseVerifiedTooltip: "Подтвержденное ТС в безвозмездном пользовании",
            carInGratuitousUseTooltip: "ТС в безвозмездном пользовании",
            carInSousesJointOwnershipVerifiedTooltip: "Подтвержденное ТС в совместной собственности супругов",
            carInSousesJointOwnershipTooltip: "ТС в совместной собственности супругов",
            carExternalTooltip: "Привлечённое ТС",
            carOwnVerifiedTooltip: "Подтвержденное собственное ТС",
            carOwnTooltip: "Собственное ТС",
            carInLeasingVerifiedTooltip: "Подтвержденное ТС в лизинге",
            carInLeasingTooltip: "ТС в лизинге",
            carInRentVerifiedTooltip: "Подтвержденное ТС в аренде",
            carInRentTooltip: "ТС в аренде"
        },
        TrackerStatus: {
            promoAction: "Как это работает",
            promoHeader: "Теперь груз можно отслеживать\nна карте через приложение для\nводителя"
        },
        LastActive: {
            exclusivePopoverLinkText: " эксклюзивный доступ.",
            ago: "назад",
            activity: "активность",
            exclusiveAccess: "Эксклюзивный доступ у другой фирмы",
            installed: "установлен",
            hasTracker: "АТИ Водитель "
        },
        Invite: {
            car: {
                cantInviteTooltip: 'Приглашение можно выслать только на мобильный номер телефона. У водителя указан не мобильный. Телефон можно изменить в вашем Справочнике Водителей',
                tooManyRequests: "Слишком много попыток отправить приглашение. Попробуйте позже",
                toApp: "установить",
                invited: "Приглашение отправлено",
                invite: "Отправить приглашение",
                undefinedError: "Неизвестная ошибка",
                cantInvite: "Водителя из этого заказа нельзя пригласить в",
                alreadyInvited: "Вы уже отправляли приглашение этому водителю. Попробуйте позже",
                resend: "Пригласить повторно",
                atiTrucker: "АТИ Водитель"
            },
            driver: {
                                cantInviteTooltip: 'Приглашение можно выслать только на мобильный номер телефона. У водителя указан не мобильный. Телефон можно изменить в вашем Справочнике Водителей',

                tooManyRequests: "Слишком много попыток пригласить водителя. Попробуйте позже",
                toApp: "установить",
                invited: "Водитель приглашен",
                sent: "отправлено",
                invite: "Приглашение",
                inviteDriver: "Пригласить водителя",
                undefinedError: "Неизвестная ошибка",
                cantInvite: "Водителя из этого заказа нельзя пригласить в",
                alreadyInvited: "Вы уже отправляли приглашение этому водителю. Попробуйте позже",
                resend: "Пригласить повторно",
                atiTrucker: "АТИ Водитель"
            }
        },
        InvitePopover: {
            car: {
                exclusiveDescription:
                    'Только вы сможете отправлять\n' +
                    'заказы водителю, получать\n' +
                    'актуальные статусы перевозки,\n' +
                    'отслеживать местоположение\n' +
                    'груза на карте.',
                smsIsSent: "На номер телефона выслано смс",
                caption: "На номер телефона будет выслано смс со ссылкой\nна скачивание приложения",
                invite: "Отправить приглашение",
                exclusiveAccess: "Эксклюзивный доступ к его АТИ Водителю",
                onlyAndroid: "Приложение работает только на Android",
                sendSms: "Выслать смс",
                atiDriver: "АТИ Водитель"
            },
            driver: {
                exclusiveDescription:
                    'Только вы сможете отправлять\n' +
                    'заказы водителю, получать\n' +
                    'актуальные статусы перевозки,\n' +
                    'отслеживать местоположение\n' +
                    'груза на карте.',
                smsIsSent: "Водителю выслано смс",
                caption: "Водителю будет выслано смс со ссылкой\nна скачивание приложения",
                invite: "Пригласить водителя",
                exclusiveAccess: "Эксклюзивный доступ к его АТИ Водителю",
                onlyAndroid: "Приложение работает только на Android",
                sendSms: "Выслать смс",
                atiDriver: "АТИ Водитель"
            }
        },
        "as-ui-kit/src/components/TrackerLink/strings": {
            "js/ru/atiTrucker": "АТИ Водитель"
        },
        "as-ui-kit/src/components/TrackerIcon/strings": {
            "js/ru/howToUseTracker": "АТИ Водитель — как\nскачать и использовать"
        },
        "as-ui-kit/src/components/TrackerAppInfoPopover/strings": {
            "js/ru/trackerFeatures": "Возможности АТИ Водителя",
            "js/ru/atiTracker": "АТИ Водитель"
        },
        "as-ui-kit/src/components/Tabs/Tab/TabCounter/strings": {
            "js/ru/of": "из"
        },
        "as-ui-kit/src/components/Signee/Signee": {
            "jsx/strings/useByDefault": "Использовать по умолчанию",
            "jsx/strings/signee": "Подписант",
            "jsx/strings/remove": "удалить",
            "jsx/strings/positionInGenitive": "Должность в родительном падеже",
            "jsx/strings/fullNameInGenitive": "ФИО в родительном падеже",
            "jsx/strings/actUponWhatText": "На основании чего действует. Например: \"Устава...\", \"Доверенности №...\""
        },
        ShortFirmInfo: {
            recommend: "Рекомендовать"
        },
        "as-ui-kit/src/components/SensorActivateLink/strings": {
            "js/ru/reauthorizationRequired": "Требуется повторная авторизация",
            "js/ru/inactive": "Неактивен"
        },
        "as-ui-kit/src/components/SearchLoad/strings": {
            "js/ru/unloading": "Разгрузка",
            "js/ru/loading": "Загрузка",
            "js/ru/loadParams/__html": "Вес, т / объем, м<sup>3</sup>, груз",
            "js/ru/transport": "Транспорт",
            "js/ru/direction": "Направл."
        },
        "as-ui-kit/src/components/SearchLoad/SearchLoadParams/strings": {
            "js/ru/widthShort": "Ш",
            "js/ru/sborgruz": "сборн.груз",
            "js/ru/onlyToSepCar": "отд.машина",
            "js/ru/meters": "м",
            "js/ru/load": "Груз ",
            "js/ru/lengthShort": "Д",
            "js/ru/items": "шт.",
            "js/ru/heightShort": "В",
            "js/ru/dogruzPossible": "возм.догруз",
            "js/ru/dogruz": "догруз"
        },
        "as-ui-kit/src/components/SearchLoad/LoadUnloading/RouteThrough/strings": {
            "js/ru/through": "ехать через:"
        },
        "as-ui-kit/src/components/SearchLoad/LoadUnloading/CustomsOnRoute/strings": {
            "js/ru/custom": "таможня:"
        },
        "as-ui-kit/src/components/SearchLoad/LoadTransport/strings": {
            "js/ru/capacity": "г/п {{number}} т,",
            "js/ru/onlyToSepCar": "отд.машина.",
            "js/ru/dogruzPossible": "возм.догруз.",
            "js/ru/dogruz": "догруз.",
            "js/ru/beltOther": "ремней",
            "js/ru/beltMany": "ремней",
            "js/ru/beltFew": "ремня",
            "js/ru/beltOne": "ремень",
            "js/ru/sanPassport": "медкнижка",
            "js/ru/loadUnload": "загр/выгр",
            "js/ru/unload": "выгр",
            "js/ru/load": "загр",
            "js/ru/pnevmohod": "пневмо",
            "js/ru/stsepka": "сцепка",
            "js/ru/koniki": "коники",
            "js/ru/cars": "маш."
        },
        "as-ui-kit/src/components/SearchLoad/LoadRate/strings": {
            "js/ru/allTermsInATIDocs": "все условия в заявке в АТИ-Доках",
            "js/ru/cashlessAll": "безнал c НДС, без НДС",
            "js/ru/cashlessWithoutVat": "безнал без НДС",
            "js/ru/cashlessWithVat": "безнал c НДС",
            "js/ru/cash": "наличные",
            "js/ru/bargainOff": "без торга",
            "js/ru/undefined": "с НДС",
            "js/ru/direct": "прям.дог.",
            "js/ru/bargainOn": "торг.",
            "js/ru/payDays": "через {0} б/д",
            "js/ru/prepayAlone": "предопл.",
            "js/ru/inFuel": "топл.",
            "js/ru/prepay": "предопл. {0}%",
            "js/ru/onLoad": "на выгр.",
            "js/ru/inquireLoad": "запрос ставки",
            "js/ru/noLoad": "груза нет, запрос ставки"
        },
        "as-ui-kit/src/components/SearchLoad/LoadDirection/strings": {
            "js/ru/km": "км",
            "js/ru/seePath": "посмотреть маршрут",
            "js/ru/krugoreis": "кругорейс"
        },
        cardsCompact: "Компактный вид карточек",
        cards: "Обычный вид карточек",
        appearance: "Вид",
        RejectOrder: {
            restoreLot: "Лот будет опубликован заново на тех же площадках.",
            restoreLoad: "восстановить груз",
            toArchive: "в Архив",
            move: "перенести\n",
            cancelDeals: ", Торги отменить",
            inArchive: "в Архиве",
            leftLoad: "оставить груз\n",
            publicLoadWithoutDeal: "выставить груз без Торгов",
            restartDeal: "перезапустить Торги",
            rubles: "\nрублей",
            withRate: "\nсо ставкой\n",
            chooseWinner: "выбрать победителем\n",
            noReasonWarning: "Укажите причину отмены",
            reasonRejectionOffer: "Укажите причину отмены предложения",
            whatHappenedWithLoads: "Что сделать с грузом",
            popoverWarning: "Заказ будет перемещён в архив и отмечен как отменённый"
        },
        "as-ui-kit/src/components/PopupWarning/strings": {
            "js/ru/notToSave": "Не сохранять",
            "js/ru/save": "Сохранить",
            "js/ru/edit": "Редактировать",
            "js/ru/p2": "Изменения могут быть потеряны.",
            "js/ru/p1": "Вы не сохранили изменения и пытаетесь закрыть окно.",
            "js/ru/header": "Что делать с изменениями?"
        },
        Selected: {
            showAll: "Показать полностью"
        },
        "as-ui-kit/src/components/PhoneForm/strings": {
            "js/ru/phoneInCar": "Мобильное устройство, установленное\nв транспортном средстве",
            "js/ru/exclusiveAccess": "Эксклюзивный доступ к его АТИ Водителю",
            "js/ru/phone": "Телефон"
        },
        "as-ui-kit/src/components/PhoneForm/TrackerInfo/strings": {
            "js/ru/promo": "Укажите мобильный телефон, чтобы выслать ссылку на приложение",
            "js/ru/invitedHint": "будет выслано смс со ссылкой",
            "js/ru/atiTrucker": "АТИ Водитель"
        },
        "as-ui-kit/src/components/PhoneForm/TrackerInfo/BindOwn/strings": {
            "js/ru/bindingTypes": {
                "driver": "к Водителю",
                "car": "к ТС"
            },
            "js/ru/goToAutopark": "Перейти в Автопарк",
            "js/ru/goToCatalog": "Перейти в Справочник",
            "js/ru/alreadyAttached": "Этот номер уже привязан в приложении"
        },
        "as-ui-kit/src/components/PhoneForm/TrackerInfo/BindOther/strings": {
            "js/ru/carFromAnother": "Вы не можете привязать ТС к приложению [[AppLink]][[Break]]потому что оно привязано к фирме",
            "js/ru/employedToAnotherFirm": "Вы не можете отправлять заказы этому водителю через[[Break]][[AppLink]], потому что он является сотрудником фирмы",
            "js/ru/atiTrucker": "АТИ Водитель"
        },
        "as-ui-kit/src/components/PhoneForm/BindingStatus/strings": {
            "js/ru/resend": "Отправить заново",
            "js/ru/driverRejected": "Запрос отклонен",
            "js/ru/cancel": "Отменить",
            "js/ru/sent": "Запрос отправлен",
            "js/ru/sendRequest": "Отправить запрос"
        },
        PayDocsStatus: {
            infoTextForCargoOwner:
                'Перевозчик может добавить трек-номер \nотправленных документов прямо к Заказу.\n' +
                'Вы получите уведомление, добавится статус \nв разделе «Документооборот и оплата», после чего \nвы сможете отслеживать посылку на сайте Службы \nдоставки.',
            trackNotExist: "Трек-номер не указан",
            learnMore: "Узнать подробнее",
            carrierTrack: "Трек-номер посылки от Перевозчика",
            addTrackNumber: "Добавить трек-номер (номер отслеживания)\n для отправления",
            choosePaymentStatus: "Выберите статус ДО и оплаты",
            tooltipText: "После того как вы добавите трек-номер\nЗаказчик получит уведомление \nи сможет отслеживать отправление\nна сайте службы доставки.",
            availableToCustomer: "(доступен Заказчику)",
            trackNumber: "трек-номер",
            status: "статус",
            paymentStatusHint: "(виден только вам)",
            paymentStatus: "Документооборот и оплата"
        },
        "as-ui-kit/src/components/PayDocsStatus/StatusLabel/strings": {
            "js/ru/changeTrackNumber": "Изменить трек-номер (номер отслеживания)\n для отправления",
            "js/ru/cancelDelete": "Не удалять",
            "js/ru/delete": "Удалить",
            "js/ru/deleteTrackNumber": "Удалить трек-номер\nбезвозвратно?",
            "js/ru/defaultCompanyName": "службы доставки",
            "js/ru/ofCompany": "компании ",
            "js/ru/trackInWebsite": "Отслеживать на сайте ",
            "js/ru/trackNumberCopied": "Трек-номер скопирован",
            "js/ru/header": "Трек-номер",
            "js/ru/trackNumber": "трек-номер"
        },
        "as-ui-kit/src/components/PayDocsStatus/PayDocTrackPopover/strings": {
            "js/ru/trackNotExist": "Трек-номер не указан",
            "js/ru/learnMore": "Узнать подробнее",
            "js/ru/carrierTrack": "Трек-номер посылки от Перевозчика",
            "js/ru/trackNumberForShipment": "трек-номер (номер отслеживания)\n для отправления",
            "js/ru/trackNumber": "трек-номер",
            "js/ru/change": "Изменить",
            "js/ru/add": "Добавить"
        },
        "as-ui-kit/src/components/PayDocsStatus/ChooseStatusForm/StatusFormRow/strings": {
            "js/ru/availableToCustomer": "(доступен Заказчику)",
            "js/ru/tooltipText": "После того как вы добавите трек-номер\nЗаказчик получит уведомление \nи сможет отслеживать отправление\nна сайте службы доставки.",
            "js/ru/trackNumber": "трек-номер",
            "js/ru/addTrackNumber": "Добавить трек-номер",
            "js/ru/chooseDate": "выберите дату"
        },
        cancel: "Отмена",
        "as-ui-kit/src/components/PayDocsStatus/ChooseStatusForm/StatusFormFooter/strings": {
            "js/ru/finishOfferRequestError": "Возникла ошибка при завершении перевозки.",
            "js/ru/saveAndArchive": "В архив",
            "js/ru/save": "Сохранить"
        },
        "as-ui-kit/src/components/PayDocsStatus/ChangeTrackForm/TrackFormRow/strings": {
            "js/ru/chooseDate": "Выберите дату",
            "js/ru/sendDate": "Дата отправки",
            "js/ru/inputError": "Трек-номер должен содержать только цифры и латинские буквы",
            "js/ru/trackNumber": "Трек-номер",
            "js/ru/trackUrl": "Ссылка на сайт службы доставки",
            "js/ru/chooseTransportCompany": "Выберите службу доставки",
            "js/ru/transportCompany": "Служба доставки",
            "js/ru/body": "После того как вы добавите трек-номер Заказчик получит\n уведомление и сможет отслеживать отправление на сайте\n службы доставки."
        },
        "as-ui-kit/src/components/PayDocsStatus/ChangeTrackForm/TrackFormFooter/strings": {
            "js/ru/cantSaveForm": "Вы не можете сохранить трек-номер, \nпока не заполнены все обязательные поля",
            "js/ru/delete": "Удалить трек-номер",
            "js/ru/save": "Сохранить",
            "js/ru/cancel": "Не добавлять",
            "js/ru/add": "Добавить трек-номер"
        },
        "as-ui-kit/src/components/PayDocsStatus/ChangeTrackForm/TrackFormFooter/ConfirmDeletePopover/strings": {
            "js/ru/dontDelete": "Не удалять",
            "js/ru/delete": "Удалить",
            "js/ru/confirmDelete": "Удалить трек-номер безвозвратно?"
        },
        ParticipantsPopup: {
            noPermissionsText: "Работа с грузом осуществляется только сотрудниками с доступом к подразделению груза",
            anotherPtWinner: "Победил другой участник сквозных Торгов",
            update: "Обновить",
            noWinners2: "Отмените Торги и запустите заново",
            noWinners1: "Нет победителей.",
            winnerRemovedFromBoard2: "Выберите другого",
            winnerRemovedFromBoard1: "Победитель удалён с Площадки.",
            winnerTimeExpiredNoNext2: "или начать Торги заново",
            winnerTimeExpired2: "или выбрать следующего участника",
            waitForWinner: "Вы можете дождаться данных от победителя",
            finished: "Торги завершены.",
            untilEnd: " до конца Торгов.",
            startRate: "начальная ставка.",
            participants: {
                other: "участников",
                many: "участников",
                few: "участника",
                one: "участник"
            },
            noParticipants: "Нет участников",
            Participant: {
                atrucksTooltip: "Сторонняя система для автоматизации работы с транспортными компаниями",
                ptParticipant: "Участник сквозных Торгов",
                tooltipRate: "Участник сделал ставку",
                bestRateAndDate: "Лучшие ставка и дата",
                bestDate: "Лучшая дата",
                bestRate: "Лучшая ставка",
                or: " или ",
                noAccessText: "У вас нет прав на выполнение этой операции. Обратитесь к администратору для получения прав",
                at: "в",
                yearStr: "г.",
                shouldSend: ["Победитель должен предоставить вам данные для заявки в течение ", ""],
                dontSend: "Победитель ещё не предоставил вам данные для заявки.",
                winnerConfirmed2: "заказах",
                winnerConfirmed1: "Победитель взял груз. Посмотрите данные о водителе и ТС в ",
                exWinner: "Вы отклонили предложение этого участника",
                shipperRefused: "Заказ отклонен грузовладельцем",
                carrierRefused: "Перевозчик отказался от участия в Заказе",
                refused: "Участник отказался от участия в Торгах.",
                skipped: "Не предоставил данные вовремя.",
                winnerRemovedFromBoard: "Победитель удалён с Площадки.",
                removedFromBoard: "Участник удалён с Площадки.",
            },
        },
        loadingDate: "Готов",
        participant: "Участник",
        outputStrings: "Выводить строк",
        "as-ui-kit/src/components/PaginationBlock/Pagination/strings": {
            "js/ru/from": "из"
        },
        orderLoadNumber: "№ груза/лота/заказа",
        orderNumber: "№ Заказа",
        "as-ui-kit/src/components/OfferTracker/TrackerSummary/LinkToRouteOnMap/strings": {
            "js/ru/routeOnMap": "Маршрут на карте"
        },
        "as-ui-kit/src/components/OfferTracker/TrackerSummary/FinishedStatusView/strings": {
            "js/ru/eventDateTime": "{{day}} в {{time}}",
            "js/ru/driverRevoked": "Водителя отозвали с заказа",
            "js/ru/driverRejectedDeal": "Водитель отказался от заказа",
            "js/ru/driverFinishedDeal": "Водитель завершил заказ",
            "js/ru/cancelledDeal": "отменил заказ",
            "js/ru/finishedDeal": "завершил заказ"
        },
        "as-ui-kit/src/components/OfferTracker/TrackerSummary/Accidents/strings": {
            "js/ru/4": "не было данных",
            "js/ru/3": "часть маршрута с выключенным GPS",
            "js/ru/2": "поломка",
            "js/ru/1": "ДТП",
            "js/ru/0": "попытка подделки GPS"
        },
        "as-ui-kit/src/components/OfferTracker/TrackerInWorkStatus/strings": {
            "js/ru/driverWillSendDataFromApp": "Водитель взял заказ, но еще не начал работать по нему",
            "js/ru/from": "из",
            "js/ru/ed": "изм.",
            "js/ru/fromApp": "из приложения АТИ Водитель"
        },
        "as-ui-kit/src/components/OfferTracker/TooltipMessage/strings": {
            "js/ru/gpsSpoof": "в телефоне водителя\nвключена функция, позволяющая\nподделать GPS ({{initialPhone}}).",
            "js/ru/gpsOff": "выключен GPS в настройках\nтелефона водителя ({{initialPhone}}).\nДанных о местоположении нет.",
            "js/ru/noData": "перестали приходить данные.\nВозможно, телефон водителя выключен или не\nподключен к интернету ({{initialPhone}}).",
            "js/ru/youAndOwner": "вам и заказчику",
            "js/ru/onlyYou": "только вашей фирме",
            "js/ru/rejectionInfoAvailable": "Информация об\nотказе доступна",
            "js/ru/infoAvailable": "Информация доступна",
            "js/ru/dataAvailable": "Карта и\nстатус заказа из приложения доступны",
            "js/ru/activity": "Активность {{lastActive}} в приложении\nАТИ Водитель ({{initialPhone}})."
        },
        "as-ui-kit/src/components/OfferTracker/StatusDescriptions/strings": {
            "js/ru/notConfirmed": "Водитель не подтвердил получение заказа в приложении",
            "js/ru/finishedByCounterpart": "[[FirmName]] завершил заказ",
            "js/ru/finished": "Водитель завершил заказ",
            "js/ru/revoked": "Вы отозвали заказ",
            "js/ru/notSentDataExpected": "Укажите данные для перевозки,\nчтобы отправить заказ водителю",
            "js/ru/notSent": "Данные для водителя\nне указаны",
            "js/ru/rejectionReason": "причина отказа",
            "js/ru/rejected": "Водитель отказался от заказа",
            "js/ru/sent": "Заказ отправлен на [[DriverPhone]]\nВодитель еще не взял заказ в работу",
            "js/ru/sentShort": "Заказ отправлен на",
            "js/ru/sendToSeeOnMap": "Отправьте заказ в приложение,\nчтобы видеть груз на карте",
            "js/ru/awaitingDriver": "Ждем, пока водитель начнет заказ",
            "js/ru/carrierRevoked": "Перевозчик отозвал заказ\nу водителя. Новых данных пока нет"
        },
        "as-ui-kit/src/components/OfferTracker/StatusBadge/strings": {
            "js/ru/gpsSpoof": "подделка GPS",
            "js/ru/gpsOff": "выключен GPS",
            "js/ru/finished": "заказ завершен",
            "js/ru/revoked": "заказ отозван",
            "js/ru/rejected": "отказ от заказа",
            "js/ru/notInWork": "не в работе",
            "js/ru/inWork": "в работе",
            "js/ru/sent": "заказ отправлен",
            "js/ru/notSent": "заказ не отправлен",
            "js/ru/noData": "нет данных",
            "js/ru/atiTrucker": "АТИ Водитель"
        },
        "as-ui-kit/src/components/OfferTracker/StateWithoutDriver/strings": {
            "js/ru/toWatchCargoOnMap": ", чтобы видеть груз на карте",
            "js/ru/inAtiDriver": "в АТИ-Водитель",
            "js/ru/addDriverInOrder": "Добавьте водителя в заказ и пригласите его\n ",
            "js/ru/addDriver": "Добавьте в заказ водителя и отправьте ему приглашение "
        },
        "as-ui-kit/src/components/OfferTracker/PresenceLoading/strings": {
            "js/ru/loading": "загружаем данные...",
            "js/ru/hasTracker": "АТИ Водитель"
        },
        "as-ui-kit/src/components/OfferTracker/NoTrackerAccess/strings": {
            "js/ru/atiTrucker": "АТИ Водитель"
        },
        "as-ui-kit/src/components/OfferTracker/NoInWorkAccess/strings": {
            "js/ru/carrierReceivesFromApp": "Перевозчик получает статусы из приложения АТИ Водитель",
            "js/ru/changingStatuses": "Смена статусов недоступна"
        },
        "as-ui-kit/src/components/OfferTracker/MapActionsContainer/strings": {
            "js/ru/dialogDescription": "АТИ Водитель",
            "js/ru/chat": "Чат",
            "js/ru/shareLinkDescription": "поделиться ссылкой",
            "js/ru/shareLink": "Поделиться ссылкой",
            "js/ru/sharedWithCounterpartyDescription": "видна вам и заказчику",
            "js/ru/onlyForYouDescription": "видна только вам",
            "js/ru/sharedWithCounterparty": "Видна вам и заказчику",
            "js/ru/onlyForYou": "Видна только вам",
            "js/ru/map": "Карта"
        },
        "as-ui-kit/src/components/OfferTracker/MainActions/strings": {
            "js/ru/revokeData": "Отозвать заказ",
            "js/ru/dataForDriver": "Данные для водителя",
            "js/ru/configure": "Настроить",
            "js/ru/resendOrder": "Отправить повторно",
            "js/ru/sendOrder": "Отправить заказ",
            "js/ru/setData": "Указать данные"
        },
        ActionsButtons: {
            dialogDescription: "АТИ Водитель",
            chat: "Чат",
            shareLink: "Поделиться ссылкой",
            sharedWithCounterpartyDescription: "видна вам и заказчику",
            onlyForYouDescription: "видна только вам",
            sharedWithCounterparty: "Видна вам и заказчику",
            onlyForYou: "Видна только вам",
            map: "Карта"
        },
        InDevelopmentButton: {
            inDev: "В разработке"
        },
        OfferInformationDriver: {
            willProvideDataLater: "Укажу данные позже",
            fromDealModifier: "(из сделки)",
            registration: "Регистрация",
            seriesNumber: "Серия, номер",
            selectDriver: "Выберите водителя",
            searchDrivers: "Поиск по водителям",
            driverLicense: "Водительское удостоверение",
            passportIssuedWhen: "Дата выдачи",
            passportIssued: "Выдан",
            passportNumber: "Номер",
            passportSeries: "Серия",
            passport: "Паспорт",
            enlistedDriver: "привлечённый водитель",
            enlisted: "привлечённый",
            edit: "Редактировать",
            driverNotFound: "Водитель не найден",
            driver: "Водитель",
            clickToAddDriver: "Нажмите, чтобы добавить нового",
            addDriver: "Добавить водителя"
        },
        UseTrackerCheck: {
            fromTracker: "из АТИ Водителя",
            shareData: "Делиться с заказчиком данными"
        },
        OfferInformationDriverFooter: {
            editHint: " чтобы отправлять заказы этому водителю в АТИ Водитель",
            editHintLink: "Укажите номер моб. телефона",
            willNotShare: "карта и статус заказа из АТИ Водителя доступны только вам",
            willShare: "вы делитесь с заказчиком картой и статусом из АТИ Водителя",
            nlistedDriver: "привлечённый водитель"
        },
        TrackerSharing: {
            howTrackerWorks: "Как работает АТИ Водитель",
            youWillSee: "Вы сможете видеть груз на карте и актуальный статус заказа.",
            carrierWillShare: "Перевозчик будет делиться данными из АТИ Водителя"
        },
        OfferInformationCar: {
            willProvideDataLater: "Укажу данные позже",
            fromDealTip: "из Заказа",
            fromDealModifier: "(из сделки)",
            remove: "Убрать",
            unknownCarType: "неизвестный тип кузова",
            vehicle: "ТС",
            clickToAddVehicle: "Нажмите, чтобы добавить новую",
            vehicleNotFound: "Машина не найдена",
            edit: "Редактировать",
            chooseSemiTrailer: "Выберите полуприцеп",
            chooseTrailer: "Выберите прицеп",
            chooseVehicle: "Выберите ТС",
            searchVehicles: "Поиск по ТС",
            addVehicle: "Добавить ТС",
            addSemiTrailer: "Добавить полуприцеп",
            addTrailer: "Добавить прицеп",
            addTruck: "Добавить грузовик",
            carTypeNames: {
                trailer: "Прицеп",
                semitrailer: "Полуприцеп",
                tractor: "Тягач",
                truck: "Грузовик"
            }
        },
        Contractors: {
            readMoreLink: {
                text: "Подробнее о справочнике",
            },
            button: "Добавить контрагента",
            header: "Ваши контрагенты",
        },
        Organizations: {
            readMoreLink: {
                text: "Подробнее о справочнике",
            },
            narrow: {
                text: [
                    "И подставляйте их в документы, когда оформляете заказ через сайт",
                ]
            },
            button: "Добавить организацию",
            header: "Добавьте данные своей организации и тех, с кем часто работаете",
        },
        Drivers: {
            readMoreLink: {
                text: "Подробнее о справочнике",
            },
            button: "Добавить водителя",
            header: "Добавьте водителя",
        },
        Transport: {
            readMoreLink: {
                text: "Подробнее о справочнике",
            },
            header: "Добавьте транспорт",
        },
        CompletedItems: {
            wide: {
                header: "Заказ",
                text: [
                    "Договаривайтесь о перевозке за несколько шагов — через сайт ATI.SU. Оформление Заказа возможно, если грузоотправитель предлагает вам груз на Площадке или в личном приглашении.",
                    "Вы узнаете такой груз по кнопке «Взять груз». Как только вы её нажмёте, груз ваш. Сайт сам составит договор заявку, вам останется её подписать.",
                ],
            },
            button: "Узнать подробнее",
            header: "Здесь сохранятся грузы, которые прошли по Заказам",
        },
        Completed: {
            wide: {
                header: "Заказ",
                text: [
                    "Договаривайтесь о перевозке за несколько шагов — через сайт ATI.SU. Оформление Заказа возможно, если грузоотправитель предлагает вам груз на Площадке или в личном приглашении.",
                    "Вы узнаете такой груз по кнопке «Взять груз». Как только вы её нажмёте, груз ваш. Сайт сам составит договор заявку, вам останется её подписать.",
                ],
            },
            button: "Узнать подробнее",
            header: "Здесь сохранятся грузы, которые прошли по Заказам",
        },
        Payments: {
            wide: {
                header: "Заказ",
                text: [
                    "Договаривайтесь о перевозке за несколько шагов — через сайт ATI.SU. Оформление Заказа возможно, если грузоотправитель предлагает вам груз на Площадке или в личном приглашении.",
                    "Вы узнаете такой груз по кнопке «Взять груз». Как только вы её нажмёте, груз ваш. Сайт сам составит договор заявку, вам останется её подписать.",
                ],
            },
            text: [
                "Вы сможете отслеживать когда отправлены и получены документы и оплата по Заказу.",
            ],
            button: "Узнать подробнее",
            header: "Здесь будут статусы оплаты и движения документов",
        },
        InProgressItems: {
            wide: {
                header: "Заказ",
                text: [
                    "Договаривайтесь о перевозке за несколько шагов — через сайт ATI.SU. Оформление Заказа возможно, если грузоотправитель предлагает вам груз на Площадке или в личном приглашении.",
                    "Вы узнаете такой груз по кнопке «Взять груз». Как только вы её нажмёте, груз ваш. Сайт сам составит договор заявку, вам останется её подписать.",
                ],
            },
            text: [
                "Это грузы, оформленные по Заказам, по которым заявка подписана, а груз ожидает перевозки или уже в пути.",
            ],
            button: "Узнать подробнее",
            header: "Здесь будут грузы в работе",
        },
        InProgress: {
            wide: {
                header: "Заказ",
                text: [
                    "Договаривайтесь о перевозке за несколько шагов — через сайт ATI.SU. Оформление Заказа возможно, если грузоотправитель предлагает вам груз на Площадке или в личном приглашении.",
                    "Вы узнаете такой груз по кнопке «Взять груз». Как только вы её нажмёте, груз ваш. Сайт сам составит договор заявку, вам останется её подписать.",
                ],
            },
            text: [
                "Это грузы, оформленные по Заказам, по которым заявка подписана, а груз ожидает перевозки или уже в пути.",
            ],
            button: "Узнать подробнее",
            header: "Здесь будут грузы в работе",
        },
        ReconciliationItems: {
            wide: {
                header: "Заказ",
                text: [
                    "Договаривайтесь о перевозке за несколько шагов — через сайт ATI.SU. Оформление Заказа возможно, если грузоотправитель предлагает вам груз на Площадке или в личном приглашении.",
                    "Вы узнаете такой груз по кнопке «Взять груз». Как только вы её нажмёте, груз ваш. Сайт сам составит договор заявку, вам останется её подписать.",
                ],
            },
            text: [
                "Это грузы, которые перевозчики возьмут по Заказам, но ещё не подпишут договор-заявку.",
            ],
            button: "Узнать подробнее",
            header: "Здесь будут грузы на согласовании",
        },
        Reconciliation: {
            wide: {
                header: "Заказ",
                text: [
                    "Договаривайтесь о перевозке за несколько шагов — через сайт ATI.SU. Оформление Заказа возможно, если грузоотправитель предлагает вам груз на Площадке или в личном приглашении.",
                    "Вы узнаете такой груз по кнопке «Взять груз». Как только вы её нажмёте, груз ваш. Сайт сам составит договор заявку, вам останется её подписать.",
                ],
            },
            text: [
                "Это грузы, которые вы возьмёте по Заказам, но ещё не подпишете договор-заявку.",
            ],
            button: "Узнать подробнее",
            header: "Здесь будут грузы на согласовании",
        },
        archive: {
            narrow: {
                text: [
                    "Здесь будут отображаться грузы, которые сейчас не публикуются на сайте",
                ],
            },
            button: "Добавить груз",
            header: "Архив грузов пуст",
        },
        published: {
            actions: {
                restore: "восстановите из архива",
                add: "Добавьте их или ",
            },
            button: "Добавить груз",
            header: "Здесь будут ваши грузы",
        },
        noAccessToAddingLoadText: "У вас нет прав на добавление груза. Обратитесь к администратору для получения прав.",
        noFilteredLoads: "В списке нет таких грузов. Попробуйте сбросить фильтр или поискать по другим параметрам",
        clearFilter: "Сбросить фильтр",
        trailer: "Прицеп",
        semitrailer: "Полуприцеп",
        tractor: "Тягач",
        truck: "Грузовик",
        add: "Добавить",
        notFound: "Не найдено",
        // "en": {
        //     "js/DEFAULT_EXPORT/Organizations/header": "Добавьте данные своей организации и тех, с кем часто работаете"
        // },
        pressToCalculate: "Нажмите, чтобы рассчитать.",
        insureLoadAndGetCashback: "Застрахуйте груз и получите кешбэк от 5%.",
        insureLoad: "Застраховать груз",
        LoadFiles: {
            otherDocuments: "документов",
            oneDocument: "документ",
            manyDocuments: "документов",
            fewDocuments: "документа"
        },
        LargeCities: {
            km: "км",
            bkg: "ближ. крупные города"
        },
        InviteButton: {
            invite: "Пригласить"
        },
        LimitsPopover: {
            orders: {
                other: "заказов",
                many: "заказов",
                few: "заказа",
                one: "заказ",
            },
            doNotInvite: "Не приглашать",
            invite: "Пригласить",
            doInviteCarrier: "Пригласите перевозчика, если вы хотите, чтобы он взял заказ несмотря на лимит.",
            editInCatalogs: "Редактировать в справочнике",
            max: "макс.",
            youSetLimit: "Вы установили лимит на одновременное количество заказов в работе:",
            title: "Достигнут лимит на заказы"
        },
        insuranceConditions: "Условия страхования",
        promoText: "Застрахуйте груз, чтобы получить компенсацию за утрату, повреждение или порчу груза по любой случайной причине.",
        InWorkStatusSelect: {
            visibleForOwnerControlledFromTracker: "Статус виден вам и перевозчику.\nСтатус может менять только водитель.",
            youAndOwner: "Статус виден вам и заказчику. Статус\nможет менять только водитель.",
            onlyYou: "Статус виден только вашей фирме.\nСтатус может менять только водитель.",
            ownerInfo: "Статус виден вам и перевозчику",
            info: "Статус виден вам и заказчику",
            noStatus: "Нет статуса",
            placeholder: "Выберите статус"
        },
        ImagesUploader: {
            carsPhotos: "Фотографии ТС"
        },
        HistoryPopup: {
            load: "Груз #",
            emptyHistory: "По этому грузу не было Заказов, Торгов (аукционов) и встречных предложений",
            actionColumnName: "Действие",
            timeColumnName: "время",
            dateColumnName: "Дата",
            title: "История Торгов и Заказов"
        },
        FileDownloadButton: {
            downloadExcel: "Скачать Историю (Excel)"
        },
        ChooseDropdown: {
            offer: "Все встречные предложения",
            deal: "Всю историю сделки",
            auctionrate: "Все ставки по Торгам",
            auction: "Всю историю Торгов",
            all: "Все действия",
            show: "Показывать"
        },
        GlyphButtonHistory: {
            history: "История Заказов"
        },
        GeoPositionPromo: {
            promoNotice: 'Отслеживайте ваши заказы в режиме реального времени с помощью\n бесплатного сервиса АТИ Водитель',
            sensorSharingNotice: 'Заказчик увидит местоположение машины с грузом на карте\n системы GPS-мониторинга, в которой зарегистрирован датчик.',
            moreAboutShipperTracker: "Как работает АТИ Водитель",
            trackerShipperNotice: "и получать актуальный статус заказа",
            sensorShipperNotice: "системы GPS-мониторинга",
            shipperNotice: "Вы сможете видеть груз на карте",
            shipperHeader: "Перевозчик будет делиться данными геопозиции",
            moreAboutTracker: "Подробнее об АТИ Водителе",
            trackerSharingNotice: "Заказчик увидит статус заказа и машину с грузом на карте.",
            sharingNotice: "Это может повысить доверие и повлиять на выбор вас исполнителем.\n",
            showGeoData: "Показывать заказчику данные геопозиции",
            sectionName: "Контролируйте грузоперевозки"
        },
        FirmReputation: {
            unfairPartnerAbbr: "нп",
            claimAbbr: "п",
            recommendationAbbr: "р",
            otherFirms: "фирм",
            manyFirms: "фирм",
            twoFirms: "фирм",
            oneFirm: "фирмы",
            unfairPartners: "Упоминаний на форуме \"Недобросовестные партнеры\": от {0} {1}",
            claims: "Претензий: ",
            recommendations: "Рекомендаций: "
        },
        Firm: {
            claimsAbbr: "п",
            unfairPartnerAbbr: "нп",
            recommendationAbbr: "р",
            otherDocs: "документов",
            manyDocs: "документов",
            twoDocs: "документа",
            oneDoc: "документ",
            otherFirms: "фирм",
            manyFirms: "фирм",
            twoFirms: "фирм",
            oneFirm: "фирмы",
            unfairPartners: "Упоминаний на форуме \"Недобросовестные партнеры\": от {{count}} {{string}}",
            claims: "Претензий: ",
            recommendations: "Рекомендаций: ",
            document: "Предоставлено {{count}} {{string}}",
            code: "Код"
        },
        drop: "Сбросить",
        allParametersCompact: "Ещё",
        allParameters: "Ещё фильтры",
        ExtraPoints: {
            unloading: "разгрузки",
            otherPoints: "пунктов",
            onePoint: "пункт",
            manyPoints: "пунктов",
            loading: "загрузки",
            fewPoints: "пункта",
            extraPointsAbbr: "доп. {{point}} {{type}}"
        },
        take_lot_access_denied: "У вас не хватает прав на это действие",
        take_load_access_denied: "У вас не хватает прав на это действие",
        access_denied: "У вас не хватает прав на это действие",
        ui_error: "Произошла ошибка",
        contact_access_denied_error: "Недостаточно прав",
        cannot_choose_winner: "Невозможно сменить победителя",
        invitation_not_found_error: "Произошла ошибка",
        load_not_found_error: "Невозможно взять груз",
        load_cant_reserve: "Невозможно зарезервировать груз",
        load_cant_take: "Невозможно взять груз",
        close: "Закрыть",
        access_denied_reason: `<p>Для того, чтобы работать с Заказами, у вас должны быть следующие доступы:</p>
        <ul>
            <li>Работать с площадками</li>
            <li>Брать грузы для оформления Заказов</li>
        </ul>
         <p>Чтобы вы могли одобрить заявку, потребуется доступ:</p>
            <ul>
                <li>Подписывать и одобрять документы в АТИ-Доках</li>
             </ul>
         </p>
         <p>Эти права вам может дать администратор или руководитель аккаунта. Права настраиваются в кабинете, в окне редактирования контакта.</p>`,
        take_load_access_denied_reason: `<p>Для того, чтобы работать с Заказами, у вас должен быть следующий доступ:</p>
        <ul>
            <li>Брать грузы для оформления Заказов</li>
        </ul>
         <p>Это право вам может дать администратор или руководитель аккаунта. Права настраиваются в кабинете, в окне редактирования контакта.</p>`,
        take_lot_access_denied_reason: `<p>Для того, чтобы работать с Заказами, у вас должен быть следующий доступ:</p>
        <ul>
            <li>Брать грузы для оформления Заказов</li>
        </ul>
         <p>Это право вам может дать администратор или руководитель аккаунта. Права настраиваются в кабинете, в окне редактирования контакта.</p>`,
        defaultError: {
            reason: "Попробуйте перезагрузить страницу."
        },
        EditArea: {
            cancel: "Отмена"
        },
        DriverSelect: {
            driver: "Водитель",
            clear: "Очистить"
        },
        DriverEmployedToAnother: {
            carFromAnother: "Вы не можете привязать ТС к приложению [[AppLink]] потому что оно привязано к фирме",
            employedToAnotherFirm: "Вы не можете отправлять заказы этому водителю через [[AppLink]] потому что он является сотрудником фирмы",
            atiTrucker: "АТИ Водитель"
        },
        toWhere: "Куда",
        fromWhere: "Откуда",
        clear: "Очистить",
        selectedDepartments: "выбрано",
        allDepartments: "Все подразделения",
        deletedDepartments: "Удалённые подразделения",
        allDocsWithoutCount: {
            allDocsWithoutCount: "Документы и фото",
            allDocs: "Документы и фото ({{docsCount}})",
            edited: "Правки",
            notSent: "не отправлен",
            document: "Документ "
        },
        CounterpartySelect: {
            auctionsWinner: "Победитель Торгов",
            firm: "Фирма АТИ",
            clear: "Очистить",
            counterparty: "Контрагент"
        },
        willBeShown: "Будут показаны грузы активного контакта.",
        areShownNow: "Сейчас показываются грузы активного контакта.",
        loadsForAllContacts: " грузы всех контактов при входе в Ваши грузы.",
        dontShow: "Не показывать",
        show: "Показывать",
        allContacts: "Все контакты",
        City: {
            unloading: "разгрузки",
            loading: "загрузки",
            tooltipCoords: "Координаты точки {{type}}"
        },
        CargoOwnerHelpPopover: {
            moreAboutOrders: "Подробнее о Заказах",
            carrierHasReservedTheLoad: "Перевозчик зарезервировал груз."
        },
        CancelWinnerPopover: {
            notChooseAsWinner: "Не выбирать",
            goingToChooseNewWinnerText: "Текущему победителю уже отправлен заказ\nс вашим грузом. Ему придет отказ по Торгам.\nЗаказ будет отправлен новому победителю.",
            goingToChooseNewWinner: "Вы собираетесь выбрать\nнового победителя",
            chooseAsWinner: "Выбрать победителем"
        },
        orderWillBeCancelled: 'Заказ будет перемещён в архив\n' + 'и отмечен как отменённый',
        notCancel: "Не отменять",
        confirmCancelOrder: "Отменить заказ",
        CancelAuctionActions: {
            noAccessText: "У вас нет прав на отмену Торгов.\nОбратитесь к администратору для получения прав",
            willFinished: "Торги будут завершены.\nПобедителем будет выбран\nпредложивший лучшую ставку",
            willLoseBids: "Все ставки по Торгам\nбудут потеряны",
            cancelFinish: "Не завершать",
            cancelCancel: "Не отменять",
            cancel: "Отменить",
            cancelAuction: "Отменить Торги",
            finish: "Завершить",
            finishAheadOfTime: "Завершить сейчас"
        },
        BlackListLabel: {
            tooltipText: "Водитель в вашем чёрном списке",
            carrier: {
                full: "Водитель в чёрном списке у заказчика",
                short: "в ЧС у заказчика"
            },
            cargoOwner: {
                full: "Водитель в вашем чёрном списке",
                short: "в чёрном списке"
            },
        },
        AuctionTimer: {
            at: "в",
            auctionEndDateBoundary: "Если ставок не будет, Торги завершатся",
            auction: "Торги",
            beforeAuctionStart: "до начала Торгов",
            untilAuctionEnd: "до конца Торгов"
        },
        AttachCar: {
            headerText: {
                semitrailer: "Полуприцеп",
                trailer: "Прицеп",
                tractorAndTruck: "Тягач с полуприцепом или грузовик",
                truck: "Грузовик",
                tractor: "Тягач",
            },
            noResultsText: "не найден",
            select: "Выберите...",
            trailer: "прицеп",
            tractorAndTruck: "тягач с полуприцепом или грузовик",
            semitrailer: "полуприцеп",
            truck: "грузовик",
            tractor: "тягач",
            add: "Добавить",
            edit: "Изменить",
            cancel: "Отмена"
        },
        notToSave: "Не сохранять",
        save: "Сохранить",
        edit: "Редактировать",
        p2Text: "Изменения могут быть потеряны.",
        p1Text: "Вы не сохранили изменения и пытаетесь закрыть окно.",
        headerText: "Что делать с изменениями?",
        AtiPopup: {
            cancel: "Отмена"
        },
        FileUploadWrapper: {
            invalidFile: "Выбран неподходящий файл"
        },
        FileUploadItemInfo: {
            uploadError: "Не удалось загрузить. Попробуйте ещё раз",
            uploaded: "загружено",
            removeItem: "Удалить",
            abortUpload: "Прервать загрузку"
        },
        AtiFileUploader: {
            uploadRequired: "Загрузите файлы",
            upload: "Загрузить"
        },
        PopupOrganization: {
            removePopover: {
                contactPerson: "Удалить контактное лицо\nиз Справочника?",
                address: "Удалить адрес организации\nиз Справочника?",
            },
            notLocation: "Мы не нашли такого нас. пункта",
            documentExample: "Например, IDNO 1234567-123-123",
            documentType: "Тип документа и номер",
            bin: "БИН",
            unp: "УНП",
            edrpou: "ЕДРПОУ",
            officeTooltip: "Введите офис, помещение, бокс, квартиру, комнату и пр.",
            office: "Офис, помещение и пр.",
            building: "Дом, строение, корпус, литера",
            street: "Улица, проспект, переулок, бульвар и пр.",
            locality: "Населенный пункт",
            postcode: "Индекс",
            organizationPhone: "Телефон организации",
            locationAddress: "Адрес местонахождения для документов",
            inn: "ИНН",
            residency: "Резидентство",
            fullOrganizationName: "Полное наименование",
            other: "(другая)",
            available: "Доступна",
            notResultOwnership: "ФС не найдена",
            nameFirm: "Название фирмы",
            editOrganization: "Редактировать организацию",
            addOrganization: "Добавить организацию",
            addAddressDescription: "(адрес склада, магазина или офиса)",
            addAddress: "Добавить склад",
            addresses: "Адреса",
            addContactPerson: "Добавить контактное лицо",
            contactPersons: "Контактные лица",
            extraPhone: "Доб. номер",
            add: "Добавить",
            save: "Сохранить"
        },
        RevokedBinding: {
            popover: {
                deleteLink: "Удалить связь",
                header: "Склад отключен\nот сервиса «Временные окна»\nего владельцем.",
            },
            timeslots: "«Временные окна»"
        },
        AcceptedBinding: {
            popover: {
                writeToPartner: "Написать партнёру",
                showTimeslots: "Посмотреть загрузку",
                address: "Адрес склада",
                faq: "Подробнее о сервисе",
                header: "Склад подключен к сервису\n«Временные окна»",
            },
            timeslots: "«Временные окна»"
        },
        UnbindTimeslots: {
            breakNotification: "Вы разорвали связь со складом партнёра.",
            breakQuestion: "Разорвать связь со складом партнёра?",
            dontBreak: "Не разрывать",
            break: "Разорвать",
            breakLink: "Разорвать связь"
        },
        EntityRemovePopup: {
            dontDelete: "Не удалять",
            delete: "Удалить"
        },
        Entity: {
            edit: "Изменить",
            remove: "Удалить"
        },
        DepartmentsSelector: {
            selectedDepartments: "выбранным подразделениям",
            allDepartments: "всем подразделениям"
        },
        ContactEntity: {
            extraPhone: "Доб. номер"
        },
        AddressEntity: {
            shortCity: "г."
        },
        AddOrganizationContactPopup: {
            editContactPerson: "Редактировать контактное лицо",
            addContactPerson: "Добавить контактное лицо",
            fullName: "ФИО",
            extraPhone: "Доб. номер",
            phone: "Телефон",
            add: "Добавить",
            "save": "Сохранить"
        },
        AddOrganizationAddressPopup: {
            placeholderAddress: "район, улица, дом",
            coordinates: "Координаты",
            selectOnMap: "Выбрать на карте",
            enter: "Начните вводить",
            addressWithoutCity: "Адрес (без города)",
            locality: "Населенный пункт",
            withoutContactPerson: "Без контактного лица",
            nothingFound: "Ничего не найдено.",
            selectAddressContactPerson: "Выберите контактное лицо адреса",
            placeholderShedule: "Пн-Пт: с 9:00 до 20:00, Сб-Вс: Выходные",
            note: "Примечание",
            schedule: "Время работы",
            type: "Тип",
            editAddress: "Редактировать адрес {{addressTypeName}}",
            addAddress: "Добавить адрес {{addressTypeName}}",
            addContactPerson: "Добавить контактное лицо",
            contactPerson: "Контактное лицо",
            add: "Добавить",
            save: "Сохранить"
        },
        AddEditCarPopup: {
            cancel: "Отмена",
            semitrailer: "полуприцеп",
            save: "Сохранить",
            trailer: "прицеп",
            tractor: "тягач",
            truck: "грузовик",
            edit: "Редактировать",
            add: "Добавить",
            ts: "ТС",
            description: {
                own_duplicate_error: "Оно уже опубликовано в вашем Автопарке.",
                duplicate_error: "Она уже указана как собственная у другого участника ATI.SU. Если это всё же ваша машина, поставьте временно галочку на «Привлечённое ТС», прикрепите скан ПТС или пластика и обратитесь в техподдержку: создайте Тикет или позвоните на 8 812 602-01-09 доб. 160. Мы всё исправим."
            },
            header: {
                duplicate_error: "Вы не можете отметить машину как собственную.",
                own_duplicate_error: "Нельзя добавить транспортное средство."
            }
        },
        CarPopupForm: {
            truck: "Грузовик",
            tractorWithSemitrailer: "Тягач с полуприцепом"
        },
        GeneralCarFormWrapper: {
            semitrailer: "полуприцеп",
            trailer: "прицеп",
            tractor: "тягач",
            truck: "грузовик",
            edit: "Редактировать",
            add: "Добавить"
        },
        GeneralCarForm: {
            semitrailer: "Полуприцеп",
            trailer: "Прицеп",
            truck: "Грузовик",
            tractor: "Тягач",
            rentContactHintText: "Фото или скан",
            marriageHintText: "Фото или скан свидетельства",
            documentHintText: "Фото или сканы документов с 2-х сторон или электронный ПТС",
            contractHintText: "Если ТС не в собственности",
            ownershipType: "Тип владения ТС",
            required: " (обязательно)",
            uploadGratuitousContractScan: "Загрузить договор безвозмездного пользования",
            uploadMarriageScan: "Загрузить свидетельство о регистрации брака",
            uploadPhotos: "Загрузить фотографии ТС",
            uploadLeasingContractScan: "Загрузить договор лизинга",
            uploadRentContractScan: "Загрузить договор аренды",
            uploadPTSScanOrPlastic: "Загрузить СТС и ПТС",
            attractedCar: "Привлечённое ТС",
            documentsHeader: "Документы на ТС"
        },
        TractorAdditionallyParams: {
            header: "Дополнительно",
            canCarryHeavyContainer: "можно возить тяжёлые контейнеры",
            hasGenset: "есть Genset (навесной генератор)",
            canRefrigerator: "можно возить реф-контейнеры",
            externalId: 'Идентификатор'
        },
        ShowInFirmInfo: {
            tooltipDisabled: "Для отображения в карточке, ТС не должно быть привлечённым",
            tooltip: "Для грузовладельцев важна не только репутация фирмы, но и наличие собственного транспортного парка у перевозчика",
            text: "Показывать в вашем Паспорте участника ATI.SU"
        },
        ReserveByDriverBlock: {
            noAvailableDrivers: "Нет доступных водителей",
            cancel: "Отмена",
            select: "Выберите...",
            addDriver: "Добавить водителя",
            reserve: "Закрепить за водителем",
            reserveByDriver: "Добавить и закрепить водителя"
        },
        CarSensors: {
            delete: "Удалить",
            update: "Изменить",
            addSensor: "Добавить датчик",
            helperText: "Датчик GPS/ГЛОНАСС",
            geoposition: "Геопозиция ТС"
        },
        CarOwnershipType: {
            gratuitousUse: "безвозмездное пользование",
            spousesJoint: "совместная собственность супругов",
            leasing: "лизинг",
            rental: "аренда",
            hired: "привлечённое ТС",
            owned: "собственность",
            ownerName: "Владелец по свидетельству о регистрации ТС",
            ownershipType: "Тип владения"
        },
        CarInfo: {
            pts: "Серия и номер ПТС",
            vin: "VIN",
            vrcFull: "Серия и номер СТС",
            manufactureYear: "Год выпуска",
            number: "Госномер",
            noBrandText: "Такой марки нет. Введите другую.",
            vrc: "СТС",
            hasBodyNumber: "нет VIN",
            hasVin: "есть VIN",
            bodyNumber: "Кузов",
            model: "Модель",
            mark: "Марка",
            clear: "Очистить",
            cancel: "Отмена",
            exampleHint: {
                bodyNumber: "Пример номер кузова / шасси",
                electronicPts: "Пример номера электронного ПТС",
                pts: "Пример номера ПТС",
                vin: "Пример VIN",
                vrc: "Пример номера СТС",
            },
            description: {
                bodyNumber: "В паспорте транспортного средства, свидетельстве о регистрации транспортного средства, гарантийном талоне/талоне технического осмотра или в страховом полисе на автомобиль. \n\nНа неразъемных составляющих кузова или шасси и на специально изготовленных номерных табличках (шильдиках).",
                pts: "Паспорт транспортного средства (ПТС) – это один из основных документов на автомобиль, который содержит в себе информацию о технических характеристиках автомобиля, сведения о владельцах и учете/снятии с учета транспортного средства.",
                vin: "В паспорте транспортного средства, свидетельстве о регистрации транспортного средства, гарантийном талоне/талоне технического осмотра или в страховом полисе на автомобиль. \n\n На неразъемных составляющих кузова или шасси и на специально изготовленных номерных табличках (шильдиках).",
                vrc: "Свидетельство о регистрации транспортного средства (СТС) — это один из основных документов на транспортное средство. СТС выдают в регистрационных отделениях ГИБДД МВД РФ после постановки транспортного средства (автомобиля, мотоцикла, прицепа и т. д.) на учет. Документ отпечатан на фабрике «Госзнак» и ламинирован, имеет степени защиты.",
            },
            header: {
                bodyNumber: "Как узнать номер кузова / шасси",
                pts: "Как выглядит паспорт ТС",
                vin: "Как узнать VIN",
                vrc: "Как выглядит свидетельство о регистрации ТС"
            },
        },
        CarDimensions: {
            fillDimensions: "Укажите корректные габариты",
            height: "Высота, м",
            width: "Ширина, м",
            length: "Длина, м",
            internalDimensions: "Внутренние габариты"
        },
        CarBodySize: {
            capacity: "Грузоподъемность, т",
            meter: "м",
            volume: "Объём"
        },
        CarBody: {
            containerSizes: [
                "20' одиночный",
                "20' платформа",
                "20' одиночный + прицеп",
                "40' платформа с полом",
                "40' платформа без пола",
                "45' платформа с полом",
                "45' платформа без пола",
                "20' платформа для танка",
                "40' платформа для танка",
                "40' платформа разъемная"
            ],
            dimension: "Размерность контейнера",
            select: "Тип кузова",
            body: "Характеристики ТС"
        },
        CanCarryTallContainers: {
            canCarryTallContainer: "Можно возить высокие контейнеры"
        }
    }
} as const;
